module.exports = {
	"trips": [
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CI)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T12:55:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T20:45:00",
			"destination": "HND",
			"downPayment": 802.47,
			"id": "a8c8e4b1-3b9e-441a-ab6e-0e43b813af87",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pblAngQttNFJ4HYvkua_f2xEAQYjkBbEa_pj56Kg_fyTpZUl9eqgwxhBW1fj5WQUSNwBqXAu4qHR0xyQpIg3yR092Jz2YBkH2qt9rXFZxsK4vau3ZXNhQt6d3EqHgBzsaYH7esL5iGhrjfVU0QqyXhbwQ5nQ5bpTH8lQlYFnrOTVurJ40QXWGl4wjngDajpHIshuZhU9E5i1qq1SsfH4y0ZuM2pcJ6acC9F5h2RX_prgSv5qP7jht4JFVxepjWZuUle9g_pUy08H7afMFy_pX95kBNEME2PXVXXSvHwwqhQpx1XtaPgEyOYFRaCseKsliYplO7Y0FtpyoT6EN8fWVlM1YSrA2MHzJzGRleXPyVqpdhtfyksBPm9XhBwiQz_fTs2cCYyZI0gmb8HiWQQuDTtip_pqhXmbVDHsZdQkADgs_fGsOz4CDC2NYNXNxncHT_fLYQ7fXkg9za2U9aj9a_fOdZnVbmJEB_pnYQVxZczG_fV_fp7375BaVQacP0RJSKPuZc_pVDBMoUNts2FyHRvaWiYXMyh7cp8_pNFX70s7x4_p3HhFqD5XChus2yEmmBtsk_p1Yxp_ph_p1XTkM_fqyaLB7lYL0NPfERxdueUXmnV1CdkYsxmi3NQ_fNyKU1n_po0lB1jV35BwV84GsTTI2TyFj1VdHNuk0yT4rURNwSx3zFWd8CDumnaBn8S8pmwh3yHWl5sF8L9ZISAZBp7Gh_puaNGVVXHCf5EiMO_pNCeeSYKvkxWIVE6KJi_pdnrcfogLLKVGgTeor_fMmkZZ1_fwvZ4PmSjJrs12ljLFdJH1zmbyQivlra4TMvsaSMC_fV_pQy7PQL30K5EFstFDusW7l_fVB1d_fPv9L6GzWlLDpdb7dvSIUhNytZIMJNvr0o4T8SrtkU_p1s3xeM3WTcX1A6WNLWlWaHjXifSYmoct4oHkpKBV1yzgU1j3dDhaUB_pV1gNYjXCG_f_pwvGXH1f6DANN_fKjRwthRFzCDtQV1PCjeianIKXcc3bo77TwpdLxaYbHNHeE4XifRoPWcoO55vpTK17J8Y5J9WCkby4FZvK4MVfbE_p4eOtpL_pjI6Qj5y_fGC75sfGtJZBTi2kW8cFAavKfpr_fr5GYzlcfGc1MMW_p5ewTfBEeY0LLHrV7fAcIKHzu9djaJQdOkWBEX2gX4Xoq0kBK_fqxTcuDgth2Omxy5y2J2UWyN_pX8d8ps30Os6nA5SubZXmPd9Szwqx04WCWMN70_p2ZOIT4u2SU5BnEsbLgdKLfjrV6haODCHN4UAHuahouK0Dblb3Xz1PKr6zOfSUzHPNsAFBr10chf1Jz3HlW4P3yt86rjDBXxzNzWCdUglZkQO2EQ3MaoBJjPtEKOjrol3ngLpnX9mjFss0vyicBUy87Nady3fxwJGEt_frvpqee1gs31qdLmXKMgZcB0aK_p9v98nwc0FfkyN4dLrqx8AsRdC5k_pFT21Fs_pNeEq_fMhKaPq56KSXV2FPfTSU_pfJo_phTYum2_fdXqXSyX8IgrHR_ffm5Cr1HydkCOu5iVCSXddc4pjkPjprdQkY7fxPNdqX8sTeSISVIBHHS_p5uzKO1O3U3qYikffrPebAvQqKObMGWICcZ0nVqwIGJxURM_peMWpxs2pQbD6cczTKtzxKU_f4fxORL_fMhmV4fPoD9Q6Ikx56DRcRiFcuHebTJM20fvXHbwEFs23dPrTeRMMDWVGGaLZttCtqBYJO4OGJiTckqOjOjQGDbB2ZtN5klz_pqCEPVAaI_pURwilzKoRhGjPpMpttfFUzRW0SbnAsKmpmebmAykxuIK_flyYlE5nVnlwmFazZtbiMRiysVazcZcHtH593HgC8cdwLReesxB7MOdlfp8_f7zyjjtTjj8jOK9U25Pn_fkpykYvaPUiW7eSEwMaILkoZNxv9VkdHuSXf3ax5mKKhvTArPtPqL4TES294989NaiK4nFNmX35PINhGYrs5j8FNGButL7_p_fNvqM48I3_pK6hc5QJHILf94kxJaLnMf8G5Q8mAm5CeSyorSv0C_pyPm_fZgceGlInG8vrX8qJahdcNaujAgTjqO9g5UGf23VSsR5V8rCFnrL_fePnG_fA1r8KzeSPh0i0_p1clEiAt8Qq9XkAUH8wbxfrIFlAkwtgQiw2c4Yga2aMGyNC_f5HIffG2PZwbikB905EKmdXZIB6aaNOI5STrUEfLOJxvypluFoy3qIPgoy1aUNToaaoUYBTD1oDVuFZSW19zTRi5fMKhe1mNxyOAB2_fFDAG1H0aJXy5Ih_fk4UyCZf6K5sWgLvhbTQGg4ulz8UuViFaYgpkibFrNhdP1e7Efq71GAPUT5THE6HUqg9ze_fLTCRKs8FxO8wWyaGteMwZwHE6Wdl",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T23:11:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T20:45:00",
					"flightNumber": "311",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 26m",
					"layoverDuration": "3h 9m",
					"layoverNoteValues": [
						"added by Somto for testing overnight outside note_0",
						"Overnight Connection at Vancouver Intl Airport (YVR)."
					],
					"totalTripDuration": "1d 3h 10m",
					"arrivalTime": "11:11pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:45pm",
					"departureDay": "2018-08-23",
					"destination": "YVR",
					"destinationAirportName": "Vancouver Intl Airport",
					"destinationAirportCity": "Vancouver",
					"destinationAirportState": "BC",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T05:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T02:20:00",
					"flightNumber": "31",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "12h ",
					"layoverDuration": "3h 40m",
					"layoverNoteValues": [
						"Flight arrives on the next day.",
						"You will be required to arrange transportation between TPE and TSA."
					],
					"totalTripDuration": "1d 3h 10m",
					"arrivalTime": "5:20am",
					"arrivalDay": "2018-08-25",
					"departureTime": "2:20am",
					"departureDay": "2018-08-24",
					"destination": "TPE",
					"destinationAirportName": "Taiwan Taoyuan Intl Airport",
					"destinationAirportCity": "Taipei",
					"destinationAirportState": null,
					"destinationAirportCountry": "Taiwan",
					"origin": "YVR",
					"originAirportName": "Vancouver Intl Airport",
					"originAirportCity": "Vancouver",
					"originAirportState": "BC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T12:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T09:00:00",
					"flightNumber": "220",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "2h 55m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 3h 10m",
					"arrivalTime": "12:55pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "9:00am",
					"departureDay": "2018-08-25",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "TSA",
					"originAirportName": "Taipei Songshan Airport",
					"originAirportCity": "Taipei",
					"originAirportState": null,
					"originAirportCountry": "Taiwan"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "12:55pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "8:45pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 3h 10m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CI)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T13:15:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T20:45:00",
			"destination": "NRT",
			"downPayment": 843.59,
			"id": "55d7d3c4-44c9-400f-b93d-b45a9493d887",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_paqveu2BjY7xW_frLDtLnqlUsXKtZo4FpeOw1BMKMk6c9euHUXjMf8gxbyDKrdsnIFGwJbMxGWy_fzbCojs_p912QJQyKCiUSiVCrOJV8_pd0Ke_pe3WW8ePrKsYwHndsFj_fzFIowIxrGfKvp0mraE_fOuEwVWNn29wb_pD8i0molxe8MCfK_pajY6R36MxL84JbqtbMNxDIxdMfaNg9R1l_p6SinoGcwhr4pDHPT1U2jnboDxFHh_poap93w96Bj6p7pv9CRxjDePQSeBpZPkiqeyGCr0Yr_pEuJ9PS5AObEJg8q_fEYzx24epnmfACL_pIYnCfwyhGD6tB7Mdm_f_fT2gevf7TCX_pIvM9IkFy7yMPVbVgk_f0oKkYaPy7VeMyiayrvGv9cGjOCcy4AauHaRWxlEwbKq2QqxW8Q4FtAh1RGnfvM2QnZpMNxzKd67D9yzdY6BK9tgh0tCKHWDLpHg_pI_pMTYjeLKCEAz3fbggp09_fkSILThbnmPpJZZkDJAiIrEQWt_fSRaVb9hOZsOyt8t2C9ekY5iUSiDh6bt9uq7bBnG2SScVlUyd318ztWoyDYd9KgGIz9b553H61hyIyhmbLNz8nsapRMqkvSfQVUzvZ0w9AtconV4U9SHHGCw_fu30tYJm_fZLLlLmcToLKmtM8kHZtxtRE_ffPZKelpD5VwBhMm0AZqiatX_poTl24UMoFljOVW5TuNVtNEnsg_pf9k9zNuxAsov8jZacTnVZKRpmt2yRwjwbznJc7p7nOlgKbtfj_pkJGE9Yw55hrWV4WfLMh7qWytG3AoFbb6vDdv7Anag13HMi9ft7MUL_pIPuWZEv2qad7V24RTr1_fY935fNDRrfdUBquVFPC05gdh_pQQfYkkjVsNCopQH01VgeniwO2EQ7qvLJg1btFRRVGHZGj5q1lWaP2XDku1Vp4dWzaxYmIigeKhSsu1O46AXsQs0cVHx48F4LJYHcR3V9XMp6TGkp3bPGo68afPqmFYSrp_pmnhIM2Dy3KpVZB_pndy_plS8tnNmaPq5dEZWikTcX89B9Y7nl6u6Zf_f4MnzIFcB4pnskhilNWl4XpdC9bznBxnsc3yfaCWiJl0WLkuc1_plC7anM0GMoYvHtKTNeJUg5vSnMPg4HVl2hJRPk7EOgz2Xs8E0Y0GTASu_fOIocCsNVebOcgmys7XkZ5JuWzlQZicnzBaNwKcWZT6_fRrrpOkT_f26UsZ1BW9_fDo3DkqsS0u8_pvLzm5qESHEjeIgZEWhfNIRgPqvv0xusv2oealwh0oOaJXNKybcC5pFuGXwkgiOKrR4WJTlq7OfEkvgVf2ALBHAph8QYa6CNPwE9Ykb5gWbu3eE0oS6GCelm_p_fXzd6deOfifF0JLueGLghOuAeJb8WQA0EcbQC3yeT2_pdXLuqT1Y06bSb_f8SG8L8V5HCd5xCNrCNHJV0iYdTX6fJw1KenaX5RgHK7h1FO4I_p_pt1R_pyZ5xaywPsR_prTBu2UuQfHnYwqH99QYwxJnveeTjXXf62Qe48upH_fEj4phYMXknxkkyfhs8HpBr7okX6xOrL2aRkRVPpr0ldbOEFaRrr_fKqu109tQUd5Br34MuKqh_p1b8MNI2V11nJrjcE83JqOVhNocoD6A_pAAnYV_f99udULejwa5D12rVkTKZoSoqcLyvcHWn21hlNCS4qnpNCTNVblxFFlZkp5ifNHFu1QG1viJ9zk_p1eYECw_fbfsnNisWVrgKqaCvfXjHH9aRRDnPyUUowlw25dBvQtlueo5wP4VWt8fcyJUL1sAHbml20Q9DEM5mF2zHNXxwydXzMamlXkW5Pc9A4PK5LskWPgk_p_fxEgTTRStG9jb9BZW44xaVNc661hRIfWQSCKNZrUqvuqEEx8KvXXxEuu_pkUXGv_fy6Od3AF6_p1uzoPXxnXtg9p4_pIPoiMqV2mxtBzgFTkVVnRQhjeIeFBykIO0nfKWS3JKUxjesaXCPYN22LNDQyhKvQkPDUlSHuzTrOAbIBJQEjTNeIuwuGKskCpNK6Gb8wmDgoVGrHGWEpg_pg56DUl7CcRu7eyaOm5f44tLYeacEWFOlxCxVfyY7j_p1fJ0_f5Eb4Wozfnw2WFy0Rh0CKzwxR51H1lcdDcJtq4l9_fBiw_fPV6A7hmm8YUdE2jfIhCLVCNmaLpTRYmW0kGmm8M4uNNzc5ZDT0nm2fkpIu7Q8JSiduR6JMz4Y4_fIV_pfuEUSQLG706QDPj1W3ttbcSLPrRKVX9l_pQpOf6_fEk2PG_frwEv9Z_pqtWz4RdnExirpih0Fsv7zA_pLELsCbf61qQLM_psmtI_fizkrTYXJSaU1h5C0obcksRWqXsCbok6n0Ky0v6E85Pzt9xRA1ecLwHJF",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T23:11:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T20:45:00",
					"flightNumber": "311",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 26m",
					"layoverDuration": "3h 9m",
					"layoverNoteValues": [
						"Overnight Connection at Vancouver Intl Airport (YVR)."
					],
					"totalTripDuration": "1d 3h 30m",
					"arrivalTime": "11:11pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:45pm",
					"departureDay": "2018-08-23",
					"destination": "YVR",
					"destinationAirportName": "Vancouver Intl Airport",
					"destinationAirportCity": "Vancouver",
					"destinationAirportState": "BC",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T05:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T02:20:00",
					"flightNumber": "31",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "12h ",
					"layoverDuration": "3h 35m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 3h 30m",
					"arrivalTime": "5:20am",
					"arrivalDay": "2018-08-25",
					"departureTime": "2:20am",
					"departureDay": "2018-08-24",
					"destination": "TPE",
					"destinationAirportName": "Taiwan Taoyuan Intl Airport",
					"destinationAirportCity": "Taipei",
					"destinationAirportState": null,
					"destinationAirportCountry": "Taiwan",
					"origin": "YVR",
					"originAirportName": "Vancouver Intl Airport",
					"originAirportCity": "Vancouver",
					"originAirportState": "BC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T13:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T08:55:00",
					"flightNumber": "100",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "3h 20m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 3h 30m",
					"arrivalTime": "1:15pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "8:55am",
					"departureDay": "2018-08-25",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "TPE",
					"originAirportName": "Taiwan Taoyuan Intl Airport",
					"originAirportCity": "Taipei",
					"originAirportState": null,
					"originAirportCountry": "Taiwan"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:15pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "8:45pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 3h 30m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CI)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T12:55:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T17:00:00",
			"destination": "HND",
			"downPayment": 858.74,
			"id": "bafcd482-a960-41b8-91d0-b6a1beb54c78",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pdnR1uZWQ55j6_pnl7Uxe0Fze9NU27VfVeJfHrW9CJfZMxRqfMe8rTZwXHLhfILiGHLjbm8RXxkDPL7_fT3lnLetW41RV04bWfEi_f1Z519Shy6HZGiWNftb2fa_fEuQZ5IIxIRyJdmUTdg_pJy1CkYjr7De5QRdwKkMryS3Z6dz3_fJnL3Yf6ITKiJaYAbnkrOdNX4eDnDeyTXxobsBZpD9SXXoxQ5h2pL1TL6dPaBSh_pB5vo66DFBica5WUhBx4CuVccPB7EPjvW5R70o_fi_fWnCZbzBHTlvny3aUAyhUPqb9yd1K_p_pOX47NxeImHoeVvi58_pvRsoiLqkS2rIpRel_fu4C0WqZyiHREzhIWZBHqGIRSGbOrVIyZ_pqXLvC3KgdhHVZqGPySY4rqdUSywy9cg_pZOGXbwkHNgXWYU9u4aqBx8obB_fC5z1uU3_ftgyuJZbCKGHpJAffmWfwHUSyKFzayB7XNlHOrDLaWf4ZEujJdbKZi431XuRQjmo1OHSv3O3HUMPf7GJgNIc2LbGX_pALC7n0CjdeofiTq2ZLY7s5Dg5fDC36wOB4gai3Q2QlVhYCy5xcrevSEJNKY2uztxhFiJ3IOGhQ3qEr_fi4pZJUtAJ2CT4ED2BjlWvG2tB6x21AYVQf4Te9R_fRhp1mftwcihnoRsY9QjN102VZ_f55Ttomu2BwdHPCV4oK_pvGmDjPqJ4dQzqQhRyegsZL8wQW3jSr6N4BIwZ42AESMznGupfUVKFpaRmacI5U4VAutd57JtnBu64vBO06sq8d5OKU0wzfgdIiUKAWK0Bi_fGQXVT2h1e1YW9oU2FB3wUzvQ7iRKjouNtQfzkIfEKTicelI8usRzD4CQlcdM3dUuFM4nRXv_fMulJpA86TmrHuX2UhrPq1lec6ztwio8U_fPEcUYGi8ob07vQthMPXldIUS081pEMYEIELwq_pXmJSiENH6IwsHWmwOT4PDG5oP2z62QygrW6UTubax67WZbDCKLKYQvRPVHuzqYLzUWLaClBjY6Rg8Fd4kips9Vm59xMsghWU3rwX9R7WL6ya93EVne0I9qZm_fUO0uYxtvDWd0780vCm7LGLorqYFh9_pGddrNLxglAaKlfGX3S0AJX25Aba50yfjXIkhDgPqGHH76mMVn8sHE0hVtgQpZoxvy261omo9NiGmIyJfSKEtTuGmNzSJE8oyLYwuewEobkF5US8OEPzIG_f_p_fVwDAjkGvOSSgnyKILrdDpnmc0RwbJxlQ0_pHVu5TpmET3JJO63dzpXn7WmSMcbWdMBtc0rNaCGzxDoga8CRk7DD_pUCGAgakBCOKeSRTnOmT67anu_fVIYWd8ve3rOnyBsTaKIvhG7wWEUqpPVWl1khS7_fj_fEOVdhAKdnh0wXT128_pph8eDz3bE6xaJwVI2AA6QG9mq9ZgKI0CMHOKVwjk7mWpIai5YGQ8i3vOpQMQWV28O8me3iUVPROHknr0yQaaf5lwPHcGsSQaX3x6U3yKYfWBphk6Tav_pzZSDlMyYfO4QtTXi7F_pa2vg4hdWnfY552Bc3uog2asxm_pKS_feCm9vBJOi_fdVpEqwqXEF03fxhxPmu2kRJacPyvGp9fd6PlyU90kRbaJz3Y_pw2ZtZk1rGaYs9yDW15ER79ieXzvlh0XZRNRnVrn4wPbyPfg9kqNHp_pNP2kvBhpgQsa3O1hG4Sl4re00jPRHCmSXE5AsBeodKlhB9urL2V64GAZjMhBBzqZO93TUf_pAp5k8VN8u53fNm7q9_pbzoF_fB6TDM3dnE6Vjj2grVG_ft_fEJwifnN0FlBa3ulA9nlmBofmTgmOF_pf_f9zfq8xEg_pSGmp8N1Y_f0UZJZa31_fSpJdZxYug5At2whDSc5jaNDtEQ_pUuh_fx8q2rjlPicdpZKyMc9a5Er9sdyzJGoqHuII97bQEQ6Xe4aSDwUXr33bQhRDxmWsGmj_p63E_pbo_pasw0yWke2M_pFo5RxZzKSs5Pz9KrYkspJZZFlN83s1_fKqyDkqeguIQC4O5lrv3ufcSAvCzRnF2o9cxtPqtGencqsGwfPzIga2Qy1_fOHeLPo7zXXmJy4qJaLpq31a7zIFdPZMXl_psI0wJy9_pstFkfhRDvSnq4G3sPGYjWBIOPkCmUVi8mff5w66tkPYdqwQHtpasyNEO6tU6fT5Iys_po17YTt976L3iq_fxfxMUn9bXcJdfyTDkVmIe_fLjPYlKypZQtjtyK221URgtjC7iqbm_pezYqlRyUlUPEoGFnWOlVCys2eihvhiO5gy6saWzURlDH2wPclXy0X6r7dlbUXQQ1Ndgp0jn9F_fJSVMwnwPzBw9ROxco6SFDDj6LQePe7TrXLbWiv9QTqcG2L",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T19:34:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": "WestJet",
					"departureDateTime": "2018-08-23T17:00:00",
					"flightNumber": "9329",
					"aircraft": "Boeing 737",
					"aircraftType": "Jet",
					"flightDuration": "5h 34m",
					"layoverDuration": "6h 46m",
					"layoverNoteValues": [
						"Overnight Connection at Vancouver Intl Airport (YVR)."
					],
					"totalTripDuration": "1d 6h 55m",
					"arrivalTime": "7:34pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "5:00pm",
					"departureDay": "2018-08-23",
					"destination": "YVR",
					"destinationAirportName": "Vancouver Intl Airport",
					"destinationAirportCity": "Vancouver",
					"destinationAirportState": "BC",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T05:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T02:20:00",
					"flightNumber": "31",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "12h ",
					"layoverDuration": "3h 40m",
					"layoverNoteValues": [
						"Flight arrives on the next day.",
						"You will be required to arrange transportation between TPE and TSA."
					],
					"totalTripDuration": "1d 6h 55m",
					"arrivalTime": "5:20am",
					"arrivalDay": "2018-08-25",
					"departureTime": "2:20am",
					"departureDay": "2018-08-24",
					"destination": "TPE",
					"destinationAirportName": "Taiwan Taoyuan Intl Airport",
					"destinationAirportCity": "Taipei",
					"destinationAirportState": null,
					"destinationAirportCountry": "Taiwan",
					"origin": "YVR",
					"originAirportName": "Vancouver Intl Airport",
					"originAirportCity": "Vancouver",
					"originAirportState": "BC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T12:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T09:00:00",
					"flightNumber": "220",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "2h 55m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 6h 55m",
					"arrivalTime": "12:55pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "9:00am",
					"departureDay": "2018-08-25",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "TSA",
					"originAirportName": "Taipei Songshan Airport",
					"originAirportCity": "Taipei",
					"originAirportState": null,
					"originAirportCountry": "Taiwan"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "China Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "12:55pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "5:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 6h 55m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T12:30:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T20:45:00",
			"destination": "HND",
			"downPayment": 889.13,
			"id": "34b0a3ea-bb19-4f2b-bf7a-ebdf3eebbf36",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pUhxpaL_pUu9Wc_pwvAjHtypcblv2j9S0kwVSYc8pCKImEvYtdsZ0O3GsYZr_fgMcsSPm_fUjB_fLS6TO_fhB5BxiphszEkJ96Abz6SJdfSctPnW1gXl5YicaloD3PnQbJ_p1NCY1vAIyhb62Ie0D0GsMt1XFheUU_p45z_pcWNkd_fjqhsxtFGVINR1dw_f1z0ChgqtgHYfcN_pO4kjLpNfwp_pDg4bYYKNppAGZalP7D9Lp_fQP2_fFNM_pA5zxFxMxwB2cw8OZAt78RwCztqot7wJECqsI60Zr2Cukvyw82Mrl_f0M6JBFdRsLV3UiX9zcQElfTbRv_fhwVBxXyQCakBwNIFG3kwjybJHtM_fhgJR9GvMfHFW_f23mDxEDBb0LhCRiwj3vU0kIefYS30g3wDtZ1gaHlGmpvfViKaf4n818XSoCzvbuwINipDpKkWnCUfcqy8ld9F3Hnx35eXDR0TzkAkwtXI4_f3TgXnJHKAD1fbaWsd1H3hqs3kNJ371ExCD5d58vISe51IKjzStZDzAOiVzbbG2uvHBYYDQckjhzD0wqY3cpNLTPRT2Kd9fvRRBGWb6NZ6Me_pTjOu1PqYMfHjaJg1TOZUrDGO3qg_p3vp4RBic_f7wmFirXDUg2FTOweEgPxISGKaLx1SOjj0A_fFk_pAz4isOvvuLaproEhr73j7yTxDmrrsAQ_fkUDTwphAPJowJgwGOxQ_fXBd9vsItYNvR_fLI8NUhcC41ezYhTknA_ffgHdkLLrk9fO50XH5rDQuHSvH7xtdjatJgErCMarGy9D_fYhI_fGXsUfLoKyaIfDQlQfxs4IyyWnIcU_f942E0SS7xzyfbnCD29suwkAZyetzQWXN_pgDQkHyIabD9KtStemt_pc8IA5iOPjdAk65MYgrgrYXaMVSddQaH7gsnM7mUFR64vDLLmFvgQTrVC83BgpzeozYNRxz8Cy0L04hgGMQuE9OaF_fe6h08LNYV_pNgCeS6MvUNEwiTG06kaJDLAbFv8crbDajGcr_fN0XbqvKNCg_fSEwPHHXz26IZBcJz_f69FQOkB02ZeFnHZOyhtOMfrucrUB7X_faowXAU3jOHx7BAXIuwSwhj_pMo7k9xfJHcOynKRFaXe2o01rRpe0zG2_fqrAcbDNg_p7pggi8lWLbosCb2Z23BYpS_pc_pRTWp9tuRwT_pn6uX7NW8MHuJTkjb3qwT_pblsxnjLcUPi0WgzG8E7xXP6Yxj_f9_fHsKgzkGdXqQ_pV6kwfFwPwJh24btWaAZ2LFj0npd4AArdpk_ficsH_pSuMLqEQeBjMIKFj_fxC8xrBgIrChjHIR8jQ_pYUIbvVQsDEFNxPFjsdWm5JrhfetjggFU4DhRM8YY7uNq_fLUNYAu_ptSrVxfhJmrAxJTN1R1ARfXhXZNdzSqM7dtTc68m9iVleMuIqRDAep93aIUyZrZiLWmk4zhOWv5EZtWuJHi_pcquYzHONF7KS44CRKz5v5bECvEaoR0Pl7KoIGuVBlSDhKa0_f1Brxbc6jBrnyMEut0bAtwrr8XGIkxb_fLasr2hP89ntxkzRjWEcQWQIIymO51Eo1y_pMUA83DPX_f0Zk4Vc9Rha40R8rlxueHdmYNlxPZPolvBCe_fLR2wtDyOv8xTWOqbhPrYY0XTUAeTIpnrkursMw09cUSjknd_p84ZSeHJDLOmW4NhgqaBOu_pcNsIFvsgBOIS2vRnqqcB82X9KDf7817riYGk5qOYUZRh_fF3XMuBehvm5jaw5rBtcASAtwxriVEg9IqLdZdmDVavSJ6_fQ1q1OUyPGZ7ftFAFkJFMAk7C3Iyaem3j1MXwaIErc0Exp7DFAYUPyzmQeLfQ2RGkbhgcu_p_ffz0WFmme2N4FpLosBQOzmPyjA34uTYyeKmC697ePzOu1UH8zeOV6HxeIJTwzBf0utVNhvOjxZ2s_fHKxNAlMPLjw_pDlSQE_pegVoI_fnNE2HdxWKBb222T_fHAqty14TxQvRxUNBqPQeHDy0pvFAca5HAVsqjtqO4e5YAqy5_p0xDfkXqMDtcNbTwA3LzXk84eMTb1aBz8G1cSj6IOQ45LHFMQ0iM9KjN2adtbWewd6MTLYMchKO2fVblW4o3LBLLfBcVDMnt5GKHb_f5Mml3rBM0FxDK6TNZmMpC9TvWSYdeWuqRlrHAJIfeasVF0UdGeMEz1r8C55tLT9yPHeaUSmL4dV8_poF3C6e2HQePAWRe7wAmCTTUtCGu8_fwJuGzCJDIdO1TxSwCOTthPg_pD6188URmIBHau2hKD7lVPhYh8nycr4slF8i_fiRrK8pTzlkvW_p_fs7K_fSGvQIwCK_pzoxvQV3FomrSzWrnNFExk9YqkB5QnjGMdFAvwchgrQXsTMO1_fB9U7U",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T23:11:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T20:45:00",
					"flightNumber": "311",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 26m",
					"layoverDuration": "3h 19m",
					"layoverNoteValues": [
						"Overnight Connection at Vancouver Intl Airport (YVR)."
					],
					"totalTripDuration": "1d 2h 45m",
					"arrivalTime": "11:11pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:45pm",
					"departureDay": "2018-08-23",
					"destination": "YVR",
					"destinationAirportName": "Vancouver Intl Airport",
					"destinationAirportCity": "Vancouver",
					"destinationAirportState": "BC",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T04:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CA.png",
					"carrierCode": "CA",
					"carrierName": "Air China",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T02:30:00",
					"flightNumber": "998",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "10h 30m",
					"layoverDuration": "4h 20m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 2h 45m",
					"arrivalTime": "4:00am",
					"arrivalDay": "2018-08-25",
					"departureTime": "2:30am",
					"departureDay": "2018-08-24",
					"destination": "PEK",
					"destinationAirportName": "Beijing Capital Intl Airport",
					"destinationAirportCity": "Beijing",
					"destinationAirportState": null,
					"destinationAirportCountry": "China",
					"origin": "YVR",
					"originAirportName": "Vancouver Intl Airport",
					"originAirportCity": "Vancouver",
					"originAirportState": "BC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T12:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CA.png",
					"carrierCode": "CA",
					"carrierName": "Air China",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T08:20:00",
					"flightNumber": "181",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "3h 10m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 2h 45m",
					"arrivalTime": "12:30pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "8:20am",
					"departureDay": "2018-08-25",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "PEK",
					"originAirportName": "Beijing Capital Intl Airport",
					"originAirportCity": "Beijing",
					"originAirportState": null,
					"originAirportCountry": "China"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "12:30pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "8:45pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 2h 45m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CI)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T13:15:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T17:00:00",
			"destination": "NRT",
			"downPayment": 897.86,
			"id": "3080ce76-d022-497e-b003-1d5ea69d899a",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_peXhMnBdNv9zl5xA_fBGwD5wBtXko9Dcy5G_f1c2771KO52I6TcnSbA6XfQTn0qzr7iMKxqcZ_fimZrtFi08KpM1tWv5ZYTPdDbSdtV2DfPGVvPm2yWG8AYGC5Yd72E420AKRTic2OQ3fgLCtmVmmYSPPIhTHqDqJwHLhOJJ6_fUgvrzJwedSDfhXMYJKBvmoFZT7Q06A9Y3JSFOR7Mhjl46QM8oMBDMWZifJrU_fZmpRtDHmUHxCPiqomryh8PhlZ6sSFdGde6G_fQGlLH9_fhfzsQjitck8XV5ceHPSNAJHeZOiCbxXC3TY2ZBOqEIfprPjoGztT7hzh2CYTqW7Keo7b56XWgTlN8TIC63mHG_fN7sigD1YRgbBG5M0VCkvwFIBBQFxuC_precq5IE8_paWrDmbxMuVkDEJex0o45KC_f_p92kgG6oxcSqvV67o_puZg569yHdNvtZGWE4Gjz_pd6tgLf_fQJKXlfvhVBOHEpfZGXFaf9RYL_pABbiuLjIZZsvLaoYbgBQU3l0iim8E3cmJkHHrznKpMRmNt_ftvM6RXsFcRNQQcjyAsmWv7Fv1v9xGDzDOgyVAqNLSWVfuOlbSZtkGrZBiXZVGlsrBLNIjTD9vraaSsx7cmK2h1iw9Flbk_f7k9wgeYjkFvsfTk6pBzhWtPWnaVT6QtAC04IJcH_fDud4bWM2cYABDsQ7Ql3GXVZuL5ymAXa8rFzab8HpIvZLPZyFSVowWuMzo6M2KdLGrtMGcEqBfHteuAR2k9_pjRF537D4m_p2LSOKsfLXCrifsZIsIU9V2jX_ptKI3zucLdEHW_pS_fGBZm36QG_pjK5lLK_flgCldyVpwwiyoDpzztSZr_ffSoX_f_fi7aRtoVXet0hCUCEeZh2_pHXdAAAxTy_fEDEqPaOvioAs0aaazvDpIXpyNgWaqTR_f1dxg8ir_p2FcegnymwStL0K2oJGd8TbEpJGUxr_fYNYaNydC_p2Dl5SxOsH9ZohiFWBl3x15XfsAVtCW_f5_fKo0yvpuPy6bkv1aboKDb6fUL6a73mjQXpC02K3EaE92_frWPMclLj7CxMaQ0IMxa4xKZ6Rp1ABl88Gqutfa7QLY4q07XjpSBPvg6KASZMnYFQIIWPNcdwq2miDWh7jQ_fK2gO4o6pz2AXo2XGNxztG7HqwJCKwqzLOeika_fDkxW56ssc5IcpnnZ8_fl58UQBpq6_fJxe9IJkUKCjgTo4rplHmCo0kTyHuWRnaSnIS28DmgUdO77XmcESjUVwPjxwiDVMpsNnSKUgf32w1PR3dwvSrf_pBS1bwVCaRoPJQsJ8KtFDDSs9odkQQn5SuvjMQoj0if_fPIOUcV0df0_flOKW9Gw1mIeKP17gjEJNgYvcc60vu6942pJK_p_fl_ff2lSWJ9liwmpfK_faxfH1Aj_fKQRGAt3hR7Hzgd690gZeanfwKBoMuWIVlYxXu5f6W6hL2FCMgdFVdNKhWeS7O75qtUOzTDoqqlXybn7DxzHPRLRHscI3KtlcQi7jxcoFyVGO7Bit43tp_p7ZoZB0Zw_pXrElDLolkSD5KraAJ5SHZCvUneBsfDdZpTHOGCegRLs96XV2L3Qhv2f_f8wm2s_fwTkzuEzEYcrvoN5ioMxu0xly7Zk5QG5S98CC6dxoR_ft7OONz_fa6J2PIZGEIiVpverbpY4XmK72kCJ6VxlrskencV6R3RlMjFUT_po22OiVXPSsSMcvp_fxrMF3KTgvQI_fdcfFxyxbuGIlSPAdSD2BnX5zVFuptvSqoo55H7WpGVr0NPErjXGKz309cQKkar_pgAYbVjIcwgf_pbCeBDFynNaubquS4ij8ozW58fxkO5u4UpZpGNznQ2_pnKkXpLXgjV7USVHy6Tk7YZMfjCvoR0A6IOjbY0eBvHs_fzlmzT1JHa7Kiu2RmQ9Ndm_pPmU2KD65nFcySYSUylDQ8IzoAw6MRDiomwq9YBZcIFpT13uP1PzUi6hsJlP2cSMloTFagJIMhLftYkc6zIKi5y1UtHdhUa_ppTPXA_fbsus_fkEzLTTdJ8jOMAVASJPy8IThANPV0YZPMDFY_pIiemvqO0R4jFS07vzEWvpHRWoC5qKfqffbNFMCGvopRFYvxdWb6DryrqfeAymWcrkBoVt_pDc0b6c6KssENfmcmn7YteDUzMny1E13QNJYVz_pXmqPmZ29nAr9cCVU8iFYaP_psJRucDqkq_pkvcoVRwx6MwE3N1N_pp3a9SMVKlNbiKejfz9E0164kpXq1xWF6DChi59vxS0sNu_fsmi5QkXwgIIeOtCQf10faPc1Kg_fFhMtPZ9XW_fO321YPOe8eSXr9K19pZYTWfWTI9jOB5T_fhdwVA1lJTFN40i0Sc6obA9CDGznEt",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T19:34:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": "WestJet",
					"departureDateTime": "2018-08-23T17:00:00",
					"flightNumber": "9329",
					"aircraft": "Boeing 737",
					"aircraftType": "Jet",
					"flightDuration": "5h 34m",
					"layoverDuration": "6h 46m",
					"layoverNoteValues": [
						"Overnight Connection at Vancouver Intl Airport (YVR)."
					],
					"totalTripDuration": "1d 7h 15m",
					"arrivalTime": "7:34pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "5:00pm",
					"departureDay": "2018-08-23",
					"destination": "YVR",
					"destinationAirportName": "Vancouver Intl Airport",
					"destinationAirportCity": "Vancouver",
					"destinationAirportState": "BC",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T05:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T02:20:00",
					"flightNumber": "31",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "12h ",
					"layoverDuration": "3h 35m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 7h 15m",
					"arrivalTime": "5:20am",
					"arrivalDay": "2018-08-25",
					"departureTime": "2:20am",
					"departureDay": "2018-08-24",
					"destination": "TPE",
					"destinationAirportName": "Taiwan Taoyuan Intl Airport",
					"destinationAirportCity": "Taipei",
					"destinationAirportState": null,
					"destinationAirportCountry": "Taiwan",
					"origin": "YVR",
					"originAirportName": "Vancouver Intl Airport",
					"originAirportCity": "Vancouver",
					"originAirportState": "BC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T13:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
					"carrierCode": "CI",
					"carrierName": "China Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T08:55:00",
					"flightNumber": "100",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "3h 20m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 7h 15m",
					"arrivalTime": "1:15pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "8:55am",
					"departureDay": "2018-08-25",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "TPE",
					"originAirportName": "Taiwan Taoyuan Intl Airport",
					"originAirportCity": "Taipei",
					"originAirportState": null,
					"originAirportCountry": "Taiwan"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "China Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CI.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:15pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "5:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 7h 15m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AC)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:50:00",
			"numOfStops": 0,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T13:55:00",
			"destination": "NRT",
			"downPayment": 906.38,
			"id": "c63254f8-47c5-44e9-a23d-a76b72d38ee8",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBkAZv_pYI_faYzyN0hPQBp1tEUi58MVt5pBQQbKeh3IUCkpa_pTM0nXF2ucB19fjuRkYWdmmwDUFGKxY5Ufa1yV6KEbHgxkLCvMv4gtN8J_pTjKr9SFHe43iUI4931f94AL1UnNu4MEp_fJan1vtFdGYy_ptERLHJTTRMiy4jlrglOjqGMIH6WykMWbePs9DCqdIlwES7PCmhtlHM62wNNHbZ8Wwj2Z2Efz1ZidS2qlXEAI1J2ICpDcWZcCKD3VWkvK1hxmM3gHJdoGjVUgBYjbr0Xv5vFZQG0HlrZQw9e9BqvMkMD6PZr8_pnky_pG9q5k7TTq_pDyZszM0bxH3b6I_fSXNLVEmhk27SvTqYCtUkdIjhrAxWF02mnyDEW_poaRx8IKOcgguHpj_fxBYGXxMOf3e3PlO11Y3Mza6v_fza5nyEbc_p5jjdqlTww1GiurL_fiiMVYoJl3Hv0PA8qeSb91Fwg9JOfP0mIhMGCWQpO5ovUoGx0BaItkEtaSM8mTpc2Lsl_pY7rPVuiiuvLXY_ppXSziRe2esJRBR75Kti8mQ4urbw7Y25CF2nnkZdd7Fp69MLPeTx70P0N4I6iHcLvB78iMS29xFgJK9HMjxvvmUX65EERbM0rhzWPizRM8WU9futbM8_pvphD1GdV8Dr1d_fWhVZdr6ZadyBCc3uGzIk_pjInIggkgmPhT0fV26ApFhvcxJhKIzk3EJyEJqzkyfGR_pR2KPtBK92to43_pP_f8bzaMxdPb_pBIQMgM54bqK14W06MQkHaoygiXp08c2MQy_f_pVq5hAY_fNWRyrO7tsKP6IiJrOxSaqKegB7zRY3edkhaBAcxz_poXzRL94zlLXTwHlPf8tH3z7FZaG4D_pMdeugb9drJxlXMk_pOc4iu_fIkXs8O6iGYAYelLc1ok2TFpSFcB_pshIqkkGercCEaDkK5anUja37JUp1Dev30ouZ6O4gSd_f4qhAq_pAG3pJDMa1qzbdiZEf_f1RcB4DwMAkezD092nTUm9oUNwUp8awZ6oV38Og_ppQlWXmied44IuWc3_pXXV8Rq_fCwbwInz86XsAFK7Lb7_fSoOfEbVMu8s2o2ONn7JNQF2eHdkrbxJe2f0VH_pTAetzbesQmJj70A_fJazelCDtgCR2z_p69vOQmOWwWjT80BVU1W6CCxOT_pke9dvaICVWuUHoUfz4t_pBhyuggGBVHDBTAadhL2ERakg9ojxJ1ppaxenaubqV8LW0KUFb9VSYQfgiuo7zxG7ZQFZmXWJ8wZc2kDGmtrn22eNKm92ZbQjqWCZ3hbLr44lxV2Xv_p13ZUnIY3R0PZ_fUk8lon8EjKX2_fhwr19xgdQEs_fhW_pVHvCIisGLPhc_pzjIHVaXbpNBtYsmocCTgOwqxLruIjDnI92aHVowr0bepjRQppNNT1scsh8QeSPAjy4XKa8wwoHrbZnn3mJrXxDYi9A_pynmuhrlgRS5GWSvpGxOBnYceFuK8g8op_fBKISCOqPxqX4C21RZWq9cfx3A213Q4d1CKBNFPDx8cLcXw6e4vyb_pnudX41Ar6zmeDz0uvWny07c9Fw8dxXsI0E55995qOupddv4M7ZsVWZI7INU8cLAV0DXg_pJfnYwmtDsXMjZJUHH4pCtvg6k2BV26fk60HrT9z5aRWUoXbBpqCTCDnDn0B_fNowBHEt13v6_fBddDv8ZpjN4P1_fNhIKRG15IYzImT1P73CpEpxzhQHH8CNf8_fj0Q_fUpIOg_fUTGHzIpMDF9rkeI_fhCJ4uB0KlrwwW5wmqxU85YV6FbufefBWXxyoXuc6ZJnxHekpLsSrcE8TbMe3In42pgcqoIooAqGmkzn0feQM0lfcTPQtTHiZYEtjH0VA9lujhdCIq3xfyoMreHpHFbP9s4smaujtmYwvu9_f_fEcXXfxTfIRBbtJMI0CwF7Cesjsukxg3npPeGV2XVXuOeWdFtLCFEBfmzMXTPhrHEAJheOyjOEkHJ1x_f3STlKBkooKlAIMAytZmd83mX_pyBQU3EiFLtmNrVRBuFGOxRxH5uAqzB5DuCUcKhWDc8lKLZNBX6cOT8G3jFJfY9PHgWj6pmB9WsszTWMEYE_p9fv0yEbhF4C2RZ1UMRugwV6ROrgD_fp4gVmLnf8XMc1RQUl8KaRA1yaJ_fnHYnZGT5cKyTt_fCy8j1ZoF04Okwb2k9WGeZUa5cwAPb6qXla2_pUCv0u_f3qZl7VGYu6QjoMKkYagkeKVRg1JsPJQeZlUZ4Ix8GbAopv4b8ByuMr82PnlbpnmwntbjUpi_fUIDu7sP50",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-24T15:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T13:55:00",
					"flightNumber": "5",
					"aircraft": "Boeing 787-8",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "12h 55m",
					"arrivalTime": "3:50pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "1:55pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 0,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:50pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "1:55pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "12h 55m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T12:30:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T16:10:00",
			"destination": "HND",
			"downPayment": 908.9,
			"id": "53acc921-ecbd-414c-844b-d18b94060dd3",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pc02JOYkiEOkigYQvOJ7l1ttTSmVleE692JdLGYyJT5GfEoF6bwlVjxabvNGG6rtKk_fM5G3w7Rmw4W6Dr8z_fTNPqPG4CeRF_fvuSws6jtcn2Vfb7JNQmvuSQGs7ZSQShgr3lHrHiOpJrfaJ4i8EMJa72z3U_fMOxL0VhcfMha1Q3j3PKRVb7_f_pxInYZ76DMoonBDoiXsP25ufig7AJDsVsExMt_plUT54n_f4BGDpYkvQ4HHtmX3DbBlfMqNV4EolRXAoDyTC27WrixVtsHDwDS6l9Fd_pjwdqiuDo3QBt8iRtREyOnpAjvf4y2fu9Qo7EAqrMOefbjA03GEEB8kiEKLOnuI3h3Co9T2A1risI1kURvGguwCdZKiNO6yiR_p4PMXacZVoqSjMHkn2OgvrXhZMOw9o6ExmHdrplBcEeCs_fv7BttODS4HMVWYCSmGiQSxZpsBBGv62v2zAGcCQuy1wboY967_p8I9WyN4C8_pd50By0AbOU_f6MJzuoIDY3c55Gb0zkB3ur8UTg61SdPM45wRohS_fu1wakyXKXb2Gdz2_p2JJ1GCC3qG8z191z7o_pCHpcJyIOPq64HmLKvUh5Led_f9FD3ntblHjfAWhQKpyIT1pK7Ci2SroHtR_pzOxhaxSAF0oajcQmoR1l4UW8M2AV3aTqYwRZLJnuQj3OHamw8dt7dUIosMcjcHjUiN_pDDQ6COy_feSlydexHR0S7vCt0Q7TYtKQeEivOFJdBSOBT8vP5kiKMa5ZG8lCiAm45fnAi_puVAy7AtBtLOmR4WHVd1o9XaevpxWJ1UBXKltauAIYx42eUmlL0FFVsxMVMk9_ptWTFNqNNR7OFb1ygr3WtS02_pBmVEg7qi2deCZgniQCaKSC_pgBk5s7SpovM3PHvAA4O5u6cbJKFVtE2AmTCyuipp6etPVjlOMxxeDhn1z5a6hdm9QFCDQu3YdXtQ3h6OcX8V_psqGve2COb5AlgG_fqzYv6YiNs0AtoI9wZL519QM2Y_pr8WgdnMHpwFGAG73_pLSZU5jvo4RW9Gkn9DS5u1fEo9KeoUKuaLS635v8f7Ol0W7a9W8Lg0vQNuDL8oc4qVga89wkN0o6KDi_pHeL5Y3ULFE_pcLbw69gFjDdSrzrf6GAXUw5cXuVj4kyegPVTtbnYbQDrkeovJpk4bF_p80qs_fSZuoe0B7KlSIpDRUj6kWmjrzgxp5jYHmPm60Rn4JxoJ4JiQN8OeSRxOOF4YARAcSxfTX7_fgLgXwzNXaCi8EFtv1C3yud9VpJeGuktTrLYsApsDjejNnYgL1zLhP_fZFf_fMkqQs74fTt6E8cIZE_pLn0nhmh78Qm6gmpgL_fmzYz22CZVRehD9sGsIEqWyFK4G6ovibMV23kCSZvlo_pBVCB8_fju5qNeumZFwbX15J1_pzqxyfWHmcsvlz6wHWocrqse32aYuU_pHLXN5WokMOD2285dW2FesBPFhXrKX7PEsh1KOr2MNVfn1E3l7xZTms_pQ8Gj7pO8anciYshpAC9Q160k2MtubmebdmsyGcv5RCiUd7eDy_f1OyE6vbcv6tn5kKzzxoM5kd9GDFnxSj_fojnFcjM7qsW3dVq6xkaSOtiGZ_fVQmu2VET8s4sJqXgJ6_fgUzZ6rYMOb7tiOEFMbouGrM05qR2cDHNNnH_f7mZJzXiA_phjY9T1_f_pCvmC9DmXXknufm5dq4mRThXDwZ7uNkrfP61_fx3WytasNLksjIldMcReSnORTLMaIAtdfGwaY0VsqdnOlZrKFsg7WFbEuWXBWYC5UOdq9fBKFSluIA6ZmqP1RAKrk07z9ZdZgqEAMS4C8jkHN84mLEFVXXwX1LNoAIPGQKrxiAuWvjS5LDgACSA19U77FGaymU3d3IRV67cvIwekVTYllYMoBfEX3RQU9aecJ2R4JYdd6tQQ_fBpXsFql2gSy1rK3_p2LrpkDQXvhz9ypD0DlAPHYE3_fHQPHG5A1oi7npO0P4JAfqZLsqbFj9bHHoGxxytNuLrpWzS1Z_fOcXaYoOLI7fMSGk7lLDUA0DkELYJ8JknY9qBftyGGxAlZpqP41LIZd47b_fdW3bXgxBcQFL3d2GsvoDvmew8Faz_p4HqyOuWHRbZowHXC3MuggOue6k5mjcQhTG1eeeUej0LLx8h1eyklfq8DZFIjBRa0JHaz4k6QzuwEGqTWiF3p1xVbdCR92_pWH3tEL7elBL5pGkjD5QRXc65x7rMuZ93vxK4fyL7huLFd23sb1SSLae8szzX7_fUKmRl8iJDmkqQAsgXWt_fxa3ObyfgNz0ngZfZ1LfN_piMDZiSsbUviEIrBa1B0PdBvf1sg_fuPG9s6S0U",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-24T17:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CA.png",
					"carrierCode": "CA",
					"carrierName": "Air China",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T16:10:00",
					"flightNumber": "880",
					"aircraft": "Boeing 787-9",
					"aircraftType": "Jet",
					"flightDuration": "13h 40m",
					"layoverDuration": "14h 30m",
					"layoverNoteValues": [
						"Flight arrives on the next day.",
						"Overnight Connection at Beijing Capital Intl Airport (PEK)."
					],
					"totalTripDuration": "1d 7h 20m",
					"arrivalTime": "5:50pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "4:10pm",
					"departureDay": "2018-08-23",
					"destination": "PEK",
					"destinationAirportName": "Beijing Capital Intl Airport",
					"destinationAirportCity": "Beijing",
					"destinationAirportState": null,
					"destinationAirportCountry": "China",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T12:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CA.png",
					"carrierCode": "CA",
					"carrierName": "Air China",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T08:20:00",
					"flightNumber": "181",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "3h 10m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 7h 20m",
					"arrivalTime": "12:30pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "8:20am",
					"departureDay": "2018-08-25",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "PEK",
					"originAirportName": "Beijing Capital Intl Airport",
					"originAirportCity": "Beijing",
					"originAirportState": null,
					"originAirportCountry": "China"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air China",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "12:30pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "4:10pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 7h 20m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T17:25:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T16:10:00",
			"destination": "HND",
			"downPayment": 908.9,
			"id": "2be2e3af-9b93-4060-9a94-1f7981eb9864",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pSt1cSAnGfyXZ8YEPHDKAaHOON6gOuecx8mE8PN2O_pTL3Rc6raXTP5FL5vM_pJKJ_fxsfsKhPZTkbsWDAESolSfX6DenQetDQcrgsq2231Gd6NEpYxgu1YkBxW5lBw5vcdfGdMZAafK7VuTrOzekMK1tOy0Jv8VQQta2e57wGP3xs1biIrJE8YfPaQfahwtAG4Lh8ydXH30Co2XJjDGFJiNW1_pRtmcP6OXygWoRGv35tWtmi4X2MvFQUBlWPtWCyJ4Xo_p_pdFhAilNVi8BadoNCDjv0CuWf2QOvpisK_f3ym9xhbigQwOAUEHDfkGAgLOuirKdIeyKidZzO9plKhy0d8SGww5KDtT2hW47soRUmE_pbLFxfdhckwd_pIvsKiuJmpSC6bd3dM7oyXuaR7_pDEnsbZz9UHCGWQh7_pgzffEe5_pNU0Ex3gJ0QMe0dTOXP2T5XtvIH8o14e5Z1DSiw54BbIivhvj9if_fRyYyHSPlvjopLQdXluBnniNEjYDTQlT4yntE0bcOz0RYd9gMt1b4cvNeFfkFYxtKmOq5QxKUl5XwD1cu2DcDygOadb_ppdDRDNGUXlL7z8ilcYAr7BQdCFe97OfVFIQfuRtL_fovLySnIp2GYaO1dFdRim_pxMF_f7VgkwYOA1RwDzfk7cGPrD4dKp4JJHAxxB6EK8bDIfMSlexEHJCH_fptvTWC01EKKHhfX8YzVPDdzwfS4o9twiabYuS49uzlfPPz_f4sLAKnXbLMK_fi9KUQc338hAI4IVqn_fJl6kXHaz2aa1ZCGncwkYtcfmsRv5mjdc12qNwksDSzIg4bulPznrKPr4AK69fwXuRMtwI3L5W_pduy_fFGZ2JymyQrFsDsXTVU_f4LLPRvagvZsBO_pdfuGB6lNOv3v1TZtnQFmRzW5jgqiDmHz8M_f34ultYOMMVLByEYrlsu0cWqW35ruK5BlnPwB_fBysg_fWc5WKk4H5t1lairKhBYAJtCi_fMIWHkHXOLpwpQVrCxWsZuIhNkXzsEbzfKOO3NbhHu_fqcAzlFMwFMZ99_fspqUr0Sh7bRCFi7ThWK6tEYXWCz5oF5mmOM_ffPS3a_fcfSZ3ocI5X6E53Coj_f3ZsSx3sui4QPI1wZClRuo5cUF9L0t0IuYzzQIrllpBlRelitsBmJr38NNERxXGVOeT8wF4SR_fsg9ekK6KEMGuxNIoHq5KrjEVCgCmM46szXrcuhPBnV48Wx7tuC3x_plgEhN7bwLGBVWusWZPFo4_fPEGSCOUkVEfOWan1IFNs1mrOsivyFVW1KONuNCOFMg_pdSShUrt0QUcOt4UTNFsSXWy_f1s3x9NY1XSWBy0SZQLajl_f_fcgG_fnrJFRmSQs5ItkS5a2qiJJHrPYsaN4YtrASbJtqgIbpvLBa8wO_pb7g8NniRDGgk30fQxnrOCBPGafn8Sa1HwMZ7S6CZAcYKCIWfhDqwv3d8O2wZ_pBIfuncHhtceN7lUjuogu7r9hzzfldWQsyWg5EyNpit03Yt7aqtcs44y_pQfCstV9rKCHg7ueD_pVs7vqZ5RAFfPK0_finrvvNbx_fOWBhZDs5uUlZR_f_pFXe4Lj12otNqJ41QS8Tgf0HEkgSLEt_fQ6etTRiauGjX3sKmZf2Cui84s9UVizb_fy3sGA9atnOwtqm9T9hUviWT56RrNjg59ptSs4NthUrDp2QZVFesYfPBPubgNATCryX1eg41dLa3yTpW8vCKlWjnKS9g2Xgc6mawxVQksaDSunpC3rZHTWdXe6KKn35ryRuEf9PMEuuoeBLARyQtxLNej3pqtVxSGGD9xiMo7xAZUWGptnuciFLB8pMeF49WmRpnPgGIVqOhxdIk7zhrM_fmNsak_fjVjyvxeL9gP_p9SrJASkRCBmMjIrOdm_p769_f7axsnvC7ke5rgGIgwHXbgargtNZthX0E1jiz4IH9VBzotdWTcfvWAEh_pAvB29ww3ein67DAz7tK9fSjcfrntXzudawvILho_pHFNFmoEl9E_pisepWwcHDxY7AkHYRCknVvMjoed9pxfv1JGKs1lhSfsDz4StYPnAZun_fMOUb0PKlWdIoRh_pOL17AL9M_p_p87JIgjqSfWG8ybivSYVI5ctca4dCRSKUKPhmo889Gbo1zftmTbGMm0BnNEv3elmWyb4778bLZhW6ic6voiclOoUCBtI7cMDVY_fft0R5NWRcRxagBsGg2464YR6xAJaesoAyRi621mcQC2zTVPQiLFCQwNa0RV8_pGwYfRqs1S5lmz_pg1baaOB5wFhrku81K8MYpBUiMA7Xu_pbPcPCI_pnvwVMBqcEoJAaqKUEYZkR6lk_pDVDVHdTzAf_fPTyY",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-24T17:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CA.png",
					"carrierCode": "CA",
					"carrierName": "Air China",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T16:10:00",
					"flightNumber": "880",
					"aircraft": "Boeing 787-9",
					"aircraftType": "Jet",
					"flightDuration": "13h 40m",
					"layoverDuration": "19h ",
					"layoverNoteValues": [
						"Flight arrives on the next day.",
						"Overnight Connection at Beijing Capital Intl Airport (PEK)."
					],
					"totalTripDuration": "1d 12h 15m",
					"arrivalTime": "5:50pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "4:10pm",
					"departureDay": "2018-08-23",
					"destination": "PEK",
					"destinationAirportName": "Beijing Capital Intl Airport",
					"destinationAirportCity": "Beijing",
					"destinationAirportState": null,
					"destinationAirportCountry": "China",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T17:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CA.png",
					"carrierCode": "CA",
					"carrierName": "Air China",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T12:50:00",
					"flightNumber": "167",
					"aircraft": "Airbus A330",
					"aircraftType": "Jet",
					"flightDuration": "3h 35m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 12h 15m",
					"arrivalTime": "5:25pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "12:50pm",
					"departureDay": "2018-08-25",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "PEK",
					"originAirportName": "Beijing Capital Intl Airport",
					"originAirportCity": "Beijing",
					"originAirportState": null,
					"originAirportCountry": "China"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air China",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "5:25pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "4:10pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 12h 15m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AC)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:35:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T10:00:00",
			"destination": "HND",
			"downPayment": 910.44,
			"id": "f1f3b34e-2ed1-47de-b185-a12e3345ca4c",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pRl_fx3CK3PmmNxfr6B8OK_prrXR4b1XEsHkteXESejSKvNC_fQXQWsc9xt9ztVAEX2vX1KbHDNekTOq2S8hPfznUKnt1_fW3yruMlf6k1z_fhLKCRfv61AxmSwTab0wgQc4hd9zkxIfABTK6UMVvLcXCiB1NfX9gEl7YSFTykLL_pm4EeYNrTSAuFAqN4Wlgac0T9NNjZ7xAt7o_p_pY2Wmfw5gr3C4sO_fC6Skrx7gdAojGIVIL3hdXIQ6telfQuUE7U_pkfsmsh5q5R2Dp7Ot3oCKgqeV1QBhb_po3AGMf9RNvk_fWb0EAXFpptGet_fQGPmQjWOO_fC_p2qXGqr1zcBr0Ho3JypwKWFmqAeB210Y03WPUtG8Xbp2rSw0TQfaGvzrtw2gVSwPdbo3tL7b1BYk8hodIbU6ae5sexK_fF4N1IQ5170TGZDFZAiH0x1DivwM_pL11xlR96kT9zz7Fn8DC_fJDz42NkuA4L1t5UG3o_f_pRwEbsdqZ3IH7Jsj9M57ZHZTynMEwLLVU9eJrP2E6efssfGAD3GIF567immFLpwasL2J1aC0vdtz0_fZmn0QwiehvAihSHVHXqEiDotzeJ8NFQi0ROrTbxDJPYgxX1HhcQbiu4nf0bMnuYB2PUsefMlt_pvUWvGeY1J3oa56rmJibRTxIrDgGg_fUkotSgsVa_fG9z_pgjggMriOWtOQqDvga2m7FE8shDJX0Mo7WePEGyRWv0KDos_fWzcx_p3iiZ_fJ7gVejYPCssq4T77Yp6urlzt0BkDTMB_pG8CrwMkkHDJxRu9ffqEh569E2eZezVP56A6dzyZSUFU_psIep6QjKfBb6t8gm7ctRILbbJUlsQPs1mvnjdjf8nguZeCU5kEokX_fB0VrcFb4YyEJC_pLGpxL2BIbJs50raE8nEEhQ4o8_fBtByrAhXqs1RMtZfJHfmTisxTn6ObIMY6Bk5VFTJfyCtNJmAr9YhRwGUkg_pREVrk9fTao4C13_f4duqj9_pvhuN1RVuxzkOdEtrKp_fEbLVMLEAWNpaajh0tMnkadTWtdz5pVd5j7DpDt4rdA1V2m_f061eCa7DB3YXcBRoHLltCTcVWPVyBeEubPxGIm7rcxFRgNi7Ly6HF8w_pd8rzmsN2rCIYjKhbJnumM_fC2wikeoKVQs1ZmXWC3C4t0ZHZs1lqNdS8iXuUiObfru3eVPH891Plan4N5PukL66tGyFOSYG89seGBI2p_pi8AcIe8rwRLfN0R2pjlMsNCy7Npd9P1cnYHuoDYPMVDS_p4nstToZxjX_fQEG9wIO4lO0RIsOER2X6OhAWkgMgAS1epMdGSpVUHyAy_p_pFD_pOi9jex2I0HglEGQqAoLLrDDCoIBOK5ujstXV6p5VKws47YVIuF67WFoHQtamvlTXZEY3rJRgf9f6QW5HT_f7slXcrhz8SGQjLi_po0wYXxlman2kP3kP7nEkIzr0W8n1JQM8zHZ2HK2r40CxGpEawLduDlYpMJ9ONsESikWV54GP5sXJo_ppm2A2YJVgtUrxpaykGVeBEOmK572srOefphXWsfJ9CtqtycHjjFYvwZ5qUtWaHoJDQFupsKcpEV3A365Jd2l7jKatpnkPa3IwJDA3aUC78WXzOywl_pFkpDhUm3uFvjOJXhyt8SrE29J0XUxu67pfEwr5guaR3NHOsMkpPsw4nJAlOtyZqzU4xm1TiuNi9lckYZYEjqjA5sTribaCm7xR9Ao3JpSg4cm_f_fawQgJ8x1hSxRA7gqQRdvBJsOovCV0xijMwXCQ0ZbwV_pb2QkqtqlWV4EMjaVDRPm3F_pOVur4873ZbCBLaiTxO9EBgNPSbAJLohOYQX6FeOygtMD4ZAUZ82kqDahBa0Lu9fZQ1iCFPgWsoRfvvCvC4sSF3DWSPDU2rCZgeqmjS2JjNvQz91hq3S6kHxcamoMPehRIqjCULSbmpbL2Vw8Ashy7TKMjdkeUlLzu2rkrtM_p4b2JOBXJQtO3adrcdkiguE7NgiMLqb7chbliDWw0J2Jt5j_f9kUJHL0_fY3D2131QovfyeG7VIzMOuHxp6U14rvY_pL9tSrJC5VUSNKgQ1WcDZTgR15wuY_f82O0JBCDlNXlt3mXbaRAYGT0STMnJFlfsDPJhH_fMJ5JA_phXWF2O4UlJSRoXU95XxnRzPy_phIZV9v0W_fiEAA5V_pj5WlbwebGbxGOVbtJKn5MNcU6VeOWvzbfedPnoNGPYRghH_fNjA2HV7jwNeTbg_p_pHpWNyhqK2Qn1178j6AKCYNUtSScgRthiM_ftHHABjGpto9jhwC8GpyCxUolhG_fY3E0K52wG6ulVAQ",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T11:19:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T10:00:00",
					"flightNumber": "407",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "1h 19m",
					"layoverDuration": "2h 21m",
					"layoverNoteValues": null,
					"totalTripDuration": "16h 35m",
					"arrivalTime": "11:19am",
					"arrivalDay": "2018-08-23",
					"departureTime": "10:00am",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T13:40:00",
					"flightNumber": "1",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "16h 35m",
					"arrivalTime": "3:35pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "1:40pm",
					"departureDay": "2018-08-23",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "3:35pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "10:00am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "16h 35m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AC)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:35:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T11:00:00",
			"destination": "HND",
			"downPayment": 910.44,
			"id": "d8370dbc-4876-427d-85aa-ce7aa3021801",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pTfJHcPhwy0cpKH5HNuGuj9s_pmXc9imG6vLX6o03h71Maon1XtqbtYdhyCwkxlqNrtA678sQFw3uOJNEfTQiEXOwJx6C96k6LtFdSki4un4EtGfrWrD7bbs4LdHGDPZAkFbytBsNngD69TXdbGUktxB7V_fuzRVh29L1zRONSDmlSe0BHmhdyjAYLYOq6yfME8D_fUD4b0ZDQZ_f8KnLyH2h7nTXKqUD4gpzCCFA22IXwfHJ4ieukpnJVE1DW5QagXgQZ9XqOKzck06hgbHJavcelBBlZC3U2kVuDgKC9C89LZs1vMm1OlIarLl65jihlrZxVncc36Nn3Zuj3_pPDsuXEGrRjsMwnHgg2oki51ApHACgQ9xhCKOnqUN5nW4RObqlhCqsPOfHxPTW8bAyOqx4jg_fEa9_pLsyFDk8JG6G7rSMIEZ7cwmt1Dq21M_fA2hguNEWen4j267djyKZCqSDp5ne4QfR8oKeOhTblPYA3m7DQU9TzlZW4a3taZbIxh6EpupdwEnNjOWXA3U9sVNMO88AMuubUe7lGAg1MzDi6BJEcM_p32bKZw5LL0qGd8ks30DmZRtAeS9PPBKV1jpMmU9Zy4IQeQln_puFL6rFGeruBE0AI7_pbnnGWnoCSVjqwVfxkMHMynwHKcvxeTutZGUXwxsdRIBdcxfGETq0XPxkQSKzG_fYvOF64iJWKecccWrmM_fi7IqsNoXnhEYjniY2Xh_fxdTqI8n79_fIFFwvvm52GHGpnNSlKEpu0ydboniw3aAKbgD_fhKdQxwE1o4GHfHm64OICO5_fo6ymJwHkK0PTRnxFbE11hTbdeO7e1tDKw824IJ4A1zbIaC5xRpMJlzj5O9uut6P5dNxsvNntklhqp02jxsaZOzWLpBkrmDbGeJzsJlVyavLHFXZcXPwThTMLPnU0jyUTY8vJ8UeBoprkGZTHqsMHluizbRgzRi_pDyjKXF6KdwzZG4Jvsz0rdmJth22QN0s3dSyWkJbsk9aE1X0eSNr_phRoQdw3tIZxw6w_fzclUEqIU2tDUM67jaEkqKq1t52abrkUnvrUA81pszbNhwR_pmKtr0DriQHbfhyL6if_pbOgyh3FYuFv0euuTkq4Pnz_pk_fg2eERZ81Z8crtRZbA3y2WCHWG7IRe9WIu66eP2Opm0ll3Uf6jup9nZim_fNSAhZnKOywzV7ZioFbWKogbXadj6lLLau_fziWXxHqgauzZbDq2q_fhMNI8NBmKJpn5PPUz8WK3bTg22uLEaxtaClkVS6e9_p4i_pf6tIb95MBQuGQyTFzPkKRV7_pSzA6k05AFuB29e8vC3LXggMeJn93xZei5Swx4sL1l6bLFT5qofhyhO_fJgR9QUY7xnLoJ5Yn5GoJZT2_fWb8Ky_pnlTBNQ79EpqCEkwHnlb8aifGqXXsKcW4E6EwEOJHQi6KwZVsbrOyx1L23njk14PJ0YxhoUdk9WtUKuCT1xbm1GZ8Az_ptCwDYOhR0bAl6Z4iLY2UVIsoxLyeIhmsye0tyJTqZiKl1W_p_fNY_p_fWvHRK0gddx2ir67Ka4T5NbrdGlpWoL7wpv7yCsjRiIombCbTnb_fYgls4CXJ4eTTDci84m_fOdP10r2rbVN8Hy3B45N82d_fG_pjlDfw2t45BaMTEbTKvB5XWVvWy9Hytk86M29a4UyS7qzLkSn6QiSM3L9UnQZbpiUxn18_fE5zB41UL8fIJDihGneBU3nKzipNCft_f373m5PvcULEzimdpbBUb13hVs3TJfXhFTNS50h4LCJAImCJBsvReSZ5AO3W7ROuxU_fWnMh2QwWDmbJyLns1Mi50IKb1FEa9xEPWjpO1_pjq120f_fG8N1_f56_p2fKRDzU1_fbTpcVnLXSPG8psuzSmXGMkl1ssnfgcHDDRZhhtVGpPPS9g6q4S75si_fujfQ3kLLq7J40u_pk1OEE6wV4LnHT8chjVVMEfa1vSeT_fD64qJZ8FmFloIOJ2SYsN0bkw_pHL5jsC3FZVnXtZEbVqs8SajmwdxfhMhbDgWRRBbk5aFNjCN7dmRZ3dy3mSRWqveC_fpFRRU_fkheAGAy5O7t4xCl5n9FCbftjrI1QVIowZx7SDgwhaRD0DUWIiEK_pivd_pAzMzFzy_fNuZ3R00_fBkkw3AehNwvOuQErcaYTF1IILmUNa4XPnmjkzS387sKsBpBYULb84nsAKnJ0i_pfkGDTjKzzHZvezJjcq9lh8J_fnpfOGzOTHEmysKujMZK7B2VeV3Kd1Aeiv5LDnHtqysJKNBjqTNsD05UuSWbp9vUGxDdNlezLtsihobSyGKg9cDQg9ahZbHNSjw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T12:19:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T11:00:00",
					"flightNumber": "409",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "1h 19m",
					"layoverDuration": "1h 21m",
					"layoverNoteValues": null,
					"totalTripDuration": "15h 35m",
					"arrivalTime": "12:19pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "11:00am",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T13:40:00",
					"flightNumber": "1",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "15h 35m",
					"arrivalTime": "3:35pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "1:40pm",
					"departureDay": "2018-08-23",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "3:35pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "11:00am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "15h 35m"
			}
		},
		{
			"baggageFeeUrl": null,
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:25:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:00:00",
			"destination": "NRT",
			"downPayment": 938.43,
			"id": "47b984bd-aea4-4cf3-b19f-5126ed64934d",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pTE3LlYqX_f9IVnzoVCT3AfHo6dPGzdUsY3O7crpdiroUpmLve9lBpPfp0TfroLvmTqtoizOMlHg6HRJjQa7QO_pQ_pE8inho4uyTTBaFOUFPqWod49Jwi5WK4pqQk3dFNyZKOQ_fZovlCriwQr2mgldehJccVlwIVb9HrYFd8JQJvshYN7ptVGtOhQqGjJI6s4LirqmsRmchZtdUpkMh0udTVuDQOl9N6cgn5V1sjVJn6enqiVmOkcySM0WaFZxQmKl_pLXNJHuYxd_puzx0dYmWKUCrhMV83FQACiiJV4jAgzpywdxcpbHkdd9oHYgZurdI3dnpYUmj2kvu88ACuYmMSqRb1LqOBi1NSsGoT7GKFUgRZvAe5lVjDLCF4di33H3Tz_f0ybw_fdMFOgSLQFNxQkypQ8X_pVpdaMmd9mphRjddzawZPopFYXOM_pY8yHLPbhi3xtryUHiQMOJDkuE25qHr7HQs9716ApeuwrPjRPxEM9w8p5RchAMSOkGJtVhkcPgwNh2sA7Lr8JxauGIXX5KqI_pNlYXURUe6I1UCFAVlIFJ8prqvPzhS5CYlZx4Qmwo_fcu_pNYOP3ZOJ348zF4R0VCb6TPV1tKJNIeGvx4ArY_fQv82d0yHB_pbQdyi4sn0B85NLOgUYLhzi8MZoWAbbRJh0Yr32JKWsA75vqnIfk_pTQBI_flxDU5ltA6_pjfElklJsx2qoS_fNGN1BnwPVLME3S9GTP8WnxOt3SgSsclBBij95HiXWtomhNLIVDDdtqMrTnukTlPxkL90T_fohDpwt31K6Rp1mqIjweZYCQmEydgdEn1N0Ra10Dm5TMwqRXDWgFhYW8uVXa_p0eqjimZzVDcMk2l2fqFI8mBa8VJbZAnWvXcdNqH_fAqToOwy_fDVfLixm27CDpo1L_pgoXzDCYGXsq_pMVoYTBZRP6vhz5pHP1Zu12L5tyac5h_f62FHFrj95knDVAoZlOWqLfA2II26r5qDQdmrMV_fDpPX7DSRRWv3XqTfzl_ppCfelvrDPk7gk3Zvtn_pWdQtPUCKHEScSsUpCPDpRdq152H_f5Y0CkLTQqpk2QT7q_pegtt8o7Wd1zBp6gGSim8fW9lThp4OeJn_fqLWQCTPn8kyVzSTyQKfBzcqKjS8Btn2Jf1WKOi9t_fHw7JtMNVzU9CzP80GzBai0ynCjr_pbot7DewBbA3Sx_p2dfuaVcQch1jvtGWXhFZ3KY9HkJkQnw1PcehCuMXEImxgJUtKlEXjtdAgCBPpUEZSYxtHBf0Q2kvKVx0ZtM1jlBMZNGzyJ0so8sdATlfkmy1XY7Dwy8nQjxcqpYz7qFi2UBtmKy2QhEIEwBMBu6J5kfQkkoj_fipVeRIKkfbkaGnVfYUl9dKT7A02qHz2jpkqWxAaCC8wf_f7gv4xm1iAbgXzTWtmKmTnLlclNGCshPttl23QKACyMv8ocAJP9lxww6b6oGSZFeTWMqg_fkchyI_fiHRaziBbPGhFS74NOLP1RKfSqo3u8kxftmKVKnx2GSpwZgqPboqB8gI_pGfx8Cpr5uQ_pdIxP_f_f2KcV7kwbmAygeSACMfC6ZBiC6udY5Dathju64f_foGA_fbGW_pukCBk9P2yKPdQ39jgg55m7y1pHE5tS_paBnsgwxiu1EoQpBdvXFYRGGk_p1ZjTnSKCme2rHZ0lAjpwX9l8GPwtaUGOFaspzmkeTkdQoSYfE09z5L17fkeCwKVUnqpTDDUlA3sywKaedA1wQfA508_poHxe26g0Zy2fNZ7x5N5Uo0djhXoVKRL0ihR0sQcTrU4cUCItZXK2XQdfrY8qz9Ht3Ns_p8_fcIWqcXXnqBpLpI9R_fH2FnXb4ppUcivj026id6UUuPFsf2b0lH0eFiQ_pJ9nCM_f1TQXcU8E3VV4Q78Y1Z4eQVdPFIvGMygNfX5syyA1_fEtSiZYt2TFZ3eX7NiiGQBmtBlstDs4vFIb6_pQQU3E8mI88pAM_pfCZPLUb_pkpJhS9OPCd_fHFf6uSILC4umxYW1rzyHzUzHG2rj767Hq9B1Dh7ekmIYaKm_pRLYXDYZtDz4SY1Y1CRaU7sLu20Kap_f8FbAlg7Ur0vtNkD6Z7DQi1Ii3i9GBl5Y2XGmH5aSPWOIgtzJEYPkmwdjDO05hXHB7yM_fKKuklpZXNcCeWrGjpmvL5zzPt0M2fus6HAf9ETGi5bk5rHXDucx_pW9G9do_pDuS9Hx_pWyDE5uOG6G7YQ_f346ocrnkJDIffiWVZALj3Xniar3AALLKgvkwY7vgFJ2_fuJF4_pNCGVeOtP8GC15jJAznR71HHz2mafUlw_fV2a_p2SQz_pCuZ5CVAXyURspDtcFsr3Qi7QtwVPM",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T07:53:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "United Express/Trans States",
					"departureDateTime": "2018-08-23T06:00:00",
					"flightNumber": "4750",
					"aircraft": "Embraer RJ135/145",
					"aircraftType": "Jet",
					"flightDuration": "1h 53m",
					"layoverDuration": "4h 27m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 25m",
					"arrivalTime": "7:53am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:00am",
					"departureDay": "2018-08-23",
					"destination": "IAD",
					"destinationAirportName": "Washington Dulles Intl Airport",
					"destinationAirportCity": "Washington",
					"destinationAirportState": "DC",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "ANA All Nippon Airways",
					"departureDateTime": "2018-08-23T12:20:00",
					"flightNumber": "7941",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "14h 5m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 25m",
					"arrivalTime": "3:25pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "12:20pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "IAD",
					"originAirportName": "Washington Dulles Intl Airport",
					"originAirportCity": "Washington",
					"originAirportState": "DC",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:25pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:00am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 25m"
			}
		},
		{
			"baggageFeeUrl": null,
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:25:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:00:00",
			"destination": "NRT",
			"downPayment": 938.43,
			"id": "cd19fd1c-0894-458e-aeb6-a0ccff3a1f8b",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pWtOcgKoqqlg3adSeKfmDDHlUJg5QMrQyC07GLyNTN8Bn1YyqVxbKD_prSgcTHvmknkrcJKjVzrd7kvL0EvrxGYQ2vAL73fE89_fRNTjyFAC7dRQDtSRKomwoykN5oHmw5nuy8KRboSA6gRgA6zvAfyyjudRaZeQdB9yO8rrRUzQ2My9gUpnOHC1Km_fCzNdOhjzRMC8HtN7D28iEE7MV90Q2YeMze3XziDGn36lChuJfHfNzo8qD40hLQw_fv1VavHFyLfQKfuBfOB6_po53_p_fCCtotDxv8LYZPCGtheRUX8Vs6eq_fmgTehBzxGc83dt_pxCmgspIsKRAdhzWQOz7d2b_pHEMbkSk_fkL329GwxQTIzjqFEqO_fdYHQjgWrSCyyNSoDan8DFfHgeUfeYL3a92HkgWfv3Xt3wX13JGRF_fafiiQYJ67rwgmxfLRmn_f87k9GppzIvyOLacJMUr_pSTpbk7LeUi9KS6R72x1uVtgu3QJvFLnlLcfynI7RgFw7SI37GlyvDzjXk1_p6uYJt2CJ7tDJCoRmu7psnc0CMfTsxql0RbWx1r7U0sQBd_fEPioGEAZ03CpCdFc6r2voxb9wJIYNJ4hm7_f0818nJKgJcry_p4h2yYiFk_pYH5twSEl4t_pGFZcdbP4_po4Eygh6h5lnJi1z2WfnzbhPgzpHzUxeJv_f7Q5JukjSuXGRK1ffjrqHb5dXpTiVqMcDdB8Ko9MnSaFNSCMvyHDxQwiUaZs7_pCZrQ5yPPtZxiGg_pBAiueF_fgFG1sDxmuRHwGnJFX0qhLcqJiaOlINU6mjHfwE5JEEsjm4Nlc2YRcb_fLw2Yrp6DJBkho_fd5SSrUCiijzFd6qvkrLyPVNMU4JXGrT5a8Tz0GxskEX_pFZRsYQCMUGX08qpPh8Vc9aiX25y2P7uEkvoY7CHVef7_fjpgtptRWc7JBLhNgVP5o8Z0s3EuObVwWT3zUo1sGuu07jtE9QU7cP9_fu7c0hbTNikATZYAfvg6ad8CvpvRKkdd746BvPxlZpubCIaXsaMz9Aw_p4YsU2j5PdeAqRfm1ikEY3KEEpfZNEYMhhVD0wOyc3i6p67buWyeVavHPRtPkl6lLna0VPmiqz1MFw5kwR9rxDASlCWAt6u9CYehMmPJgi5NvCxkswVv4rK1Px_pRtGsWBFgst3p0kPr9OpkI6DcKbzZVysJx2ZSPyy_peOx_pF0VmKq8b8bE8PCi8LounMcztd8tp0q7q_pAEJ_fC1mYfFCDmWOh6ToZyzYJIhGfXoax9_fFwjHT9u7WgCwbFv3HVHEi8mMZrNMhxff9ItAG4cWpNo_padUYvamwqbQcs2AD_pVL60N_p03YA0eUJMQAwxSQ3YG0APANwxNJ8XuIHmErSdZk3InW_f1jMuGX37RDTgWa7jYQVSUZY1woHuIA_pdh4Hqqxoz_pk6aNjESU6mXQbFw7P88i9lMJXfWamyFMHjsWxTW2D0hRyCyxOZQv5foHpVcfoj_flvAnIaL1GF_fkF1DDMOfpQ6vyvO8ZBe1b29HV6rZjrNpEf4Eq2EEIFeDS1fdekSpT4_pvAwZ7lrEtH_p8hPByZuGLlmDGQvKnOdbVyKWG1HE63v3iahdMA74vcU8z4_fV61gXoblELmNDtcB_feHeIbeodWpdiM95OHhi0uD7Ilfe8u_fEuPAp_f_pn9fo44jgCCnKD6WCh_fsyUkhFBgqcbuPAIE_fWLmYX7TPqJnDQBebV_fP87LvrNbh9oEWLUcoQD6hgXJqo3lOx3_pHHYrZl5J2WlNd7XQbPuO41smX_fZIhfvcYYXxFrpo7cvX_pQmePFpHrXoL9S7jJNOQgxMcSL6nhlFkXLZCoeedxLqpcLAUgKeIRK6vnsudHn9VynfYixtA2Ibxj7IYTB0hnDouBBHr4ufqJfFaTTcJl5vtpW641sYg5yEFJdZ4HkSepAQcsHAgpCzrmJHcpNUr65_pNovInYRE9t6lLQct57C5hcOJBK3CC_fGLyWt3OL2_fKKNMLSs9_fxK12iSw24cjQz9Jsfga1O6vcEPdjbA7xv4sB90dw9EhS35_pwXhevwACl3qqhPvmC2KHO3FUjry8D4xiYegcY4XaFed5t7RFWcVxOqQuZuT4UncDBreEbvbyyOBh6h3M2VZJyRNaoUvd_psUidawGpPH8LQ_pBnRNoKv2GdW13aJxIxfNt112TD_fRpoCANSjuB_f94UMNAfU4cVdIhKMHxtD8KgXzTiaGELL2syCoA2mjFfkMKVxMGtkzQqT1KCfNslGSqphUbMqgAzUcvVA81ejYtJtvR44WfiuX3XpO2MgSWENgVYzK90I95rawNFsnbfdKIXkbJSWYk",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T07:53:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "United Express/Trans States",
					"departureDateTime": "2018-08-23T06:00:00",
					"flightNumber": "4750",
					"aircraft": "Embraer RJ135/145",
					"aircraftType": "Jet",
					"flightDuration": "1h 53m",
					"layoverDuration": "4h 42m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 25m",
					"arrivalTime": "7:53am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:00am",
					"departureDay": "2018-08-23",
					"destination": "IAD",
					"destinationAirportName": "Washington Dulles Intl Airport",
					"destinationAirportCity": "Washington",
					"destinationAirportState": "DC",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T12:35:00",
					"flightNumber": "803",
					"aircraft": "Boeing 777",
					"aircraftType": "Jet",
					"flightDuration": "13h 50m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 25m",
					"arrivalTime": "3:25pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "12:35pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "IAD",
					"originAirportName": "Washington Dulles Intl Airport",
					"originAirportCity": "Washington",
					"originAirportState": "DC",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:25pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:00am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 25m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_B()",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:55:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:38:00",
			"destination": "NRT",
			"downPayment": 938.43,
			"id": "4c66f137-9175-42d6-9d83-b7253e348538",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pdBNZN5gN_f_fHsJCBAPwvRH97NyRG8BgwxlajDTPGRv_p0jqQ9IYe78U3Fan_fvGUkcX69LydnEvtAQMVcD_fQkfhgRSLoNCvPj5eFeTUnLGBh4t8j61FNvJaxazIppFmXTfdZqdJLqIvuk59PjXk9A2xl3qclLg_fqPF_peoV41X3otn_p37cT5isgPVrruTkTTh4U0drFL_pKwm3fiq_fzu_f5j7O5KbihYsoOx_fLV2jogrpsb8LeD9B8pj5h2q5cCHxZ7DyLjLh8BtBOqv2ZNkuK4iP5ZytpeqR_pgVshfcOlgm1_fPIsI1xWUucBmiKk6tsXMaCHWKuvidytTYg7XP1kkgSoE5yRcyV2c4Hg_pLJy6stFs_fiIAAbUQ7vGouFeJcYeQPtc611Zww7rEL8BFj1e3_pdSTD1fS_ptZbczFhrARc1wR_p_fs1Sl1hBiiaMlYZnCMmpwciFhhH5VS1SCyjWheShrblwNKn_fojkjjpeR7cRHsRzaeWCTOTDD8V7jc7Zwh2QCYPYqsvm675qIWGwXdmRegrxeI6JhPhJugneLhD_pGGrWrhyTa_pN5Yg5CPTt41tKN2ezg_fwK3q7aySCOIhtZpJlRFyXZCO9nQPFxtB5yeRdtS5Kf7kVeYfoIy8Ky0iorWs3HKNKZboFUxZPcjyt6SS8NFhCpFAtaseahKFz1qVwCsyVnFTL90LRpdjoCICei8cfEu228ProonmLwnFhImkUoh_fQeS4WGiFtajB5ff_pPHGd6Yrt6QcR2inrcRA2rTvPWcxabTaPkiGSUdJIjsqc_f1H1SDzcFaDDusQ9Hl4zObpLQbG3xKr4CXizSJzl1Tjan12KJ4vdblsIxa9Ejk584PToaRzJplEGcRXrq_pp7wTjRsJKwg9wIV6LggM_fRAy43Cp_pgPHCp_fNRvR_p5S1NxGWzigh01mJngixGJVl4Ob9J30Fiwhs41_pJC0c_p4timCPS1j1B7cs_fLBfaZvfmrxTWEcelYTrxzsc2cf35n2h6FahuwFiocBfBYICahjdOdxqbTBxJfo0YOwko6hyCnmJWamlvxJCchflgQsEE_pFUYB2FToK6Gc4m1B6hWRumyCfwcpOF3fbFB0zwyTBJhTFdIMgaNDjNgUOTCndl3WJCG2272XkUze5HV9TN0p1OldhAlGs_pWiQIXhYNx1Vk8LLLNrYnzELsudyE0HirdZg_pRLlJE7VEs5Pr7k8zmv_ppz08nqVTmgFCsjFeG83qSaFds5VW5ERvAhqjYq0fy_pJILcReSsKRJYokTlz42Oqd_fKtSu97paZu86tMF_feHdV5MpeVyNhzE8NH_pQSJM4VRZt_fHdJLuvWeSGXk2wn1XTPkNNQQmk3PU2LLZrtgEmA9JGcXFH7js1SusZk9_f4twOABRBrjN5qcQSzjVI2_pW3LphQ3ZS4f99ogEmV00GPUtDWOhWRjn_fz1K_pLkwpuuV8LG61AoGcPFdLDxSPBdDa98RehMriO_pBi7a7EkY1TSecXiGUcUcJPvYLMWQFqGRKpO6Gq1YXOO86P7cNdJtzKWXL_pF2r0c8XwQGxm18PpKXHxJMDnLmw0dYFLMoKoMfsDxyyCXqIOAyIWiMJFYJW3HR4_fr98zSemQVWF50Mp8p_pRpMZs6zD7y4tLbGzKu1Rem_fx0DBP7YqfYioyUYnwG_fVuand3MFzin8vKt3QN52xH_pJCUk5IVUwh422reaDp77aQAQggg_fWcasPyoGivswkxm1Pt8y61J1Kq3GSIPZM8vLDMeCYQFXYFvh_poCqOX7tkaTpRsB2mKNkw8Fn_fUBu_fMAqrbpbgijBsYgISA58oo8UL9E24rVR_ptQKKdgY84twWrZ14aPUfv_f6TPt3H67O_fwyScjy6XSssTAxgMHgEDJK_f_pYyBHi8deL0_pvmydMHuG7D63JO3JUElNWr8ABS9OW0kg6kjbGjDpXAeWfzaaDHn_pyNgH5Crx8xIXdjyVvWCZrl4ddnoPdaW6FBBIjNc6hSHKv7olNVVW9og9vq5nxrtrI860kVjmM1KDDbBZnRrMQPTQh8KLOoPCxlENW56rmnk5EuNSBUwR4aXhSLRclfaZ_f39FgkGe_p0j_pU43wNVlbhmgB4AR305tgSF9Hw7m_fgex1315NtfnZuwDrIhLirZ8p3ViKHfQJp41zFJ3vWTX_fvBCzZxmxATr_fpkvv7TC0GVfm8yIj8AMoKpg1q3HFrrr8yuPbEWd7yjcvdVR_ppSxLyL_f2jlhylu46hkR4for2XMwDS7CjLidm2WyIHYTmp64OTS5C8osTZljQItMsD_pwWgM1UHN55ewujFttNUAg",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T08:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "United Express/Republic Airlines",
					"departureDateTime": "2018-08-23T06:38:00",
					"flightNumber": "3519",
					"aircraft": "Embraer E175",
					"aircraftType": "Jet",
					"flightDuration": "2h 37m",
					"layoverDuration": "4h 30m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 17m",
					"arrivalTime": "8:15am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:38am",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T12:45:00",
					"flightNumber": "881",
					"aircraft": "Boeing 777",
					"aircraftType": "Jet",
					"flightDuration": "13h 10m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 17m",
					"arrivalTime": "3:55pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "12:45pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:55pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:38am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 17m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_UA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T13:55:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:40:00",
			"destination": "NRT",
			"downPayment": 938.43,
			"id": "0fbec833-cf33-4eed-8230-9f7423c3977e",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pdrKiwR1IaYzOogtWQZm4q1oarMJUmNubL5yxA4hOJfIUWtBfWo_pFRoexT2mvxqdUBFf_fQTwrBx_fxh5ETrOAcSlSyZ_pt_ppjPvutwG2Jhh49NTZt1_fmavUlKhT_fNRbBz7E269VbLL1jskKGwdC_fXDTtrP019Hgx9jLnYFl5VoawwDXjvvXAFjA1e1t1wTmZug79UbaxtKZd2b12qZi1t_fUotfFtRXLn3Ac5nwPd5jalchaRT7e635R6EIqzu_pckCf3n7Ax4Lp2iyNHuenNx0gj2cOTaNrC8q3wEZ7i9mzaoyGOxAbGb_pvGAmEDbGt1xo_pgD2UlphxzWXtDTr_fole4HNP1yqU7mhflkuUZmZgPqTExMB7TThF7637yOTPe7kQTqAnZPiAJLL9HnEWwZgZxSzhzpwE8DxjILHRlPvnY6mPdfen8F6UtlwCZ78FfJf60kxvccDBl38FTIVwYphT0lkre7Pr8Oyz71a3oQyTDVjciYKmpPz66xihAc02JTNy3XB8JNeZJ3eYogVjRZwW_ftmchrkDdSgzBy3w2Xnh0XHbuMJhz3k58lLAC25Dc94H6qgqbICX3zq8tG9po2xP_fR38a6twhzWTqpyjfTH6N_p8FWcJORQleTuSqpyYeIZS2h8xm8BtC_p5_fBgPKSCvrk2Ii0XQG7FTltv_pgGoKeL03eu3txflZXhlSbES2E_foW0TkZy0cqQakq6RvSmc1_fk9WaoArPpH1tvFLbYzFoZHQ_fi95ljV5rgL_ptPwlX5MwXOh3yKCK9H3LIcuq8H4IwkwW4U8_pnRevq8Xb_fkrs95F8_prTnIx5Pv6CxmJTuZRUgDnsqPXauf6IFWV7QP_f4DgkhN_pEdoFOvXdhTW549GCHoMwweW81ryXEPq811huI6f_pbCsVZCPcTzMxEALlwGAjUxHN3tSVUqDm2krSinDTogmrxwx2SyVCppZguEAwW9h_prlzRk_fREBU2SCfZwixSYMhqVmzGXgQ3bNfPu3_pNc82K_fd1GKSgQKdLMr3WDKfGFMc8BpWwSLQEzgSm9GPa_f5uw0Qe3oSIvWpztlef3iaXFqinmUSJZ5_fuTD2Y7KTksi4OBb2TwqS6mt7TqulXWC5DBGbbjT4FnQ7SwKe1_plg63ijVfabgwRlgzPcV8gSasTLuL7B2w00D_fB8sAmf94g8IJnAt7x5EkaE5Zm83pTTmufeTmVW9hc_fmGuw7Tgl7y38_pToThpnh64oG3T_frO71jBYoGaycMoWzRuOtIOrU5_pSJ3FOLrR0P42ZgEciqHS6rMzVfvXg6t9mrV0gSzOBKHW3h_p5_pNZWBxwvmCRdYVhCpf5obUp5FE42FU7JhZhDUkbo3wfXwKERhycF6Fra04aMc9G4LFEFoENI2Mn_fWu60MWeYzcFXo4MccagGXcmOmhHSgnflQ04b43Oz6engCwHoHaNiQozyi5FgnT7lipTsr2C5gPxYOw7IPbz9PFcPkylCaTjWDEnk78q0I_pBgmdGWzhgPjxK_fmrOcURb_fcGT7ATrWN_ptXvaSL1L5W7R5OIr2kL1FyrvnDpv6bfNgGWqA7VOtzKsaBDZucaGB4E9r70DCNfoE98zjcHag9lHw1lzPOTyQ5iNQ765Lr_fp4poelIkYz602FooZ2nfEWT3_pJ5qimkXL0mNl_fpoRCkIQILomkEGMBzKmq5JnLqBUlLZ7Uwg_fcIdccqR5zGAaN6X4MoJieGGHGYE7CjVUuUTibPIx0mFvnBuJOWVNNSDzdJ2MTUWWh16x_frxY42S82WxYGV_fyVz0SvKcht2z0Gqbrttn6Buw_fgIZBlq9Mo0cb8pnEXdD64wEbA_pauhkamiGI_fpiKlpht5iCwnbCbu4YmB81zk836mnvE3v5xUgh_fMopjDgz5jriQMHShzCNOu1W0e2agAnzVlwtMG51iOQFOi3ZQJRQX3MoLaF_p9ZOlYv_fMrYutwt8mp8gp9GL8YyUCClTW4vDWd1zG3o4yDIGNzNK_fEpVvF7c9RZqZlyebCr1FXkdrbofsI8eMb97el4QWozsv5rReS4afYzb9iUNlhXcFBGz79_pjx8tK9TB_pmmYRXNM3pFG3yu230_fal3LKYCeOI16bbevDTbfZSTA1INidHH4s1H64vwW4X6lchHBGGPlltKs9TXTKxSs6d7Xp1Lm5MAx9OM1t8MLYL_f2F_pRsHByxKS6ulJVekZCb8ydNKNQAk_fLaf0HZ_fPu2PkE3rnBAGQoSgXKaxpXFJz3GgzBRJpyV4Rgfu0_p3FwNz_fMCLivPxq4vSTPyfQ1kPvDWTra1kMFC3PHCFCdHpRHA",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T08:19:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "United Express/ExpressJet",
					"departureDateTime": "2018-08-23T06:40:00",
					"flightNumber": "4341",
					"aircraft": "Embraer RJ135/145",
					"aircraftType": "Jet",
					"flightDuration": "1h 39m",
					"layoverDuration": "2h 41m",
					"layoverNoteValues": null,
					"totalTripDuration": "18h 15m",
					"arrivalTime": "8:19am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:40am",
					"departureDay": "2018-08-23",
					"destination": "EWR",
					"destinationAirportName": "Newark Liberty Intl Airport",
					"destinationAirportCity": "Newark",
					"destinationAirportState": "NJ",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T13:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T11:00:00",
					"flightNumber": "79",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "18h 15m",
					"arrivalTime": "1:55pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "11:00am",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "EWR",
					"originAirportName": "Newark Liberty Intl Airport",
					"originAirportCity": "Newark",
					"originAirportState": "NJ",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:55pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:40am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "18h 15m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_UA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T07:30:00",
			"destination": "NRT",
			"downPayment": 938.43,
			"id": "7e4c71e5-e6c4-4f1e-99c1-38e9d07727c0",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pVYgPKKuKLeZZyCizjfQQ_fJcrJHt_fUDyMeX5hT8E8Uiiu57ILnvYmRhgi8nVYi2NxTJwqyJC7Mtkd8wFykz788yZjzo2evFs_pej6kXyTGMLdxlxUTw8EIZugyjFD0Sfm6Kt_fMU3dhQLmIF2CbNIDZ8nBKtSPc1qMzcuNgq0pEuALNrqRKDBXXJinB33i1pPwjdi0VbniLiFePWCJVEhAwUowCTmvhI6ju7LbBe4_p1ri3Yiw6Fg8DTCHUQN4Gnyr4cIqfLynYrh1dfeci_pXUH78X_fMwfQ49qu6LU1QOotsJo09vlIOyhvcOMoLmuQCMdS9r_fwxcamcdgZtUiSaKaYKGEnScQYiZxtZSUtKWvjGghumvBtnJVN1PqwkmE0_p4Z3q3S4MQSwtSZy_fOPmvcT_pXLgsyju9mjxHTiQtj0_pI2zPukd8jlLx9cObotf_ffFWqWkX2nl4BUFgPWx2Jkt2Co_pBgVRqmSW6fEfbkKoIbqyl_fWeLRwxAdBDclwuZisJdBHBt8x99GxNQWMs4KFinPw_p3XjbCNLwWt46JvDRmnW1jwL5gh0UXgOy1uudtsQjPpmLD5cxKAEL_fYJLo2vqevSF1KyBGY1oAzGMinN5bl1B7Ffxh8I186K3GEz91V9cL_pog7OPaZCzwkK1raTn4Ta3lO6Nm6AbTwl6Eua0L3F4qvXuUzI3kRdxHKqm8lhwtSTFtQPxfgu6ALV_pU5gdw4y20YT_fu1SCd5Lx4AUfZT_fgC9sjS5aGS9dNLwopPRnV2GLPmmFLEA_p_p3fFih1WYWgtrxeAFnSJ6Vl1lCgPSt1twvLJzLBh8iE_p0Zc1VxLGqAoSlBlk5pjZX8rw0VJvzmzQ6xI8290trRJ2uOxDrax7oA9fR4tYB3GyLwqWw1_p1Nig9NkSmrVNCm8IniGtTPgqyVA_fMjBedOUa4N9f_fvZWO_fHcllmcpKqPF2QcKPA7qDcVcWT9u68P1B4qHdIZJ67QhNmwRn_pj1xTyXMSzdwnioXVOUY_pu0C_pbqkMF3RU9qBRIrrYvS61e6GUKojlBtJ63Azs3LZQ40mglz9kI0TpZU3PnoxwDue3P30E9rPfsFZlKZ0BOC24SXznEPlvqEg6EpiP2p8YeVrl655nrl8_fjTD2ZhSPOOgd4GOsmrAw0FqHOR6KeK1ttf2EjQFoWp7oSt4dHMLTov39pn5rEb32e7H7XYqfHY8wT00X9ys6CL1_fDcDQ3v_pQaAMqeJ2fEG5D6NJNH7FOGMgk_fYx_fRPJvLBImf_f_frUbkarLZsIUMrHp4Jv7nR9X7pTuMHT5Auo1mPuTRpWPFEPVohmX8QztOw1lr9EL2hsk9O7C5sd8zFwgMhlr5DpPuNNIWiT9lEpsjfZuRROJhF6P_fKhwuVD_fysLrx840xaoCrexi44U7TUxuKqU4j57l0f3GDQ1CiqO8TFeO3EPKi2_fBU65_fpt6ni1SezFBPc_frDH_fann428ajGOgmNojzebdvibHxRSE_pCb9mS3tLes09eRhaB4N1PqYd4uixOkViDMstW9BYdSoDZoDW8cFjsIsG2fm_fXG9op_fnOZ9J11KWtXG2kvicB8lmXv9GCJ2pjk4jZnPgtdFu_p8xJYxIVh_f4d0iT06_pzNlnJgRTz9iB0FxPDrw3QWtG63K_fsU98vODejMdamW01b2h8GWBk0zDcWPbDRDd_f8xtRD8C4qQLIQ19ZqkvDlmK9zOe_pqMcEn1o9P0AxG_pVslPdd8ujth1NgpWIWDjIH5NECImFGKe7Y7VAZWXwjURsFHfsnJt1Xh1UCNzgyx4WBwFi5ognvDmLVTTKEYBKDAfBzWVC6UewiWhBdSiMfr_fBI3Z3BoQd_fMaddsdlj8dcAiDoNS4VRdD5ZgU5LbCbczGiE_fdkzdk5JkHAUp2QzFySOGADj1RAoV6TuySlsQZT5fUXJo6sFAOJ1rZ1Ni4Bve7QjoDsqoss0k5J_f8XmhA0grxOOzzfuU_f4mfLPdlE7MVjGErPyrOGN0nYArhDIk7RzLnGNiLNiEkRR2l_fxhr7_fuF_p6FY_fd2sZZpYIivH_p_fjzzlGBHifrUWL_plvK8uGzua1RBFPcwOl2eJqaxrkQn_pBfq2ngBJhm9j_fBBvTlf3QTaVIYllnI9238F4IizPiM875Xr0seJOLFobekISPzV0pm_pNFc38rXFhMpFZ4UIaOEeb2GAWAoy96nVCGcTLYfsk05n_fgp_pbcWlRTIWBMdxw7hvQ3OgEYSwDRSWHgAeG_fqGj86N4RUwzIEOkyCNgSbK8_fPft9WCz8cYjbMbUD4tkKCKoUyG_pR_pCyoZZ3rO2qL5LNmriKDfQ4K1PqmbPQ",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T09:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T07:30:00",
					"flightNumber": "8665",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "4h 25m",
					"layoverDuration": "2h 40m",
					"layoverNoteValues": null,
					"totalTripDuration": "18h 50m",
					"arrivalTime": "9:55am",
					"arrivalDay": "2018-08-23",
					"departureTime": "7:30am",
					"departureDay": "2018-08-23",
					"destination": "DEN",
					"destinationAirportName": "Denver Intl Airport",
					"destinationAirportCity": "Denver",
					"destinationAirportState": "CO",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T12:35:00",
					"flightNumber": "143",
					"aircraft": "Boeing 787-8",
					"aircraftType": "Jet",
					"flightDuration": "11h 45m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "18h 50m",
					"arrivalTime": "3:20pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "12:35pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "DEN",
					"originAirportName": "Denver Intl Airport",
					"originAirportCity": "Denver",
					"originAirportState": "CO",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:20pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "7:30am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "18h 50m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_UA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:55:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T07:55:00",
			"destination": "NRT",
			"downPayment": 938.43,
			"id": "5351a1d7-e422-47d5-bc32-5e3427b18471",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pfGQxBfzXCGvdRpQRJ_fWcCdOgYcLHnyB5mGJCni4cx5v5TylW2s_pmrrK8VXDOMcGzK5yps7VQLPUc6LbVPOgOzjMQ2G_f6qOPyYN4GzzvfZag2Kf8Nb_fXAAw6a4uGwDaBhqVRQr7zTaywQrcA1SCDqo0_pCsKEwY85dbbyHXAtNvc_fJSf5vrWwfQOXJYsN7Y_puMcEzBPKC8ZpuZOXMX7T_pJKOsKSi9BDXQXspm162RExfOkhe_pht9Am97L6pL2lMyo_fro3IY1OSe8jCKMA4O5k_fq2O_p2Ddtx4Srhr415mNcH7D_fyZEgshfdruzkrAIsGv9ptNc4_fOtjITI_fETaj66toJwbE_pljGW3Nst2TS8_p1GpQQuRDVj6CWik7xQ8oOaaIB6rJoQ6Kv6oVwvFAA0qVICpxDI5W1_pVKJX94eNmT9vT1HWVYEDF_p25cEOdYbdbgyHTf9Qh7Bg3OPCqbVZet3dpdN2ci5_ftMaGudptKY3JBGYhOu_fFW3hPpKBB_pNE9lVEz_pI0T4AHDeHUg1CnVuueOwTGi1fA4_fJEqtDldnDpv2_pjajJQQVw0aaPPJ_pBnMqgk1M2Ie7U_pGFhd5q2q5r8Jndb2AGYT2c_fZaeOnBzsqOxurEcfkRgjcuN_pU8o5g8owyv1nNwOJgEtocs_f1ya62Tpw1Y6nAPt0_fk6Hy1xRHGgec_fyHcvUazJBFESpHoBp_ptlG0XVeCwU3uVKKZxQA7Tl8vFpJqHoSrkoFz1skIZH5IkzTDl3e8LVOG8s86HktHXtnBCxC03pByonDg_pFhjg8FjL7gt9gqKY5rlNLp2FGYPl9nIcGME1cIP_pvQ_pi4c5ElO6MAuL6P_pbsFBZUG4Syi0J2vvDRhMpBIjtblQ_f1hAwUTnm3Somdq_fwoqt7fzOmh2SYX8gVHtMAecg7damP0byqsY2SilaU3hqk7ZYlqJBoLH15zgbUJtuQ14m15iuCQvFf_fLC3fUxSTerdWrPT1ptJ5EPaWIXqn1w3yrnyUyeb0CLwCIMtKZ4CspKN_fXtnhPnY44M0c4R9Qr9UYvHh7_pTnqMPf7o7Z4n_pWqly8YQviU7z540ogF7N5Sf4YZwMnEHRWJEKAOf0TnHiVdAIQBUQfiL6_f9RXJWbWXbxYZdgOsqcA6yKlipWJyjGqBPSowVbcN0v87yhXS1sf353GxkdCc_pp_pZlfQzjNbrCY8M7toHNQ46xKnZrVMuzIq2Z8fm8jlNx2Je1_f1LCIsV5x_pX6LM_fzmM15ctK1jH1Zo6ED_fm90dgzpaVS2Qd6BWtU_pWvYm_fUhJVSiPytU69V0eAB5kgVM5aG09eS_fMGpHewd0drOeFgqSYKUhtdATCnSyDY0aCDxOvufwN4Lar2aHabDwHFvalBYF6s1SQC0dc9_f6gJqDQ7Yl6RMUSKiXJ_fgKF9ZqKjT1xCDH9QV9JQ6bBmt9kRLWcc0i5o_pLlA8qXFY2O9Ms5EsodyDVh36F4np7QAsI1Pk94dHuKVHkZkn_pTmZ7IfQBfQzlQUCh01hvW45kpz8Hm4hTDg8kORy_fciNiaQXYQ_fH7TIxykHZPnkmX214eS7gH89AC9_fmeU7V5puAJY6kBQH_p_pdUlZrsq3pjNA22acOKC_p0RAnMpz5oSiJGKK9XOqIWKuUxLDiUUZRRxQd4N6nj1YyJoAHs_pWVXKF_feWz2D8mtGHN_fX4fJpNACOY9lcYFX2nZcysFF7Vff7KrYLickcm8HNJmNrNRVmeHt_fmRlNOz_paUyCGlesHmB0DP9H3Z66GZukHxP8ZWGI3V6Fl6fqtjeHS7ldQAnYLcKd4ltWN0ojD9M9bl5TerFJwER55IoveWhSBSnaFlzK7axN00mhZu3PEQ3gprEXxvcAZkSs2tcBwQbX25h1NRJrQBW_fpVvAqe1sO3J3QqQJKYFtwdXraeOkCf3uHCvlGZrekpkvb5WWTQStUQrxx9WSqhXX2sCWFsvPT1hwNa0NViHAP2NrC5u_pJJwXYWjuKKdK9w1CmfMYKzFVSp_pURXwRRBUKbqMHGRQ2tMDIjM50NcPutr35l3HJ128SdALW33bgIaB5yjtVyeKPgyvmUa6eY5yrDBuo3Iuxb3_pCwnTHPRDBzF2etcqzsk0twG5O_fUyGR9N_p8SedaiME2V0oWWMxS8Aps2XqmrMcWoY93SCt8p252TxBxv3lTPexoBnthjkoBIs5_fWdFzaXiP7_fXxp4mxTwdOG4acUaqDfy6TMaCf0KpuZMIMet5kvnMremco_f8MWLgE6isEjVpasx189ejY8TVNHbQ6iIjWJfivLSLo7I7vSIUQh3WUWZXHQ",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T09:19:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T07:55:00",
					"flightNumber": "8371",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "2h 24m",
					"layoverDuration": "3h 26m",
					"layoverNoteValues": null,
					"totalTripDuration": "19h ",
					"arrivalTime": "9:19am",
					"arrivalDay": "2018-08-23",
					"departureTime": "7:55am",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T12:45:00",
					"flightNumber": "881",
					"aircraft": "Boeing 777",
					"aircraftType": "Jet",
					"flightDuration": "13h 10m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "19h ",
					"arrivalTime": "3:55pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "12:45pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:55pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "7:55am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "19h "
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_UA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:25:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T09:55:00",
			"destination": "NRT",
			"downPayment": 938.43,
			"id": "b85196e6-c4bf-4f3b-b2ad-a0c94ab61254",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pZk82gjnR7Ii44QgrsUI0RKlkGFg1Z7a3CULipPUcrrh0Ee4Fv2doqpiV73OzOdoh_p0tzGJiXirdPpFqvXBP7MPwd5XErMRdK_plllt8BC0kK9koTOmk9bfQFh7D9v6khZCw7CDBj692gC0qa0jHK1Mcu9NaVBbQqNmmJwyRExdhmMGDOAt5XwTshTx8WxBuq8mOOBOpPXy9q194TZ0AaDJNFr9xCg_p8VQwVcbk3yJ8G8QUR3EDKolFKdh6FbwtjUXeuZ_pkSlqjojFKI56LXZEAhRasIwbiZm3APPRqaO04PvH7e2kQ_fdumxMsnTzRT7bODNiORNHa1H5RIAIQnvyQ7_fdKg1MuVyEHNl_f7GA0l_pJXr_p1XWQZc4Y6tWNwufAdF8etocGr6HdoeY_fsBZRFBk7_fp6n4hreOQXLiFi1HEUdtA8pVjobWN17l8A76G_pxktLmdNG0_fEq6IFFZ5e4knG0gB3PfQ5vDQ2NIfsA4cl4uvjvKUy1AQbsvdwNclHx8aUNkOKjUOARY1jRNrHNBEUOE7OUrnP9_fWVBgkD98qbrfmTO10WcpEymgw_fVN2aMduHwoZq_pBR_pc4XWuqUKfSQ_pydErsfzkeQQ06IpDEjfplVfszwhNlOQ0NqtdrrShenj7Fs8BOjghY6NSx8mLVrDZfiO61Yk4kmn_fuckS3PRf9uHyBfVM9taMC0zZDXiygSml675TwCRn_pYrOkENPBlK8Wl_p9l19AKJd6RLWGK9hdBzxCmvU1PhFTXF_pkGT_fTQhG62bbCzZZTx1sIZRxCiIwQmWF3CQ3gFUZWsdHFPn1qs2_p1VCcugUS8s3KHB5jBotNKQUMBiQgUyQ0O_fPGTz9UHT1Wm5_fTL3viIbuRQYtqMdeCuyCs88Eh64aMl_p3kAUV0udQjF4wFJJXQ0mIDx3l3ncnajSsAltgkRvOQ7YmBJt2sGqcI622tLn8jebgNVb3ebL_pk7eYb38uyAlA2LtOSXmrm8tq_pmRg5loYcVVFsoAPzn1boPU30LDm8mXvCi_fCbZR9DBWfaWgwwSRQCSv8_fzhShMuOHhXv1uE1rNwlT2EvS8ZG2X2mSb5GE3hu9w6XMoQPaiMAuyjxNJCJkGkEmzmmOwan2kamxYVpMJXrRyV9AoYiIkVP4vjycjJz7qF8LWtYHlTYF_fT5TuonRYREvetsZJxejbAVD_pvg3D9rk0CFA1WyGTbR0_pFZxdhkSQxaGIro_f8pO4C7rQWu8P3GmXklIkjGLkAiKw4s2mm_pN5y3veUyQfOFtwCmj7I2NuhutlD8IuZa5hZhP8dVkdZkAjFhSt5trwuwlDtf8L8p5P_f_fI0bBNPkEgmwTccS5fjv_pF39xkYQ8NxDHlfXKJ4_fyAym7EbujbcfYLv4vz_pzwVlsH3sEe2oY5G0ghg7CuVXWldO57jrXGvQkXcit7PAmFc9EYg_p8I_fZ8On9YZx85VKb6q4rPCqeGJ1ZyI6DIENgIAv01M4ZBe2cE0gZ7oinllLCp5_pgSktI4BRGd3wO9ABm_pSCzFG2MfGvdhWH91HptIDhw8_p_p9qq78HGZHikviuLfUbfJqB1GG4TQWOKmza6ksqRFjh3LK4QkFE3oGnKP65aDyKoVHWSMImPsWU16l1JiofVvhqcs1QIABy6KF75udIYBpbCN3zOkZ4SHGsNJIzm7JgNSdK5zlTjau9AGBYivCJp0UPNoly7zzKtPDOyT5EJV3_piBHvYhXndxZiw7mTq_f6S_f1Q_fP0j1LyzzQXWEPje98KeejBTfA_pbdfRO8PmZT3Y2XQyn2OrokzQY8U16svwb49T1qaiYVJHO8j_puVbNWzYN3lAxZhO5hoF17CWTBzsAbBy8z3MkAFlIz8mKU1K_fMNi0WiFFrnNIot_fuoEgzWAs2_fhiWzZcK3FYqOMGv1PqPNnHsMln0H9pXcfFQttc8m85_p1V_pmZPD9TbClq_pIN_ffUaLbE9gdmwRkaoePz8luwYsddeFsiiQf8BI8y0QADm16XCd45O4qYm62pQdIysBYlAHDt8FHrM8V83QfZYV5UPPJCELyEhGTRdlGofw8b9cjkVERRhasZLt5UE_pLlbgHnaDOl2QuDMHJ7DB_fZf5YJUYE_fKwNMlLn1LYuOJZ6S6L9qGRFNLfffci4AwRl1KoK6PZEjHLSn1S2MhrKFs7_pMQIe4XCe2RqPm4f6luCDKbEKnSbTtfs9KOFtXf3T5s4tvuDsFVqkSJZ77rIgdREMSuYDFjqbF1pBOCHAV_fOAgX0dmkFrUok3llpaKBXs5purha9U_pCbEKCcoRH7Z14bMRrSEA9xMfw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T11:48:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "United Express/Trans States",
					"departureDateTime": "2018-08-23T09:55:00",
					"flightNumber": "4772",
					"aircraft": "Embraer RJ135/145",
					"aircraftType": "Jet",
					"flightDuration": "1h 53m",
					"layoverDuration": "47m",
					"layoverNoteValues": null,
					"totalTripDuration": "16h 30m",
					"arrivalTime": "11:48am",
					"arrivalDay": "2018-08-23",
					"departureTime": "9:55am",
					"departureDay": "2018-08-23",
					"destination": "IAD",
					"destinationAirportName": "Washington Dulles Intl Airport",
					"destinationAirportCity": "Washington",
					"destinationAirportState": "DC",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T12:35:00",
					"flightNumber": "803",
					"aircraft": "Boeing 777",
					"aircraftType": "Jet",
					"flightDuration": "13h 50m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "16h 30m",
					"arrivalTime": "3:25pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "12:35pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "IAD",
					"originAirportName": "Washington Dulles Intl Airport",
					"originAirportCity": "Washington",
					"originAirportState": "DC",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:25pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "9:55am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "16h 30m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_NH)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T20:30:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T10:35:00",
			"destination": "HND",
			"downPayment": 938.43,
			"id": "116a0059-a51c-4c99-ac73-ae2146c52d3e",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pYUTz6eDEQrN0bELn_fbccquH0y_fNVEAAV5ENScfRAxcAvFvwO0HL61U4npTA5J_fBjh6Nd7a6KHlVfRprOUkdy34U206oods5mD_pH2Aw28hDI5ZchZ2oKDRkmpq4qNlRegtmAlGVo2yTUNLAUP8mlNu8Lx07vTp_pnWU_f_f5rMnVZXTB2iNgDUr0wkSMTZzXtuOuOzK_flEYkK1Q1bab98sKtdfIv4lYdX9SXmMt8bPLJpp5XaujzCN8Pj9eUfl5KOSbZKDPiaxMXw4bdQvJHuQefM7qlXvHPJkXFMhViY5SRKd3tUPBQghyOh8n6Nqa9wbm5CwdInzR5_fYGjPn1vqwhYqoARmYtjP6yJvkrV8cVK4LipeNln3tbI1zM4QsZpa346TVwsONs3nCyEUUs_pNUBCdaHvHhOWl5s0ruo2nVdHt7bRyxTfGZJqz_fs6_ppMdNI_pB1Pl0xrwda_fwwVJ05C0adTaO1VPNv_paHbWi_fl5eE4FH0TAn821UWaAcdIlViIgQT_fo6RmjnZVn3DN2ppyslbutSRVj6rKS_fL0Aog5Ss6SFSthsNACdUo7XFHOt49u1o9zkOIKyzfm1mqvHEKLOK8RRmqUJxOA7HJ0mGFdHxvGIUTC39tNdudxnjJopm5D_p_px6SZXmKBYpU27w16gub2Zq3ot32K04LdmZjF0BlUPSU_fcnZm_p8ASpNkzggSm0bMv9kPibJweJ25wXXUYyJN4JGnXLQXKifljoHiaqn_fSIYJR_fm2buISUdtWvGWdRazfmU_psooF4w1NdM1F63XKFcMITGO8BTJbqLRkcJwPictUZpoyRdralrrsjgff4_fbPVQdgFE2VldALEv6gTuXzIuu8YPC1LnPlyl0QwMF3vTBDTdB_faTFYVpdvQaP9OwBKBfJzBoFlReJQ4UAyA6ID_pHccjAZ0XROKCdbid6xROW3s2UdSCL3fsA_pbrb3d3Rm51qWACUM7oIYDkkFIUzDgn0q656BwCmqLMahCeO2L1I41Ct15PSGUbQwp_pDwjTsgGVOk1OVtFBW1mpUi0e2XdtRG_p1pIIg0_pueuJh8lgHHyEP0uN7ccWbfGGWNT3XMmH3e1b7_fxRutq3DYqDiE28yGVmK3l5RsI4Pk30I6IvW_paHI_p604P9lXXzqyCXr3zL2siqP1PZzl_pHlbyzElNo9lIAn8kJEc4ugS3xVUCpwxFcTy7hslnDQaLbXQMx_pR2PPmQZORCWfIvKLlIimDx68SyUO4pjFmZ_p6ImvMF9OI76U5bZSUJLWHrmestUGqi8Ws_fHE6hIJpKwsuHyFyUY3z7laHD_pOsNlg_pddWw16RDNlciqtjrpticF01tt_p_pFJswfC9XPzwbaK_fi2cDGdsHatRmjO8WJ4M8xJJJFQUJkqRnVjV6XUlvy7MR0nfo3N7ZXDpgcjC3FtW_f02Ccx6TnjC0m_p6yeGIn6vX8Tf_fiRxT0_fpxG_pWIL_pdt6tgjfXANV6i_pJnyAValcm_fTkWh_pc_felHwHHpF29vJ2MWn0UTdezxz6lwpMtmbTbRmILNd74nr3_p9_p9JS7VhBY06ynh6l8WCWQwCIW_ppkstHOAYvjnz2bTgiJeM8vk7rKcwgG3Zm2gbrRF2LuGzo49_fJs03N6re_py0vWm02YtKTXuIxxiOiH_p11pOQ_f0qEJNc8sYVWX2bLvKlW_f8V2pbSLDb8SK7Y5TjeUUSGLTO9tEHfTLn9x2RhfW_fwgemuvxjFO0SviIf2l6dmxMt_p1bdC1es3OlLaimuAvgFhcy8cDpLqKSBsh8sbSZaivQODbiNFLlEShCTEXX99wRv_fGFZQ71jYQLQYIbIyz6hIbiOnIyJ9JzrfchpUSnNFzjqLFCID174FcJ2ZGRpVjKYCWbkT1H_pK7r0i2_fexg0UUGhmNwGxNYVyK_pNwlqWFXLYBu0WY7d_p1190s72MgK1FYxniZCkl_pJjMPECfy8dW5pkTBuSVX5y1qvqqNTdpIJlTxWa48ZglykFdrpQPd9LzevGIsP5O8xhoOI2AJSyS81Q0vud4teqpsLXCggVHgV2Ay298SRlxJc6IefQwVj5G3wLDJPUvPp4ofgIWQsuJCVMkjTHYTjkHk9FGFj8bPE_pUCvouBgCgaYk_pfBxJilQ86_pgaE8zn2wHGKV_fRr6m0D_pBj1UcN05PG_fLG_fRliOZK3cfEqt_pWIK2MBZOqCs_pTdw_pBmHzpDp9N9bbxg3jp9S70XjlzxycX09H1A_fZ37LS1R1798uFrIuCiJ1fInAtuBqerFlOgGJpGYG16_pILdC8msd4pCpP4t44M62rXA95e_fyLUFTo8GL0p8cy7Ixifb1S11KIzDW80",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T12:12:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "United Express/Trans States",
					"departureDateTime": "2018-08-23T10:35:00",
					"flightNumber": "4726",
					"aircraft": "Embraer RJ135/145",
					"aircraftType": "Jet",
					"flightDuration": "2h 37m",
					"layoverDuration": "5h 13m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 55m",
					"arrivalTime": "12:12pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "10:35am",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T20:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "ANA All Nippon Airways",
					"departureDateTime": "2018-08-23T17:25:00",
					"flightNumber": "7911",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 5m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 55m",
					"arrivalTime": "8:30pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "5:25pm",
					"departureDay": "2018-08-23",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "8:30pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "10:35am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 55m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_NH)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T20:30:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T13:35:00",
			"destination": "HND",
			"downPayment": 938.43,
			"id": "676527d8-2cfb-4159-a827-2ea8c7c25994",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pb9hyrl1RTG45Ge2ZpXil3k1dO8z4I_pXNvXYJdTkywd4BNhEdPwNrwrf3aO6133eBiLjtKscsuUyTcjXJIPhwWwTDjDDVi9xqJcyHetwt0qCWFmtuHrOGfUGTtM3z9VExkmUZk1InJxn1NbmsvcB6lPzFaASshK1H3mmpwe8xnMr1SNJ0NZxieJW3wZDIRlVT_pRyGRnYvt2sqxclvynLkx0uvYCcHO1vGjTYH2uhSCpb2CMHBBrmWRVqNd81QLxGx4Zsru3T0HEGqo_fQRNdS7aqbnRHlMFCIyLBv3JXB0wLV2ImiifyOc8lD78Ee5x5IOktjCbXqE2yHhAYpKMwFe7GbKzWvUvfYD3vxKI2pdmVPojEjLcpDpqjsVwABaPG5iaC4D7f7fNwlVrUYstF1ZixahScTodj3_fnT26inwJZ4crVe6EuixR3ONx8CxbTMfxPagE2VMEFWHW78c7Ee_fzCVqsE3HsBjVZP2r2XubsXsgz2ArLXtukEq_fX8Mi4E2_f_puPiusNbVG_pba1v8IZMwx9Osy29aWB3GYoDMJlYdPYMtBYLL4VF9WknJGQ6DTYswyA_puRWW3G3Wci6i40GELR_fKJKd2YxqMCXvZJFC_fuXQCZbjNYO2g5KoeFMrC_pr8sK2_f3pEBGesvy1sU6h6aAM_p4g6CC_f6vi9B4domjKix7aPw2sARcD_p5i_pnLpqhnQCyS9UhGVILOMtUqpEp3NDnrG8ryqGWst4onc0Nzgmts_fYX7XqurNXk2WXy77UUk7Bal43UwaKyHDFuKaNIjiOY5qdkscM46zkvY6MB4kGh4yimBxsv6iTb31R4HWzIqfGD_fBp9wI2dfJx_fkf4M3PIz0oGu40QaB9WcOZ8XcEPOtqBXHFkMaRuwl9MM6KsQdiAyt0NBRnlBSsA4g72m9ttaA67OAHnl7vm2m10eAcrFHkgIPVGDSNR8svV3OT2f5gWOAZNXZ8fgEx7LaJwfBa3h2jAVIJpzMmhb5ibdqgnz_pDU9sBccXzH99D4D8IMyYKfW7h4DM5vi3V6zTFA5_fMfVekWO7a8EWg1xNc65SaNB9tKXQzv9kD3_fjI8Bhcov8rCaGljA5tJKDk7eGXlkzjI9FPE26ug2JvyiU2cnHbXETyIy_pqkzIf72EP3UZkCWPH9q4dBPZW6QEVYtW6dPl3Xf6LNC3r3X3K5RhxF9PKN2YEgAMDtobij3HBu2X7gFtx7qVhbbBXxo28UQQhW8Qok469u2HOcgqYy6WtUbhd6asLh0dL3FQFKwK6nLa_p7jzDUruQP6SHJu2NNOl9VxQL0a3m8Bs_p0_pKvMCxE_fxLK3_fdg4je2yoky_pwaL3_pH6VXN_fKU9UZ_fs7fcW2u9it7W_fmewUkoCEnJAHjAGXenJIVPLSMTrKZdcw4pK_pHyRN5AxwJdde3RM90dPtGbzLiD9CdRQ3oBnfr_pzOSCjnNDIwPTsZZr5nYabX3x2pTmZ4wHYa5a8Hy_pWwtkTQA_fva_pu4apoUwbkTftbedkVjwFu81Y_pO6WrjzAXGIsvLyrR77CsuMDjMoZPzb9rqVAktEPoOReFqSJjc13EbJ_fUnICZnRw2zqTEvIFgM_f33ePoUvW2jItwdohCUTa1WY63NCKUk0eyPbDJWjesI_pFz2w_p0Mo52EimcHdR5BalBo9Ht_pSlN46HIyKlklFaHw5XDsy05ibzLLUa4jYjQ5U6ikIL82hEoVjMSIEa9SWzmeZ9NforR5XGok0fPgkBTT03jpCgJvFCnxBYjTczMAtwN7DDtF88xu7Cv0ApkAVpzk51WfeJOPhFuETvx_fGWbBarcWOUmj1ITjiEkg8lKycVVz0khh2njwk7Bplext8ikr4mVMkrI6JSWFQlCY7kMP_fpAc6BQNh7S9y4yN6dD6jt6G9uwyxoCszuuvVd4KAVhaK7b0icHhQckYWI6CAWJ_f_fHdkE2_pwLXm1RA4aS35HeqRjzJHQJa9O3YDOHK5mEEFCz6wJ2AZegutRrZaFiJGKCiADmUvM7GGSH7u_f1xLGVzsnS0ChYpwZMHpKAkdYkrxT3PWsqD5kavGSC0rQpHfArikHhzsn6o8O6voR2f0A_pb1Q4bx59Oyfx00mEfeGhjY6eg8w7NMwhZ_fsszP8lk_pbXspIGrytOFbW87jnbih7S4IKWavOid0l0NUHg0aE_pYzdNQnGohSzpKJoxx23IQsE0UkyTSMRsy6TWSgInkfjwvx0Ec56Qd9gm9pn10i9P1FpQeRfXQzfsFwcbhmrG80Zy_pL3LMDvhcYJYktulRE74FL0toYoPgIFK5vZeKVmlZAw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T14:59:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T13:35:00",
					"flightNumber": "8481",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "2h 24m",
					"layoverDuration": "2h 26m",
					"layoverNoteValues": null,
					"totalTripDuration": "17h 55m",
					"arrivalTime": "2:59pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "1:35pm",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T20:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "ANA All Nippon Airways",
					"departureDateTime": "2018-08-23T17:25:00",
					"flightNumber": "7911",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 5m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "17h 55m",
					"arrivalTime": "8:30pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "5:25pm",
					"departureDay": "2018-08-23",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "8:30pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "1:35pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "17h 55m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_B()",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:55:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:38:00",
			"destination": "NRT",
			"downPayment": 939.63,
			"id": "51d60096-8a5b-4dbc-ab7b-ec23e4c6f8ce",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pd8Q2GpNpXpCpCEznMDx2WqexkAe2JkJ2rOS1x3EvtIEZVmMsrxoHF7Pg3iplBBHUTO9drGKcymf3uj9tMjmQ1fE21iAcVCr1QCNrb8KclmZ9RpmeOTHMTA_fNtzIGYzXCSuGZjet7nG9aUC0RxL9Xc1f3S7GG1jollPm0R95uMUDtvE_fo2g_fzC62zDOcMZPEd7b4khHmQcjmj1E_pc8g1eC_p4Kki331klCYFQXt8I9QEWs4Dra9UHL_fq0dPXHyyj0h9quq9Mht2A_fKNJCzINJg69rHMEGIkz9lOaCoHv8N79iUPgTjP6QIiBNz1Q7grmDdg1Xs3sZtdLs15MKVrXK5Hv29HBq_pZPwY3R1VrDC3Qh8Z2JSgjXceMGtdjG06TW4ZgEUR7t57QyNWFv0azkk3k1zupJ6UQH3_f80LBXt2Pl4Swnv_fP5HoXvnZphnFStsnYwXvM5eNYP_pBxlGXFR_pxOF0iMcr_pNpWJX_p3TSNNoHWEsFIbqEKcqhIEJi3MGRfntWdeRc2CzFCNL7FOnaMrBtiGmgxDFf5CmxacOrkh2ChF5pdmAU3vVrwLOFCxEAebtJFnd1KmL0LpzP1zmOWJMW9IjVkgU0QcZcUL7TcAKggMCaDMXrsGXcyiWfJVx2nOx0FCyWEZzHac4pDDDytRUjR0HnU5CWOJGPKDNm_fAx5vFaK_fjj4Y0WfAS48TPdBeofu5jSGQRwuhhtV7727uC93vV7AwDiUEyc7mhX07jrunJXwgrjHpfvgaIFst7eBAjXqCazGOuC9nw2jI4FI_fJrws28cD8Z6cwb7xT19_fGiuLgYeeG2D93n7sOvTVLNbajx3vM4SJGjQfERsAoMO5DnlLlCPPPEsrb_pUlHIFnvVfIl99wskJ4cbVxwlFh_pu_fQP0D9Uom8Q_pe_p3c1uph2PMiEsrvhE5UX7GgWu1QqSrTr7pD3oJh1i2_pjq0GyoaYJmnPsk98hoBP3oc00_fyE_fpIDCZpo1PEvUUv_phymbkf1p0nQSd6Ns3w8eUxJ_pXp6oDEoyUwuDSalix6_fTAOpC9UC6pmxGsUR0Shh3ux9_fl8MleIaFjC6pB4L4V2QvHXHQjhUBt_pWV8FJf0aQqxcGBPk0NwRsucumhD0gDOighCSUnUjJ7KmGWsbd1GLrE_pF0lx_pFNJwIeHLLU4ZxmlcOc_fTBZXgoA_p9wJwFm8sRkbn0lWvinomjvpbiKMKn_pzm_px8O1FvdtG69OJoI1JK0YGO3evYJ3VJBJaHckgoDMb7yE0huUvyYuN6HvV4_fEXzpwrdIxiQKPfee9PK64wxkdQbh_f9UofIKLeW2y5B_pN3iY2AghtIQvwGrevepbYS4DaILXwIiJupb1tb2o2PN82CwM1Aiu_pclUWVK_pW99nBKsL_pcC9wUAJVu2OMohSswt1mtvGg7FR17GTq5NcbqVmIuv6NXPZW84ioJMatclpsfIMK_fP689zppDACBoWmwDZLA4lGPyCPPaXQBNQJpk_pPTjlDC3oEidx27snKkOAc2tZjQuKMgB5wR7y_p0N7_p_foB4gvmPRgTncsqbz_f7NkDTMvjLKFY5IXQ2q8uqb4fUTjRKD7JgKf0FY5_fbbHkq6qVX0_fAscF72gi_pLm6g4eHPaEUuaxUv1WZimI_fd9FkZoQ_pcRU18kp2mQO7tI2j0BQmGBHTPzIZ8f5GBBbxwntXN2OUeZIWuA4g0bbk50PsstE69WpErAjTmcVP9NW1MnMUdRDzMSyvWgtmLxcyrjRhWNhhcmx0wIwPG4NVoGRsi6c7DM6uPv2n1UqV6fLGNXfJLP7KV6BS9mkgO0_fbppATL3RrsysEGTjHu6wF67nDkgBH6B8ckRv1_pXjXFjRrlw_p2ZB177ZLBVViLTnB1Yh4tbqHhk8NZC690i4TsrLnrOzyd07yKDe7jVxZh_pPOavdZBKuh6fug0IoNI31ieOKNEMqEB95KrmVHWE6Hiu7VOlRzj6R2QikyVmo5QSQkEObe5eldCaEqeEAlFZ9w3P8EqFbAMGSyCmpl0syiS8jxApDw_fqfmt0373ULX3BCRQ2hMf0_fdF_foALRntFQNBm9RxxJUiK1d6ReI4cQXtgJYUfU_f1Izeup4jghnN_pGnviZrQwhSTp75yDAWmRfWF26kyFcQ23NpMvf_pFUWsR0F1qGr21an07fYKb2UHr2MI9mThzQqBDwzasJLQc0_f9Hd_pogoJ_f9Yl169t7GPosjwnZ2Pt526ZMKYed5v6GdP_fSSs4hC_fbg0ab_ph19M_p_fmKCxWd0fSTa8CMmYDoaU37QC0q9s6TyLFeUpde4R0gxm_f2JYgUNvjdiHe0H7vB0EHol9cQw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T08:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": "United Express/Republic Airlines",
					"departureDateTime": "2018-08-23T06:38:00",
					"flightNumber": "7431",
					"aircraft": "Embraer E175",
					"aircraftType": "Jet",
					"flightDuration": "2h 37m",
					"layoverDuration": "4h 30m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 17m",
					"arrivalTime": "8:15am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:38am",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": "United Airlines",
					"departureDateTime": "2018-08-23T12:45:00",
					"flightNumber": "7009",
					"aircraft": "Boeing 777",
					"aircraftType": "Jet",
					"flightDuration": "13h 10m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 17m",
					"arrivalTime": "3:55pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "12:45pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "ANA All Nippon Airways",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:55pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:38am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 17m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_NH)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T20:30:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T10:35:00",
			"destination": "HND",
			"downPayment": 939.63,
			"id": "cef0d3f0-4b29-4563-8cf9-ab043689d542",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_peHBA2LAGYcARMQxHIeJnGPQkUkbgAXwWo_plcpZTBBQydDg5sW8_pGvh_fEhEg8IbTgaBlG_pOtxCPsWuTZ4Bpwt2xLdHffMJ7R0TwiG_f1Mm4DzeyXoxU_fkBNNFoM_poUHvtwvCVwRTeuCS2CaMKAnKA_pGm3YfTXSVxdVqt_pGWYuBaJ4FVlafggleMn1G6sOC_f869w8trHGehEFTEZKNKP8zvFWWCtCCJMmAiuPI8kATjfCJ_fsruQzNwsmsr_p6_fZ11cWzt5KzGOnYKuTxn3keAR2OIw0Orzq5228SHWOG7cTL5GHZmB7OkqoaDd44nwuMfUkf6zrj18xAyOcUSbxL98gzaHkXx1QzzCXG1lgFURRzgaH60f2YPi9SFJ9GPLF1NbH75n9maROHc78iv5RVsgNQWuJpYaTIjAikGx7jyQd7dyrKvyNJXCl1HWPIhId1Tl1BvH2CiewZvV1IlAGet14PDeYGAtzNj9fPISKJB8NOgG99FmmbNg0WycffteE6cin939WT_pAj0x77EhFiRJf9PtT7ycTgN7D9frgRD5BH8kBf4O50fUJuXVqtGkln4yWAw_fL5Nw0PRRnpE_flmVJDOz7wzkctcBokiI_pwYboeHEWOSFtO_pnfaWYVwjNdCwF1mk_pQpVBCxmknk9M5Ambm29zv_fM226qsYb7RMZxb_fq4WRN9DvsxB_fOmk_fuEU0IZmUP4u1W7wyov3seKtmMhtBdrGdf2e0X683qD42BJcTgp7xLlUcgnzkkBEd7Mkc8Y6A_ppM0UtFPudIRW66zSKaniOGzTzH4igpK7p0Jtx2jdPCANSdRceMaC199bQr8iPhVkq1g2yaeS0yTbOh4Z_pzBnl08J19t5jHKok_pPjLlz7Y3Jr3jpD6xpd7dQuCsWtJp4JACgpypn9Tk66pN6dFLutAptntNCc2LfI5xT3JvZrtFgcbHpMnZdtTWIXA9pkQBRrVNAgzYPjSJ3cCf6_fody4hSOXyPUTg6jroDw_fPDgepncmD5uKe5KJdsKa6noaMpG_fvfenqcWES9qWuYGNrXntUNeg0mL8AzlSNghiHlby75_fS5mQhqvqvlmFMy_f1_fcQk0NVjZsOeHx8_fK8zsUi85awXDIN8EDx1_fEMAYSWoMSUQmJWX5sPlzLJN8KyU8rYKPld2sOpbW_pOG_p2fZ_fM9wsJ61I3vxr0OcnxyjWiKdQwbLoNy0xuat2i13PoceaFpVAoa3EYh2TZDi9USb_p0Cs_pzi_pnmY9cwXFSneRDLuk1GJczbPedNB_fcTXbS1U5EGlXWvxEWYiWs1fSBuOcmjVyIvYZMLZC1sL5yVECCkqLZvuFiaaT7IVymq9lsfM9ADDJRd7FNaXvkj4iw27O9C9t81UgJoz_pv9OgZyGLzFcbpMrWFbIg3uHIBXXIzhjRfu5jgByjKyaIseTl2AmpAZvo_fb2i29rlxQSFMUaP_pDWUgtIZCVPpo94_p33fIb5VGZOlqHK4ZddTpEI6mObTe3ZaUl_p61XNqsKnevff73Og3_fm_p7bSVBvzsmDLwaY9XK_pplk2jjFge96YQg6x6EtTMKUVuHjha45IiDq8A7flpn8pJdqXIiaS_pIQf0_pj8aXLWHvekgvKXzOUVxS0ZVjFdKosqA4JxSm4epqjniAVhaT6_f3ainvVxmOQroSSwd6CzYkHKLI1PG38epFEOTIjHzpyjVAQwY9x5Sn8_fAiN7HLCklk8pB0uMlZnKLo5nFaP_pSyFKFXsA0wdYGar8zkQBPdOt_f846cgOrHkiPagkRxpka2EE5qoPhwDw9M2rvD_fC3JID6ktmy0SZAgtThgaDaYf4bThFrliiRSal2aaNr2Pd6ZE2jOFVGNfm5frQ8Oh0bHTdp2kqbPNv8_pYdLxHVYSBz835NLC7waEI3Z9l9QeyOZSvDPKiY3jDZtlxJoWUtLA8alt_pgNtakNarjtoLswl25RBMX_pnA2vuHD81wD6_pz0jcFwfzH3WQRWo9sVKpW2TpQSSj9EBMs13N94gx4v3AXEZVvWRlI4RFWSd1rhQ7NtHL7l_pwW_fx5dyxBXttvoofwT_fTOPiStnK4d0My2Lx_fkUaVc_fgJiP4DkEFy4_ffFifux9aBSTc5buBX6sMZS8k4OFUl3W7B9bQx1T9riEoWW2Yc37fahFT0woUejz6wNjSdKwAxMILR5PG4C_ppUnCV_pFSL2K_fXVnNwM3cLEvzaWQ2wYa5B9khDScQzGrcKX_fNLGtzG0udkT40xobKmYMwK74ebLOaFRONt4P3XKtqyTc_fzQaaDl8BQU92F2fCKpgB6alza_p_pVVgLWcRBoBGrLaHYEbUz6ptS1MKlVjA",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T12:12:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": "United Express/Trans States",
					"departureDateTime": "2018-08-23T10:35:00",
					"flightNumber": "7805",
					"aircraft": "Embraer RJ145 Amazon",
					"aircraftType": "Jet",
					"flightDuration": "2h 37m",
					"layoverDuration": "5h 13m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 55m",
					"arrivalTime": "12:12pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "10:35am",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T20:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T17:25:00",
					"flightNumber": "111",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 5m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 55m",
					"arrivalTime": "8:30pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "5:25pm",
					"departureDay": "2018-08-23",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "ANA All Nippon Airways",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "8:30pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "10:35am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 55m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T14:15:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:29:00",
			"destination": "NRT",
			"downPayment": 942.03,
			"id": "b4b4e5be-100e-44b8-a997-6cb189724455",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pe6MXYQOLgv7fP8nLX_fhVospd_p5FWpwcCV3IpNWYcQ00jUT_pBFSU8M1m169OxYtYtyZ19oVn5HT1qAoA0bZQ65fYfJ9vtWXVnDFlId3rkybwUeKnACcbHA5OPBJVr9nMChtluYoispp6sK24Ll9hx_fJIRLaMh_pNRXhuMWMCfk9EAt3CT_fOK2SgdojbgmOTml8dsJfFpBpw4iP_fbyZAS42VcKiYGzZ0YqaEruPeqJQTSxptLrQQ_fDEtSbr9kuJA8QbMH_fwTRUi9Lq3MOKj4N5CTbkcG_fBBdn3FSbFeg2T0Zd2yy7ndfAqX9jmjwyKRLaJ4d2vNt6py4VJpuW5EULvj95dKicmymZnovZWrE2KOglo4z8jbURiKO0Hm9_fALDHXDM_pQOSy3cVXvskweQKHPga6KNTFDuQjUi050XuM_pHtAUeLDzIgetueyQKkhlxRKe4zPP_p6LDknaLxZSiv_pegHWLPYPdpWH8nVo45pWaF9jZy7O_p_pqmvOCqpBUaWp9GXa9xpd9UT4RqGLOImUF3leLZfUoi4HnNoaTfwBr5mbwsg_pC2YBpOtk9uWkjeDmiUyMh_pPC_pA9jKHQuBADHnq_fMUG1aFDMIW2LCeAeJXpx2hdBiJ3tPEVSz6rjbY02uDtIJLWq73SX7hZi0pXain5InmBR3h0cTCESOmne860GrSEzbAixzR2LRwhqoEU_fbBhHdkBWVFtgmi3XKuuLmIfOsschnNxpeIHql6JhmR0rtb4OvCgSg0qgpW9jxAMkEW4z5y1EN0gOpm_p9o6ttw_fzuqmHnZ7mLzZIvvNhqnzXm6_fa3DrwHmWaOFZ_pAsr0SOuMMx4FMnhFG1_pZncDZGyyh3chkdAAoPCpabN5oFiGM8LVxTuAri2kvdCdAAps7404dJfKBvGvGXnT_pcygvIKFE_p3UdmhiOI3Lmhq2d0tkK_prpmybVtTwV5GEB_f4ZYQIpEaX2T0TtzykBJjTK3yRlMMV47v2qnxnytZVRjlea1yFq_pzhhnT_pJh2OYY1WV28DI1KnlM7SeHR2VtuZcRnf157Cz_p1PlHbozaLrntjlsqMiRCRDSRDiqFhbwXd4y8sjqMyyTtMfM7IMYQh3hjKY2a0H9M8thcXiwum4xiwC7T_fBs4HO2W9dpX_pIIDw5G_pFkcUOBCz3OXIUA9g0TgcMuTmxiOvCD2sGxKR9ZwT3NtWs2WsrJmOJGrBlDbvRHtKTxphvAxmPR1N3yV2uOzHuBC8DOkkkEmxKgWRgEExX79AssxlHvQIi6ovlke_prq4eZNr2MVhDn8UbV1ssRAXif0Y_fstyF9nudCOS8sRf8neHliCxNugEn_pCFIYjgJG4alODRpsTCb8mwdAZ4c9fcYOpfgYoAAvMbPkOV7lkntALSAaNVDmHaAp7PkCJ4ryhJSXYj28ytaBQNPA1aqjWGXN_pyV7ELZQ2esW2gdgKYGmizThQFFl1d7XYpSFvmm_fJRL0xdjdMdEL7nU8RzDv0M3utYcQvBOYIGa9_fjjQF_p7XH4FTJYJNCVZTqrH2zHxnh79GaP8zNSZ3jcpM2WUm6FjDbwyLIgoGNKk6MtrDyvZaTvoQVJUi3wr_fiF_pVl_p98BNlwAA09cJR0dmNbA6UUDE_fjnQ_pFpZwxB0gdHLG2y2YwSABBT0_pU6RfaB1GiFQFDbhfIjfHFZAtmyNggjrS8bvsxs1eYxhgs_pTZKMqov5aheXKbbE7s1scNxXkMTClhLJVTdrbWHcu9pwxHlPhaKSE1OnoMR6Nnl7_fKSQJSrDQh0iaRPCl_pMNwsjSzZrHkzYVa0bHWBxAh7HOg4WtPuqPNAOaOH2QUl_pO71GhevP_pqTuWrceXVNLnTvJ6cjWjELHfxdBWnTePXuK1il5tzfGvLt388rP8bRdKTugGvVgWqGOcmMTu9Pyfbagwp4HqPqoMCTFAtTsGR3BR1fX90yUrL_fBGqDFOYq0e5SUl6EzEK_fPA0A3NsAWigqTcvP4pDlC3vYGOXAoIe_pYDKLgxjhAHk7MzTHdqqJlP_pLZEVJEZQ_pvKAa0wLgkHz9Kf_pMcm_fBj4fztLFxn5XI7RCVbxcGM6kpM_ppTRhnaqh6bqL49wGF_p4fk9wYpKIk2hDtJMhnaCdNEIim8Zx_pOwqol_pos3XWs6o4kykllvcHNc9_p6wchQKpyQvthvwOjRfStK0_pzA3SyKqzucdALl8eVT9mQFofMuIZBVlHb1jvbipW7q6slpullScT_fkq4r9b6lFQP3Aa9o63D98knTb9HAfPEatnjCH634_fgeIjc7xBW0_pjPMJb4ONuhkGXNSeQY4zTwNONOlUiAoOWd2WCPMa0YXco",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T09:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T06:29:00",
					"flightNumber": "3981",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "4h 11m",
					"layoverDuration": "1h 5m",
					"layoverNoteValues": null,
					"totalTripDuration": "18h 46m",
					"arrivalTime": "9:40am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:29am",
					"departureDay": "2018-08-23",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T14:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T10:45:00",
					"flightNumber": "175",
					"aircraft": "Boeing 777-200",
					"aircraftType": "Jet",
					"flightDuration": "13h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "18h 46m",
					"arrivalTime": "2:15pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "10:45am",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "DFW",
					"originAirportName": "Dallas/Fort Worth Intl Airport",
					"originAirportCity": "Dallas",
					"originAirportState": "TX",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "American Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:15pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:29am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "18h 46m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_JL)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:05:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:29:00",
			"destination": "NRT",
			"downPayment": 942.03,
			"id": "e975b8d2-198d-4597-8014-6c0af4104b7b",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pZ8tqI8HbJqRr_fWkeo_p117O5A1o4b0E_fAYtkOKpOx28PzdNP5lFxJ4_pExhKE1zcFuSaGHErlFEpogjvUdFjMvUvACjxfOkfrsaXA_prlfhnEi3Wpb8FzAGAHfU0RBHkaqQ8ecnfk3XjlYWsdkP8A3Tae4AesZ_fpWntnRdtKdOuKjk_f36cDcEyfqAJUKwGbP7lmw2JfF5ZPK8SUHpygTn5twZFdPSPYYLWNLLxJTxfcUGD47IvUnPv_f1ZCliGCNTFN3E0hxqpuv53qZtqOyPfacomvqFpRaT3lgIRl6N8fgheOPG4AyFj2MlEpEhscGrxfKZ6fDs1zQG0_fEtUAxfcw7RvUESu58donf0hlOjcabGQiAisPjm4e_pq33KsgGRqKyczjs_pClENVsHj5aHxVZGz8Tob8p6kQbVHrh_p3doYsgOiScKb5ZgGWEITt4lHg6Gr_py9RuULVyppcRWLHuGV7AYOH35p7mmSx4zZ95kNN0rdn4kZnN_pSNXBBGknoDGvm3D3NIhJiMK4Yj70x6uz4qzVoMDyv_ffnnqCQnoVsOFq4HskJ0CSw_fAXFXu7txjglNZQCUgQBYXPTR0F_pCkor0GzlHbrnZmAZPF38umT1wf7_p15Ft7dVJLPGX6yrbWQSbYjwCyS6_ptI3JpgAFz3qplo6C8ajAA5ffSmaJ1Fq9MSfkM8KE6uIxR978_fRdifTXSwJ_fZ5dXv_plqWj8hTOqEW6gXUF_pYG5WqMVAjOXJHACoyT0_fmktwMCdNFYU5LMTikuZYO6HygTOv21I8jIP_p3c38XH28QGSbblELWDhA9z89cN93CWToM0cdwHR32oMKL4LfivEoZFYkvsrM2g9bp0HMBLuyuhq_pUVs_flaOC2QPj2J7_p9PCDnXfrpfUV6YsWAvfLMi8GOpmd5WGYpWi0rc1Us6pEiZDMhSKUmmBcphoIXBueJrMht5rIVsR96_f0ORJ4_faYZsl7au0pjQJ_p2lmUyHHTik79X4KrE7XoWm5a9i69Zk8YkbYxnso653splRZOMfKxg_fPP8dXsTdqYTxrkxpkCXFmcVfI6hvFwS3XAttcqlvqBeWl0iaGbHLRY71SnuQ9_fnVHQ_pRX4Qe3jxG3_fK6zdpBzabMTT6Gw5OGPiKvh92h8Sc4lW9pnYIAJfAKNIfM7KYGmQhxUbuRoGQPyTmG2b_ppNO_pH6KnxaQTfrAUaTbh4Rp0yzoZXU4OoEF3rzTDJoQy2iTEpqIT40tI3PHVazwkTcW_pDcI5jgCMKfnumkQmVdufQPHH4hZsZ1U1walZHjjDdLoWVcRrgcYvotq0Ie2w5Ph727NoleX9fTc2MW5BsgHSgxo4Q_p91wJjUWMvTWafB_pSUxFE0QkhfI_pIQjnMuJ1IcPYRloybZwf3aupMIhaRSZ6YPUQIemhCU9UGSqoo1InZ9STc9e3ZEeRZKOAKooX_fmesEmnTnkLctSpQocuhyn_p8K_f6uTADo7BBhzMQZh1qPU6h_p5sp6qope9apoD4aJJB4paG1qggUIsPJjPYRTSWEnfCODLz2hCbHtecbIGxKDgKwKv4whtloP4ejDjP0hqV54u0j9ucSYkxrFGmjuE_fxq_f8g_poDJ4fFy4EcjdWyLgu_fdRPUPp8BODc1tDgyR8_fwFLG5lLj1Akj1a0_p56fVXSKjwRwneTG8AIOy0uW5P3PaR99wHVZGQOoMgUk6LH9UOjfDh97WY_pm5sb7my8bi_pRy8XhNur_fOf7K064ABCB1m_psbL73x_p8Une_pw0LxuBc2nljZ4Pp3bnbHOKLJaq_fvdwpncBqwadQ5W67taTghy3fE12VWdAAcijO5PpSsqZ7Ae8K8ifQLbEw0PCr8CxST2bWIPfmowRCXMlQ0vhOZyzKmMYolOE7D_psumpz7YNuU9sdoh9GEBblvLaEaMs_fwrHLpSPnQffDpKXtlGgMfYcHTb_pneJyidYuYnEWoNh9bX1WEDDSEZ4RX6l4x4vizB11AHpbCOGoYHRaG_pa4vFQ1vJuo69dqFZk8yg1MFzEMrLEzT3XC5Cgub2ZsdzbkbFaijdn9NkGJSsz6n7RuuwzBTI_fPJ_fmcv_pZ9V0f6rTLxcbEa0dSlTrk4cq5F_pfq00JgL8UlLzFbquX6x6aKKizHfHkdQ3ZjMhjmG0RwQdZOpmJlCDppn_fO_fAb7LT7LY4_p6HsBhts0qDRXFkJ3rUmATfYP3tYf8H9YaI96NdObgJmFg2AwCPc_fKJzHNEVWs9qlxkmjmdiq_f8YwnmzHVRSEQKKjPiNLk8Nu1qD4BsKT13OFVP83QitRSXilp5lGd4_fb0O1MeKqrPLJqNQdk3d08_fgTv5X5s",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T09:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T06:29:00",
					"flightNumber": "3981",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "4h 11m",
					"layoverDuration": "2h 15m",
					"layoverNoteValues": null,
					"totalTripDuration": "19h 36m",
					"arrivalTime": "9:40am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:29am",
					"departureDay": "2018-08-23",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T15:05:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Japan Airlines",
					"departureDateTime": "2018-08-23T11:55:00",
					"flightNumber": "8481",
					"aircraft": "Boeing 787-9",
					"aircraftType": "Jet",
					"flightDuration": "13h 10m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "19h 36m",
					"arrivalTime": "3:05pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "11:55am",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "DFW",
					"originAirportName": "Dallas/Fort Worth Intl Airport",
					"originAirportCity": "Dallas",
					"originAirportState": "TX",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "American Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:05pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:29am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "19h 36m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_JL)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:35:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:21:00",
			"destination": "NRT",
			"downPayment": 947.43,
			"id": "e89d2637-804d-4b19-bf1d-6a0175820c94",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pSx4P2XoLZ5TCIxV48g7VoPr7CXuE0rN5qLhym91wCKC2Vi84fwiELTmIngkgKWCNDn_fRRovsLlEopyX458LeAsl4jt4g5_p3Du9_pIjG_fZDHaY_fquqw6wuIos602lX65dbVhppwlueNzKTX2tVE_fC7OppGzea9GaMj1Z12PTmlmkUmTgbrT_p2993hspgumqqpMRlpB2t_f2EBGK91gzZIH4Lduq2eunDLk5WbQXGzDyDxTBrKVxrOFB40275RBB902G6TOXs8Mkc9rZH_pCMFP3Sr6k_fUg5TohNn0dE_fSZuym_pMfwvdghFv9ork1unh4t713bEg_pRHRGExN23P9y2EjQojJFsP7S1CVChKKSxbm46umAgAtn3e312b_fhxMTuUo_pgvc7IyK6fNJWc1JpLkjbju6Qsv75DtbBEfZirk79aBKx2kk8vMORu2K8DEiiCa6SA7_pqq7n6cGkWLAqckGhBB_fAHsiTLtY53EwnA8w_fwgipKOFL7hONop9K9GvvpQLex_pcdibRbkklUvnResB_pIsF_fZ_pfSWNpufCALu6W6Q_f563qfQht3mgKiVIjfGRr6uS9FoNLaUztJkqZSJK3FtRSvPNz0_p2UIVFO7OSLKRX2DnSWZ0NaflzsgvHj4Ata7UxfeQHLy7K0c0MoheTHj95gkowNzhrEl7_fsl284Vp1czFopPcQZdkYLZrDQeHof6ZCmpN6uQ4J4dyxduCUFycxT9yS6qePeJ5aEs_ptc4IMy_pF2WeRMH8wZj0SMUjKFZYKt_fuK15odGbUez5nVAfGoGMduMHAE9tRWMYsFtbKiPFgMEo63JaziBvwnVWAWQTb0l_f6YqPGR3YgixTWN313eNcxFCAPYW20toWAPCtBtTrdk28uIiiFcBZ_fwnCral7eJjrql3KctzsgDEGnFaSLiFC0VznDWrkCKXkiq4sFLdPTpTw95XWl7Vmt3q2eFZJlQx1t4WPYXKo75KtH1WyId6rxpXh4vIMVJuVEMjJWwBhmmJPfJKiJi3g9nnSXIAFn8SimIiPbJJLRsu1HIJ4BWZAENC2I8FLr98QJU3tssg4eq2_fK1o9FDqX0lnBwl_pLl5_pMdFvEThe8Q6XkOYs1wHvPSReGPvntx2j2Iu_pZ_f8Ez_fXm_fJzVY2tvmv2kcWdg6xEgXu53VGG57bQBnPfkJUDAE1fY429UQeW0mBQmfSwCwhD4omID_pM2XwV4lyuPlv_p80_fUVBxdPRTAL0nh_pIJikVUBe1Jz4sFP3FDhHVsAz6gHXyy4t3EX2YEwlmgszRAjmJ6IlhTTUlsA5s8JILaKA3h6HXWaz8dJCHnIGTHXwgYPEad7a1jfKuwuvpyEZOZlZs7jN7ItD4ChxjFdpmHv_feUy0U_f6kbQkpo_fXh5U4ZNFtKGKk_fxJCZ_fEg441V6l9_fM33WIIRHWCQa_p1RI0qFWzpxT4McVpn5SRikQHRFOdyTiSdJzcEDh8O5il8PmBo4ewXWrnU2_pFJxuy1iQTMEVuiR4tO8x7tpJ3hlEWhTVh6ji9j0PvtwLCxKoi6fiXrXuNc8EB2v2JTwXyUcIN_fOwGJ4kbbVg3sqn0bpC5c5n_fTuSkhmNkpAL3o5SorjpnRZrBOy3e8V8M8seNGs76LC0gpfnylQR2S4uqtHPVwAccSnc0QYIi7M_fSf74U03LPjRQKFaibU3cVwTHcqP0C96P1acLM5qPOFb5GvWruWBJeYGoZZBAjxn8ndoLJi3tQRbLoGi8_pYW18LLzrrwKE7FKbF4YybIIqPorxN4S7AqcrvmkiPanlBuoaSDSk9cT7LNNMUXLmZT2v7X5IihL1AGWFC0CtNNSqLo3oGw6V2xTm6Tm1TDa6SjWZGFoWua_pDJuvpeMTB2FlBcAhaOD54dM5XJDT7TC8q4eEAxH9CGzMcuNuQtMfMufv_pvQMX7XZJXZCTOOg5HZGNhmuOJk9V7gQeAwkoarnc9Nb3o4I74xmbhhpa4cXrQTC5LYEv6pxUFfXy5v_pDbs5g3zs3ukXR65s5YrS2W0tuhOjUJHk54yrx7hNEeY0TasJugVca5NrDoFmRkKRt6Y4Ybmn5oRvIRj5dYZ2E9vzPMmwWzd0nrRSxeAIR8lE6X75b0Ti6YhrFEbcHbIhrFwaJ3XIcdjX6rRp4rkI6W7KMtFv7rp5r2CEfDUYVW_f4Gx7cg7Y5auxD1otK0W5_fzV2Mi_p9g1Yf_pHdnAMsB8g10gc2PtBe6ZftLq7vFPg40E74EF5W99Lsl8MnQ8AYB9rq6RAZl3gdWzyHfX2L_pj_pplbH5VtoKBNsZ3XqqPDhNxb5y_fRFcRNhpc30vG_f95pZwn539iqTyo6SVcAyJEVA_fMVlmaL",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T07:54:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T06:21:00",
					"flightNumber": "3652",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 33m",
					"layoverDuration": "1h 36m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 14m",
					"arrivalTime": "7:54am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:21am",
					"departureDay": "2018-08-23",
					"destination": "LGA",
					"destinationAirportName": "LaGuardia Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-23T11:19:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T09:30:00",
					"flightNumber": "129",
					"aircraft": "Boeing 737-800",
					"aircraftType": "Jet",
					"flightDuration": "2h 49m",
					"layoverDuration": "1h 21m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 14m",
					"arrivalTime": "11:19am",
					"arrivalDay": "2018-08-23",
					"departureTime": "9:30am",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "LGA",
					"originAirportName": "LaGuardia Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-24T15:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Japan Airlines",
					"departureDateTime": "2018-08-23T12:40:00",
					"flightNumber": "8404",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 14m",
					"arrivalTime": "3:35pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "12:40pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "American Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:35pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:21am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 14m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_JL)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T19:15:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:29:00",
			"destination": "HND",
			"downPayment": 947.43,
			"id": "3a53c2ca-f955-4460-a41b-dda528ddbe9d",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pTC76uxx9XQ6IdAffBzogu0Q5OCbUnRmefsivBBZtHaFVoccww53LGGI34QsRkfIOEKy_fybVCD_fra_fVBY8_fs7VzGPSjTp8bnq8iFoH0pzmUMaa3_pJ2hs_pFjuLjvEe2CqcpD5cRKdoh4KtPNqfVcU2dH8kLbRFJ3AF0ThwC9BOSjKWeFJbZUZndBspeXEUVo522XaCIptvBoU_fjTpr5B4zGtEIzGPsh8zHGIPiwLjHtVZ2kNuNpUTkNJp2AJ5BynlTr6ElPyAvWNILRN799NWMprgDNgpf6Ola3TWZEB5O3LRw9iXcsIFQe1Mlq_puxuU7f_fQf8jkehEUKBn_frKXOL86rZV2ls0Kg0Oev9Wfn64OyI8Vh80bMJbiLEmPJhuIS8bBoTVVQMTnr5895_fU9cV7IUfXA2cboB0pbnI_frgjLDoCJ6gwqAdjgqmQF3Xc5DUb0RgdcVSD3JPk_f5OTsa1cH51pyVhV_pUP6pvbbgEK_pU_fLoRVCjKVxGNiAtecj6f2wUiPVnpqi6pxFEmcLR5ZxDtcdo9P4FSh2iSfmBcs6YuzKIyf2idkycd4nN227zgoS8ngU2KKgIMGgVmV_pEY01ikDHJMKbOhIu5j4G0b13iHV86F7xCLv99vew7N_p6fpszC1JNjewkfKDOLduE53VxhWgND0_pWPUqF9n4wy9gH8yhlpxKiY7UNhyYp2qz3NbgfJ1bUbrA9_frdrtTDzFEK5IgRc09SVTOBN4pEadiTb83HCiCeuhLsx1Qtit5fpKqHkTFdiBMzvPSJpL_fo3EA0UrJkNicNdrIGr0ElUf7z1slU0g_faszGupaR3Pwp53resOYcg50Jjyu0Tnfae_pJoCRP3aAyhtDQbHmvTP59NYjpnAXcQjOnGpDUv_fdiwy5SmdDV8NHXwE0jzyJxWuR_pbZBSQUxWzd7SjUGbdu0_pdU1xTOKX2mb5yDmb7hkB5NaTTG3hGytSnJz8oO7Mba3FntTzHQF1pN5qahrcxk8J2xBmAVepeJb9dbwChsuEWYBBOkLsNYjUKVj4a_p7aXNwU1_fUfnNGiwUvdjZP7SaG61ZvwHW_fJjA6m9ReV_pQT4UuiuFPaYr457X0Lrob6NE_fHyEtbqVRRExElnE1FscSJ6t6h77hstc9RQVnRZU_pGrEbdzHehzcD1cBjp98I9dkuwsCVtljdl0oP2hVBwvyFtpCzBRfJBJsgofmAi7d5lO047o2ONoGwCIInlt9R6qjvMTcbNFb72iDz3NrmJYAvf3BRhw1r3QA2YqA4HKF_pLLDuYHU6PVfOwoKE1jwh3YSsF7qu44jjrBN5JdNz887VpIAUkRixzjesW0EI7k_fIno4lq56wm5VT3gD0N1aPlcOLmcCyPlFeqS1EaGLoA4SOaPmW8jZJUdYVi15G1d_fwqoBFhuD2tCWCkrXy8MHeo7mZAQpYIypb853kBMGFyvtuV6z9U8NX5cM9ntkVgUnE1x9y97XFHWOTAFSr6Foz7TWNh_p4_f0WyoJ5LoO_fVi7m26oCmx1D9KhfKzMguOqHdXqThgcEenDJjA1HNqKnjo0r3M6eQxvd_pzjfiAb5nwWdfuSMiahenWI3wcxpKRFLdOWnUcedo8G0DxWvo22IUDaXlPgala0oNsNYfFadqL_pXZLl_paPWdzOixcTAmMpplzKmh_fzrlSg1aYkJ2uNij0peOmOIoUP7BlxOn1p66_pl3QWUAUEtyqIMmmEQyeRTmVyhWG_p5LtlJsBZ0rkcVx4x9YVRhAGUhHdnPINhbLjPZW_f_py8DrLMafXW4gk8iqex0MUlksr4PX49f_fiEEi4dWJD2OltyvjYTNd938L1xeglxcGVRb2Zsn6OayLatwPaCxDtb1c9_fziC17jh9MoS3tGT7Otnmt1CumdBMU60SGGGMWdvpxV8UjLJV5C4Qjlv8C7QIg0HfUAutlICuKlYGYxvmduWi5dnDD2RiYFyUILsbLHFcXckuUO_fpfqDh62KZ39oie7ezBGs2AjxyKNB63ojntJGYHzOTeeaQeIktn3aMVvRZ6WaUeyDW6qyl3vBf9g_pxDXJ_fFW7yW3Fq5BKdnmTQmEH_fCWIQI_fgT3ob8ra2r8_p4sD9f39Scy4xzkGCL35aasBFQIkONIH_p2b9EfkMaJRl3vqAGRqi1u49X_fMfnO_fVMpZN42nvKBN07VFgA5K_p4YZoBpcQ9oT_pIexnG9qkf8MIwaTqALHN6ilp7JP77HJW9kKDjMEkcpuV3sD5hXba7SK_pciRIs3xg_fq_pEDHPMljIWJQdG4sgMd6vDk_pwlIGtaqTpYBiKXF_pHo62xGBbLnMeLIUYu6oFs1TweZbAw_fA1UmRRCsF9rWVAonomc6",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T09:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T06:29:00",
					"flightNumber": "3981",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "4h 11m",
					"layoverDuration": "3h 22m",
					"layoverNoteValues": null,
					"totalTripDuration": "23h 46m",
					"arrivalTime": "9:40am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:29am",
					"departureDay": "2018-08-23",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-23T14:48:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T13:02:00",
					"flightNumber": "139",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h 46m",
					"layoverDuration": "1h 32m",
					"layoverNoteValues": null,
					"totalTripDuration": "23h 46m",
					"arrivalTime": "2:48pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "1:02pm",
					"departureDay": "2018-08-23",
					"destination": "SFO",
					"destinationAirportName": "San Francisco Intl Airport",
					"destinationAirportCity": "San Francisco",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "DFW",
					"originAirportName": "Dallas/Fort Worth Intl Airport",
					"originAirportCity": "Dallas",
					"originAirportState": "TX",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-24T19:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Japan Airlines",
					"departureDateTime": "2018-08-23T16:20:00",
					"flightNumber": "8400",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "10h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "23h 46m",
					"arrivalTime": "7:15pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "4:20pm",
					"departureDay": "2018-08-23",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "SFO",
					"originAirportName": "San Francisco Intl Airport",
					"originAirportCity": "San Francisco",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "American Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "7:15pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:29am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "23h 46m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_UA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T13:55:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T08:25:00",
			"destination": "NRT",
			"downPayment": 957.63,
			"id": "ef15b8fa-d147-4f3b-b8d9-32b9db8e87a1",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pSewSNpUDTVqSnrLj4vmMEBWyLFWgsRhwCHjid5_pMui_fcA2aB_pdKU0AO4DN7OMFW2hlnncyMi_flUBqyO2j1Vj855BPdfuJhr97Tecdksto5ASMxV4GbryADnBPvCH0acasnfSv6MbO7qTbR5wm5glZsQVQS41PWPPf2hKh1yirTAkMMTXbP5FzFI7hSIbAMM8WxomxG5rqWZwJJdHTv3DgqbhOT96vhX1PlnJjDeFebbW0YQlve8VG2seuCMy5vDKFB2eV_pzQASDRjRGUzTx7P0EeXmMURCnoBME8YMbDFoiUfRe2Yf7PMA7jBd9M5vrRID4afmxFlcRYkC_fwJIoB6aH_ffxRCF5UjHKXd1kP63K1DmtTzbiuWDnv_fOmLto9uaguPOryuvd5kINDno3yG9nknJTnwGizXhpnRde5XCRd9cIU0MkSLLMZycycFI2_pVgef3RR4HySHPypY8iL_f_fd7C2AywRC_fOvkSqdHVTL9alLeBx_fUTBXW8zG3A59_fsDBrJASVYT3FV_f4SLaN8sQ_pAWlbwOipEn5YRbpMc9ZUzgj2P1cw1sfRVtj2k0Zz_p_pKPzYEn7o9ALZI7COzY_f3R4_fzp_pcdQcQDO3QYQHatq54gWD9j4AppuULa8z1SCo6rGbf8tmMZ8XIZ84ioZKtTVH_p7F7EtYj_fyuGwjcjI_f37RSVS6a31WcAq2lnEzW7DOBvn9yQSxJpOEXZd8MI0bOvX7H0yHGJsU7B6OMXclMQ0cc2sENZ_pHsYVD7fjA5sf9yAwUHdRxPLyyFdwS_fat1ZoneDHvoyodlDLrjRRr6BnBUmY9PQk5U5fHJgrrhmROM3mLlsC3MaXlrLB11BYNELGIHaEr5nANOFwWuNiY_fD8AA2Le0uhaGx7xcwlHridLC7bZbZk7YmOvGV9v7a84l3qMBCFh8YlpY5_fHBwEcXvxx9uvRMabLNZ3Z30PzAuFJ3TSQ_pNJq09_pitsqj0keqbAlwfRpDjA0i8IQTyKuf2E7CP6e9oYiVK9NrZotss0E7t4q_p47_fas4u5hsZF1G94tG8fgMKz0PSv2a_fI8Nz_fmYTe9_faUatfLWGPZIpABkpnn_fLC5onOTzoqbN0mGl47yPb_fDX1KvQQ8JddWclQj7NgyOf9ffh9US9jQSAJkR2hgwESvDuSmLLiSFJD_pFUhV9rjv_pwOtODU9RMuzP_pJkxrz_fBTZ1Rnyv8Qfn6NhpTWYHhuF9ciYs7kKC_pryDaqafL8n2TohsNm_fRpBVFpGS6lQf_pBB1fRbxEUFyX5L2zzvt3nEOfsL6CrmmvxQDy2SUjZ4_p_pYNeACpKIqYVoECbbZQ_faoOQtR8WH2Efr42M_fsif1viRYP3bBFioas_fCz_fE9JIi7lpElD5SzkQZUxiZYoHJakcJ4aSZTISvdnlVdl1RntqnMw6di_fSHJ_pXe12otLm2Iy1qrd6qE52VzQSILf0jJcs_pbEEuJB8bja2cFtT_pHuvwBEaVTnJMEAuMTee72YOT250wIbIqi2q5W316urCXe08mZrB8rQmEogNDxQK8diC9B8FCVIn9sTNWQntw9cD3CKtVy4_p2RC4cS3RNpCqCipJoL1qY837A5jHVwNQmhLSAw2_pt_f5jkItB9Y3Oy4YWRsjNyrT9axHyLQbHk4caBYUuuM_fgAKhs_pAeVYnjvpBlygYJkLH966rIobvmlUzKUKGNyhcZMjz_ficuA3Iu5DRKyVXnc8BU6nMqlLX9bT4DFGcsFrjY2d223bi3z1g3zkd27M1uspjJ9wtxYPHAiR5jjG_pcTJJiV2dJrR41NV2HbX88uZmOIcnqhhJ_f1l28VQcgYgl7wof_fOUC2ASkofKvF7RRFUN8EhbgiBDRkaI_f1Om0nbfGpRQf_fQbH69GTxuCfj_pJF3ooSSgimDJHxWK6YT9rsZ_pFr6ce3uPNDk_fOJyc5usjng_pXDp6D9Wr8F_fJvy_p9hTEucfIa9_f4Sxt76qgUqB5GRRfHirjc7uoYRGn3_pFmAA9CKuBIO3jeqNnReestBp8RHFAXGpyP3Ie2uW7lh5_f9jGUE8TPT8di7Hh7Re27NomOnEGm0LFvcOvcF14V7830bpOkvQ_fPGyzlgJ_ptRw63G6luw2v6jWf6KOSMbWsM7iWnHJjZ6RsPihca3PDiAqPMDj4R4sjy3kaLM0fuT5uRZBgX9gpkBqGHY61M5Irzh7PAzv_p2jCKpOG8YcwJx7GiE11gBUkEMlwWywySsWX_fTK6DOva1jaCmVuSro3KuJHoB2mxQuBzOgMTTTyqwZYIOI3RZawnOsrdDAPYeKB03rV_fWJwXwUaOvB9eHziozoFPD_fek9rmfb3A",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T09:54:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T08:25:00",
					"flightNumber": "8154",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "1h 29m",
					"layoverDuration": "1h 6m",
					"layoverNoteValues": null,
					"totalTripDuration": "16h 30m",
					"arrivalTime": "9:54am",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:25am",
					"departureDay": "2018-08-23",
					"destination": "EWR",
					"destinationAirportName": "Newark Liberty Intl Airport",
					"destinationAirportCity": "Newark",
					"destinationAirportState": "NJ",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T13:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": "United Airlines",
					"departureDateTime": "2018-08-23T11:00:00",
					"flightNumber": "6453",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "16h 30m",
					"arrivalTime": "1:55pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "11:00am",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "EWR",
					"originAirportName": "Newark Liberty Intl Airport",
					"originAirportCity": "Newark",
					"originAirportState": "NJ",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:55pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "8:25am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "16h 30m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_NH)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T20:30:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T13:35:00",
			"destination": "HND",
			"downPayment": 957.63,
			"id": "ed8fedb7-44d0-437f-b78d-9170f3a634d7",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pZc0KZK5hxWNLPSmxghKJpHaG57dZ3TNkzhckg_ppz6Occo6V0Omupansy8RDdlgJP6avJe92z9KrYXU5vqVVxjtpqJ9ske_f20_p_pk4Oh6Ac2PdUXNWQDIB6PMlBP734n734ZVt_pEDjwwvS_pdzY4Z4NHsRXaQeQmOi7q0RhMSBf_pLjXRpGc6ozCTueT9ZdKVcbYV0BOYeygcSNiSu41VHdU_pxFz6gt4ZkVduCnby2xazmsyfEIHA6jgS4Y_p3_pMv_pBXSsFtD0ry4uPvcR2pb6T3l7Za6U77tdorzRpAy9hyHkw3l8_fj5TPKKr_pq9IYYB6n46zW7LvZkSZYAsxikG8Wst3unOsCwV4UwUEa9Qhy8O8h2CYYjVIrZuS_p8RqAE5UuyBU0DDJmq_f8kZKgBaxsnQDTZpb_fUhfLYBAGxoeifo5F_pZ3sJsi4_puo9G_pQAjzFZsb6Ce3VdczsWB_pPrACYYV3dH6Hdl3ocgSLVJdldAE6AL8TeAWWw0vpCYp3CUH9VrD5_fDI6Xi3LmUoJKxkwgkTd5td3Em8pPx2ZQbLXK1FzI_poBO1V1l_pKu_fn21yWgEStNIN5n2Az_pcg2R6iHpuR_fcMcQGnt6uVbgy9i6RaQkBtcL9lwI2Kw8OZVJQsu0pVCp_fDSmKK_fkz2Eo99uaDi1G_pEF2mEGwbonoNgLUr87W5nDELiIyUt31584_pqDXT1BIwIOSxu3iCUWQEY3k8I0SNi1frllGr4XhbwUtR_pJJ7C6tJmAMy3WHOWbwjQGJLk8rfPa0_pAguUAlpS9evi2HUTVX6Nsg_fJrJRp2nHNumFk6J1xillmsM8x3qU_pNw0Ja1tDqrRsTY_fcsGPoU7JPmXOVzOh8OEl4_f50lMDKjVUSlQQLDzOP0xUmu6nqGYVjfqUyy08OgTa0XZJxdXC0woCe5fcTqGkKiA7KM_p36uh8a9IpgSAONER6NLrEkhhBTPbhw4uRsjLiIcHS52xfQa2CBVU_f_fTWMCfA_f9pLpuJ8Nzj20_pM391dVc7_f0cagt_fF_p61HREy7a69j6Vau65hYWwvicm9sPdhyn6N8t9acxpVqHKCtMl1V8p0uPghWjwVjuZu7syWg7tLw_fA28SufGSu_pHTvhfM5_fEYdC48bpEBq2SwIMug9bpAnXrgPAdHu1uTvVf41CFCMKKbxOGqqvpjURF_fsyaVoglmkaNGvR7t_f63puLGb02RSO7VvTi_p1acVGEPUWOXbMHeSF1fLI5r3cDPdokvOqAeKLPRDz7EpO7Sh_ph_fofym2ya1QEyWrhIbT2_fAQ04sZ97S35Gm9Z4bGlpKYFTvRqOLVMxX8XDGnLVHUBCuh9rD68gXDL9Zj6mSW8Xe6OOMdZvwNCAF8qKPGRWhI9UCAe5vG3jvnpPgvUOshdjxEJUYyUqfepgE1a34yxsAYY3UYvvAE7ZslnGr6JA3S1L_fyQQWcx_pXXKUHjjgQHAJC7FyBAz_pIaRmEgu5_pSTZ25CyRbJ5HF4P6NybsFijIIPR7L_fsIXARgPQRxygZxt1pyAIAT7daAIpe_fmTEsQx3XKyNGjjFUwhVvuuI42nE_fwRG4pY2Nt4wHK2qJal2scWOHH7f8YRlMzAbG7GOsS0bYTNlBCILkGcZGIciTldI5HP9O9XVnvAZnrRVUWIvtNYnXgazETiLwUOQxoezhax7w7L16wSHRxUglVwTUCFRm0NVS3_pZdWfM667XYdzVIKlG3udTtKNRs6gVNGSZO9w3MlXftjORDyjpYNdLY4nIfr5p0olzv9Lp775RnhT9H1BAPkY6E6KKhrQK4NIgD8I71dGbgmYDYYrSfnITqvqcimH0rJzKQUEk8PMxlTiJXbpQWgf_fVJLtbX68edXI1_poi7761KoDe6m0HRMueIxKiMm81rauwMA6SwDq8rx4Sf7ZLE8MLEzfXLHjnr1qtdFVK9IiE02drpKpW2zCnkcCjGerg8iYYoL4G3kLZPEpNXZtPsncgq_ftF6Hfv17Hw5XJn0gLlA_pg34taJToIGHvvAPIJ0yd90lJBm5JvjD23BFalmZzlz8iYUurj_p11CEMxoGzyUWOaNhXI2U7OyyNNZ_fWIjn9dCrfOIIu_p_fbM3diHDN278dQztYD7g_pVCu_f0qI6xmmun3yZbbDaC7NBcpCxPHVR_pM72e5dqz0ENs20jYNcj_fbPDDG67EhlItTOA54QY0y8x4XOZFSPhH2KXc6DuE4ahaABXnFETfO33zrNOX7OYE89hsBRMUPxAW5JOGpB9JbsvjHRe3fXarynxfzQKfxTCO3p_pFFEXVq1BJ8_fA9sxmM1WgupzTijll0gyUh9zujM6vqdbZ6bW6c",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T14:59:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T13:35:00",
					"flightNumber": "8481",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "2h 24m",
					"layoverDuration": "2h 26m",
					"layoverNoteValues": null,
					"totalTripDuration": "17h 55m",
					"arrivalTime": "2:59pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "1:35pm",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T20:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T17:25:00",
					"flightNumber": "111",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 5m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "17h 55m",
					"arrivalTime": "8:30pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "5:25pm",
					"departureDay": "2018-08-23",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "8:30pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "1:35pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "17h 55m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AC)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T15:35:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T16:00:00",
			"destination": "HND",
			"downPayment": 960.96,
			"id": "2462fc6d-916d-44c1-b821-3c9a5bc63065",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pcMgQKxujTDJ4YPme9zxlWEniIz7O7M_fjIL_fsLu56w0xnjvieDu9j374Brr30_fvLUae_pCrxNGATmkD_fYSma_pdulcVyebOuIdz_pdR4nekt9Hr_fgicgcL_f6aRxx4FQAzks6SOBe4IRlmpnVbjc2b8V0PNFtSYHgond_pWUKRqleWsJu_fI9kyuSuhjU7isuoLe_pYM8ygVXnmDFluFqKsVQuuXGRXvWe8uu3aFXhYb_pclTW7D43squGbTAL2wYJ8Mdd4qY_fLkv0qwDsn3D_pb6ZdTiBISbVEDlbovsPVniMEeELWBv1iV5Onmj_pETjB6c2kszt6iusOT6k2sAWz9HRb8OKMiznqoUPbpT5juhs6EQbyd2MsNJWqN3YYwYMNEkEG_fFWtFBdDNc2LuEax_pjFNbHkLhpJQow8dXFdHMmyXrr3P0mFnJLFbCvi9yiDdFQnuT8YkWXeQ8vDcXXsqCfUjP2LPdoz50rLmJcZnUuRLPpnN1Z_fvTMWbEL9qunkxmnpnDHnwHQlwdJv8Qs0JxQ9BlNMkzOtI9zkV0bxjW04_fjJ1izqIZLkYFOlrXDqbZ5pEhdXcqupZ6Yk0FRgMq1kC0Z555Hzi_p07Xh_f_fd9_pr_p9FJhih16Oeg65wZqNaTeHf3s3usPP7JTi3SthBB4rJ4wksYlzgbxDbXx_pj03UM1Cd0Vr_puLl4jaRvgnIFhk3c_pf35m4aIdQZL0c61T0qklCNAOCspqIDd_p_pDIdPXKoU4nNYUOTk347nlz9sYJqKwSDdI271s9zivzCvPgDP93s3pDje8k_fuizsq2B_fTmz8bzPEICTT7UXTp_pbwFJEPmYgRH0_fZfDG4bY_fYN17fV_puWDwjV3lvYgeJhz1OdXAtCNKro4VLYRMr2rUtEEM8rTtrfMBUqBZBKLlm1Ic7os_poce8N_pQlrYXWCHh52gNj1ULQvJDlLwOxAOSf78M5b9_p7n4bpDr7xjA_pFtQAMEQQCaKDiR3iOgCiFiSdNGw7XJC9ZxDcDPKGeL0QzbVZdHVMfQDrFwaX1zOirQIpd76fqw5C7EbQqYBq3Hm34DxxCcwxo8t7umy0_fxj_f_pv_pa2hGGmSVPtbskFvhcMG8IyFgCWHzt47NcQjKwYpjWoVcjtI6IEbLO_pnlm42dVfGG2aWnJvCBZhK8LqgfK1H1U_fr7dS6Tj4JbzHgcBh4HvTSa9b7zGBODJKh4Vc0wzwzwVTvOR2iBtS4QlFirz7Az_fuc2mZJBBrmBtJ9LRC1wfQ_fUsdGb5vgbhmbhe2n4PHWypnAoZruc5FMONwqtujqVj8BT9vkTfndXRJ30lIEM8hjEpzbeIXU5_pOck3hQ8aLKTyl2HTCSGisdRp_ftVT1p38Ml0wEhP_f14FTqv7swZdv6lMWMu3LM2rnrUGrQCwtwd3_f7zASnKShDI9I2atTGuT9D7QRf5Ur74c5x24fEuU_fgwKTIR3LQlsO6nf_fNvWaFZ1Qe6gqtaF8kqr0COL7FrUUGjHN05DXiDvoPSH4ZrhLh1dAxGE_fmu027Gl75EGGUwivDyyfRdF9QwxY3FBW8KBjd4KMeysfkarDpnR9knJ4jo0slTQ8k6hdtJB_pX2avy63Qxd63mjB5AitXYlcWreoF0qBh31CKYPQ54IPOAU8YxVRqcaLDBhV7iqgm8HsIYMnjsM4OdMd0L7SLtxxUmndIESi58Uxl8OLm6lDlT_pNOgOqEmldw_fFSSqnCzZCBCb7wT0FrkaE4edzG51HaVJBoFi_fVNga3UcrxAOIFjqqcp20xO1HX5cv_psVvX_phiE_fw4wi6BXp8UnX9LLR_pDnZP8YS3BQhAH4FD6kc_pEFXdlaT2JqoxOikF3e0MkwhL4RZqx0TPr84Ru6XBz_f0EU28mNm26zBAqen90Cc9zzzxt_f68daRFQkNrru7oqUQhBIt7NUkA1Ac_fUNCu5KinfJ2z_fXBXru1_poQD_pHQRH_fNkCf344_p8cDMxczfWt389U6dCzICU_pQR9VStVSVmaF9nIfDVdV8JK0oZsuU96vXNPlVzzC8d_pagR1IKg8Sv_pejlJGA5HEWRa2HFbXb_pO6stM_ptPCqiR53x2W90yiWRGJEgtB5oVzROAjxDidwZrnkoN2p6dIsq7JyyUodFRh3QAlWaQJLxBcOF_pxRX640nqSuAsJ2DHJwMHbCJySP8IvYoAccE2AH9KiqFlqU7k3uptNUnH3jwGGxyaSzSvdBfnn4Jtw8MyH2cRbtiLEu8vPMmxLWpFCPBbzqtbdqWJzvdSK7r84yweFPSQ7evhtoOAs0_ft98yH1_pSG98yYh_f2tow81K3pBc3w",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T17:19:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T16:00:00",
					"flightNumber": "419",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "1h 19m",
					"layoverDuration": "20h 21m",
					"layoverNoteValues": [
						"Overnight Connection at Toronto Pearson Intl Airport (YYZ)."
					],
					"totalTripDuration": "1d 10h 35m",
					"arrivalTime": "5:19pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "4:00pm",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T15:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T13:40:00",
					"flightNumber": "1",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 10h 35m",
					"arrivalTime": "3:35pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:40pm",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "3:35pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "4:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 10h 35m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AC)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T15:35:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T21:30:00",
			"destination": "HND",
			"downPayment": 960.96,
			"id": "5b57fdb9-6cda-4dd0-82a2-cb938503314e",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pTL4XDXFeZxxSNLf12Itwa2xnTiBxjLvJYjnMxWVlu0qSmwC59uIpYQ8coUcfb_p1Pia0uQdbA8reel6_pbOsWyC_fI_fbVp7QSjAUzg77fQeRw7StzpbWud6tozjrsvcutE2oGoXM3DJR6ovMA40ZDQFDdLvtmLA_pqqr9IA1pyy8SHgjukUnTCBFe2LOMYd1t0M8cym60O5KyxgEzUPva7BRrOZz8suKtp1JWJ_fp_po_fjnZS7w1KHoDdtbQM6twPdm1pSPErmSGHOixLH9pPwFnK0lgZzIZW9cVNKL71E_fLJNOtITooyjpPreb52KT6drzwFMRa_pc70_f0X_prvRCQAriQFVpH0H2ivrav_p60xIS4DgrGKvbDmg4oiq59KqWJcLSUZXQVPesGG3PI3lj29GXYN_pVc1xZnVIWnlDs6EV8U7uf3v_ftAUPQSHnT8_pCCuvHIR8xuh_pFuUx9m9ffxcIjz2fZlGlGYSvg0SIZAKR7J1Py6aPEKUgrNU7KxtEdpDqhAxW_puUGlmGb_pNSseN0mIgVP2VP5Cd9KhhPK3L9_fvESQw5BWW6l5a48_fD5X7ZHQENCALgquiG5tGm4yzJd2n1NL6IpJ_pp7xB4GepnsIo6ZIk0EN3n8wFT2bg6rWhztR4gaRgA96mFX8pAp7APGw8DVQJcVkqsfAxbgNXlBCXwFHJmgPqwpCtY0R6CTizurY3G41jHWzomvyfQ9jhEPtH4_fjfyWAgsb8Vz5zMtvx3OIkOfcjegqxseQqnCeqtZ7frbbMwk_fm5hq2CTYJJNtt9l5Pi5BagIuUDQKf3IH2ptd7gsx7oMhCaZVEpkxoEUBzX4GEwCyUGvuwR1o_pQX8JFr8mFJt0KPXiyXzm_fdz_fIlUI_fQdSXCKDpCUiZa6SbVGxfcyIS9ckwha294PmKkQcvYwpHFlSI4um_pLLYIL6zHf9LVgLZUTsYYR8bRgCn9HvUYzCnLTPK6P6K8MKzqtEgIAyZbGt144u4G0doTKfCeN_fpIcuE0Dh_piiRtQBbw4ErkH6oulfbZiaGqLQZh_fvc4YCi_pMyoIBXlXLeAyAq0mrC4OUbqnf2_f8IhJSuFrAyQuwD3Jiyx_fhNRRmUHtZJ0zJcgj_fDaJWi6yiQt7S2ABCgSZI7_f_fI6rb3XDWSBatqlwz46zHlr9njTI4kOBpVhWFTVRaxRq5cuYX9FI_pj9m8_fvRhvmw2iAKyNW8ZmxNtD40A0JkRcvQyMBbEdJ5P9HQ_pDFubOzI8v9s65c0FKP28HkGLGLekT_fq9Ex0dz08A_poauKcgWEoNdIhFedQLi90t5T6HT34vXGP9FPTxyScVECyytzPej7bj5POOSCYJrDF9GzyndlpIa18DIsFlgt9uK1PM7t14O0wJ60pWfyeI6Bq_fF5WU_fRhYgureA0SsPZzeXEQDJLOad4LHkSlXuuNC5VN8OF_fIPCZES_frECxOWKwves7JvoiowhZOEAX_peYKhQzEZaZ_fx0TP6xQXDgJKdaQbb2UqxuPshlat3jLoTphK49jXYX93JTDwzXaID_pnuSoyj5A3oEwh_fBsopslKVkNsbe1f2L_pJSayVEd1cdEITTfz0_fpJZOiXxHGoHvW9Pma3eSEAzgj0K56S_pts00SXLCAu9AQqZ1fu0RhqHUNdkpDNa_povbju6WfB0jjBVV1GW6fFsTVpTj5PAbdKbsPoiMyOSZSTD626tW83fZGrMMqzdDLUkkF6z10p0davFChczGjVODoRLDvVCWLRfjjJiMxOIDuWGBwE7GmPg6J579cJ8KVtq1BLZIGyUEQSicIYUAw0kVnNJjWppQR5hO_pMm7is79fVVg1EtXh5BCsqkPaqrj4_faLWBpl_fP_fvB2oJ_fkZYv3mAiq3Tbb1X6SMWu9aC6C79gkO1E7Cs93fWXnlK_fGEOIBqSVJcOL68e_pI0PoyxJwsCXqCkgFo6AuF_pxWZzxsmcu_fq4bG4GT8Aa2ucYGikL0u3990LKgJpRtxLtgV9f6ZBYbZ1bpb3rWtOCYIW_plAzk4j3fQBC9CnCmNzQxodP_f4_fZxSQAehtEH_fbXC_fE_fye09pSo3usOi3pBZurdbtvUJAC7AIzC4BEw6TqSvBSIQs2Z0ZBh9B_pQ_p1cZVjrBYkyO5mt_pz0xPb5toUrVj85lt_fW5aZutfNqd1nxSeHqU_pYj5dX_f39n1XEz9p9mDJBc_fQbFAsklFyHHz8j89dJ53fuLfZA2lJE45g1ehbuPFCCybgQKQJNFRQ_f6LrU5Ms2VJuJ6mjXk2UrYla_fT2QHaJFLgwlAHmQOqoP8MNYsGaWb6h_f9wGn9APw3lXxQ",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T22:49:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T21:30:00",
					"flightNumber": "429",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "1h 19m",
					"layoverDuration": "14h 51m",
					"layoverNoteValues": [
						"Overnight Connection at Toronto Pearson Intl Airport (YYZ)."
					],
					"totalTripDuration": "1d 5h 5m",
					"arrivalTime": "10:49pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "9:30pm",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T15:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T13:40:00",
					"flightNumber": "1",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 5h 5m",
					"arrivalTime": "3:35pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:40pm",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "3:35pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "9:30pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 5h 5m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_JL)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:35:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T06:21:00",
			"destination": "NRT",
			"downPayment": 969.27,
			"id": "d7a971a4-93e2-4c51-9344-359cb237b017",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pRr12mp1iMvJdFO0ukO8Nh8TAJrCeHCFqH6MGp0uQVXc1nykHjcvn_fye8zQwEmBHPT4o5JaUj7L_pYufktPC8MOEHX5rwcARS2N1_fB1R4wOoUFBKv7pfEjRanF73o0KOsXHljd4vuOHdlNIItFG5pUaGgiuNWErgszY79XnO1yYshDbOA3ccyV0sDP6S8GB_fHii0R1ZuHqZECSKPtNQERyYuC_fGEaSlurnacBTGOUQejiXiqSwxaPWto4XV5JxkiP6esKnb7n01i0s8IFLz2y4FpvEH1qd_fhIWNsCVqSfVqdKf4bb_fbItUoZx6YEH3LFC7B_fjmxjaDjejP1644M1_py4IleWWxkd9YUlPFhuZ2FDZmWtCmfjAz9vrNZVL4HT4FJL3wgCoKULz0MheVMFPEAPc1cssm7Rt_fs3fCVt5vgDN8I2cAU2OOa4XbgivzzvllWWvcmNtugwxejHgylyXx6P4OIielggApT8isVB10G_fP1Oa1oaJKdzK8zGg7vIuo2hNTJpdAiQsJZJWBSw_fePmoVAwV8fxDIVjsa_pvHQkVpInTBgy9RjNnWijHtKpcz4z71HHCUqFTiYMvtk7gxKfpWG4GNwlNXX97XKU4ODzkFdzizeL0KJ1SQcU6cYHlTuLcVPqLC2ZpDwwM0W9JFns5I3fyJXqV5rw0IQuotfeiuu2xxi7q5qnzxIsFRTPy6JIx0_pNdPiCN6wwyyrDHJ8xiCrG7TJzbEtHMOvJf43FjrZPhhIT97mlHrrYrJ3BSXHiIWxSorhaaceDk4CfE2_poU2QHZ2DoQHEMDR28AjY5qBHO7eXaeXtsxjzXwJYgoVCBL87CjHB_pF1YLSgYtCM2OrDUWkC98nLzHany3sOXl0TV2bMV7_f_pGWT21Ljynonx2MTsvQm7UjuvT6eCzbtiqBc31AfwxioB0IvtxjGGeeZqpS6BBomD0BVKrNBJRN08A80PVJ6tXHJVxWL7MlFnfhaEhEtcZunPdTbdRZQdtEpOfMm_fS47a4ZjRBD0O62N_pjAaP_plfCayt_fnFNnWUX5dPNcpAtMYYH_pBkGwjAit0KPfjaUeDUDAk_pVtuEGJE_fKCYo7kTJyyO9RbGPB9fSOUEXNS7n9aSqh1oFI3SV8N7lrGPHLuOnGl8nrLsiAK_pL8HMZweFclaXo_pm29SF16JMzWeIb1YMuKJkq_fAP39TnNAT1fvHecYzP1Zkb6h9asrcS_fYqfH_pv2SsJW2EuDbCzGsUj0jua71Ouzf_fMD0D1y68BNW9JDI8URg8EAkyoNji3HURVn_fUAr4Qjdlz0Ws0LnEdTtzWP_pDo2xBY65ZhncPEbcVOy_pcQdlBuUCO3XJj_fQgxXrCyN3Po6NWWq4RH9401aeBLk3yvr6ZYl70fsKJx2f8PULUoJX1dapo8j5WdLZUScb5Rb7bqeNntRv_pusskiSgfdGwW0TkeTenk0pad1_pqp6LARD1_f7xOvSrXomH_fRId6YWoe_fEA58nlfT3zSt83_fd9uTSbaceuh0OAaPlg_fRhUkwPsvfFwJDwCuBA0nhK3L_fP_ftYXT_pJ_pZ7qiHajQ7Y4lAfS_pH8Z2b5sk921DrNlSOKva7hQLZxeq6Rsb7lo53fVBee8ErxTuum5KxLyZNOb40Xbi3zH3PoMpKQhi1FFf7y6MC7w59DohHnu6YXdXLXyTIb5o8s_p02wVhdgVAVDl66TqclcbmQhPHwboqRS6sNunom8dTEab09vFaFVfvBZUZfWGFFTODI6KKuW2RpKBeGVYU6s2z3U_fglpkcVzRklveBB76ZUMsMyEiD4lIw0m_fAQrZDIg6iTK8G52g_p_ffZD_fO_flD_pZVyxneIV5jpML7FHPpB_pd_pjrlqE2pZsceCxrjRBf5dyYoetGXA6aVWdAwuTTNPgnkeUFsv0NoyDWj0YGyO3JEjWO13jB8GToPna4_fu39C5pq09amaSesGhCkNftn8mhqCpItNG6z4I_fg2XCX87rlkH3Osl7yNoq3qo_fYG6ShrTIe_fujdoTowkZHqfds4Kq_pEwCQP5Lot8pM_fZVr7SP6ub6VDpqnPYgK5Nhd9CrkL7D29Gt2iLKaReweqwhxDpusZdL_pOvIxaK4XwvjX2b_fmbamfGq4wq_fA3LENGbO1IG34r6ofP8Fp0ZvL1D5lvOZ5l7_pYW_pdsDKhFn1v4HKUFVED6svuX423tjrA1Y2byNhUnL5gUXnkScg12zW_p_poAszeofIWl2_pigRnwqYclW7YaxnIVr7cSylK0N4_fSxMagffZE5KENlHqaWNnCrAJ_faBXAIwLrlDLPTodMiR9I89aTNoGnMUB3vBzU47k7HM6HBjVLK7OLJC9j8mpS9wZiVBHG0D",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T07:54:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T06:21:00",
					"flightNumber": "3652",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 33m",
					"layoverDuration": "1h 36m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 14m",
					"arrivalTime": "7:54am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:21am",
					"departureDay": "2018-08-23",
					"destination": "LGA",
					"destinationAirportName": "LaGuardia Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-23T11:19:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T09:30:00",
					"flightNumber": "129",
					"aircraft": "Boeing 737-800",
					"aircraftType": "Jet",
					"flightDuration": "2h 49m",
					"layoverDuration": "1h 21m",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 14m",
					"arrivalTime": "11:19am",
					"arrivalDay": "2018-08-23",
					"departureTime": "9:30am",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "LGA",
					"originAirportName": "LaGuardia Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-24T15:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T12:40:00",
					"flightNumber": "9",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 14m",
					"arrivalTime": "3:35pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "12:40pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "American Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:35pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:21am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 14m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_BR)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T13:15:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T21:30:00",
			"destination": "NRT",
			"downPayment": 970.24,
			"id": "a25d9d86-7ee1-4aff-94f8-177d8928a359",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pZGN_fM7vBnAlJGn_pxKrDQkb4_fcpvAUuePpgQPJR1KI64DD8tAPMuRxmnq_p5nOzWMAQrQ_fzlnvMNCVpg_fKwLC7Ba63mNzSgCjUgET0POLB_fkIEbPd6bhwsDgbGkZ_f9Ps_p8K0wgVM7LIA0aallOwB_f8VIKEAhhcfZhwluD9FBgcBwjKFj_pn6P1kHl4EPCFPIBmm90MdJfma3_fqQzY4itlnvLcSIGwOtrD8Ky3mPhWeAst6fecsl4eaQxvVDmzbvlDJmTo_fvm_fnNd2V8LlO0aX2kACFgEmsJoxlvI9co3Bf5U3qvFPFjsqvqbFvxoYc6bGzi_pB_p3JYtmACdUvMriGLcO42BXvNCIFgy3zpC5Ay3X70nDiidxHU9trr_p6VC5CHQkofJIgdPPCvo2QeCIlTCGw_p4DFxS7SfOd0k_pxWZlr0Zs1z_pbswjKOjB2IfLVpt6t_pa4FY4a5Y7uU1CIMbtDruqhDFR1Tt14oEV_fwapSI6LuIxd7T4GuJ56eXYw_fRaQSXCpr4pGeqiVIj08zCp4TO7z3abLcLymbT1jvaGbbC5MsPCbfE2zQrw0rLXmaGszlSp1PFXfs67cP86Bjb4SEH41aTIcn3vdtnI2GVleOcc_pj44BeIJRKdBzP9tDQoVuNmP_pbEn8t_pKluGX2THU_f20o4UwXsD8k_fto2QogeIc05XbzTQ_pIg8joQ5yuDe_pwmvSJ9ZhOTYZY3VA4pQgwpX03OKKHR2OsYfVGIg0iraIiii7Vr5TYHrWWoIjNSWZphqfeSUQbNSwPbIF_pd02SP9dtxqJw_fXFNcK_pYovbacTMLNvkt8AqbHfefnmvnJZoEA26pLvZOkKi3G_pA2smexEh5_pCO67PYmFHT2AC10i2vurh_f9uzO6yw9MGpc_fOntShlOtm_pDWz2Pz2aH_pufuIRkca7iF3Con2Dj_fGcLTfJ8He3KN02NLFOwfr_pym4Fhff1PySFKkuCBcn98nj0HU6ozD5aBwMPySsID2wc1wbXfAqA7BgAQzkX30TM3Ngi3se35EqYIONa1XCFxoWu6DiiUHKLhBIqNqAohJxeUL4a3lY6FombektNen17CFGXEOWGbfroUTJA8YwnAwJi41MF5zv90pedYoEFQT5_f3vBuhsK1rSy_fJHNL5i2kNDfMqKUlnh9XFaAnlrrmIyyp_pCTkfccWjmppt3pQjeCBkZmejEN4ZRt2pKObfkO8kUBKBW6_fNZj_plsHkMo2OgOaXARIhs4oYfEDTXl_pjr_p5DdF2fboAvUUjcgZ0GEtltjiRgSDNdMvez1Kmi9IRnNLFtUSgjJkRrEFoT4EiYNEC1u801Xk7F4jgNbScG7xnVNkMykP8r5d7qooDKiRSfyqg_pOUodRI0HNS7JTc3m_fvLGfN28msK6_f2rcMQrqq_fjbH5JnpnV0fXqIJvL0sDXpqGaEUqVFx4idWfy0gQ_pQoHCUN_p1CvFZ8kGL7sGnxnA3faFHI47d2AnatiSamEzrjPMyPtux_pf_fa6OYC1nagVJKz8z81V_pBJXvTsB1SAkL4eviqcBgRbB6sQ2r8leAEQBHBTb59MucjVN5THOTIa54klewS159TIJGTxjIWSyi9HrGmx4dSYq_fqQVkc_fYPlfrv4B4_plQhEfcGwu_fHehbxgAhK_pegeGV3bhYp1v_f3oyoFhIjcIxa3jEcJdOIkLvzMymv_pyBzuc3fQyiaHbxGmfOmwttRcyVeINubaKT0S93YLk9M7gLvdwCJAG8k6pGQwbtHK688WWb_pQCf8MUbRjB8L53fNgCM6GYCJhp0DKtdOGltm34ETdqRuYcRmzVACgbGOw9I3PmlNxzLzFTeSTnDcS8jbfQ8_pl_pCuY7dDNuqRAzWMQGcjtvTlt8OODGDlxFwkCf9iSq2r6OGJAlH6ecQ7qnB9nnUnznfguzf6OK2q7Jc98dPmpluPkV3qTVxqweQy5FQPAMWBF3qvt_p0wTK5HVaSjwyX_p3xCiET2x0FSqVkxLL4ZwEq8mpr2yKXMRVAJdUk_fcuHes8U7_fCZ1AgKytczseOW23915EnVSo9f3S7wzM9TGbk7WTwDZRR9nexh6_fNzZ80rUt6ClZtyAJhO_f4h_f_p783qlF7DHXsERxPUq7_f_fjGjVJX1Ms1_pc5PtwKKnT6ULcupP1XhctmK20COckl4_fRbdp8QDdyVHu8xj7kQcLKv_f0XdeBpfyz_paM3iLwsiPnO_pl4y3_pNzFuYLEmsI6L59JvjBjufTEMIrS5C0_fW17SmToSVdxbG4h6bPsFAa52dzuDGapNB_pqfxtZmjWAA9jG4_pjEYd620taDaea2UXUWjVvoff6jLXxa1J8I6aWub3s_fqyEbkCuLYt6BD6W3C",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T22:49:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
					"carrierCode": "BR",
					"carrierName": "EVA Airways",
					"operatingAirlineName": "Air Canada",
					"departureDateTime": "2018-08-23T21:30:00",
					"flightNumber": "3091",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "1h 19m",
					"layoverDuration": "2h 56m",
					"layoverNoteValues": [
						"Overnight Connection at Toronto Pearson Intl Airport (YYZ)."
					],
					"totalTripDuration": "1d 2h 45m",
					"arrivalTime": "10:49pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "9:30pm",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T04:45:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
					"carrierCode": "BR",
					"carrierName": "EVA Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T01:45:00",
					"flightNumber": "35",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "15h ",
					"layoverDuration": "4h 5m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 2h 45m",
					"arrivalTime": "4:45am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:45am",
					"departureDay": "2018-08-24",
					"destination": "TPE",
					"destinationAirportName": "Taiwan Taoyuan Intl Airport",
					"destinationAirportCity": "Taipei",
					"destinationAirportState": null,
					"destinationAirportCountry": "Taiwan",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T13:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
					"carrierCode": "BR",
					"carrierName": "EVA Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T08:50:00",
					"flightNumber": "198",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "3h 25m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 2h 45m",
					"arrivalTime": "1:15pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "8:50am",
					"departureDay": "2018-08-25",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "TPE",
					"originAirportName": "Taiwan Taoyuan Intl Airport",
					"originAirportCity": "Taipei",
					"originAirportState": null,
					"originAirportCountry": "Taiwan"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "EVA Airways",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:15pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "9:30pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 2h 45m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_K@)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T04:50:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:40:00",
			"destination": "HND",
			"downPayment": 989.43,
			"id": "96feaeb3-9371-4a31-8e7c-1d1b7a7a8f80",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pdG5AV2bvwv7nDaIg0Xf2vfzpg7MKUorqEZ4fVUP_fJJevAAXhaHxnZI3rR1zjZvJ9gxA5F66R44SeE9nYJxx32xFDtgl_p8pIYt4CjrvddiYzcLdjL01Ci7m4qKb4LtY3vHY67OMmtGC7K_fgYopcS_pjR_fUgVuV9oed9zIlWf6T_pJIrlpVLw2rAgDw5VHMR60ycGmsy96kYACDJhVje_f9dOwoZmNQdHUgOdeCuLORHJlrNe8D_ftVRcCLyqJZHkyUw3jOCDtpJDaTk3Nxvvc_fEVLnVMZ3dcibxZUIleE8FeOvfPBdk7lXZ8TohoLJBOcC9h22It641ZSoscszNtW8lrqFYPaA8Q5pjexL79InzcvVeY1tRzDBX5W1cc3yv8uoy3cbc_fOswvCo0XRFwnMclu7s8QIR0WP6VH86l_plq9Nb71q28p2xSPZeI0FzItX9p_pfUKoO2XbXefOT4sGTqoztmwuGjECby6W6vywkNcNEnLSRw1aDlOoUKVdhRTYwDCwCPHVd_flBub2bKEIM_pWsEo8ZZ2Z8IXd8wnJ31vKN_p_fxvHc1nY99jCx52abS2LYgh8OqwEkq7ItK7zf9z44puqXu6LKb08hcfScbdNcKh87QRrV_poIY9JD24Pf39k5q9m9bOGIsXcsrYZpDIr7bDgc6QjhLfCAgq7pBVyPMO_fR0J81r4FGCxlO1PvQPSch_pvrt_fBc1erRTBnAoKsGL9TmRpnANDztRZILbhXRkpAIkUzwyQIn97g53zX3PuEsF9CDpA2oT3kGbdrt_prmUa_fvUFtC4OkkTSxlooPIw6rmmIC3AVoQLSbZy_f7W_fwnxfdOL29_faMee6gsiljG1h_fGZI31nNh1tcVH68Qk8o92_p672uqtP5B1Twlwvp_pP3uWRKYKQDc0O27a4wNby4Mnq2MwlEaBKdfK3QRoMuY7aOeyhLkZCl1EjaexUKiHIYOG3wwvE96etbniy1tMk1Y1EiyijFU2zv3_poOuDlLVq_p4fqu9b24Kfxje7etVmMx4KJkeaXTMcjDLJk_pmYfvLxK8QLPVTyX26tSuw1t112yRNFHdCHi_pvsaDD9C6T0Hq6hiQc49TC0aj39Wiiai9UvVR97zBYpyJM_p6k1euYco4eOJgystDcahYWXGsgPhgzibLWU_fnVXFCVq4mSvxO3jwXoQ0hVn6kyEcMwhknLTqp3uIyQFFvW7SrNKl2sD0GVQvS3SZ0AhIGyloV9WXTa7zy2NfaRGzXwCCqdhpbqmlM69DSi1RdKy7Bcb6u7dk1Ru_f5kgIe8v_f5MnbmqugIx_fD5DkrAr_f7w2Y5PzKqCj4z6tPc0DiypBnQ_pjxMpWlIudhzP1OasYons_flvCm_fj1Pwod78GJP1K5xQbYFKjaxUiWg3X83Lm8cI9Yfk14Y1LyZcSySnvG4Zbwk0B7ahxIpUs1Bo_fylDdOJ_pBZmPyet7VQsXgO0tf_fWXQdVvHjzaQ00ldzm9p5JyBYS4WSfBHizSu7y3_fKqU_fBItcTK65MSDGu1dKIUhrFymgc4big0qYAJkKFimIxKpcEp0Mi_p8XYDRi46MJ_fIvseYHAd64HU2DL1JUXZVH4bleeJ0OxfNEm2nJU_fOfD6JbXCH4IMqlCHtc_pUdwkJ8E5SCi6y0_pObuOtrY7WN63DROvyJrkflxUl2UfX6wZLBRFkkeMLuqFwVInrFC7ewiX8G3SWtSYcV8Sf_ptEZntlMX4jsDgsTzYhsCNrs1u7i_p6SGljofoD3VdGxgw9iMfLL76lJlKCuI_fCifLKmpVktp_fuBG4H7GVV539c4tMlmTcc9EJFYDbJ3Ybg798RQir3ZSer2_pqKtEIotbShBuPJRJ0D3jlb72L8jGDQ9JqtCQ_pK0gFq4pvG0HjnDtPUk6UQfF3flMc3i550ep9B3b8IOOe4d0ZZLConD0amEg28sjd9XHtkpSxSw8ufnVo0zjt9CScmwb1sUMmldWx4f0rJptVpORMRQ7YhIqEwKckdMd6AOQsXBv_fXBX49U06nsMJlx3vohhPEMj8eXKOdthZQcW8CG0LjNnBXKGp2aW1m3nVFpcv9FllQytEnaohlaK_fpncmSXGI3HF3Nzx9uZ97jcMq4JmUw7X1Xoufv2loNpZU79OnKBoCGxYmwHa7c1_pj5GfeTx6_fMY4Rr7s4louExQQ8vYjHof7kXulE1fJS1Ddr1c7Kp9O4kHmrkmTIUKY712i7tVmR8aK4bHZTQ5UbX0YiotecrLbDprGlz_pKGKfDoaWK6e4Q7MBcdLAP21fhizCxPBHgFiX128ae_faziZsseuxdcCaHwo0Z5f6SZMfx2wSQdlSKtPfSqBhsotl6NIP0kYjwkvV5e",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T08:19:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "United Express/ExpressJet",
					"departureDateTime": "2018-08-23T06:40:00",
					"flightNumber": "4341",
					"aircraft": "Embraer RJ135/145",
					"aircraftType": "Jet",
					"flightDuration": "1h 39m",
					"layoverDuration": "9h 21m",
					"layoverNoteValues": null,
					"totalTripDuration": "1d 9h 10m",
					"arrivalTime": "8:19am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:40am",
					"departureDay": "2018-08-23",
					"destination": "EWR",
					"destinationAirportName": "Newark Liberty Intl Airport",
					"destinationAirportCity": "Newark",
					"destinationAirportState": "NJ",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-23T20:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T17:40:00",
					"flightNumber": "275",
					"aircraft": "Boeing 757-200",
					"aircraftType": "Jet",
					"flightDuration": "5h 50m",
					"layoverDuration": "4h 50m",
					"layoverNoteValues": [
						"Overnight Connection at Los Angeles Intl Airport (LAX)."
					],
					"totalTripDuration": "1d 9h 10m",
					"arrivalTime": "8:30pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "5:40pm",
					"departureDay": "2018-08-23",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "EWR",
					"originAirportName": "Newark Liberty Intl Airport",
					"originAirportCity": "Newark",
					"originAirportState": "NJ",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-25T04:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "ANA All Nippon Airways",
					"departureDateTime": "2018-08-24T01:20:00",
					"flightNumber": "7983",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "11h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 9h 10m",
					"arrivalTime": "4:50am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:20am",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "4:50am",
				"arrivalDay": "2018-08-25",
				"departureTime": "6:40am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 9h 10m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_NH)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T04:50:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T16:35:00",
			"destination": "HND",
			"downPayment": 989.43,
			"id": "8d8d49d5-6b7e-4058-b6e5-31bfe1ec39a7",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_peXXmt0eOJR8cpcK4KGtbP9Zizblbv9A1wAA4KCYQargKg7Ll8phJ_pWvAYYW5hmQBOzO7u3fihjEh9tKL_ptJBcMPTYVRZgZd0oDqFEWJZwFJxmZwub9bSsbZjq1I6cgb5JWWDmjEfytdFfzGO78gP_p47krYYmAr_fFEa8MFTh0EUYIQaTuppDrDPfkzYXTUEIRV7bPTU3HGHgKX9eoPtR1SLa94_pmwQkM1MxeoNZJwEYe2BamjUm_fFF_fnZRttLfRFDnxDW_fKRiXjxXuphtaxJaZHOKDLRiqBe2KQF3eX_pAu2y7tsIk6dK3w6U_pjLupR6HAYrmJK_fd5j5hpbLQCmqGZgHVi0BKTjBA9y_pD5Hbq9LbUjCubXemeYkva78napJ4OYaDSSiSsPKf0LvX5NGfS4fqyeJQbbyq93d90QF6kTzZKOaFIkL5zcbQmFqVZdiRDDpUYbxF_fB_fQXlu6BqeNLpD35Vz0ZF9tMcxi4y3p2Sy4k7Q_fyPm3oSvWdJY2ylvtE8UQEIYESiyYHtjYcJdwdw3LLA3E5u6WyfggUrFyiNmWNqNDp9SN1hDlsoRd4iGox7sELa_piDDgdMO5_p8TeLoC6s3k9c0_f9rGk_fKbxZxcsGBrFCw2bzvICejPf7FD_ps_f_fZnN6rWSEAV_f8cWFjdaAI26dkIwKV8tZsLrZEsnNg5NR_fVjYlXqP5HGWtiDQ04CBjUa4hOdQ2KsexZWlH9tf1gXorCyQZCmqxNX9ii5WveJKGxl1YpqsD8hZgz38_p07O38YYChzz6ApqU0A5N3ZauuYbv14Kdzew_fvJGepwD3ijigPHi0rF6kNTwj6n4Vozo_fQDKdk7m3VeKYmOXBXZyJd47G8FzEsQc8YsVJwOOB8fLwPdjs5Ibcj0LvWBnShYf6J7uoLWEKOptQM2WqCS27B3NW2miml9_fzNwCm37iN1DR36ucM7FD4ZVh_p1Xr4yGvIGyeTi3yfYK0DDDc6oL1IofG6JgmN5Vw0N648DX9q5RS4Wysc1Ea9ONotNJBJrE0xk_p9nrSS1eeKZhZXxfoJjpzG54iSj_pE2FnbXTZYJo5lgd1rM1MpNwcEASgV38w3hvyNqM90likTQzoaVnCEPnNbUt8YaU88Ve3z_pHfXYXHLTyaQ2DJqfIukKeUUifkE_fLtfQ13X97WMXP8JDX8iWJ9CbpIKwiD2XHaoRdkejnsN9kAma5u4z9Aw0OXU3yoyYpZK1biDt3_plv4Lm5Ge5KeGQanciACf9Z3yLcsqiPX5tmhxRDQ9zm43O_fPLAWI0dOJvqWsJtK70f6Kb9FRP96n11hpYwuVNN2WzUUbJbp6pP9vTY2WvXhTyvgamBEP893v_pqZ14Lxm76t4KDlg5wcinZVbPwPCvdb9kCHQeMheO21ha8pey7zpQDL8559BKdL_pdx9gSGMED118F2KMDj_f3yS5nqFdWSVuAxM1gSOrK2yLrescki1P8a_pK_fJoU3KSEyAJDo8QgKnmUzrloCBozeFijM3jGxDud9KcglpxmVtjGQTo7_p9Tocl4REdKgCeezt8E7i_pDzaVzLZ1KNVBZfU_pYF6Y55_pbbwtgZ7AiRTLK7p3c_pTY_pr_fKOJDVUkUiaw9UUUBhYdSogevcui8sBxCXxvQLyJ77e1FmDIPoBfkmQGyyztDuUwuyD_f2tY54mwD41OHp9kRLGGKTVeyA3Lv7fw3aQy2_pZ6J_p_pRN6w6m8V1HBvya_fMNTmns974JhtbEW5dpldC2WtdKCyw_p3qi7MvYENasm5zoYdVoUKNMBFYILdvvz65nnblGLctfcvQcUHI0KY0S9xgZ34OoJz1DU0AuuZzncCtUkc9B04e_pZHFiaFFZ275QoIGpwF8Bb2vmfE5xEB4s3nE0N3gvFr0tHM8t81TE3Ar1EecuD8IBdkInJScZ2IGoSe54aw_fZN91Lh7JUh3QbxUdNRhqiROnqILShmQs1icScKwTjyjCE31rRJEpeZeJ1ko1wsv_pgnRRDMDO2sqIGoUqnIG9uJKrc3NWij5C7OlMm2sTa6_fEyiUNOC4SVC2k29fesU8PrpTyLmHcdW_fKWa4NbTIUwdptYws_prXLgwlieUgpNy4Fa_f5fbURJoeFUOC6Ee54YMq6IgmTL4VoE3bYf4QtFF7MrFXXrIgZvH2lgZIUMFHVTm390LlsVY4_f8dbi3Bco5zQqBTVJr_fm4guRP7IN793v9lTS6_fJuKpxQ0hgNs9MtGdsLZ36dSbLFGvFstcCa_pWdEWpbhUAOHKGvtXBTI7_p3WHbYQ5_fa8Y7xK5NzCqZboSnZ0RHdPTo0aaAXnJmlMkb7nH9POwFWpw0BhHSkbnl0Uft4vJ_pStJHAkFG0V",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T18:04:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T16:35:00",
					"flightNumber": "8170",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "1h 29m",
					"layoverDuration": "2h 36m",
					"layoverNoteValues": null,
					"totalTripDuration": "23h 15m",
					"arrivalTime": "6:04pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "4:35pm",
					"departureDay": "2018-08-23",
					"destination": "EWR",
					"destinationAirportName": "Newark Liberty Intl Airport",
					"destinationAirportCity": "Newark",
					"destinationAirportState": "NJ",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-23T23:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T20:40:00",
					"flightNumber": "1165",
					"aircraft": "Boeing 757-200",
					"aircraftType": "Jet",
					"flightDuration": "5h 50m",
					"layoverDuration": "1h 50m",
					"layoverNoteValues": [
						"Overnight Connection at Los Angeles Intl Airport (LAX)."
					],
					"totalTripDuration": "23h 15m",
					"arrivalTime": "11:30pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:40pm",
					"departureDay": "2018-08-23",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "EWR",
					"originAirportName": "Newark Liberty Intl Airport",
					"originAirportCity": "Newark",
					"originAirportState": "NJ",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-25T04:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "ANA All Nippon Airways",
					"departureDateTime": "2018-08-24T01:20:00",
					"flightNumber": "7983",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "11h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "23h 15m",
					"arrivalTime": "4:50am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:20am",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "4:50am",
				"arrivalDay": "2018-08-25",
				"departureTime": "4:35pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "23h 15m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_~P)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T13:55:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T20:00:00",
			"destination": "NRT",
			"downPayment": 989.43,
			"id": "9e51c2af-1c73-4081-a020-49a92c4173d7",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pef_futbKfGuAdX_pPT0ZmkEMhbJ1xAd_p8vVAJIhYWXSnThkRCLM2yW9z2Oqw8AOGcJE1LxZjxoKoqMsAF_p6XgUcB8TA_fRHCNP57oLpPAujHZLnrw6BSoKjhuARvb_pVLXYmmdv85048moEjSidEbUloY_pzyOBMq1ibgAP5htz4qTItCalp9vFhZR2Qe5_f4fR3J1CvSQJR0diVl2PadY78_f2sJ6X5hxIkEouebP4OZ_pe4kUm8uU_pbPoyg6fwzJlyem5kBqxcAs_pkbWD8pHpL1p99yX4qpOjRbYJbOR_fH9M8HSANT44liVByYxKaVPtQmrIjzB3qkGsBw6z437SnQwGvzG99y9Jps9KdD3r305HtcnhLe_pgVOCGsTFf0nASdvIjtlL7PNhvtNccuDhlMPFD_fl6WkaVvr2_pzZYVcBtAKOpihcVNiSA3N64OiFSL0Y9YTU3VNSI9G0liCDguVXztO7uicXrXOkhOeTuGjY81QBt3KJPLZiwdGKgwugf8yF0W70cKOO_pJ7mqSdH9fLNWTVXtjH5nkHS8WeT2O2beII1Cr32TGtciI6A9T9r78_pxPqVoeRANayx2CF0Noc0nFPbtPMkOOx9Zz_ppIXy7coBJsjtm_f2u1nhygwUfSHD_pU7vZLkyPGAaH6NlMADy8LVbXk_ppoS_fJCfeXuASFuFiCG6LAo0fw4n0GTV5BIJQj_fZ0Vua545ROtUoJV1XXOqV_pDHqLl_pku8VGDF8n_p9s535BA54u0qOLbOaO_fxfgX8C4qYYDXsh3NGQFvKm7Cc6KTXRRBvFJOvVmkhxttB036gdwpxC4Y_fHKEx_fE4vqhorwPoDmMEulTtCaVe47GJD5EX2d795d1sSiZ2fnU8eLKeCDLECdaVTpuTknxtcFmQyuM4UbZnopyHQP_pN1Sj9Vr6rEJXCwpkRu_pBEwwG0Y1457nybfRoHwsNo4o0WfKREY0DDGCFZYUKZzE99ucifHVQqhLD5_ptq7WDfKuuMtxH6HAUGyGoWNhsjiBiCI2NWooEN_fxHgBy_pXbWNESp5NUyg94C10MCSlplwy91JV0_p7YpMrn6Z_pW32wQTqJv_fFbHK7MldRyQfyUCycBk8bx3OCkLX1LIvhNW_p1KHtLGcVVJ8dBtJu1wdfAZDZGtUu05mAQtzpI_p9q_fJzBFslTXAVrFFmsfGkg4KNIGEffBjEedSEZZp2YTLJNWFZtlUQAW3U9EGe0Fb7r7m4Kwo5roQjI9Pmec8Iti_pfWn_pQOYVZUWimEwErCeygktOZwn0G607sO3zTuZTTux_pYr7kVTS8WXQteqfy3whZQXs_fYFAX0PiyB0B1WdKCGhc_pTkRurpfcwO_pIzhKBjn85h7hGvrS7NtboiC3Kp_fc2phRrYIh4Qn6RStaeQ6fvNkAzViEwDWTAjbJkH4BmQqtwQ6I7_pVr5LmGAHhabxQ4wp8QGCpJ80Yt81TiiXEcrj6yOzBfHnLf9BXfplc8I6zgYLSywzdCBiJiGXdLqNIQyw0bmUoBkjx9k9WEUyJperhPRU6yOzM6mJll0QcPMCChpZe6f0bLRQb9TVsPehI9w5JSqygSFalYyfbgw_fnfClhAZ2qm0R4jQOL_fvGutiRrMBu8PekGsgDHAIzKeYfcKFqRA1ly9w1DZsynozICyc7IPR3rpZQFK9wL4okfkfnunuYBmLPGDd_ffC7Pz4jUKOI1jBPDsYYPMa7WZDjDAuV3KxGTWljFUp7mcq1KQWqRXNeEQy7akpOnZHuK_fkAyQxzNNwrfLG69FH_flEnx6J0By_fubENLbGidSFKDZhrkzrgKpzs_f4N_f6WS5tP2wRVn_ppNlACLfmuSwlwFzLGSDgeS0RzB3Sxeq6kuBc_fhSr7CrINHV5XR0g2hQu4w79_f65UVHB_fvJKJxCZ5VtMUCiQ_fqhGMzywpFq4MaxK_p67y4trn36oRoYTc3i4aCyJNSUdMu2C_p_p3WIZpuYUKQslobs3FiBx85T0xJo3qhFWDsBmfivAq90tDsoeju4cYbfuQ4uScB_pATlk5Np8SIE6sZqZ22nGDK4xa7M0ElUXyNiiL_fFMhqqK2YeuN7Ki6ykdx3sVjK_fegMmvVOtphGNoCSBS9XFPvDEAJzomdnq2_fW82uurAvMpXpHqqYRMPSm_pB4IcLC_p9RDSxeGxIgTKjqiqu44dkgtClbbEADk28wrx4EKOJ6otyix19BbzKJHqxMgl6ha8aviUH8hQ64vI_fs5ff_pa5E8fCPu_pd27k7z_pdyvNdyxPaSk_fcdmKHPwKxPWv_feISyxLkwrQ3Ruxuu0maTrkxpD2mfejVfQZsn2fjeUTlyNxOvJSPIT4nreQUPtTvKZqwAdOleX9GG8",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T21:47:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Jazz",
					"departureDateTime": "2018-08-23T20:00:00",
					"flightNumber": "8366",
					"aircraft": "Canadair Regional Jet",
					"aircraftType": "Jet",
					"flightDuration": "1h 47m",
					"layoverDuration": "8h 13m",
					"layoverNoteValues": [
						"Overnight Connection at Ronald Reagan Washington National Airport (DCA)."
					],
					"totalTripDuration": "1d 4h 55m",
					"arrivalTime": "9:47pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:00pm",
					"departureDay": "2018-08-23",
					"destination": "DCA",
					"destinationAirportName": "Ronald Reagan Washington National Airport",
					"destinationAirportCity": "Washington",
					"destinationAirportState": "DC",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T07:13:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "United Express/ExpressJet",
					"departureDateTime": "2018-08-24T06:00:00",
					"flightNumber": "4348",
					"aircraft": "Embraer RJ135/145",
					"aircraftType": "Jet",
					"flightDuration": "1h 13m",
					"layoverDuration": "3h 47m",
					"layoverNoteValues": null,
					"totalTripDuration": "1d 4h 55m",
					"arrivalTime": "7:13am",
					"arrivalDay": "2018-08-24",
					"departureTime": "6:00am",
					"departureDay": "2018-08-24",
					"destination": "EWR",
					"destinationAirportName": "Newark Liberty Intl Airport",
					"destinationAirportCity": "Newark",
					"destinationAirportState": "NJ",
					"destinationAirportCountry": "United States",
					"origin": "DCA",
					"originAirportName": "Ronald Reagan Washington National Airport",
					"originAirportCity": "Washington",
					"originAirportState": "DC",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-25T13:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T11:00:00",
					"flightNumber": "79",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 4h 55m",
					"arrivalTime": "1:55pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:00am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "EWR",
					"originAirportName": "Newark Liberty Intl Airport",
					"originAirportCity": "Newark",
					"originAirportState": "NJ",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:55pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "8:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 4h 55m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T14:15:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T06:29:00",
			"destination": "NRT",
			"downPayment": 1003.47,
			"id": "d4c9e38e-c499-4482-ba3a-5978e6a57846",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_peFlAY25aej5fxLSEqu4EjFWmomuIqvx4b8GgpdgFkMmdEIxQlaKJFp9lyMsK9Z_ph0UQ1S_ptYHEDcluW74_fXi5ldelmIDUmsh754V7Za17GnCDOwwyGdxJLahIS0APaMeIncMSs6fGqtUbyf8ouMxEaFFKkm_pezHeYulufOG5Zl8TIpOcSXb5WzEFarC0p5F5kS316tDutfp4QQFqIMcthJjKjCnqPUj35UrbdRft_pwgJU9_pCYjlRL9vkuyUv4sOdoKUsOLFfcbeKE7utEispxJ1IRFj6MRb63_palVRBjG7jv5PT43jqjur0bvBXsffwXf50QVi2mAuQXBbt3m76_fHB8AR6o8U7_pnYgrQUSL45ZkV4caqV0GOAT_fCkqrPb2V4c7mYjHmqzZ_f4ysU8nIy617eO0GTQrSR9xbh5Kx0SVnlRRlFz64_f6g9PJ2hZF9vjxYkN_fwbP_f6yMdlXNI960yrnCLSiTukHCQe6m4VQlXsF3UuN_ppllvUqcqY2QpzfVyq2o1f5E4e2JA_pgH44slns3qvnM7t3IxiWt9XKjZU_fpdAVeXRoM09afXgKYiGEhN_pZ8b_pd6RQSNwfiKsipJO2cbUYzDT0bd9B_fPqvLZlvKlrEE7vXL_fpEHwEXqTr0kPQc1LTxIIQpdVrtxQEEnvYYr0v2bnqysAqhsT0lKdQG3jhhRWlQxv_pvCF2xb_pWawHFdsPLM_fWTnX0B0Ms9HJl0fZY4lHI_fvA_f7bKl5x7Btj58k3KUswRwMAPqQjtcCV8J_fY3EkytMgecKrrIRKXnDGjQyAY6qu5_fT7JdRS4ctfJXZFhShink0bIbOwqU6JRGY3CrdjIAYmuVn4GOWg21nsP5X8Y3WJ2Ikl4BScqH6_pGHvUJXK9mTbGvJUoiI_fyCIZz7E0bPP57iRFh4otkWmftThvpkWn54SZh87RH89nWz90jAMIYF6nLw_f5kF8X_fz23nMhSYgijsKRArltU9eD5gCVpRskUTwxa_ptXd3m_fyRiBuxbhjzxbNF6EzzyjG_fjyRVq54yGRzQ5jEAqY8jSvVXIKzVUV1_fgX6bRaP9haRclo6ApeDJzi6vSSvCS1CWNb_pyhJzopLdjMeC7s73IHSLwzQWarvuRG2np33vfHxQos4PFKJ7oDQ4ZduBVlhVYlNrqibvLeQmmsv2muK49kkl2hLdUZuW4uFe2a7tbBk8Sety4Ox6Qn5lDH3XrtRrbPNshZrDPEuyEVHWkLWKQ6QXEwIqWkYyai7XZqAolp0jUl8qHU8_piSJubDIJjY_pl0OkYbaQithKsAsPHSfrEGl1WenuLMGGZcNmtQ_pLlzaM7AE_pzRjizqo50ihcLqDJi0_py1fZATnU83auqkier60nt2Toa8u8yYjny3VsHcDri1Rynlh6setr9kSIMtP5JyR8N0mOSWxiyHUbuuhVJmUWnoVrr8H3C0vut14LleOeD9sfE4gpvfwyV4qcQoFgPBVt_fgsTa91xQhL_fgH9XfEs1u_fBqndyAKFLKBJc2V0m77R_pN2ivgKNYrf2vRdmk4AWlus4Sv1I3Q50lNR_pO_pmxUzVsJGfomgmGHz1Xa9kEAJi_pphs0MJE_pSlHqR8SpcDRDxVSVbJbsMPWizzsF_fDUpEsNigFGyzp_f_fBHe5PFaFBC1gDUqYMR4BKWj3taG0dFB_ffUPq7n_pjW5MVuXEbbPO73DNIwtUR54l6PmHSU9ntTWHiQwuJ_pKcRCEqIbLyg2mJ8yHnZ0BYYsJ75f1B_fovLJNzc7rSJBfh7d5BEQMh2zAY6U5luPsrW6qde_pPR8_fqaGYsMyhjMma51IJ7SSKFbddaBY8AfifS1avVvjwGIaZq9xQzgfEgZSmLalbbMo_fCmQhFbXBkgf59K7Azdr5gkwZgPI81wfDm6eenyv55az6fp2yxJ0vN7PAG0uojmZXbPk6TJj8ulghsgRaQ1Zdqz0UzmAe2QvbJ0g165b8zqEmuTcHgBscXYPp2_prFP_pNBNB3u_fa0aqprf5W_fjh_ftfDssW53Q6rd8yYbCL44fDbLu_pAVj1kApUt1v0Or6_fYcxwJMI1NKP20PakjQaYt1m7nUmlLVaZ43z9sOgerGU2Ig2NDIbKbrqoOtYx0GW0vAgaT_pIiQNgvBdy106FvfhhuDT8_f4W9MG9GYBeQCzATS8e_f5Pl2Gqu3nM7UAzKw3B8ePKov6imjuoZBB1Mx3cu4KWahkdg6Wrg1zjFCuMHPtK20W0erGrgSFHNmh7XnmUsSovsxi5PN2s9svAlvtL7Tb0P1NAgL7te8T0fVnYhcyqVq_p9h24p96bEqZHrhl2EQiXkQRYUPfmUSIjH1aHs",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T09:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T06:29:00",
					"flightNumber": "3981",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "4h 11m",
					"layoverDuration": "1h 5m",
					"layoverNoteValues": null,
					"totalTripDuration": "18h 46m",
					"arrivalTime": "9:40am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:29am",
					"departureDay": "2018-08-23",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T14:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": "American Airlines",
					"departureDateTime": "2018-08-23T10:45:00",
					"flightNumber": "7013",
					"aircraft": "Boeing 777-200",
					"aircraftType": "Jet",
					"flightDuration": "13h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "18h 46m",
					"arrivalTime": "2:15pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "10:45am",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "DFW",
					"originAirportName": "Dallas/Fort Worth Intl Airport",
					"originAirportCity": "Dallas",
					"originAirportState": "TX",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "American Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:15pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:29am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "18h 46m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_B~)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T13:55:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T19:55:00",
			"destination": "NRT",
			"downPayment": 1013.78,
			"id": "019f8ac0-7ffb-4014-b567-c60c928d41f4",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pYrVHrcmqH_fjZ5SlBCvfHCCqOFFYjWRQ9SRWgsOJs4Q6Togtw9oixKyz4lRlfblous1MOgBRYnEcQW6cICO5MvnFGN4wIhqpzqnvUg6aINVy36BsSRmaNzdzg8j_ppsuGFSI_fF4Ez_pTHdKDU7qFVL4Br_pDv9XE7soXWszzYU_fay9TsyQT8KdJPuubfJZNFR4JLianhT9r55TilH_f0Cm_py7gNUnJ5bM6uclFdBc4od_fpiOUC_p4upEqTOaQsC2KYoPyuANdCypGBAUX_f5YSWzKXbMuKYGRjCL27l5LbsAto0PkPqhSKO_fEisBwPYB451niOZLC3Y5w2eqYUjCrvE_pcM_foKOiw5K2ogZdQ6pt9Vzz8UnuBtZSqJNqqylL71E2KIjNbm_pq9DXSwy7vDTtLPyvUwD_p_p_fHUbfYfCIaqYCRo6_f8NSfybLeqHTMwhkehDP5rAMY0FuYj8N1qsoYtiuOq2r_fEIMcx6IgsWBrRa_fD_pGihEtlMi7nVr9mkCbpHqo1djZxWxbvDzqT4IWByrVccwHQKj1z9Hv9UZU9qBHkdeLp4L4pexGt_fXpBGU18DmtdZ3sKC5oeiXBnal2XmzAKxxUUW9Xz2g7x4_pNiyHab6cWkDl9JkvOEcywiMbdzKObLbXzjBHy60rst0mSs0smv6cl9pSuqMb2u8_fdgcYoVYRzP807h0H0KwRQyqIIOOrM_pnAUk08l6RvV1SfJjpaAUNz1yhC9rCxzp67sTJp6C9D4xj53j4Bo2vqOgHup_fAPJMCViIHHKh76X7WJwHesBZ_p2PTmNznUil1VZYfarntQ_f0sriTpgt3U0Jri9o3sOxrUnq3eP1_pPfvqVDvDQ2h_fLJi0n_fn6tsn9_pLXy5xAnSCJcKllsxLcJKS0A1X5ZAVRtcmN20V5rEPTDbftEKORWVE2a7Co4Da1UMj9IRRF7U_p_fAnzont2bTWgoQ1wwZpxQWzObg3HLoaLFuSmbUEqIuVPa8Q72VKM5eN5VsOVX09q4H0Odq9PRa9L0kq_p_pxjhiFO7xPOsC_f6IJl9S2bFtTvPzClSPvtA22uXNrq9zkY2uqrZJk4caGetodaRpjJeAMTPlxx_fUdRbBUQl_pKxre0fzemVMDPo9t69kuv8YAti2mvD4Wx0d_per6i1_pTRv7pfK_p0L2F7h37mWihXGGDzRgbKsQwf05rK9WRU3rjrG9Z6KbbVChUvSPsBjKitqVk15GpUS3HFte0qDXFLNx_fVcFSrz3h3iPSRcQWTEFU9nLb50CB0WuFr51wPcpZKJF_fkD2I3KQ_fpjFtM_ptbivqEqOmTtm2e0F3aaO_pMjlY72ZW1qpuAYhjxW1pYK1itofCk66wl4LQDYAxbp8Hs_fIjFfsXTEQnDM804anytO8FivkLU3pY9zgeb7BsAHBHEV13UP3unRITSOGc_fdw2as_f0VqCHA_pp_fVmQf2p22hK2JI_fSbGPleCwxglCR2wYk06AG2ws8HVdh3hZvrN27tYKQBDIXbgjxRyJ9f76m0jIltSh1_px5aXSsNhGrIgtSKqXHJJLJCCgFP5uSWlJkwz_pp5cKVkvXd3g0HHl8QfdQ4TZU5mpu1EcLw7DQLLA0ycYuSNJAd6SIAJhQoH03chsW_pTef2VQhTF6Y5qHKGH26zXuWIVG7K3lBc6jjxLLPE0EOz8aLQXIBJLOlyUrBYDij5WvHjVRQOUXXkc94whM11iqSzg3FGcdXJUNgLwY2oGFVddPbMEFLelPIkLyvHkklQbvEfHVMEdOTE_fJWxk_p1uILimM_p6d_p2dnq0TqJKnOFhOX_ppmdbHnLWHk1oiyns_p3WB7y6Xj3EcBzTuwM9oWylHgm6PULrGEeY3a5SXp0A3igWjdfmUIaiY4KxLcHCIK2SbOR64xGK8X0KfYf6_pgMMiySYXa8MDIVXOzr8nKqLivBBef8aTcCABXGm_pEdr8GufoG7NRtyWXz0QnB9VA7WWPtJ1Cf1EAJ8cAfB_f5NOhpzgk8HlyocLHv0X6LUQt3otapbVjeEXZ772qQKE27aZJ1svcYh20REJxFYl864NogB4QTDQK46ENCqPn9MB0uwJiIzzicDUgMTVpZ8CtNyErkDIht5fiFk6Dul7T2itw7oDnyNbcoLfRjfOB1gtzVil4DvcBfTcTChUksP_pMqaW549BKYAoP6Y5uCQGOAmpKih0DFz45oF22fiEcQXbpLEGroSDQcXQgqmUA2Oc01iWNCoe6PF8LM2o3bpmhv47gaw4jos1F4W3gMSQ_foMVicP1u8bmMGxY9_fzeIAMgqWwzuf2ofzMjO_p5gnMHytsZcSA",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T21:24:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T19:55:00",
					"flightNumber": "8546",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "1h 29m",
					"layoverDuration": "13h 36m",
					"layoverNoteValues": [
						"Overnight Connection at Newark Liberty Intl Airport (EWR)."
					],
					"totalTripDuration": "1d 5h ",
					"arrivalTime": "9:24pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "7:55pm",
					"departureDay": "2018-08-23",
					"destination": "EWR",
					"destinationAirportName": "Newark Liberty Intl Airport",
					"destinationAirportCity": "Newark",
					"destinationAirportState": "NJ",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T13:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T11:00:00",
					"flightNumber": "79",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 5h ",
					"arrivalTime": "1:55pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:00am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "EWR",
					"originAirportName": "Newark Liberty Intl Airport",
					"originAirportCity": "Newark",
					"originAirportState": "NJ",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:55pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "7:55pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 5h "
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_B~)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T14:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T20:00:00",
			"destination": "NRT",
			"downPayment": 1017.38,
			"id": "11eeeb71-532d-41db-bcbe-356aa5cedc80",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pa98b9dC26mLcboHUdwSVRrFdBemJFq5J3TPUd8_fTsSPuSbqIwKEE2h_fxdgKMhE3s1nZrYeOxTp1DbqgFUHRhh8JejOYAmrGBOqD1b8FT4O7UAhUYi2CF61F3qbXO4Z_fiC42rdeWSqfHwyUXWV0GvopLmog4uZpgulnmo9nZhGxPsQGxf4XKfhXxEspc1Fn_pvvEpGDFM6QPrlQEaAX0cwI06KJputinjupwL4eDHVjRi15OoMrQv3V9X3hs0U7R0Zyhs2qA3F68Bpjhq0_pgqiBcvoua6jgkBpHTb2OXnwTTzczpPQV6xxAp2L_pWobMFrNNrTM5qkdt5qEU_pyv6Xurjo3MdTABdP60SAHI1BQK_fUjazBDc6qF_fDDRFQx7qa8i0lNCjV6RGT6v2Fq13xB8KDf0KJxLUAbtGuKlGmCoTF5dlcmgN0FpB7lojrvynHS_f4_fsraOv_p6_pWDDYh4kDZjLqbb2A5YFQegrbVXKQYVPeqe2eE1pLAYhZsEZUMHxzASArVcZ3JIWyI0KIyXnRwRCEKkAxeRJcvF6N0Q_ftLPiXR4gZzs6QRdLgYGPmqLL932ekGzoKSdgNPTqu8UV5WnJan5gIhRrbPOnj_f3UjbGFe3HYWZh5bm4EQGNvL_fLfAJl6a1jnJjD5dGQDlVxHxdn28AM7aReEZRdhhtobDNzqgh_fREWRnMAExjjU_fO34Vuzi3XMchsm4p_fm4mcaFKdeMfiaVteMw0dVnuGxnJ5BHH_f8e37crtUvU5dh_pkRRpoXI9TiA2R9qe4r89MHpH7ElNKcT2V4Nc8Y0Z4SvLis78P6IIlCbZvbzy1Cv8p7xNr0t4NgLT8YUdC_pl_fjwqx5G7zzg6UZHJf6EbXKAWXxWQXWz2hlCJ97UJmvMAD8hfSdf8GQKMRfohrszPw9AJ_pUlTfGe9M2BDZG_fGtM9XuNG4J3DamuLUgJNc6P_psU7LpTYu3p1i_pK1y0t3V7Ebdp89lzP06qspofAE2n8SVTqRvfSjwY6t5SnqjwJXwAXwGu43OtERQJkZsCR1wb7rUaj0306Yzf8_pUm491xS14HWuSpVRe2qNKq7Q1f_pk1Vz32IBqU01N1Gj7q2hKbmurmi9WzOV8Mp4QC_pecG_fqdgnIk7eriH_fEkBVoawDxcQGSA4IhSeVfOBOChnduP0t0JkD1_fVh3CsVI9MnNJifn3un5hvtVE8PNK5GK6y7WjWFdcvD4_fk6_p_pT_f4a3jAhl9IniG8E9U2_fqoymXgqbKikjlVwXQpu94qLgqYE8DLHcnT8IO_fMayCopR0gQr9ewJq_p6onGQk0FsawYX4H_p9mdSNBjlsSQqBGH4kKqG0jIsWs_fct_p9FJ2p4w_p4rp27e5XPXQ6QuYsyhcLFemtSjt0TEwAUFjpqb5eIxjw_fVplhRrFeCQGuUgYUEYvZOsKypbLFMo8abrTLF6O1J2B2p4pST2yxIHCSQta_pS0fbMKZGoxmJs42WKB9KtrCG_pqbzOcq4RTtwM3OhkFL1LGCfDgeeRAJIhNIrPGLjxYTR2s_fDgkJYPofKo3huPS_pCXLlO_fXtLm3suszjwaVMd5Lf_pRlWQtsJ8XJHh9yWSKfaH8533nUu4pw4eOVkIU8ZVvW_pleV_poE1YYgpFqtENpAWgEHJvfQakQC_fL5BHZak1u_ftc2ffgSE8LCaldphIc5feA5qqIVv8jsP_fQw8vZKH4nzjdddcF_fusKLCtHayRS9hKvHPeB8wN3cSGLGeaANuZ7Oa9UFalnXeWyAaKrCueIH41G8g_fARXenF4Lvc_p30lyB7Qnhe5fWnhhZJ2mZr_ft0whEVLq_pFVvACigZlrfyFK1ER0wAiXtdbcLZsRE9a3daIdvZ42GZ12_p62mH3IMM3XAOpeZy4kFcv2PEdAPpsRNpjAAFK8EuFfOh_pBdC_pXmckC8xxhpMrhzCbyFCKAMvVJEyuIFPXXSrVVbLMvWphhXCqv98_fHgX5ukdXy399VdYb9CU8tJzTkZZ7iSyQRgd7qVH0Ojl5bOhW_p8PaZ_fkHsk9jOFE2aO8j72Cj_fewdrkhQMDwvryv3JOGszVg4CfXKL2Ov9etihDvNEs1XH9VxTB_pTTImjvCE69le_pZpynp4FsH9pM0MSnz0aO0_p0PhquLpCl9YM09ItKwBgnRjyeGHQSTzJIBAlIi_pR7QkGTWLEKuj5wp3OF10vKLzLW_pzaDo8IbSSm1NtaSRZI1Fzv9xdu_p6kMGgTQ_pDjE_p1U3Pvte18_pkQ3vZAHfbwQ8N_fjvwrj785_fG8XRAV0DmI1TuLa2kGhyOrwQPYBU9KjMev97_fSSO64sAdnhIgb0bDuUCGWwr_fNZqs",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T21:24:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T20:00:00",
					"flightNumber": "8687",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "2h 24m",
					"layoverDuration": "13h 56m",
					"layoverNoteValues": [
						"Overnight Connection at O'Hare Intl Airport (ORD)."
					],
					"totalTripDuration": "1d 5h 20m",
					"arrivalTime": "9:24pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:00pm",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T14:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "ANA All Nippon Airways",
					"departureDateTime": "2018-08-24T11:20:00",
					"flightNumber": "7938",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h ",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 5h 20m",
					"arrivalTime": "2:20pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:20am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:20pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "8:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 5h 20m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_I\\)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T14:40:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T13:38:00",
			"destination": "NRT",
			"downPayment": 1018.35,
			"id": "e70d4ded-254a-448c-be7e-4dd4abfc078b",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_paPOpaBh0uKC3KVLlwxbJ3SX3_pwid8LOeAR6Cxy_phAkno7kbphfNWRZoddeaOv5hahhsT_p5FQQ071NtT5EkIAsvxVShxs2WyYPMR_pcboU31b_fS5kWVeMIZGwpHHs2vGYlMO_fojolGLtnDeRvoTMH5P9ZAIkCdgKWpN1SqlRN3_fnq7syCtx5UTpmMq4nEpvnlzcxeyr6UCslK4HEKkGNk549OejpBSctCMNzzTD2iLdaUc_pi5aWYrFveiW90qmPnT898nYK0iP3ZrhbQ4qShTlZzZY_f2Z8TXc4Ow33FH3dJXzn6_flftMc1EaZtSEEe2fxBTq9tj5CK80JW2fwjyoqgI7WgX2t8mMv4mZkYqvU_fsAEHfOP4qAWGrC6lh1GP5QJm62N6bJQb4_p7TC7NAGqd8ttSLKkGEepTOG5WGqjfaYQTq4AFuCubKC0_fg7LisbKGslJsy39ewzCvPgSWM2HrTyVPTtpYHCpBQr62HidyUi6H2p5I3KV4EOpApD2lzp3os5lAJLnHxjcLy1TiVgpLp2h8Rszr69M_pDU4klEB8ZY3Zsu3yvHdgj2GAU8lGz2jcjC1nIhnA7cvbNh0QTdNzYydDWzQ5nX3P9Lknb2zs78nWfXfjjeVijEDuwBfKDoFnKLunoQ_fZpk8GVKF6FQSO2u_fq_ph9GzzXyxbefxbxztxiOxFlaVcjVcI03oBHcwRzRPREeE1U1xTO7pLSxlj_foB9Xx57137d2aYi_p5SlzHoIc5yeicW3_pvDJDgBDNRkG60mmJ5E1hs4iPM5iUl7ah6OVNZvsaPn4NV9CkSyE6y4WG5dE5s73Zgobef8sJXJHlC7ujQqB4eS_f_p7J_pHJSUMXaxtwtD4yjeJBRriIdfNEflCGtc_fxfNYekNAo1VGExb5tN7N0zf7Fm_faLNYaB9LWvKglDcPhd3zuXtKM2JovQFCkOAlQy45okyU8Mexkxw4HPvCUVgNhv0x9drAeSaVgEsqOLzZ0VGtBFFlnQenPA_pj4z7sZL2nj8NrogzsBBtDg0kNnr05fICsw039iUszzN_fG9klcse9cBsvTRX8v_pgRl42go7k4LAHP3G3wQxUFKaYMnAWdZaOnIaDAnWwZr_ppP9jLwXGzZ2Dk0_pGAf4IxvTV9a8kJREkKbR78WCGZ_px8Z1NOCfgF2w5uXRqLOq_pXexRGa2bBc4_pdg8EyTaVm5Jumt9Rwd2WWvE6HMsZqF4J_fcFZF_feCl_fNaM8zSVbj6PfwGOXGxmhPTEylcO8TZXomKGcDRF7Rq2uGJmtNlptLA_pnJ_pHPYKBT2S3V6rd_fvpH7sAlVuP9UQEIjxFYNYtr4w79TI6tBgIq1B817HKFXn2YskV6vdTWwTM3mf79dArN2XyBUiPeVck6GompiZ3evlyNA5sj8NiZE0S1awb6DMylGHByT2oLPp9x4reCBXYSaXoFOEEtrU8cvi6qCix6FM0SPSnIUWIKcaEWUYk8kyzx2N5yN3KUUxAXQUpi_pACwcBxDQ_fhgXPrykp7S_pf3U4nntJqNEMMen75RWq_fG7NQQYJpPfy2jieNDZdPYKlfLg7OcMsnfqj2YrhcJEuXX_fC5fmfISaRXePW9HwSV7ChJTKikSYI0UXktQi_pBPTZEE4TwjY0qOv2eT1ynS9fm6cHNK7CS_fOiyn78muAt_fu5ovyFm8_fabGtU_fJMc_fbVJQqkdrMwwqhZb3c0EX1G5WgSl6GXogqO8flNOP6BawHw5o4YO5pcP_f_fIwHTvYXk4hayW7KpmJVD_fApkE9PATW4bBL_p9MM538Ue_pUsuIWj0H1NKVhZzR5Z8_fB8dDTPJ7Nzy9K11uq1Uwo4sqQ7v3pONywv6dKb6pHwFT1a0emfGrC7ePEpkD6YyBk3bv_faQwACfGFkbX8JszEZQ_p1Bujp5Pa2zTJWOyLIHuXqBXaTuNX8DX2dldqociZOFVoX3eCfzL2QUlyRsjcF36boviGNp8CGxqq2sbDoOWOZ0SCiwg00_fy_pww5485rIZhbLP_pop1O1t_fdpl7kkqJkknw6d_feNhx44L8eOQbtuJvLb0vqqVktFxPpM0N6SRUzaMKp4fJXOX8zOCZg3671SL0cNnolgODsmKOq_fLaexPJShQOg9ks1n2ULvxu5fFqvCo7R3U_pwAUlyMRsCiE4MafBrqkQsj75o8UXHlMEyJ9bSRwmwKtQthgjZ8hB_pI8N2QQ5kddUigalgYxW_f_pb_p6p7GBq3mZ_fxiiyQk9bTGc9Vz_pCHye_fHlOS_pTe2NP86CXhaHNmOOE4VG_pokEQruorDMRA9EaO47nU_fG13o5ZGlJdZQ",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T15:14:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T13:38:00",
					"flightNumber": "7467",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 36m",
					"layoverDuration": "20h 26m",
					"layoverNoteValues": [
						"Overnight Connection at John F Kennedy Intl Airport (JFK)."
					],
					"totalTripDuration": "1d 12h 2m",
					"arrivalTime": "3:14pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "1:38pm",
					"departureDay": "2018-08-23",
					"destination": "JFK",
					"destinationAirportName": "John F Kennedy Intl Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T14:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T11:40:00",
					"flightNumber": "3",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "14h ",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 12h 2m",
					"arrivalTime": "2:40pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:40am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Japan Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:40pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "1:38pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 12h 2m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_I\\)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T16:25:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T13:38:00",
			"destination": "HND",
			"downPayment": 1018.35,
			"id": "bb9e0199-1ba2-4909-81d8-a1c1792ccc7f",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pfcJxOKlQZe1w95yQw5VmEbbGuaMpdJWMExOuYM3NzL4QYkQnanmJ9l6INfGhsQzxJeMzofAty2pAPs_f2Ila8TETzUvARpDFc0w1JMG1GUjVcWM18ceaZNQVx_fLUUcVRaA8Iy0Zi_p_f2ycYGS07_f1mKWLPCFSBLqtCtUbHAIB50QNpOZy7olGpTX44Rdm69xhBt8GCPeY6b3E4tCxznIhMjP_fSSMJKVJFwivvi47XngfeGr88a5Dv4ci1fv1RXi_f2YuW1hOKJrpku2HL4synIMLCV1_pAUodVySU2K5BprP7zH7E0MN2aPKE2Dxf8bdSeOTlTscm3xvz_pS1woqfLpPFvVCJ1QexntEPFhvlzntgGNLRW8xJYOk9_pB8ZEESW0I04hCcFfaRZsiQOx3PMI5IMVBPNZifJKhAJO2Mqsi4D9_fEAJE9csf1HKJBlZarPQpel1NXFlsxkmEYJlh3sNwBwMEfSRh_fg6Rd4VXITcpFX4q6i5PyWm3Hb6gqqGx4bF2wuPsZxKBoS01kFS0GMmnjvnZ_pc9AdH6tay1qfsWgUP5u2AJRMcC_fJpN4O1UcE3AcCr_fINkizpxD8guwtiObU004YpRPcfIFxX4iRHrySCIxdAW7N1IKyRl5F8ILEq9EGBTUFUqDVGBu_fDjVHewmhJPGVpuw4GvIqjensPvOQ4M_fgNZCpWgSd96TXtiafReinO6QPn5fQ7iwhW1K7OQF00Zo8SRoequyugXR5fIzG8bWIJ1OrYCpmqfPInhT4mwKiC4RoBT4aY03LcTQPy954pyDzJosLBkYIVNihdVG3uAuHA_fZAWOwDnzJtuuwbB2bt4ACUK5PymavatH0zMrpnAXgWDmMFCx2un4USUpsZ4DAar2MWYyUM6yPqL5GHnS6ka1datZxs09B7csy08_pFTe8v7Odl2MCUqIZwtKsuG1P9kugWinkJ21NTjAI2KNmVNLpNB_f87zvMDYmWOYeEUoE8e8XLOFOHt_f1kS4qI3eZcMcQUm40LSWZpgXlIrcmSTpoxQ53_pqd2ORoKgqyOO6e_fsMvTKxkrlxHb2SvjMLsZ8VZ9IEZJ4r5SCMpo5IR99PJFl2nFeUpZ1T7F_fad0TX4cAD_folfDBkOPMRIfUTLPgivF41uUFzk8aEgYdSK54Ch8op60sl_pF1zDSpqLyQM7R_fyFNe4BZX8tDg3udr5jY1WcUVxlTJbjDN_fT5o3EOV3vMsN2swuUL3rjGcEeRWzsTxYdmM3UUscRqBs_pvoSpfB4VrAETjBWfs35Qovbw12oWQ7vhsb7EhxfUmbYXygVz3e_fi9Yc1RmNc4cI8vn6SVufYWaqlxe9fQxM1aowFm3A08FopyZ1F6Db9hQs1H1T7oer5hGAHgG_p3XkpL5x633oY7b2rQ267b_p23M_fg7IXsVln5V1ZVetAwLwQuEKAoW9ax4tQHoZ_p_pSs_flLqFg8t7kJy7j3Ln9BwZkdI0Ctrhmw27GxTttoeU1JYVce4S1bqIbu_pnfEgXzrgZPU8G4ZKTkBjuvPSfHQLRwPGtFGQ3ckPjcS0a_pjOPh_f8vTfEEcTKib9Jl2x_fvW9QuaSnkb53LUX0DVzYwknkCbtnG4MEqa5z_f4FKLcMGLWbi86gMTqZ5IoclPY7rdLiWop9OmaFSkn8SGIRT3O5BkVDpZ6AHbRwXXhCwv662dHXnfvospTWB6qSDS_pALkEhTBfNtj3cgcgZypstrpRefbK21EtiKrbmMJyYP3ywXy6dhzbSRsdj2_pZvLYyVWf7UCHvmttQ6H7GbrcThOKsvXA8EmegO2rOojmD3cnPBEnXUcuPvwqy7CpEixdJR8nd6NO_fjnYD33dfNFIhocwOTdL9JaCSl7xQG32zNJYWr2yGcbQgloYd_fFYlea0KZQroZumU0RUyewDtRAEQ1qDtxjmGMHTzBltpOj9P8_pnWCpy9peWNo7PGdfIs07BIFHLiQdyc6bcQt_flojnceOB2aJixDOv0ZOnFuMBj_fl3ooq5KfBrNek2E7aQ7UsvyDKIdu5y6Akx48IYrysw17lT4KTPC0_pVKurkCkkfjbyudDlgB2CyfdvDX7196z3c5VmsPV41fzkVhv6IesB6Pille6YUcpvGlVowxU49wYW5gGn_fTlk5fLmTKe51ddTlSS256HBumsAM7KRkG5SlQO7DtAU06j_f5qbYHzAfdNbkYxgbVy5ux9Wh15P4hprSk3zn1y7FPD5Eg9zrIA_fS3GxQNuVvF5axHXM7h1VPxf9FbJ6QzmOwelLwkv6wflMKFLqfZ9qLgQC6xTM0RMN2EzUFI5Wdw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T15:14:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T13:38:00",
					"flightNumber": "7467",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 36m",
					"layoverDuration": "22h 11m",
					"layoverNoteValues": [
						"Overnight Connection at John F Kennedy Intl Airport (JFK)."
					],
					"totalTripDuration": "1d 13h 47m",
					"arrivalTime": "3:14pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "1:38pm",
					"departureDay": "2018-08-23",
					"destination": "JFK",
					"destinationAirportName": "John F Kennedy Intl Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T16:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T13:25:00",
					"flightNumber": "5",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "14h ",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 13h 47m",
					"arrivalTime": "4:25pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:25pm",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Japan Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "4:25pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "1:38pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 13h 47m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_K@)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T04:50:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:40:00",
			"destination": "HND",
			"downPayment": 1018.77,
			"id": "29e93d02-07de-4311-9ee8-f482c616173b",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pYzJSa2P_fGBCFf_fwB6i48t5_fxoICLmrxO6cw3hbE76kSlL9ztsFO7lTWG_f0xEA8Mcrra6sHqOKR8FRO9pyp4zXGVyFJm91v7BChCedm_f1W4GZbdXm72m7fiCSQVUJl_pZFSLUfmrgHpoMdzVtRkUs9xOjDZAmPv40GQSH1jgEmoFM4_phY0HRoMUhyOymcvzU5jYx_pysKkQQcOZf1JArs3jfjHnAotJj_fXhCkhbk7UnNDlCSJpx1uH_fjh4ELRLbKEp_pytSUctAoCiivP7x8FbCC6BrVQoYsGOFZZEqOiLf4xupBuvxg9LmwIh_p7jc77ILZ8J69b7PSbp6N_p0Oyr4_f_pQmquhpmdj8OrV0o_pnp9MFiaLeMJGd1ieuWGTE2KybPzeVWwgor42h8QHy5q9EFlVT1Np_pSTxWvUq_polxy_fgAtAmINArfh8pkvjX5RzgLfBuSohBVbyWz1wmxrSTlN5raW9bYHIlzfOyP_fCw8n4EABj66Mku3xQ_puauRSWEBAlwpOjiNtXxmdTWSG8i92xUfjl_psIF26X_fis3iyorLEMkeDDgQjxtsVR7P3rEjMa9ESXOxLAgLenUnPe3r2oHbgOMd_fiuOs_f_p3Kp9qe0TPaurQKhU3dWp1Cnh30ROWRBKG4vVAfpuPVEHJDOkCFYuNH_pZKWlNxosYswovbBZn6WDvpwLwRjvNWz02TKQhIs7_flb9PVUjSfPP5ex_pJLObiOlEZuw7E7q_pU5eXxUDFm0_pUxgGjxpCOvnVCY80Thktw52i58kCKFU3hCecvSqxla_fhBzstqH0trrd8DVeWF_p0MtwSHvGHzo36SBWvzbkVeURksDEtmp7VbzybiGvg3sULg8PVo0o9cziVZWPcfedb4QUrXMLU_piuNRLB4n_pylKN03_pLpx47QSxVZ98geATakPt8Ph_fx4IR5oRTUGLt_px9tMgVwwyZKSCUTOD80ZhDRnhTGpuw_fnCeBN_pyASfIWhnVgdh_pw1mxdhyk3dQq14JxiSCBjv0MIFPonE8xqUN9A2x4TRqJqgxKoNOkTdug2xfKCvKS_p9sIh1NYodNFJ_pdbOUfFKs_pr1BuCPao3_fNWyuF60zxw5i44RV17YkpFnNJWYa9TiLf9ttQCY4nLh_fkcJbXyamSovelt_fN0vZLXQjDrY7MdJXFJYwqz9GNCtWsRqW79OZabTtryPqpwxHX7W15_pC_pSxvpwGBPKQ3s6SqLheqeozDESYM5VS4B4Au8ckGB775wF5MWKWinz5LMfRMO02HmdSEUEeWlVcocL6CqZkokDsHQovQaTa0WML0FIjrLOVcNiVAcllbzyfap8tV9e6LW46kZaDJDSqPwSeZtuutnsRv2EEZizvriW30H_fvHQNab7t2gupl2_fNVpPWvR1SbbY1eV_pg_fbXAXZ_pwIQbxsSq6DLK3qlLxl4DlBaAjagdM9Cy0QUeA4XpRceHki5oD2m7iufsL6gzzUOiSdc7POf09ox1Sw9cRP2WQw7MD9rgS_pXfXTrjDEVD8d6uVJEpLmRPs7AaSfkyA8cbI4lI_pAzaSrCsNJt3mhT7h4bRAW5ldAthkYUM5unZONG4Vr_fmK2GCsIAORCivIBL5NgOr3Dq64jilsaYjPi_pb0svr5vjqFrgKpL47sY2PsnFfakKLIpHzpLLDJboAV2K4EWEHzJuCQYzzZqoyai5m6Zo0H1tAhz6o_pKIY55FYGAKDXPjXMBCTmDK2KDqlfXkl0BuRH3QCWFSZdZ_fXFCvq1TRpxLSywEGZtYdZ1sXDQDSl_fKRjL2a01U_p2XWumU5_pOVWo4ZLxAnpMqG5SkcgyXhpIILkpBL_f1WLmzPGRpnyOlB0BmHVA7gDVH_pKsHneqeVoQbgMITnocTQX8I39lxQyEipvCUVHjTtL_pMgBHcx4kIvbn59naMLs_p9HT7DxNqJCdDYhMjUjUcISo2Ut39QJXHi2vrMrYyQgo6ar_piKykdFSgUu0RKHxSJMLzzQS_pFq3FGrmFaD8b44oIM_pd2HdFWNGXXpGS2xL8iPe3kkJc3z_fsAWEmM5Sje3YlNLqSmybUNJXYfgIPVnIdVvYlHxF0r91qA_fGZcSWcrLXgDWM40OWbe0g7SOTnVjyKeMtUNUH5j_fC_ptaiJvvWjOT5SBAewio7dQKs6BB6DEy873J4QydtmPct9NLjkWUVZe941UTd1O67ABavyAmt8eLHQL_pTYPiBVC_fQLwxjpLLNeOmfZL_pbym_fl5f_pu_fpl2BWOtJ8YiT6cs7niqoJU8ykCuuqlVdod2uwZg5vL_p7D5_fjStJQPeRrRgYzy587HgwHdmaauPd5Ueggqvmpd0FAz0M0b6zRxpyRBBPJdLEPvbqrmMh",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T08:19:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "United Express/ExpressJet",
					"departureDateTime": "2018-08-23T06:40:00",
					"flightNumber": "4341",
					"aircraft": "Embraer RJ135/145",
					"aircraftType": "Jet",
					"flightDuration": "1h 39m",
					"layoverDuration": "12h 21m",
					"layoverNoteValues": null,
					"totalTripDuration": "1d 9h 10m",
					"arrivalTime": "8:19am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:40am",
					"departureDay": "2018-08-23",
					"destination": "EWR",
					"destinationAirportName": "Newark Liberty Intl Airport",
					"destinationAirportCity": "Newark",
					"destinationAirportState": "NJ",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-23T23:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T20:40:00",
					"flightNumber": "1165",
					"aircraft": "Boeing 757-200",
					"aircraftType": "Jet",
					"flightDuration": "5h 50m",
					"layoverDuration": "1h 50m",
					"layoverNoteValues": [
						"Overnight Connection at Los Angeles Intl Airport (LAX)."
					],
					"totalTripDuration": "1d 9h 10m",
					"arrivalTime": "11:30pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:40pm",
					"departureDay": "2018-08-23",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "EWR",
					"originAirportName": "Newark Liberty Intl Airport",
					"originAirportCity": "Newark",
					"originAirportState": "NJ",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-25T04:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "ANA All Nippon Airways",
					"departureDateTime": "2018-08-24T01:20:00",
					"flightNumber": "7983",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "11h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 9h 10m",
					"arrivalTime": "4:50am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:20am",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "4:50am",
				"arrivalDay": "2018-08-25",
				"departureTime": "6:40am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 9h 10m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AY)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T08:05:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T13:38:00",
			"destination": "NRT",
			"downPayment": 1023.51,
			"id": "2bd3f0c0-7f1f-46c6-8bdd-47115cd933a2",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB4AYf_pY_pkEXgwy8vw0Kctt7V3iIHnSQ7HeOezJ1jvseJEy2uhRBF_p3aDUhLiDnbzEgKTEHLwixtZG_f9B2na_fo_ffK9HFKigR4e0ukXMmIU4nT2aoOZ1NJcN8sdULelzun9Gf5IPpejpUAinagGmIRzhj7UbafumMF5CJbZ86yBRXdYQ8JqP9h2ykE97EbOEhMrO_pKyfhbpYmWAhn_pK7dMgvdicSVYPte2i5RJtzqS8mRiFKbhJEgg28akEPbzpBWGH1CbSvPERwLSOzabGL_fTCkMrz8WUZgH2Nfw3Jumc_pWf993NBNnIkxU4TLNVjEGqTgSCjQ8mWWI_pJ2q8irhGQckttihBMApcgs548uPzLHtE6qyA4I9J5uRwlivqM3f_fmJz5_faMHuya8j4J85m256WRAGEreBm2t4bNlf5M7RhI4CvpW_prnYcnhUuOJPGOiPmYqJHvdTlNRjYfWxpdYQM_pihXLsb9ld96a9W5BQZPCkH3dSid6bIVR6M6kouV3ZAtQPd31n_pGJVpxC_pcLc9GIAuxczhC7UPDxEfdbYlI2dQcy_px9x_pWS9fN5_fWtUM0fx1E7UDI_pLoRF_pa0xaxr62EdY1U5054cdNEGvv3UCLDN0qP4EuFno6_p4YuiOyAm6YE_paW5itWWweY0wgsV5QsjTUW_faCcTxrhCZGkyXSCgUaT2HM3SUXBvkUx07OImRsodH_p7kZBbHbFeIZsmhhlbB_fHQeS9Um9doGICvd1xG7qKEuw0nKz8sYRgM4wM2dUntM5V20BmRZl2_pUc9_fJ7voxLB_pRy5MyOh64pZFXbIlAfn2x1ToCkOfI82y7DUAvEnZhGKmVc2beRHGDyNLoAFySzqGZpOxQ7tB3xkZkrsryC0a6HU7WLNKFdpdFj58nKE2M49mGU_pdHHoL_p0zwcfPZJc0QHlSUNknDy3NEq8RS3pcLGbdPJHKapsyX8qU49X_px3V1bXx6Ebuq4qkN9nW_fKH9YZ0W0AaEQd77Y1pugIZkVLCPu51naAdWd5x_pyrKYWVZdrF3M5xt9fg2n32Xheme49sfhFbB86n6rfVlE8BVlo2nXUwuYcn5r_fW7qfK_fQ2FfJZWKAzx8Jdf_ftqDd6tDpeBB87VAZhokomsKGgO47csgz0_fA3I3067Wz5N1kKZ57vlOxKOTS9zfuv_ffbxvdfONxsHRlmivK1KfOBkaBUkgfjht0hQ_pU7YoFp1t0KXIAIkin46iKiwD1eyyHlMDj_pjOsiNc23PP3Y4_fKboP9q6LHv6TDGOxmc9ZwrL6JJVaM7rxEk9dAYCFXkZAvetJAJClWUPC_p49E_fKoxXqnsjaFeKCh8ZCZyZQ6VA4Hv_fmYXvEUb1SMr05UD9fvW_p9rCix2xC5huZsCs2o3mlvIw14G4eFkt2_p8Xef2dfw46CDDbfr2dIhXwobU9eh8_fMPtvqi9o7JMBiPHYmAEm1poVHc53hpztvzK_pq8j_fFuNqghlhQX2HrfL68X5uQsuu8_f2MOykoKsxqQwxj2cUs8yjNNvzDS_pgQNruBwF4SeXEjEEcWHumqVtJ0_pOdlOcsmUY484ZlLHiWkeBUzF0oEMq_fAeLCa3j4E4acIGMrX48SCsh9QJtiCD3nu_f2ALSv0YC1ieAMrzChVx2wPY8YS5oZqH46EkHH4IlqKu6BvlDrZqAUMhp0_f7ZZNYCaVLDZDNf5pcD_fXzaIY19ZGzLGk5SZ0pKbU9xgaDhOlyOdoXvCP7DAzJu0iPgs1hPsPtdGtOp_p4WZ4vfyW3Ov8ZyS3fpZTJQIXRdgk_pcY4H8zqv9pcKL_fxsUcdtXIf2KMNFzLjxQKQoVu5QbpA82Kz0SfeUc5Je5PncynQA9EAqPnIC6xX6Vdi0DAQEho8EO_pKTvfeR7sWOgKeT6o_fJkBUQe_p2yOdMNKGLo8Mbv6yauxnygbxW_pVUjSa56iDtVfVAAkH_pzyr_f23cEDi91ZYoztlVx0LdVfMSCM4rkm9J7GAsZII29budvFxZbWFK_f26xAdP7_p27YAOPxpzOJlktRc_fZr2M_pFmp5EjBUAEBoAoeoNdQEAsNUYgDTf63toz8bc1Msb5G9TL3mQtxX26c3oRL0HNX0K_pHaq_fiof9aqvaJXMGIT_fSUFSb2r_fEwn6ilPCxVyKJiWtcQTfidZm1WTGYy005btrwKwkOCkt1xdB5HZw_pJfBSnrOOzhJKZcTrEatL0ubTwN_feG1ELNrZNNkGrqzUX7P_p0h_pskA8cXlnHyCtjK6RZtOSjq6S4JT2CedmdY2Ww0q4E39NAuqBkv40F6Q3fmtVA1qxyh1_fRkFN4XCNCEo9bMOz09S078uRul6i870f5ypM0pgQhSnIRvvXZNfDZHVmCX8PrCRGVhGA2PAPt3GIB9AA",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T15:14:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AY.png",
					"carrierCode": "AY",
					"carrierName": "Finnair",
					"operatingAirlineName": "Envoy as American Eagle for American Airlines",
					"departureDateTime": "2018-08-23T13:38:00",
					"flightNumber": "4063",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 36m",
					"layoverDuration": "2h 26m",
					"layoverNoteValues": null,
					"totalTripDuration": "1d 5h 27m",
					"arrivalTime": "3:14pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "1:38pm",
					"departureDay": "2018-08-23",
					"destination": "JFK",
					"destinationAirportName": "John F Kennedy Intl Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T08:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AY.png",
					"carrierCode": "AY",
					"carrierName": "Finnair",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T17:40:00",
					"flightNumber": "6",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "8h 10m",
					"layoverDuration": "7h 55m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 5h 27m",
					"arrivalTime": "8:50am",
					"arrivalDay": "2018-08-24",
					"departureTime": "5:40pm",
					"departureDay": "2018-08-23",
					"destination": "HEL",
					"destinationAirportName": "Vantaa Airport",
					"destinationAirportCity": "Helsinki",
					"destinationAirportState": null,
					"destinationAirportCountry": "Finland",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-25T08:05:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AY.png",
					"carrierCode": "AY",
					"carrierName": "Finnair",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T16:45:00",
					"flightNumber": "71",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "9h 20m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 5h 27m",
					"arrivalTime": "8:05am",
					"arrivalDay": "2018-08-25",
					"departureTime": "4:45pm",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "HEL",
					"originAirportName": "Vantaa Airport",
					"originAirportCity": "Helsinki",
					"originAirportState": null,
					"originAirportCountry": "Finland"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Finnair",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AY.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "8:05am",
				"arrivalDay": "2018-08-25",
				"departureTime": "1:38pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 5h 27m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_I\\)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T14:40:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T17:14:00",
			"destination": "NRT",
			"downPayment": 1036.35,
			"id": "6afd238b-0214-4215-8197-36f80ad87f57",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pTWdgJj6LfzwrKXYRzoBMBrqlYYU0fu5Orqut4qbS1Ww4kLjZ_fZKaxvueItAMDS9Xzv7l0iT2xNdtQ6MPa1pex7oolQQnoPc271vITjdSBmlVGK2psdgxGLH5W1U7FtAHxK8IqzvvFKhCD4Z34zBRXrrSu70tlf74yFh_pNKHAr_prhmzvZ5HGzwG_f_p3ROwD3NH7X4ZK6bJlIT6_fkTP_pwA8yp9aexA_pmb_fMNruB8miEN8i_fGe0wU5VIZ3aeTCM3y6od2_fe5XM7EBEjI0L9NWOTmpksuNN98_f6vzX1tnBPlwxO1fRCiSVgvjfgdtkgPPEc6dLZ7ei8fJSI_pZtQiJEbh6rjI1QovERLzMhGUbi545hkf_penLeaKt4l8FJDmFkNQh36DqvMaQXMq4ioqCIJpMZCvMREp9zM_fNa2C_pi1ur1Vmn2nzkOIXNbB96fdGAIeGd1Nl5_fdpfA_ptVuq78TAhzDtS9_p2V7JTRzvndnS8A_fbCtwb4KD_fr3I6yPevnpkD_pVv7R5jqnZtrI84PULgIr7Xx_fx7AeMDDWSnyEgXDMfmSJmI59DCG2urjdz73tacj5O_pQ8gPFsqrJMUvAhMzPduFG29OrT3KVFfhqsVOWadnXkOhXrnPYa0sUFbxuxcK2C8m6cQJ0TVgaqKEYEqO9oTSwIINUR6TdZFPTyXl_ptnKfZojyZQKC4Pct5HiEWnmwHJiiA_pBEQnih8EgsH03l4mQQIIT7O6EDZGPMWHfC_fJ6laJmIj8Vsf2Atu7AZKfAT_fYO8Bnh67eKnmyXNxYwDlRzSu80AahnsiNlraQYiYycDi4gBf48sfOcy50LViu36ipptaK_pr29ypAM2333H1UFbPQr2mmtZ0kDz_fAufTaPAeobOTdABnV3QJRU5qH_fs8dw3hVUpXrVeIevypQjua8hQGzM_p_fuG_p4dLrDNypu_p0MIes_p3K6xtdUJDS9XBpXAkVFzRO5_fvw3W34VC40nCX2jGEo_pZzcwk3Kn7TuWO3jajpHQtHso2MlKyCWmF5ULELv1V_fTARyv1bCQFRGzWmwjQSKqUwB9_pvpeAQl4Kehh56LFUgRYjHWR6iw2v38JE7sNaAymikxTB4H8VW1h3gdDm_f03fEmZqz3fIQyFCdxomwei44YCKga_foWLR83A8an0tg0NsmTlvsa_fPpWiCZ9tRYE9nmD_pWqcpFYyxOrANIh18SLT32TLPvEPmmb8NZj2hIK27jPd_pD_poxAWnhxEczVJhnxd2J_fYM96kHzjoTpKIkNGp7BfHwg5Axl0Dq1DgSwXH_flbabZ_fpl1awtxc1XhufVw9jP_fzXBYR068ie_f2OyGi8Fp68YFcP_pP0d2kkvA0wL9qhgBOzJTYvKV_pylQRnICdeJkiQytBjAwg9dEgWNdDmWs_pON8M3du0kWEhC2rMzSWWWGI_fP04HXJFvrev8PINuOP5jV16T6FOaHkeI103TLF_fNBZ6mJcJ4j90I4hliWifnbxeI4_fPXurbLNLHYku5y3kPsXO4T2OFEZevI36jcYTbIXsk56rnKX0T4OUz3Q5lem6qC_fWmqpIFiBNJXn7_fhvpE8YgjW4CHlbSnItobB3aclxpLjd2xgFkruhxgqIP7NOA6ZymYNSB1vUhI3gV3_f86vEdcdbSVohz_pWfLEr0bTrRpwHJoFMjjZ31JK_pte8_pggEFY6IePx3B_friSs4Xo_pd60G1v_fR9OcmNTgHwNQ4IHOpvB74AoGNppQyD5XfpZK8HUiMbBmaD5j87j8v0QNcofqg4k3NX65D7n0AQmrOf7bSUQzcs6fMEX1VB0xqBHcwmSBAhYK44aJXWt1_pH26wDyXnEGW6Hx3egp5tA_pQeqMSKCw1EvlioBytzT98dbL0bRu6LL8c_pp4xGhPG5023NS1Y7XhOo5bYLXLJK9Zg7NdBYnGVW9pW1G9QDgvW_pqxQimhjiU74BhxAN34pjF5k7Cc_pnRziGn_fzb44TdnsC2iFCB4DqGeAhqVSyIx4SYOf_fsfqpLEjcpgK_fwxfrcFj9mcVD9eWAArvnbq6Jc63zwK0N5_f_fx3kT8PjlyI5h0m7RrQeYKWayqbLvkA3xggbolbfG1Akd3lFOU2XSMPwlbZqJS_f0EkSGjtXkk04rYgyQ8uCqiC1lxxYjegSF_f11YDpFWhzu1fTujr0Ngfd2_pCrrLHuRzqh8gjBqD29XJaxSOBM0lqWDySTQYLck_fVlD7DYCuIENJMYVLKwgjMbD8FP24D9PJihGB_pFEZ0mIvBsN95QsyX_pnnoGS3yjIoQ30cRxg3Mva6z64_ptbkea4xHJDPWr5ssP3WuF7_puGllL43eNDYa_fUnabUg",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T18:59:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T17:14:00",
					"flightNumber": "3940",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 45m",
					"layoverDuration": "16h 41m",
					"layoverNoteValues": [
						"Overnight Connection at John F Kennedy Intl Airport (JFK)."
					],
					"totalTripDuration": "1d 8h 26m",
					"arrivalTime": "6:59pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "5:14pm",
					"departureDay": "2018-08-23",
					"destination": "JFK",
					"destinationAirportName": "John F Kennedy Intl Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T14:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T11:40:00",
					"flightNumber": "3",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "14h ",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 8h 26m",
					"arrivalTime": "2:40pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:40am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "American Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:40pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "5:14pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 8h 26m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_I\\)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T16:25:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T17:14:00",
			"destination": "HND",
			"downPayment": 1036.35,
			"id": "0d71fc25-e4b3-4da2-8ab6-fc58c909830d",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pV7I3OiMQoQVj2i7Y_fqELDXZRm9_pWR0Bc89h0ExU4BOLFyVX1QbCP4VrjfWY_pHifoJAvJOSSpj7I7EVAC0i4OPar4i1vu56QqXEwGaBjH92_fyxMI5J287SvU1EhVHcJBqFQaQcC7jAQCYmXegsywjsWo4actEbdO4G_pK4XnIm0Kh1tbAw_fd4ogNoICKiX4Ai5PfKS5MyEHBDBmgI5P4R_fQrdYJbMFhi_f1g4ZVsPLreJz7eiqZ7hhDpEa8dwzMKHuD3YoLBFdQkG7SzBNCzlNQYmIK_pcTyU2x41CUYzk7EseEdQFpbI4mcN_fLdnvs3QrdA399fN_fKj0u_fe0X5LhfkmIpYN8bUd1x9CU1DPXTR5HNFFZoyTmbprzY5hDC7sSionmZZxnXgowwdQ3b6xZg4jLiCl3YF4YDIugj1M9CvtEi8Ru1UOh5buV8Bp4n4346u0UqnORQAt3LcMp8K6DG_p5imsRCtd5ZS6R4eCC8SN_f9a47ptkZwgKLAQH1suSoNOXuY5dBLfmYAtUXMWafsTVFAxigiUvM3xT6ihMnbFYXYl7T1XjgU_pzlQL7S8LKWQSiBqjusR_f_pw2wRnYfPwf_ps8vNMa_fgD5Gyy7HELqj6tJu1CQs8vRI9I52pZRlgRItENPLvoo_fYZ_pw3oxB_f5BecDLEN5JDW_fb6RHz_p8l6cQFNrSEKsqp2TJs2xfHyuS5RUJz59AQw8FS_fto2XEVKImtqNXVFlNoYJUX7dV_pUtE0h6iJWpwejru9Z8icnvBrqF3wf39_fgtDwf_fFaE23lnAmRaDuHr79534QPMaHULOBi4N9mzm9VnMyhyKEQv2Q9vOMbLoB4aeteFSM0DrZ_fVpo5gyL5rD_pPz4LmK5wpabiBS2vEbdrdSJgcMQuUp4NinnFOY2dESJ5H6ESq6prj_f0r_f9NNJm5KE3i9aUj8kwrSe0kshk9sDymI1qnNWb_f5RFLBOu9evVjnzccU_f8hqpIl26LKem9T_p1wuOC5cPeKPvv_flIiPW1Q5jM7cTmIyq6v2U9cGajb_fkDjezQQOq4cqXz1lRiO33i2lgERDduvVbXpDyNeyOVZ5WWz_f4ThArQOFSBNpC0Gx1G27SyqPX_fZFq1BcxDe_pd7cp8tKQmsuFWW6LtvfEdOuMGlSgfetFbhmP4cXaRJDtW57nZ629n46GKcwfDTPPFXPaFXvcRsoQF0nX3h0CSEHi0Rl_p5xan9V_pl8L6I2_f_f2bIolE98n1nULRMbTuQGDwVrENSk_fj90EltwCnyg6h5X7Y0wcFJEWmfGE83Dez_fN5_fkGksq_fEEOaVTZHtSWEqgDCwMMrsocuh3t0Yf5MdPDO_fbGRxMg_p44jJNF21qH_pbAtPImzmk4m19WGu28WupKW0HJJ6KIR72PKq81tFTjs3EpQQv0dDs9oQwSXiaMGRSwFY8lrelck2GqC1eHWZFVgHHdnk0_f0lJ1izexVoGAK_pGUedLgWhsuqMB_faeIZo_fYmu1VWqvDiPiiTogPvOJHK1cErWQg0GvJEo1pSSmoxaSTTMaYMnbF204uuWNZ_f8rUoulWfGykcOM4UkMaDJIIp6DH0TZsbAVoB4MakSfmJHl9vs3lH0LSnIue9f3BGgyO2tD2z02U2_fIrd7IQg8geWejOR9HCbbyplExr2f_fA6tRvcZIuTKgrKQ9P8r1omo_ff_f3WejpoQMKHhAJ6Agl8OjDM5ox9DDOnkSSRDKT_fEZGwzIj4rdUOVJyyHYBFA7P2okIuQy971DPvIv5p7sAwzfkBcdLrWsx27YBGqA3mSpwo7Gm4K7K8QeuaulUbux5r4ccykZn_pUriNAwGDIXPY35KSaLU8IsqNYGzi_pGliGC8NxAbogCu_f4a6o40Zv5T_pcGkO3lSCQlQbssbeCZjbkmllcxDfPCg0BIMdqVKGlA_p_pK97Os7WVppsIb_fpyq82IC_pu0jniL4GF5CVZVE6YUjOjTRttRBPt2aNZg1QEvRDlzgp0BJFXOsBWbTcYLpKWvJrnXhFkUnf4vsbtvAF3Org0HHkciciHuvw_feRidDTVeeD6_pz7yBKZTJe9dWEOQN9aMCFnhY62dSsUXLBPqUhKZKMVotFpNWus7Gr3y5AoF3Ggm3Bk5ag75ePz_f1uiMaPZaA5H7VRLCD2fGyPLvQjNDqcplYfU_pVvnvK1TsV4TsqC_fze46jQ0T4_pjGpZV_prHEhdKhFttKPV6FSK7tstjbfeO_pZwcAQ5USY1zHURfzixZYqSWZqxpnbB9puL1P4lsNglMyTHVqmktdvUsTP8RF174J6N9ox_pjXex2LZCWLXWeQ_fKvatahT_psmBJHSjfPQ5s5DVwk",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T18:59:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T17:14:00",
					"flightNumber": "3940",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 45m",
					"layoverDuration": "18h 26m",
					"layoverNoteValues": [
						"Overnight Connection at John F Kennedy Intl Airport (JFK)."
					],
					"totalTripDuration": "1d 10h 11m",
					"arrivalTime": "6:59pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "5:14pm",
					"departureDay": "2018-08-23",
					"destination": "JFK",
					"destinationAirportName": "John F Kennedy Intl Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T16:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T13:25:00",
					"flightNumber": "5",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "14h ",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 10h 11m",
					"arrivalTime": "4:25pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:25pm",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "American Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "4:25pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "5:14pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 10h 11m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_JL)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T15:35:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 3,
			"departureDateTime": "2018-08-23T22:00:00",
			"destination": "NRT",
			"downPayment": 1042.43,
			"id": "1e839fb9-e4f2-4385-9133-fcb053199c3c",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB4AYf_pZc9sgJ_f8FGwOXmW8W9FAtKt9Z6SncqDizV_p08z3ZZXfMFLq2rwIpdH5dL31R9O4kSsKxjr4Zn4IGwYZxtgyVZEfEi4UzMfaz7NgPkXZ4D3fiWQvwsV9lQ690X7cbX6LwPH1b1xxEEcKhLwzuyvLjthCurzwuXsE_p4za9XXvCTdTaOCZFxa14_f5GCSdDoFSc6cqtlVLCfdGbmJ0fhMSJ0tXQrLWpmVGKmRMwd6Jv1RkyoJ3se_pdw0q_pYignuuSxhno5AnEcAMc1Rtu6_p32fiqmxzpajE6SWCS3OMtll_funz3SO2s5rSSx8nbCouEFvEu_paMH6n3HjtCoPvO18nGNR4ndgkcTA8i117yKQ5KsyR_pczOy4uk6w_p7Ueq1mQxyERBE_p5IznxxDWcrG_fCnYQ_fz4xY8cRIRwv3BPMgtIg4vHX1sQ_f9BkUDPuF9iQoBQXOjzf_pM3czHrqe6lPM5iKGruf04rqXMgpqTLLMzZxemOhptjdq3t6X9TG9uR7lIX1X5zahOkLGg_pZBAQHLCZdd53NDJmHCWaJ6U2EdpipBmwsOf8Eoqa0cOr2aqyrqagyuP6w5Oc9FTNc4aLK6CV_pXpmYxduWDpmWQP6k7vdwS_pKnouC0MvMm3gWGfA1fewPyAsqiTG1IjcBg7LknXYSXtiAAC_fwhAxxbFxWswX_fNFKj_fykHe09OnTbhmb0p4Z1xhltCVmyW0Cqz3Vdu3VlQeGUVkl12iz3LTpu_fyYT_fkUTrZ2rD3Lnpi8kpIBg6i6JyxYHI9P2Mxs5ef2HIwKI2421VRoD0yIoflQA6R3iYVfMGJkufBnZhvoxTsstfGreHctbuM7_fogxjw3yyC2IDQ0cP2OvwhBy9oFyjRg9G3B84nQMvU2imn2DJSyFUl4cC4FKo_pec0m91KyWq07HuiVj3rLdrRF2XOj29bDdEeA9LsSNpo68P9pI9_f2I2_pKtiC7pkmHygg6wn95emQhEJs7wRLj33jdZvYTS_fQLzHKcpTFq2qnxxPgs3X4fmSoEdD1cXTtwjs_pdjV2pTQeW0R4mDMzRr8XYzCUXJa1Ug2a70ymym_pcCE_pJFPidCOMw4E0QGR3iw4tFbgyTe2PsUyk0CtnZV725xbKEZ8lVkNfhORM2yPIsjCFLrEXxyMy629K0B6KLEJ8wfG7utAcTe5iK6H_pNp66En2Ysm4MF7xvWKATGn10IC6AWjxnaRiJAijBe_pyAG49e5NgdOW47Wl_pEGBrFQ9yXH7b5SvnEm_fG49hn4KnQtsA0Kf_pjzuP0xa27Rcepw3rOz99t2FJGC_p69q1Hp9D7TTPirN_pTMyKW6I8LoPzhj7vvsLldkocNPE6QXIVCYEUH8AnYuYnXXjOWTvYeoEHW6qgxbJGq1kLXhwM4WWLwMrQq5bNJmwYnZV6i1YZiePvZ_f3DAXJwzIrKPvhXVxfSuzjhJ0HqW1gQB92ytjPY3YbzoxtzhwwvuU_pG9Vzen5d1qkk4a_pcOAVNZf5DlyTjFJ06VkxisQIZ98s_pC5EUxBn1nPggiRcIh1KtHpK49nJw6pEIfaDcor3RkEsYGnowtrgxZ1CvHU9ebBCpMcZfWXJ2YpSZnaOk3F7UdnXa1iNP1ZOJ2lquVfkaqKDo8oHwYWqAv9Eyy_fEZpTYSL5H1OuOV5pZhI9pNxfvfZp0dn8l1ux2hJ911nJHBzwFVYzjuyJAWZS5w6wwUk47tlS2MP9KLdl5mgY7NHeeGxlpRT31HUPLF4Sh2CiPI4qcoa6z_fetLd9HVP5PYm3snHIshZ4fTKxEABoaIwfSHTOZLtA46IIkQzPxIMhX1qXnUQahwYClspj1BRKw3ULBdCJisMVEK2YAsgu7tiKJbc161Z20dz7GGiPxXr_paEj_fs4lQnN7_fz3_fSwe2jitTsyOQ2etiQVRBsjWthCPqt3J_pZYJY7mTxFVUZ1F0ebSCrXLvjdnqh0qXdlX9zQ2XjfWjN4i2yvokV7fEbx0YAjyNnTiz0ZHPYz_pFKVk3QPjsmn2e4XzsUulLJcWaVL0TyiW_fFP3C5Ud1yA_f_f7L9F4Jn8L5481vY1UwjOFUBPko_f56aBhc00YYQA97GccJD213I_pXVppA1nb5kQQz8lsAC2t1diEQwZKFN9O2NF2qzo9rzoKyolNsdwyOTSDpFnkLHKqI1BXgJ1b9HeDz21AN_pyOBdL8_fAfRgkFheIDQSdl27KB8sdH4VoWQSYXHiEBHEGP0fIiseLh7xUF7fmDX5l97MxzMMmOUEFHUioGGId2fArK9lBVeTDplgEbsMqie3o0ZdXDnJnub5idpRAD8MmTpLB8AnShjFehr9OyTUwdzf_fkskt9gVLHgdKBhRBHA8zPNRVDdGtHEeXmWtl39A",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T23:31:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/WS.png",
					"carrierCode": "WS",
					"carrierName": "WestJet",
					"operatingAirlineName": "WestJet Encore",
					"departureDateTime": "2018-08-23T22:00:00",
					"flightNumber": "3541",
					"aircraft": "De Havilland Dash 8-400",
					"aircraftType": "Turboprop",
					"flightDuration": "1h 31m",
					"layoverDuration": "8h 44m",
					"layoverNoteValues": [
						"Overnight Connection at Toronto Pearson Intl Airport (YYZ)."
					],
					"totalTripDuration": "1d 4h 35m",
					"arrivalTime": "11:31pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "10:00pm",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T09:21:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-24T08:15:00",
					"flightNumber": "3430",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "2h 6m",
					"layoverDuration": "3h 19m",
					"layoverNoteValues": null,
					"totalTripDuration": "1d 4h 35m",
					"arrivalTime": "9:21am",
					"arrivalDay": "2018-08-24",
					"departureTime": "8:15am",
					"departureDay": "2018-08-24",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T15:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T12:40:00",
					"flightNumber": "9",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 4h 35m",
					"arrivalTime": "3:35pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "12:40pm",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "WestJet",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/WS.png",
				"numOfUniqueCarriers": 3,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:35pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "10:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 4h 35m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_W()",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T15:35:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T17:33:00",
			"destination": "NRT",
			"downPayment": 1043.55,
			"id": "efae21dd-7469-49c0-8aa2-3488c5c5a10b",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_paRm9erOy0LCT8eM4hnFmYk_pzR0YnilyelTC2jry_flYwtdHo9lUx98t_fUW4EZAgf9ZhcNBruBjemzFQ8Q4ak7cZ7gvQKIqJCg5vRYRhXHKOpy3y42My0_p5Pl5YmgpZ_ftLjC_piz0SjL2vh2WQtUlER_pmR0WoDKh_pc8iyKkLW_fL0iIsymRjJn5g8VKMbMuDOEZxnYGA5_f2N1jkuP8W6hJFELsBMsZgMwpl1F9wx2auQDnHMiqhg7EeyR60Rfb9UloyzcGalJRJ4x2oTLz_pSWMzUvuebWcX_pnItNV04nMEgLUY20TE0n4_puWY4WuzLpmftE4M3RcvyI0hvzngxGBwWrJ_fpoI5raaWoa_prTJpd96Z3_f3Aa_pSPF0U5o8wsNclnU7huLy013YGOATXWHowuX4PwFTOLE6al1hC8Azhx9qF6pSZ2deuLqmu3pG_p3FRmzbAqs9NEZiMVskPirfe7S38S8_fsnQLwPLbx9iU4IfQuD_pL19X1sI0ibUJojmh0x0BG7fvT6Ir1dUzE5bhpPod2FM2eUvTCAud1eRkkoE044tlUF29Xmkfskmm_fA82jJKxY060JqNbcBL48XDlDpRy6CWUJRUtuZqKfBRvj2oj8JzrGrJLgt7hG5s3hxvN1I56mrfEgR0r_fwnNe6hZkhb7hxpizmaXnpBouTGfEoQ6ynMYOJsqfd8PGQTXkdikjb43JyIrfopc1VqzRWrczjy4OeSl7RC8ztLHtq_pV_pfK9NJ_pT_p_furTmmJClZDfEDxlvk4NiLJXvJGaQkwRTSdedKLnSMcCNT2PoMBV3Y_fpeA44hvyoumYHWKr8fKmAG06V1Rc_p2b4QwBSF9SN9NdQ0iJRDnOw65lgpVdutFXqhgTf7lamHPcK8WMSbqiw4tXBdy0G_p_f58R6PS8iL4i2cG_pOqtIDr4jGtpJmiulbsq_fPjduEMjNtkyep6tOoVi6NWRrvODEhPR8Bzc_fsz2EpIQTHZgo_fYz2AfzyHs_flsbIZ9tw4dCIgbpcECx1ah9166evp7QkxsR90qntiXQrfLC5_fS4TyBHiZaRj9dOj6lU7lNiTp5cd3xVfzjctljpahJKJHwoqyhio3mVsTmC_p0Et3cP9ZxU0DUOGIwZO8Y_p4oCDxM3uZ1pGFS5smvvH6sMLYFP0ZABLMsAIz3kioRWYP8mxOoT7i15GNmGoSZ2atrTh9V68P_fZwSJG3mn4TxfGqN8j2x0Spj8TKnhceDtvo7QfAMRv6Bqz9YikUV_fkVTvefxyCuxaKT4r_pw_fSRgfFnFycwYmAEa6qL9vDAtHYnc7MTpvw6IRvEq86OqluJhRi2WzjZwHCSKVOndSWJVeXQbAtIoXQaCdBEDwI_pr40M2_fxKS_fF6ERmYB9gugFL0Lcqmv3SC87ZtmiRysBjrLQhEKv5jfayd7bHe_pzMyE13Lehx_pcCDHTEfDh3ZwfY3iWmre0fX5m7pEL2lPlOi9NFwn_pb_pn2RKD3XKz1d7dFLux1XBvJxS9H8KD4z_fuTeoScSvsC7BTN8KKUBRYnQOeTy8XBu874yeOniO_pKZHI808lH0gSinh0_pFkfPFNEnSM8a4hL8Dft_pJJMG7tgP_pg9AwMOGsGBGfgy3jdGScD_f3VM_fRAm8FBS2t5sSPj_f_pZw_pDWgpzzTIu6QKpuGwOermfdkiZ0UL5SK2gwytqLZvfDWOJYbH9OCPPOpxnZiOLVpa5kQPbXlj3NWcFnBrDJEe25fnX3GcrtbudKkZ9IrtGFiyBbRyxFzWhIiU3L_pP6DPUYIks4mrMgerbzFo733JNlU1oXXil46TMIuRGLqX_fhkrLVO2TmIMDXgBvVqhv1M9y_f3mhAl6qNzdGJ4q2Yx2tU4_p6pozO_pmKTXtcpqND_pI4UfY2b19nypgnfyiD7UEqutSzlVmcZa1X7dvNuiRRQuZTMlk41DPOQdKh_pWCd2pFceoJ6P21pWc_fNsuD98GVoskgZdVmHdwRTMDz1iz6Wm5xQEbww3vt4l1lHZ6cZa0ku5PpLhaUip3hjcGaybZ4n4vz47xJ_ph5gs5rfrZl82Ue6aKuoBjHE5P_fqeNHPrFvl3Bzumng2ocr421tVOzjriIUBPam7Hr8B4g5opB1e5Nk5_ptS9xstzZko2x20s2cuxCw3sH63_fCRkwut5FJIZFgUiU0NWQF7Er0XNXKzBXT6eqLdtsq9WTrwfugg49FhJIzABmUhiXCMd1j6iTLT7jjPXDJMLSi6xNvTh6iWoFaEGWUZayzompgiRuRymbt0KHCj9y_fmr3lc2_fwFy8In1hLRkjKMMgCiaS1vV8KmCg5dRucrb7N3jdRWdo18G7qxc3s",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T19:13:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
					"carrierCode": "AA",
					"carrierName": "American Airlines",
					"operatingAirlineName": "SkyWest Airlines as American Eagle",
					"departureDateTime": "2018-08-23T17:33:00",
					"flightNumber": "3126",
					"aircraft": "Canadair Regional Jet",
					"aircraftType": "Jet",
					"flightDuration": "2h 40m",
					"layoverDuration": "17h 27m",
					"layoverNoteValues": [
						"Overnight Connection at O'Hare Intl Airport (ORD)."
					],
					"totalTripDuration": "1d 9h 2m",
					"arrivalTime": "7:13pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "5:33pm",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T15:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T12:40:00",
					"flightNumber": "9",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 9h 2m",
					"arrivalTime": "3:35pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "12:40pm",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "American Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AA.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:35pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "5:33pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 9h 2m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CX)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T05:25:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T16:00:00",
			"destination": "HND",
			"downPayment": 1095.84,
			"id": "f514b04f-a4ae-4296-8677-4812cdb351eb",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pYZBqLsf5kYE18fTHzFyuZR50LtY3XVdUV73aZY_psB3rOzpbuPEjd8oWjeRlnEnITEGJFBBTKXgiMnJsZmrF4LB5OvOsWRLPnPbVbBdd82_pAfuN7L9SSD9OUfWrp9MmR5EPKCqL5cwRn0dNyD_pQO9gcwRE9dWH6iER6AbGnylZFDElXrINpGC8jiJmwgTVcSzlFW5p2aRYzPuLXLnnY7H5PvVArlWwfzGaTLoBuVfqkvZiYV3BXEpY7EWP4PRQIFJmjPue4Nqqo4e1PTqO_peCDwufhh7ZouXfrGmSzs2RIi5w_pc5bdyQMuZHlsxnbMO5iEkKhaoQAbzEPuIqeOvb3_f9Nj54kBvQE6sP6gmQV9PKUFSXydz1f8rup1uFV9CqSXEoIqKd8WSzDayX9DvaLiTj_pIyqQS_p8GRTa_p_pMfEBxcRAZ3RyE85fmYgUHopbUDi4yJc7B0FRNYUvmR1Fqp7Dae2f_fROSOp9QWRMSVoycmDs6lcNb6GzNEtsAZbdV6R1VVTP0jPBpef5MRNKoIkd2Tml8pWSzmAhKjen4_fH2jPj1CgJR1Jwh1NAY0DGelYNRn_pEXopp4n9NRvGdixxFpq5tpswrj_ppUX25k2MIjkd012NlL9dHfSKFw96Vipjwn_fRmbahKTUx3DD_pjdbziCVyrL2fB3V0ni3NXgaHO0UTkeQZUvjke44U_fE_fj_f_pVhL_pA7ovLKJR71aijYNOImfgvRwyECUS3CBl98I6OuYNq2JVyoRQRtNsEewi0hKZ8zF8KkEKVcPWYP3On4JIkifznkf9fAxU_pho0G5bAuUp_pdJoq8KeLL9hNHRx7Q4iXznAMkpKFw_pP6ax4ZEf0XvGqJrd8Z7wV0YmBr_fUmu395cYBpGqXjgmgnRF2LGDXpDRoV4H2xfDIQBrri9yUjevvcs_psN9KfbCX5_ftqqGzx6MdEIfKPQv962acZCvz_pXlekJI0UWi62SjWjbXDtf5r2wY7GusCOhn6xUBSwG4h2LjTJ9V2nWJRJR2zvKfT4cBlmN7jE01Pep2pecTxo8DgRpD5Q_fMinofSHPEWbCRPtb_fUN_fJo8OSMq_pGnrth8I5hDejCAMIFyRW3Bj3V1u0_fbkH_pe_pmtLqOU7NhuiUPR_f0HDsFFXrSnIk3JoAZs1MaMEDQNibHVEbUmpTJcII0s38LRkd6pgUHc162XK87U_foPmlTmIEubEet32mmo8FGV7tDjFJ_pGt1VfIYrXMPgwdx0qTciqY1HXsoqpHKaeWmW5GmLJQUw7CpLLPll9IxL3jr6Jwcn0zaoCvOB_fPn2be10cPMcOcElq9ydhBTm47aaHamJCCmigExTU18qz1l48uMobMIkhcH8S6zCS3djdXcvVAUllvjBnbWBxoQnfoPa0aQSU_p4y0C7UzGjy_prc0QqgqQ62uihroYEYhBHQoXGPEyUMhQFKPYJPmPTLUcC_fyEMV3GUTu2vJvi8OUhUyzDCEuL21VLClh_fZpE3tscZ4XrOFCK95PeMufdhWPJXRV62qVa7MT_pufAZEzgD4KmwSE6YyT_fCdJSReSHe6pQoFuKVr63xSUzMgfiB7QrPJwDavMnvVfL6P_pJWKYH_psOzt1S8j0n0UFC2tFjYJriH0vdCQPiytEgsqe_fc7trnVYMPWsjhmjrV4mWM2e4_p3xlyrEfW0outE3ymSyE61scRy9le8zuQGXRxYXqCQ_ppwP_pjOOpd77I12V8YJwld2ZiSfKEiJ9ou6jgt_pJXC1frTzWkkf6puKFR_pJcxorJlSPsMYyZbmQ8nwGz8L61_fd9EhiYoQucip2pjXxoiyh7HEPUuSk2Du58Mme2Xa1Navbn7pEHzZnf6JShp5K46MUES6HNpbs6ku_pXv6hJS7ivi2NEqwdapTPWkFKiWxmtsWAbCVkMBEdv_f_p3WMlCAff5bj4YtS9MtiU0DZ7Kos6j4zDSmVo_fseE0qpS8ru3Paa8HdY3f1EmrHLfHujCSTSEJZ2b06uEyYCYY0Lc_pSKmCQkkECR2MUiUG_fq9NiT0C11MMCv_pY18Mj5UlklWZj7XrKycr6tbmY_fmQRc2NrjBSzfIBFFerOlP4BFC_pECnv_fr_fisU67lNAcsUCr3XyEuZZpZYNbs4Q2veA8x7JCSeqQw9LRpu0nafB_pU8hw_fs5IAjyHvJbH7_f1YzCbsvYycjTH_pK5A3kS_phHmapCWCFlmNp6a86KKfWHVAZ7wgPtI109GbCynOut8sJlsafyCX_fJOnjfA2TVtI5lAaaY_pOIfpzL4MquU8GhCYDmajjXpDpDdw08MBeTutVByN5sdoU_f10Yw_pMeZO0oMTOpyHs3wNzqNhvl2nwwEY49t_pg04P_fNrkWbq",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T17:31:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/WS.png",
					"carrierCode": "WS",
					"carrierName": "WestJet",
					"operatingAirlineName": "WestJet Encore",
					"departureDateTime": "2018-08-23T16:00:00",
					"flightNumber": "3531",
					"aircraft": "De Havilland Dash 8-400",
					"aircraftType": "Turboprop",
					"flightDuration": "1h 31m",
					"layoverDuration": "1h 9m",
					"layoverNoteValues": null,
					"totalTripDuration": "1d  25m",
					"arrivalTime": "5:31pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "4:00pm",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T22:10:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
					"carrierCode": "CX",
					"carrierName": "Cathay Pacific",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T18:40:00",
					"flightNumber": "823",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "15h 30m",
					"layoverDuration": "1h 40m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d  25m",
					"arrivalTime": "10:10pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "6:40pm",
					"departureDay": "2018-08-23",
					"destination": "HKG",
					"destinationAirportName": "Hong Kong Intl Airport",
					"destinationAirportCity": "Hong Kong",
					"destinationAirportState": null,
					"destinationAirportCountry": "Hong Kong",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T05:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
					"carrierCode": "CX",
					"carrierName": "Cathay Pacific",
					"operatingAirlineName": "Cathay Dragon",
					"departureDateTime": "2018-08-24T23:50:00",
					"flightNumber": "5396",
					"aircraft": "Airbus A321",
					"aircraftType": "Jet",
					"flightDuration": "4h 35m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d  25m",
					"arrivalTime": "5:25am",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:50pm",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "HKG",
					"originAirportName": "Hong Kong Intl Airport",
					"originAirportCity": "Hong Kong",
					"originAirportState": null,
					"originAirportCountry": "Hong Kong"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "WestJet",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/WS.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "5:25am",
				"arrivalDay": "2018-08-25",
				"departureTime": "4:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d  25m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_NH)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T04:50:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T18:45:00",
			"destination": "HND",
			"downPayment": 1117.23,
			"id": "61f93323-0244-4015-b6df-d3756d778320",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pQJMx0H8ZjxwUqGANzOFJzKdb_fT6QF_p7NUEBzt1icUdwwtN8mQxFg1wODiZSot0pKYv0xokLU8zxO0Y2WMB1Ym0EsGsO1euN5a3cvzj_fYPXOrO9O_pvAuldHw0Qsr4iSwED2w_f89NxcSlUmGSI1Atb_fK6GLR4aFKTA_pwh_fkdTqGTrvPIxHDuJi0RtODKfH5RIy_fmtgvjZ6nV40lVg3gdKAysYVeEU_pWqYWUaeeQlGPxeueUqT7p1gn7yaZaV5F3QWcoQPFh3K5gIx_fH8KAhzBpHQ9gQApjT8Oct6rDIwtrwFm37vtTWoLOQYXlwWBJN9K9spVbAptUGYycF3wATE1QF9u5os01j_peDwB692Ti8NHR7ID2tfNl19kvrsuvM2vXeHfTvgFck3LSY_pRDjiEt7JRzDL0E0qm3puts_pBDG4RM3j4WVX4rB7ZkJ943Ssv4TqoQ5Fk0oB_ffx9Z03hXvDN9y8hYStP_pMVRLJYXOesosu_fsxzOrtu2bI_pYDXoJ0TnovmBTPE1s14bNcCkVjWIf8sMdB3vBGyU_pGX75L0CpxPa1TOFfjTSJGLlu6SaP1H14jW5zKuqsubj278901dhZRz4_fqH587y9LgTJI0jTvF4AyjvFdX6ne_fW0APfaysXXewii_fw8q3pRLmdmvMKxeivN4bwbE9nVyWFm5bSjMKafB_pQUEjlIQYGQ_fE5VgMnrJQAAQT3lezx5TimeGAgAqzEDmRFFK8VLxE9hNoO_plA1JpjSa1RQB4GLqvl6h7IbMXfDmldoYfcrzZiq5uEts7aUF395zgaRX_p4zfFUd5YbPE_p17x7zWCpQYgQ03SFppKd_pTeQqqZmRijwgHE2P4n1ah1_fQXQCwQEm7D1U6tHYFqZeL8QrAUpHBRnGc6iUgbqKJCEtP1CBRVkwLTOaFc9_pVTVMQVhyunFJSZo1yA2YLOoUGw5rVZ3aRa7R_f3G0u6Qz8QKhzxz75PHujOjN3Uo4JeDqcxsOjI5hdgN2WL2c2AjD6Scj_p8vrCvvzXpzZLix2vVb_fOgrMcFMJR3F6WIgTeMdJmMRklnIkvZ0i7Ch_fhxIa_fJSCpzeJ7Blhj3_fY2UpKwpGwal0SQ67jJshgtysOWD52no2h2XTaICkOdzZCUCZItNGhigvHKtJapnsNcXFaGcvPJ6IL60REse9oA3MGXrDuZeUKDDy48AeQmhGkuWpV_f1FhR8lTkgkJzPnKdvO_fbVA9fQBIfvS7WFrfBt5b_pMFuw9Ne7wooi2AiJinHfdaov5R_pIjAk8VWsaEqLrgIf5s5fgfHESILuf_pZA4JJvK_f4prUXNDzp0pUQ1uMHo0_fCGLri44JKC2sX3cr74w0I2_pTxSutciGiqE3qP0FjuavOFi11ws_fx89A9u2vLUDnAhF_pUdOzGUvcMxs9Zu7wY6R2ugDYQYvqLa_p3xQMyV6obmhQebMnZr9kyRoThaf4YJUlzYq8Bzc2AxNQuBlOSgjFOQWa9_f_f1O1YljG_pkRcjZ_f2cJd_pMW6Cp2YDm46jv03hGkQcMhBrJp632Fbx8vcMuQFUX1uPiNcN3Cl4WorEgyUBsSIYjxk3i9BOoDq7tgL8_pSk5bZJx_f53GuXVhGUKez6juatRun2uJsQTkgsWtdPtK81O2bcCQhMMRqq3w6i_faAkqN7GwMFfFjPdPFaA9mIAhJMBTPbcoPhvz5PM2m9_fT1oaIOEPeNwQWo5RJHwT8v_pxV5Dmfgrqzq282zzMlDoUxETt2zqyQ_pxKawQU4favWFg5SdlJdT57PfDGE9iDs_f2I2RZQU_fBjjeqyWnwJjUQoRhgRGwdxBQfTb6_peLc3z2NubiOm9Ru6TADHV7myctrwxD0s8Pxb_fuqdMVZjXhD9GmEshd_pL_fpgtDOtdjQsNJGD1q_pONFqfW85jiOqyUxQiQ3mi_fPOkT9aGjDjYowPlZVfuOYDZy8eYqFER6Jejc8fiZ6QXdFbYxgkprFbAY47sjn67tfOjum7_pWa3Vxu2MuFBdsp9bBxT1eu7EWUI2TGLCijf3Qk_fwH404_f7ie4LHu9Qq5mTuYl18dKVEQDXzZXVMRKVHRXComwK6y4VISmbMkuzvKtBy7Y8oJdBrYzsQZjQAt2PhxIowBEZbspBNlWJuwQ9tsHUFRwdEj61LFm0_pzNaF0StoHj8n81yLnC2RmKG2GzMGWURB4L4tjfkXI0ZpbYlZhsIgvDco8ohYpxp3zUGPahQseEYc5HE8Bhb8e1u0HulwHEjs3FvkvIkUWT_poUIMP8twCQ42cAlCdmzbdDD4_fTpK1LYy764YSdtQWeaFeUyEp6SSztpW7606gJ_pXHEiSNR2M",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T21:38:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada",
					"departureDateTime": "2018-08-23T18:45:00",
					"flightNumber": "8675",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 53m",
					"layoverDuration": "3h 42m",
					"layoverNoteValues": [
						"Overnight Connection at Los Angeles Intl Airport (LAX)."
					],
					"totalTripDuration": "21h 5m",
					"arrivalTime": "9:38pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:45pm",
					"departureDay": "2018-08-23",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T04:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T01:20:00",
					"flightNumber": "105",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "11h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "21h 5m",
					"arrivalTime": "4:50am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:20am",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "4:50am",
				"arrivalDay": "2018-08-25",
				"departureTime": "6:45pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "21h 5m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AC)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T13:30:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T16:55:00",
			"destination": "NRT",
			"downPayment": 1188.03,
			"id": "9b7498c9-a766-44e3-8120-0bd7bd860e86",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pdi3zOiVLwImHSB_pgHB6Y6Jxdn9Hg7HVaSX_f1BipFfX8HYQGQ5f5fOgpytdvM_pRaZgliDThUiTT_pCy9FNw4B_prLVZbtG8IQdCigqMEHOyHTe5HHSAq3YFBhEM6HsMw8YjWERNh9xi8E5bPR2m4_fFjR_pRR0Ci7tIw6vQCmwYpfiymhYbF5xI9LggaHeVS8Q4lg2vw_pdjufNDzPEn_fiVLS09Kl3EmVE9XSpybgZbYvCoBLVg4yQi3DmcPaeQHD2mUQxHd2JtmvRoUjXF5JpffqL6ImvlLVltKc5Mtd5BCloAtgtrjfeNcnS3Mtg6acZdNbsdt9bcUcvYzPaL894IpGW_plbuL6ocYIRM72qWORHlSl5FXCWtmq7L9mtrAdrGegMLXQLYUQ5Zy9T_fG3gMUTstlA4yi0eudhOadJ9xVYvf_p1EsD9si_fQq5XApAcp5f6spwQt5gmEg8aUMHrigjqoPryA27XFK1q_fu6_f3PKDQn9Y58REUsFS7_p3kEbcJiAljQ2bqZiSuUE20Sn6RiNWjHzxgWwRKx8AqlbVA4AAZHV6Jh7icWACPfPXXOrgJTWEIvhdH1OQIaCOTZ99Lugo0w0TXg1kAUhgYFGFpwZzwltDdVzFhZ_f_fVgSkuY03VrIOuG4ARw0w5SvZgdpeCS4XQ56IqwZH_pqOPNgyq0RRjpw2iIWendvvia68k_fkcIZ0WicnyyF3bvfSwWtHgSoO0px7eYnF9iG32v_frYk0rvYUywBdKu6ghW_p25MV4VJSHE2DHQj_fd37984dQKhYdNhk8OEKuZgwxlTtc63xW5K7sWH_fqERBXBrwXvyq5TokE49zRxZoM2WL_fL898UT_p2ZcMG5Zva_pP5tkJXamavloC54fqx3f1w_fsWCbzQRwk8T_faLxN9fv2cMpCCcMft1ofZMwmg30W4_fOasAGapjKNnGOyztqZNw_pveBgWQz4qh8CCFE20YQCfWhm8LFfGTsQZWreAkhedmepZabDODyZXAxx8n66CO6cLgi4pamFd0IelgXVJvRkYOLbBdQ5sIG_pBcaDmjniQLqwRh21hiF2eEalTSJfT_f8odCxPmz4DJb907Nj3AiFhYfHXhYsAeuKL_pUSkr4qk_p2WgSW5QyHr3ccX7l9NeTtdCkjQZW4bVqO9L_pKzaM5_pCUWtcHkG1OSPlncmwSFSKVPx5lDUM1CkYmxwROyYu_pKFEx_pRmSkE33SekMYKSNM3AhhUV6Rr189npEVcTGGS_pVz1VdlOPT0dFLrQDmg_pwENpfe5TbhbnU7pjkg42YCwYekEjcE1zUtm6jh4wM_pUzTxDGyd3d4acZsxCBOhMgTgSA765hpGhCzrWrOM7G_p9yngdrFnFlb965mH7iYpASjUVAXBQBG80QHsQN0_pd5eLn_f1nvSvRNPs5FC_pRzy4nmiPNdAcBJtGA5g4jkse_f4n0H_pmy2nmst89KSbjBha6RoQFusKK9yK8BLB2OWJF2rat3EbwKhmhlni7wg_poVseMOPTe7926PE5_fiECgMT_fL9dxab0FZ1p9eeI0D_pgOYpekALtpxepvgNXLjaW_pfYYjmFeK_pb6k6zhSCpuvb6ChmdHKNfc4KFMB_fG8PaFotC0BsiquW4fBZ9flEFWY2GvWo2THgQl2fFIpue_prdy33VXeQuUaOeAVBSomzJPWCgk2mCI2PzpmOoDIFv95M8bkEF_p6J1t9zBA8GntZpN6_pyMjr4_phseY4WWIsy2fsi5SdRoL6iOVtZOYf_peGkAOxE5rmvujPfIDLWT1Fvqj9lbImDwB4eFP66MQ91BtdcJSGfRhP3Qa44U5vlLMaMciVBX8S0WYkZMHxNC5a_pbuRio4RtfU1SugybhS3uopmTxHaLZz75ZgI2y1f_ftfYrOWEXCDS5tCX_faUKcrWhcZVLXplB0wDJzL6UJvuze_fLw_pi6cqUXq6EJPllH6jlfk_fFiSLcs9cUj_ffw36ZMZfM5_fJh6YZjc9tRrxVlDn4U_pE_pXIK1rpfYd2YvCHsRlrrN8u2u3ybaA7zRO68nWDbgla_puO87NLrkITS6iS5_fHPXC1JQkAywnUvn76wTZJWUIMT3eA40uZgut1NdM6nc5gLYLkwEjZQQcvHchVk_pjO2_fWH7hDOtsvjzi8SShUTHCobGysMeIkrL0QpsjDCG_feMdb_fY_f6sP7rQTyhVM9BFzg7i_fagJEzQcMIyggpuBv_fz45s6aX4MLFEG7pg_pgGIzDC8ctIiHoN_poaPnqc6iTUqrEYox7reBSzBxBglhkB_fKvLyeFedIHVvpgP_f_fPerk17o12tGhH5_p9kGuRphNH7i7EjqKsN9_pL4ezaeeOifJVp8",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T19:52:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T16:55:00",
					"flightNumber": "783",
					"aircraft": "Boeing",
					"aircraftType": "Jet",
					"flightDuration": "5h 57m",
					"layoverDuration": "14h 8m",
					"layoverNoteValues": [
						"Overnight Connection at Los Angeles Intl Airport (LAX)."
					],
					"totalTripDuration": "1d 7h 35m",
					"arrivalTime": "7:52pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "4:55pm",
					"departureDay": "2018-08-23",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T13:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/SQ.png",
					"carrierCode": "SQ",
					"carrierName": "Singapore Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T10:00:00",
					"flightNumber": "11",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "11h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 7h 35m",
					"arrivalTime": "1:30pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "10:00am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:30pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "4:55pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 7h 35m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AC)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T13:30:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T18:45:00",
			"destination": "NRT",
			"downPayment": 1188.03,
			"id": "a74ca80f-c0cf-4982-9920-c3a36283ab94",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pY88E3KZpT5Z_pP0_p3wEFxtQ_p38lPWE5AXnuIWC9Mnrl92ja0VlzAWYI_pM58L_pHnFQYI9h0HAYBtkPL48gMrBt7jsVxkcvairnDpUOE_pu_fsMvMNpR8PLIoCTWlsV6Vsiw77N6FAbBV_fGCRDS8UFF6e_fA0GH_pgP5wAGRSerl1gfDNXlIXkRSY1SdpEfc5ZuOfYXAJstr4Y5_fwCndMZ8nCti_f3G0bowX3PYWZmXuk5C_fuhJFS4HtDzGIMTtwpM4L3H8NSFgXtA9x8da8uo0V8thvlodyvYbC5D9aqgM20Lf73z7JFbrpBXlGzpW4TX3gBr0FlXPWAonFPLrqOXKF2gRQdSP186M1EIvQ4l19slIVzke6niAtAuYa4W4jpznsj6_pZ1naHuWc9mDEbfratzW8EHbi5Sv_pDe_fEGUmv97eN_f_ftd2Il97r_pHqxuggM9NYrGiG7_pPqMyOI3LtlmtRiKOsqCopL9jTUVnTtiQV8n7hv66Mcw2kSPZqMiUSU0vYGTXOMmWx0tQPljRGT09rluOm1r8QXpkBTlSMGNC0C_fqZLb4VdNoZE8Tzrg7rEeYjE9U9WHsNpsHidXiiGhsvAeSZyP_pqHl_fMYxqqfc5Eqdjyv31qsUnrZX2yUifIopSt0YhsVnxTZk1aIEOMd2hKlAOdVr6tZR_pKkAHZ5sts_pc6J_fpetwDKEhUsY_fg_p9lnZI_prv6o5_pStiz6CTepnewEoH09mj55tJCdANt_pCj1jQKiJdb7sdcGV0QXtNhdPiNM42YidgI9XJtfr86Wm5VQETtcjPKJT4pa7A_f170x0B_fCLWD63HY4ElMxO1o8Y7jH8qnhKoBGui9cKSOnL5MRB8yJfcqdU0z9yU6o3yT1tVd1T2Uv7Ej0gvDuEknnq1qdnvcPqVZheM6kkzufVqGxXdY0QAA2I7me_pQTIgOYFXl5YeGu8I64B2LdeuU7rMtOyxFR3lz9_pqGxzhDaNCfxYfC3dRcCrnePAS5PgmYsNWB4kfokEWpyiDkTqh9nYC8m8a4nDCl1VqFjheA82KEeHMFZFwwLi_fw1X5dLemStiykHJIXV3Fy_faIOtJq87h5cekP6PLoavBXvZbBnOcKIsbDWMagqmu07IbIzNDEYz5m173JZI3ZoS5UOhC2bWG1agpTFss7QPSR_pcWMhLQ_fT9KzJYguBzu89iR8wUuQO3KQ4CIsklqnCyombQk69mX8U5t52KbHd54ar2U5wfXfVVA_pcRYzA0tuuVKV6OHwEG1nrM57A7xDVOr_pL2sk6B2UWR2mC45gRIyQSnsgve1hI7msS7mG4dkkwCTbjATwHMRuNzzLGXftlDU92vGeCmgsmEHvidA1RrwO56RZk88BG03AxHpz_phwgaXKiRBW_fIH6VpTzGmxYN1DG_pp6yCXCIU6V0datAZ_fecwluE_f8FM5ty4QErKuuk2Rw4OWdTOZKm6slmogsq4G5ky2gA5l5k8SLalnxhdL2gq9GRNESohVFejD_p0i_pvPpYG6CvsOky95ptbecsW8s3Pqajbd8PvxTEJ2lnoRsU3RVGDKZv88m2Blz_fsUo0m7fmQePiz_pUkkbsEUjq9nYL2AlKFmo_pPK5vlfUQBEvKHBl5fSnuPO5kTJrNF5TZe8fr3oMzrtgfeciHxAQqkG6xINwPQRaXS4QTA7lNyvXAW_fhN2HhWOogAE0cL3NWyKRAfFVI5pCuXEShNhLnPgNwx9wfngP3z1m5Kt5CompXlFXjCNGM2NexfuQohhfd90qBf0uqKTooXhCCa6Aw53jDpmv5devCKBXwt6THmBsLO7IF4efDutGnHU7MyuPYRjWIgKd9YcqSMgaowHTiMnqxVkFB1dewYUWSJxwaKbDzxB3AuE63oiwMyI39Sts09ht5WVmiS_f1ViMZn7lYIMwkzXgY46RytUc97zPjG32_fwoJvnCcjd8980V_povsrS6St_fx8FAQwDRioT9UDM2RkTOAlkYX3EHwrbnB9EZedyOJ_p0vuxLcBwjgaXdytQWtBFEUHEaNcB9ebvo5PWdrrthZH1IN1D4OQop2WbYAMAzEB7M81HWmfJFFqLy4O30tIM9iW_f0yuExQ_fwWg85o0cA7iRAsCW5XxRPsWuLjX11iYz4Wh8R7FFdkws3K_pxoSNMzNjLYhm_plT1Rk03r4kK3_flInXnWsKC06N2L0Osdlpa8H4IrR7K42hAGDZ2FnL7KRN93_pHxG2MnzUTcD4NqJsRNufkHTdCyDFbzc5KVOF_pP25B18Qv2GKgmjwUHsLywfig0YF9QQUVhRngLunYI8kSDZNx7JgeUgFdL7_fNBCcCd3jMVlCy0tXhE",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T21:38:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T18:45:00",
					"flightNumber": "775",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 53m",
					"layoverDuration": "12h 22m",
					"layoverNoteValues": [
						"Overnight Connection at Los Angeles Intl Airport (LAX)."
					],
					"totalTripDuration": "1d 5h 45m",
					"arrivalTime": "9:38pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:45pm",
					"departureDay": "2018-08-23",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T13:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/SQ.png",
					"carrierCode": "SQ",
					"carrierName": "Singapore Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T10:00:00",
					"flightNumber": "11",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "11h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 5h 45m",
					"arrivalTime": "1:30pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "10:00am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:30pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "6:45pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 5h 45m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_B~)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-26T22:40:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T17:50:00",
			"destination": "HND",
			"downPayment": 1195.02,
			"id": "2c51e46c-794f-49c1-8823-e5a9cd08cecb",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB4AYf_pct7qjEdFYv5iBP8yVMaucKwloOi319z8VPthvyTORh1AE54iFQzTpJ4J02qfE0PJMDdIylR9rD4ijdR4AZ5W6YBS1CbHPxbKIHG2oJFt52Nq0VeOeM5DDsXRs4nFTK_fQHJ9CHYf1qk1Scf4NthJU4U_fElOZcoEnBUUldd7sFOAGO242aMSbxdulDfui1ppB1M4S7SCp_fgFudG0NNxMgS2B0jcwm1zyIWnTn_f08_f26nBP9Rjv4SvfzHf_fY7AuQI3BooAh5ang9wrb7glKHJmer5tEKdnvxyAyUhXKKnAJnCONhDZbdUaK4UOn15LuaISL76jZhTBGtLDu44GYaBxGq32rP4BKaeE2MUf_popocX7nsRV2AV2v0ll4eYIQcdQ8hIwFX3XEHBEFrZB2qG3URF9OgWgpdl71LWBaFQsGrz42TfpN31eYKyB3j_fHMrpXTPYmh3_pluq4fukmTiO8GbpOhV1mT9893e259IcYSynushd3LMcx6yKqfqrzMElXeacOnze9rNJ_pNJaQDmNajosH3Yvf2poLaRD1Wcy4FwNMbECXSB2M8l3m5iZg_f2aMF1UdenHJfaOKumBp1hgDi_ppT4SG_fB4CV8FUvQYfjdDCliRW3wTor0kU9tbcKGXN2SUqjYN_fqPTH2e_pSOV0fDi75bp5706Y208KQbkgbLmGrGV566I7ukRy9cO94uTgYKMloG0TbUMRybFdH4M7jf2jXUQzt8esSqftPyevG6Qp8rj2jEvtoQIIBD83yY00q9_p3L_pL_pMcEgzSbhvfg9PSuSwdyCPxR6F5JfkTDJovq2cFJqrZN_f1lFU8VwavZdtVkrOFZhTTI9i2Jh9MgDvn76LXMOMgwfKEHOrjx34DnyWZ7YTX6xjlA0OVQmy7CiTU0zc1w6nyguvOBW50EgaY2z_fuYGJFbBgsRHOYxlKqYr9EJMfFszSHzq8IBi0OZNAY5CgTPS_pShM_pFZm0Lao0md_fvEN4aqHTO9lIPIM1Hcxm6gHy7qdLicGECgF_pjjdIYkLeQOmOqC5b0_p_pWtMD2fV6VnR0R38kyx3cv9ohmQj0P80sQsCEAPi578fc4hsXAbNpKDTR1_pLwRSOckzk2DVeHseWHJ6iI1IGE0xMpZ8oA9DLyM4QKNqQfXASJUgsS5xSlSgFs_pmjGk0ODuezsuJ4uoYBXEuI1xK1XND9cq6SIRMJW9K9pCrFiAkZ43MQW0bS1Qqeg2kYlMS1LJU_fJq7IkSKcAgwRyuYKKzYDYJSymVRZr5NZZSoRTDXtQIUpaV5bKB9RhazwvgtruZ_fqDR4shZMe71uKtGorBWSouYpP0Q_pmQi_fdDuXk7wQirhNk30DBBKgoYF1dGCe6P23sYOlckGJucTZXTgmEcvcxQHktEQ4ayUz42xBVkS8IAzBe0pm7fPwsOTk1Ym7YoSrJkWyQl_fy0qkBIQeHE_pWTuzXQZn7TfPAPSrCgV3EeMaIJBAg9TJ7HEeNjTCi75U36uFHfD8Rc7lCTpRoiso_p530WyGTbi7JCfrxBADHFQqUQz9MFtPjNEMnl9JGjUupLvgS3EGypYPNHAxk0XOqdaIwfCwtxr_pJsfGl81bQ84SIsjSk2NDKlNBPeDVYJ2epCJRoZktC7rvM_fAEYq50NBmwJg_feGM7N6irwhfLJVglCN5RX01vN2uAzfFsSredbbQAnArKYuU20q10PuLIVC2syPLb1hvHHkMnw7702Sj4MvgH_pU_fyfYPPUcYLJR33RFaycgiiDGYfyFOZXDrA5uOzzZF5skGm4rUQ1P9D71HO_fmooAGoNnrAFdmjwWbgm_f_p9K_fe7kexOxJN7z83KuGfQfNBIsKthf7sHfSzvk_p0uRjLb_fO1cRfU_fLDWnfNfdWzh3w5yRE_pYkBoUqC2pzN_pBwdm8iYf0aX2XcgO409XIviNLsn189xV3mRPsgiYyUFtDbTfm3DUYvFforVUZnb4pWTA00QYrGthRZrz2X8nmPs_prYn6AybIlMYDetiuW5LFF5avVg9foXYiwXHhLJ5so8CXbZpSwgbdqJmMRzkjK2aciohJOQRMO5L9GxtINaEG78ZbFsrVGkzT9TnrWT0sdlQ2uZqRXnzhVQ8SwY_fv8ciOL4jWY44J_p9mMsr7BgCBS98AQEp8i4xySHa7KWVxIvvAphvyc7_fL0lBeVrDAgY8mM_fjs0Iq4q8N1uc7lTqjvdV1bbG32boQGI2QwN_fIZQjGe4HVSC8BmbCxcpBwlOccf45IVhpDpkA_fS43oq4FncG9Qo358N2Gz6fF2jNn6d5qYbfEInSGBnsbSUwnA8ZPDmXwPWa7qRTf2zFhoQtoBeAuEkttVqSM7nEFLzHD6z7utUl7CHnBT6taLV6CBUKg",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T19:14:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T17:50:00",
					"flightNumber": "7597",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "2h 24m",
					"layoverDuration": "23h 36m",
					"layoverNoteValues": [
						"Overnight Connection at O'Hare Intl Airport (ORD)."
					],
					"totalTripDuration": "2d 15h 50m",
					"arrivalTime": "7:14pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "5:50pm",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T16:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/QR.png",
					"carrierCode": "QR",
					"carrierName": "Qatar Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T18:50:00",
					"flightNumber": "726",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 10m",
					"layoverDuration": "14h 45m",
					"layoverNoteValues": [
						"Flight arrives on the next day.",
						"Overnight Connection at Doha Intl Airport (DOH)."
					],
					"totalTripDuration": "2d 15h 50m",
					"arrivalTime": "4:00pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "6:50pm",
					"departureDay": "2018-08-24",
					"destination": "DOH",
					"destinationAirportName": "Doha Intl Airport",
					"destinationAirportCity": "Doha",
					"destinationAirportState": null,
					"destinationAirportCountry": "Qatar",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-26T22:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/QR.png",
					"carrierCode": "QR",
					"carrierName": "Qatar Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-26T06:45:00",
					"flightNumber": "812",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "9h 55m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "2d 15h 50m",
					"arrivalTime": "10:40pm",
					"arrivalDay": "2018-08-26",
					"departureTime": "6:45am",
					"departureDay": "2018-08-26",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "DOH",
					"originAirportName": "Doha Intl Airport",
					"originAirportCity": "Doha",
					"originAirportState": null,
					"originAirportCountry": "Qatar"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "10:40pm",
				"arrivalDay": "2018-08-26",
				"departureTime": "5:50pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "2d 15h 50m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_B~)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-26T22:40:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T20:00:00",
			"destination": "HND",
			"downPayment": 1195.02,
			"id": "a869f4a7-3ec7-4d7c-a45b-b91065d5f13d",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB4AYf_pU_pKASpA2HRYfnVnT3LfMkwKmSy3YHDb84JCuEdVO_pu62Eu8ejht0b8beRGyWJvHJJQGhlIQPYXsF2_puScaenkGeY9sJtHhAG_pMJreNRvdEA43SjgaLf37gB5biEyQ_fPvz4bg1wUYGFn5xN04DUph3WewVjkkcxyLzN14ilfTWOO_pSVg0VMrvJxmsifnbY2XqLjKLZMYzKnhcoj6r0VbImDk7t8ZYn3P2pGk4WRCtl8_fJB_pXcmxr0igF8jm11NFnP1T4KuhYEvAY9bJPxrts_fxPXAw_fmpWQKlFsThP9TG0ffC_pLhITLqpJb80AzVK3kzSxmBBH2c7ZndTbAG0j4i1toS_ftN1HkbM9cQ90OzBoWafHmXcMNmT6ErVaPDvNaR1DaVqEpi7nXOliiBQj17pvgqWepujhilKauoiHYqzYMHyI8QfEKoJugO3K4EjCTVEfu_f9Qxhto_faIEHIdY_fIdhPeToGdYbMknbGnwDPXORHEvllpoTL2QNTFq4ZLViWSPOhMt1Mf6QRxj6Mi37ErnFaEsAUe7TRZtWlmvFdVf0o_ftMg55TM3QQ4vU_pxRrkpBNZQ4Zp_fXqe7Two8tMsV6DkhtygAkJmOI55kvdOquCp95Bn65bUj5eQu94ABpq_fR6PgNi0FzMIWJ0_pTLXXkFDGSTDWGAmE5BgN6mzh71XabXrcBnZU98hAwJ4kgDBta3EE_fpr_fyRbYZICrbnm2pxaib8cxM8DqlSTd8LAzTLWie_ptpfrBWlZVa2JTTzdANh0F9gB_flDOKAbqvCGGLJ4FKZrPEizoluy0TlFLIBJBPZ6rsnYSBZJenGdT_paAcCB5Jb7k2x_flRJ4CsuB0M61NzQRCF4gr8KGhRl_pW4xW2_fJDgDz_pisdBToqy0hsGghtVD6W9mOuKYWAFgkpvEk5dYDAyoKd6ri_pfawSGYLfyYlSBucbekRIg8Lu5a76rDc7Fs0sGQm0Ah46tF0tACr_fdSW6pjAVZ4RkOO7uGWcHR_fqtaOkH9uWi2ksfnnY7Q_fprNKCgzRCzzfIcUjDMOW8Vwne8oq_p_fZhPq_pmApLdMA93wlJd0tiXPKOH676iRej81SEwp7y6c8CAfNuN5FunUCjJtmViAmckH8FJRCYW9kdyHs98ixRSuNnR6Vdr3JviZmXhs6kowk8kOmD0sObl28JKm40lG_f7djcm8WSl_pBgfXTBadwodYRI44DC9qZJVmozqHC8c7fwHKTlbD21GChQ_fOcwYLa3gQolKhtoJmyTRrN7ZVPq3sLqMiUZcGLlY_fLQRG8cvPjxlG8dQl9DZnO_fgN4IDbd0UK3ub8kfZokdqr0OGlUTGp3484PFnvogC8fdVEGp5yo46_p_fu4hnB_fMX6NI93lZEDmdFFG_pB256nTViEUJFmLfqZPCm9IsLALDxj_ftEh9V41psG8ngITz4J3e_proWPQIiKad3ObOk3zBKzCPR3Y5IPEe4DyiL2kIxbjTv4e23C21_pNL2cLJw_pCTfnI_pQLjqRUc_pSBfuUml_pX7_pZ7AKtMlQuIEJsBjFifhDLHSDX2VFwPM65wR1vKKF5lRSH4OPYMG_pA1P0TtgJQJelIhUnAfcA4L_fjF_fmATMLHbDOty1dLaNVx6fBGUp17S6_pU7UuZJt_pcKdPUO6Nkwy_f8FPBaDG_fYvTyZSLpUJuu0sJuhdWy0ZfUd9xx0DnEe2xovrJ6a7Sjv8oJV5jXlBh9TCVkhWwSBf_fu1O7C6N6Bys6rnXvmj0egvc4sMeqY0LG5hNG_fEtTlzdapO0O8YOKxqkeTMR2LaYuTYSUlFe56dpOLGd9jyVc1yYdn1Ep5EofdhZVgg22Qt_fviNLBvAoOmn2xKYbwo_phawfVr3f_pcy8VQYFsNNa0LGLBAAypKSWAvkpGKR4_pqlDblFQIUSrGyKJcKmbhdjPuhYVTiaDva2D7NCNFpeW8glYXJZU8uegVdc7Yqi3S1j_fqSvFaXVoaviOyRmghkKsGewVOkwbTEKjidOIe6y7bxAel9LRh_pYCk4AaQeAy_pvkOcbOT4FSNrIG6IgRaV_ff2D7G6gYa9Ir4XTtNsotr9KkE7yHB5hoqLH9ZrENrz33bm7uRHiKUcX_pGcUVWxQmDy2anQxmzr8wSqC35FOXbVmnY_fZOI2XbnOj3fviBxBBlOuxziloYjg2IH6ubJikCiiBcV4hqZcd09awPrLfskzH4NH825Rd_p6TgsdKi3IDofkrMiMjK9UpOq8UxaMWMxRyP1xWVeG1DGm1mAm7bFLlzt9hb4A9Khjv_pVVJm7i16t_fc62ips_fyXYoBkyKS77pOL4M_pLUnUpghxpQWkpQu7SpI08_pIV4cH2Q84xIdk8nx2zeOKCSnNh19yDFvrwyQanHSV5xJg",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T21:24:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T20:00:00",
					"flightNumber": "7599",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "2h 24m",
					"layoverDuration": "21h 26m",
					"layoverNoteValues": [
						"Overnight Connection at O'Hare Intl Airport (ORD)."
					],
					"totalTripDuration": "2d 13h 40m",
					"arrivalTime": "9:24pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:00pm",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T16:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/QR.png",
					"carrierCode": "QR",
					"carrierName": "Qatar Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T18:50:00",
					"flightNumber": "726",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 10m",
					"layoverDuration": "14h 45m",
					"layoverNoteValues": [
						"Flight arrives on the next day.",
						"Overnight Connection at Doha Intl Airport (DOH)."
					],
					"totalTripDuration": "2d 13h 40m",
					"arrivalTime": "4:00pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "6:50pm",
					"departureDay": "2018-08-24",
					"destination": "DOH",
					"destinationAirportName": "Doha Intl Airport",
					"destinationAirportCity": "Doha",
					"destinationAirportState": null,
					"destinationAirportCountry": "Qatar",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-26T22:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/QR.png",
					"carrierCode": "QR",
					"carrierName": "Qatar Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-26T06:45:00",
					"flightNumber": "812",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "9h 55m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "2d 13h 40m",
					"arrivalTime": "10:40pm",
					"arrivalDay": "2018-08-26",
					"departureTime": "6:45am",
					"departureDay": "2018-08-26",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "DOH",
					"originAirportName": "Doha Intl Airport",
					"originAirportCity": "Doha",
					"originAirportState": null,
					"originAirportCountry": "Qatar"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "10:40pm",
				"arrivalDay": "2018-08-26",
				"departureTime": "8:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "2d 13h 40m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CX)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T15:55:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T22:00:00",
			"destination": "NRT",
			"downPayment": 1231.32,
			"id": "6f40288b-32ce-4e92-a2fd-adb2f5ea4b31",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pex13sY_pk8P4u1O_fD2hVcUFIPj12L7yBHajRJN8ApSIY7OXzNTPtXbZjmtkaDfyIc27gAkM4OpEQ_pJ0FzgPlXRFUhJZ5OIXP8zqDL989ean0U0YSbvIfsRdFUx7oOZYW9QOqCDmZ7kq6GADFiJADg_pjX61T_p6YQYHIZH92FLOvY7K_fEKTZ6DXv3nwr4vmqsr6l0IIWtIThwtO2TC5KV7XXNa8RSDwZ9npLBPMB7JMjYBRCEt584KU598rko9tHxM26RryeY_f7oPYbs2p38FZs8NrbWV488e61B4JP_fwI1NVFpEJgzGsFFJSCYn50oddlUwWacQY_fZxdAxmlYYO705SqnZDTe7e5i9GLl3v44xXYgvhCOeIfw366_f5bf_ptxRhr4rbFZ2uJzrAoRehhrS5bl0fxCr8KNZN5wanqcRR1be9WNx_pDeBXiKM7sfrMnI9aWDFHkJVzm8eesc1CTcU_fs3sv_pRZ_fgsoqHKv4fMGFScCXminK6_fHC3_fdwWr9wCpzn6B6nk6BkAcuV6GY_foxpr9khiiYGuaVG79PqDvFo2fUvcL2KX69rILSt1DqpvhXk7csGDSL922ZbOGoyFu1Fus3tkxQGzlYnN9LbX0WCCqtk8T2RTf5FtwNzZAWKXOUdc5YGzUXd_f6MWyWiqzR7fsUHPX8TcJHfirjzophcmCwGeEzjQcJ_fDG7KJOEYHgCKq1nGQ_p7YYzZiSKcbfby46qMK84usuPnj3Vm0i63C_pNmQUPZZYdZqkl4tn0UsHTQ5s93Vg9Vsh2n7PuqZ4ljr4F2z287xol9t003yzOsq3nVeaG3zqcLTMKTRVsTX_pOoSPCX4txCoBaGnXuTd9vZs0cdicPAXmQ7_p4Rlzy0cdjHi1FOJ_fZjikbO4xwUf4aFttLGNUpPtoTuz4qFO6RlhF3Jj4YMlFq7Sgfd6VYcC0A13oe_fEQnHNINTLe0F9MnMaeP3hWzp5VpLV6GCponZ48b0oOB5UJygbpPvwCPaBwOohQmvE6gHtVnNcs3J7dvJY7p0eLjlRzf6P_pi_fstdNSfpEfe2lK7t1uEzMtUuko9L8iNHVdw25_fNwg6sQap5vctucAh8B0mzt2ETMsuixd4Mr3VsQpA8BQg_puEU1CkjcsjY0MVE4ALdwbsaQ_pw6ia4QnK2OgqjWxv44jLFSrqE2U6k2G_pfGYIJYdqHu_phKDMqyUnnvW8VlZJoQYzvVJA98QEbjX66kcXCxIJ2Mc4oLRwoO_p9gX7qPA3gIRxI4Ndq_pAuVLPp_fiwt3yGo_fUpfV0JzxXqmDmKbwVhCRyJ3rzk8lypXTrrWjHlHfigu5qFbVqxzRdGltXKM3YAMrlZ10OWi30X03AyDSpjVZGk3FOHaNqrMWwbESUShOS3_p6jy72kuFJo_pR_pkiMRRB_fHtQ3uGhHOY6m_p3cABVvU7da7h4ZRL5kc4RSzfQohtt1L91mdjDRE1HTn_fQLuLhHViPDVMFo_f4P0rOZIhgzja6LZ51ukun0umNAo3fyGp_f_pqaw55d1fFlR9eUdegPA9Wk52X_pexPjkKUQhVLGmL3CKecxRkFbGguE_f2usa6bRWkkcDX1UnJ_ftH81vZct0hbUYzehmvdFZojzHDAeVFlJh8h_pUm_pCoKshU5jMWUk6xjjCXfRDurJVzXN0nCyoWNo5NWrAF3KGb8K0AqV21W6Iig_pPc4OBuMwJ1RPJu3DeQPdMIMcW_fzqPKv0EBsooa2fKmtCHYMtGw_fnOVIE9XaYcSHRUYL23_p5o7lRXXdwv52zJ7ncjpA8q_f_fQ3uQ5LIATG_p4dkHtlcxGI_px9rFWims_f1y81QzoH73lK0jkJQYaM3RYC6tax5b_fYAA8RZpTVENlpCNI3HvLsSN91b6IYHJHyQb_fxgMSIsyJNeFw_fJHFzWN_pNAQIq_pY_psfVe1GglvpCID1yRAB_fKTiwa3xlZSTVQ5SL39blnZsu0sHw2G_pEehv1e8Fbg9sfiqgD3aQ06vGAfHacJLn9LeuVMUJ3UWQ8FpfOXhsXC259VPuAOOyLm5jA_pbS9m_peXPr43EZTFWREOEK77wgsGHJ8QYtINAI_fMqH3kIbFZgylPmGqfTUhmpuCEMDqAh_pPPlNVbLoeefw7V7WhgR4JGUveLWlwEXWonB4srftzC1cf0vXQ4DMlicCN9BnHDyFzYBSiNuTMdyC_pn_f6vgtYXVs_fkLIqEYookhO40rTrWLLcFhdVGii3ub3w6BNEI_pjbDXGMnq5h7pwn7GN_fOgJsj0lAQNFvlpqCvAUOBoHVvM_p_fFzZrOE9c2W7cMxybB0PtsmfuzgKB8g_fVWSiUPzWZzDPOfKM_f8acKBV3PK1HoYL2sdf3Vn0S5jm5t",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T23:31:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
					"carrierCode": "CX",
					"carrierName": "Cathay Pacific",
					"operatingAirlineName": "WestJet Encore for WestJet",
					"departureDateTime": "2018-08-23T22:00:00",
					"flightNumber": "7093",
					"aircraft": "De Havilland Dash 8-400",
					"aircraftType": "Turboprop",
					"flightDuration": "1h 31m",
					"layoverDuration": "2h 19m",
					"layoverNoteValues": [
						"Overnight Connection at Toronto Pearson Intl Airport (YYZ)."
					],
					"totalTripDuration": "1d 4h 55m",
					"arrivalTime": "11:31pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "10:00pm",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T05:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
					"carrierCode": "CX",
					"carrierName": "Cathay Pacific",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T01:50:00",
					"flightNumber": "829",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "15h 10m",
					"layoverDuration": "5h 30m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 4h 55m",
					"arrivalTime": "5:00am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:50am",
					"departureDay": "2018-08-24",
					"destination": "HKG",
					"destinationAirportName": "Hong Kong Intl Airport",
					"destinationAirportCity": "Hong Kong",
					"destinationAirportState": null,
					"destinationAirportCountry": "Hong Kong",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T15:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
					"carrierCode": "CX",
					"carrierName": "Cathay Pacific",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T10:30:00",
					"flightNumber": "520",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "4h 25m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 4h 55m",
					"arrivalTime": "3:55pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "10:30am",
					"departureDay": "2018-08-25",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "HKG",
					"originAirportName": "Hong Kong Intl Airport",
					"originAirportCity": "Hong Kong",
					"originAirportState": null,
					"originAirportCountry": "Hong Kong"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Cathay Pacific",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:55pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "10:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 4h 55m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_BR)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T19:40:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T21:30:00",
			"destination": "NRT",
			"downPayment": 1266.6,
			"id": "b71ecd8c-eb31-49cf-a0c4-c37f2259fddb",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pVXRjKTa4iy_fJxrC8_peiE2jWlfDfjbTLp2NvK9q7Qc4z4cnDVm2f0Lm8_pTcUB6eKzNwCbeyQA6yAdGo_pWsthkID0Jtl9TzSt_pvEotDFy03lpkLvvc5z3iHQqCnaAL2XmrMCeM7aOt_fwc6gk5_pXrcE4gQC3CYp3lc_p0dDQeuK2gKT8romQ1jyf8pxLwFJcJw82ajYZQmVFBCDyHqdQEs93zpEBOXDeEEN3UL7DQtF49DhpKFpuhJUg0rT1yTZ5lCajrSdEva9spP97Y_fzqkGnhlWxauw0xnmdgDLutyubvDJjQ1UR5KnbUCqd4Lj64mAgHPFaxyQQwQV6hCidYqyFatYRLcqBEYvIdsz31V8vCadrzVD0OTN16NNwD2lz_fERUvLfZbdVR9E_pO9h6PpMR3LoZgwtjGC2fUH7XTR58qxlQM8bTAPHf_flYQpdGuKAunWXE2B3kxdURpVtSAv0XRsreGGwl_ptcanCC5aEoesf9SKJvd_fQU_f_fnuq0VmpHjaVH1XfPD_fLjVEPDAk7Z_poC1J9G0uLBhrzAZWNFRiNawJ4W_p7cSbp7ioTk1_pxYFqkeVxbZC2kiH0leAOvp7_pZQLrDoHCJU0bmZEBmMuh7F9ZBvnsKRaO1S8jDGdg2nKh8XdD9lWXgTdoYew37qUyCkx7IuueAJRftOAjXJ3gZuKNbVZypcweEv2xatvc4RLVNWuMAuDRNw6QCBoT8JpL4oRnvZse5tvkURJ_puPYvpD6YgB4stuB4KwhhB1bN1t9r9AAS2CgKa4FnkzI1ojN04cXPoJmYV_pi7bL_p7zEARfmiKFiB0NlXUnebkEGOZ1UE7bJMsg9F7uq3pTR7EhtaI6eQNWiO310hjrxxVm1HyI05vSpei8ElfkBxvv4nQEiI60tK78cBhhZrMhFUgxUKsRcP9CBudWSLLVCw_pjldRHgZAw0GXjT7auPAo1y8e79BYKSljTxH6ELLmPODnf_ff1OVWUbBGklZbvGEUcmJWRex6RrzLFtSYtGnwCv2vQZY5OKjaK7Qk3mQ_f5ClrNChjIIrwQ1WPWRQlwqqqNxddo5qAVjd1EaToPIOXLEl6QWjIoM8Mx2lRoIGUbmNR3U41uM6eGkS_fqmc4WIxrLvNHpqiN_pQASnoIBcFZIlhb9YP1G1CEJitMBEzeKpIe_fQDmBh0bs8dl22tGYiUT6vAFyV5fa3trt7kwK4ky_pjdrehIZulfoY0tZc4LFNy9jEncZJCQ5Exf4QolTbVqNouIAUCRfu35X4qK6C_pZC_pz8k2qMMCoj5P60LkhDepsKRm2mgOek_fUYuIt_pF8J5uB4X0VsL7OiO5_fuksPr71WLvcDsfgAcrrIx5YZXcXt6YBdXQ6GfqKOV63v740PsA_pgWC7cW9nhxP_foMdbu_p89UWiH0TsZUg3fq8HfVd6T1YCNwaLrNLSA_p0zvTvIJERNMmqJUo7dIPSdjKMpjgxR1sbcb9jkJPXEKEpByYb80y5ktinuYzY8apTwmow_feKfJ5C4hcpN_p4Um_fGUwZO9Tj8QV86kaCFUnhuFNZ_pJw408xQC_fJ5YjIzc7UhcOiMgxRkXgZxdyrZ1XpoaF7gORpGH_f9Simf2eYIorycjYIHAyn7dHcFqujvF9cNsjeB13wGCWLY0wewJast_fo506QTjNZFZC7ouvytdwie5Fi8eaEKBksfMN3BULAeTtnbOs9WLGHkUM_fU2Rr1Yx5F45Vxviln6AXPCnh_ppYfxbWUfGLD5JUMQ4ByP3z88gOZcEIf67PPBTsf2OAU_fd1OcN_pLaHyzyeOKcLaGrZi8DsXou86wNnp_p4Fn2vWgaRXy34PW_pPq65DfmpBt3Zibyxbh6CfRjCEMz8bf1HGRV7XFAmV3PoyC0d9lG2ijxHoakWLv1hPhd3zmW9OAtGw_pp2UWGbfniRgbNrVH6_pt94sXIpZ4l0q8DGolTLPCtssMy0a6ZC9wry55eJenjB_fNh6UiqYUM2bJJfaYS8j3gKtgYRpD4JrIYJ19p14hWpupxW0QbVZaGnqfxvAhpozDYhu_fmOwObFZvSOwJtbaCGHJKQyUb26EWTdJndQ8sZbd0HjNJ7WXGLgF240jOhT_f2NMIFEHMJSypXP7JTictfw5LZM9xWwI0bn8X9fTLaGKK1CqqG9fVTEC2usmbt8cZ_p2ass0OwYWaBZprlRILT6K_fDcpAJbBWwZBHwW_pe2_pPEqlD2u_fNkH_fx9qyF4Vhn4RJWRYAxHUoARmbTenAYVYCcJG9vbAd1Wvsd4liEIjJutcogXdflbtT2Iu1s8VtuXQhYBRcKYDPuSU_fdHa9QezevA_fm35AKerzpXcUVz5oJ0sqb3ydlVwThfGW_f",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T22:49:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
					"carrierCode": "BR",
					"carrierName": "EVA Airways",
					"operatingAirlineName": "Air Canada",
					"departureDateTime": "2018-08-23T21:30:00",
					"flightNumber": "3091",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "1h 19m",
					"layoverDuration": "2h 56m",
					"layoverNoteValues": [
						"Overnight Connection at Toronto Pearson Intl Airport (YYZ)."
					],
					"totalTripDuration": "1d 9h 10m",
					"arrivalTime": "10:49pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "9:30pm",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T04:45:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
					"carrierCode": "BR",
					"carrierName": "EVA Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T01:45:00",
					"flightNumber": "35",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "15h ",
					"layoverDuration": "10h 35m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 9h 10m",
					"arrivalTime": "4:45am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:45am",
					"departureDay": "2018-08-24",
					"destination": "TPE",
					"destinationAirportName": "Taiwan Taoyuan Intl Airport",
					"destinationAirportCity": "Taipei",
					"destinationAirportState": null,
					"destinationAirportCountry": "Taiwan",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T19:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
					"carrierCode": "BR",
					"carrierName": "EVA Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T15:20:00",
					"flightNumber": "196",
					"aircraft": "Airbus A321",
					"aircraftType": "Jet",
					"flightDuration": "3h 20m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 9h 10m",
					"arrivalTime": "7:40pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "3:20pm",
					"departureDay": "2018-08-25",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "TPE",
					"originAirportName": "Taiwan Taoyuan Intl Airport",
					"originAirportCity": "Taipei",
					"originAirportState": null,
					"originAirportCountry": "Taiwan"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "EVA Airways",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "7:40pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "9:30pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 9h 10m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_BR)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T13:15:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T21:30:00",
			"destination": "NRT",
			"downPayment": 1272.72,
			"id": "fdd9a5ec-d568-448d-99dd-e871f8d32d40",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pb2Nr_fYeVuZ5P4snG3tZkxa0IDVjCvZev3_pZtRWS6v5L7CN_plmp27XUsaFcc9uTArbIbgYZBysDc_f1_pXY3y92B_f4r0aWjM686zA44mMAALXMTBypIvxp6nuuGbkqj4kgbdQwWWs9nBjLuhogAtXVv2_fgLdQueRSVYBUaqyYCJyoJJBRsurheq0m5SFmZZHaj76k6LNsPCFbqQwkMnqYTI4Szcm7DBmQkzd9WWdPuPAVznSfaHXm_pNSA5y9I_fFxr0hufwSLNrw6L6_fOFbzlk6C_fB4eJbKxdry1VRXeQ0GSBbfXtMxkoKcounsoCdwMXc6_piuw7zThhfBPn3WHNulPwF1J4x7iJDLTW9ym9eJbyv9pE4FRrvk795uiQs1bUoFyqXH3uXrxZ3owTnYfgvsfNWQjmO9mFsygCmIZW6unQaLWpb8DYdNDM60v5a9_fxf1SlhVAtwtpng_fNd9MXTJtrOW53TmjhM1RACLhZnlN1z_plnLEFIX7A0eg_pWx_fB7BRsONNQSKT5r6BKYlFxpDN6339PXQa_fNtRLWR2m230hf9BypXOLZPblHWYGueOkq_fQTq7KLfox7nzk1ljhQq9_ftgjn0UC6RfPogWgwPLVylRA8tXGHaisKsZND54fwDX2GMZbc02YO2wZymZlaEuOeBpcAswMtn_f6ZpAoVJy5Wf0haASStTbgIk72Jtqd9FVQZlNdvNO6aLQ8norVr1cNjH9Lq5KoOn34ViJg3x4dhbsNMJH61fULJKqP6HHpDaCOUXeNLqvUaQITxJicVqkPGw_p8LfygJI6DuF5CLIUD9r7oHxjtuE0P_p7JpHa4M6i6HNIagXZHSzwD_fuBO2puTPBPz55K59jRP97aqiexkseXzV_p0PZcO1o9DqyUL_pona_fUBGdryDltg4dfbVpGtb6Txp5kgoCRv6V6vTfvxS2ieGf7AnfBiIT5hsedYEOVYfDZu6Z8IGNkPJybICniH0HWcBW2tUaaEgAlLgryCj3czRMgraeIjBZNo3GDbrLU05i7DpvNxOpJ2igECyKeaEQ2Rr2Gs4pbN2O_ps8cYVRJoQ_pPJKJvhzOnkzD0pkmcnJwq8qGjf6I4XzJSKOH1ATmzK_pDiyYDbl5Li31xXElH0JR01h2k4JQGcB2uwsfIOAKpGU4XRRyFZ5lOlBLOklHoE17mzzw14FZJsA0qESPvpEMB_f2nkAIZYZtPamuLBdiXbKsvrO2Oh2O48oisPPGLxmSmnTTQ0ULRP0_fn1qPT3WshY_pNkwlmyIBzq0BcvwvYSE7B0ncwRuH66Fha89nt48_fECK_pQi_fsiyhsWejWt_fb2PoGHjItBBy3kNXXwjfvWJV6u6Z9sjn_pAGRz_fIw3CJ95TDio9qTU3yuK1uDKxicoKtN2Cf6w0jr4B5mDAQdA_pSZGLKqQj4vA9e7F09SkmR61oJ3KSGYM2Sen09HAbl6ekU_p_f4hOCD2ZuSGXfzArmXEsyQRD5atJdutwFUqeEjVbYXfgUQBFBPQy_ffHmpNVFROB_phoyprVP46LOIME6uoqF2mO8zRn_pLw0CVoifCom41sjP8BS0ZATy9ed_ptsWfObcjS7midg6sB_fFv_ptp14ULMhtwwpi_pruPn6MYfHGbvv2KT_fROjlThXj4XTLdU7OMiywfsFbcWN2oIY72haVlhRlQ5YYsj39s3EtW9peq2ywdb5E9rqsyetmxcsT0_pfRf_foNV8utmjs10ImSJ93aYYi_fITI_pfy3H6okvshT8NFJkNT_pcJPDj_pYX_ppQJFjTzZzlZKYgew5_fTyP4y5ws8ExY35giJ1KZXcnv5e6a8B6PYxnv6qf9Jo54JTCweBHeh7lZL7Bwn6nCN2KqJeNkdtyYZ8kCS7n5afyXeOO0pOePE0JDU6h5SW9kfm_pHFqW5Jp_fm_pOmC2j_pqCFLOJG9qs_ptnld1K6Bf83M9Xjf4grWWjRCB_fuzqGyn3RBCRgrgp3hCkCLls3_pVu7is7EASoRCI2yioy709i0ApVGlGYdIAgasoz7xspi7uMCsk7Uc5erMLnxJ5lwvNGfkbW6cF6n6rOkhqL0_fHHxFNPmeaEDJ_fZAEDcxZc9Z6fSobBoZburTVUOJw3trjJqW2HuuODwH85OziGMY0s1rX3omByzI3DliNNdjyDLeP5ckr2hEhgyo0TJYf7Jbk6VE2jW57Nw5EwETUfyxEGShgSl7GP525yw_fyq_p3RbYF1SpVBx_p0h5Dhnuag3DWH2vUnD_fhweffz0citUlFg69t0HPCcQ9ifRlATjDJa3CzfabOVRmvsDQhT4akdFD2KSkUsTwLaeVNIhLiF0EVb10pGWjMNTGwFknn4yXmIFRbRuRYjyQGKR",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T22:49:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T21:30:00",
					"flightNumber": "429",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "1h 19m",
					"layoverDuration": "2h 56m",
					"layoverNoteValues": [
						"Overnight Connection at Toronto Pearson Intl Airport (YYZ)."
					],
					"totalTripDuration": "1d 2h 45m",
					"arrivalTime": "10:49pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "9:30pm",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T04:45:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
					"carrierCode": "BR",
					"carrierName": "EVA Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T01:45:00",
					"flightNumber": "35",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "15h ",
					"layoverDuration": "4h 5m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 2h 45m",
					"arrivalTime": "4:45am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:45am",
					"departureDay": "2018-08-24",
					"destination": "TPE",
					"destinationAirportName": "Taiwan Taoyuan Intl Airport",
					"destinationAirportCity": "Taipei",
					"destinationAirportState": null,
					"destinationAirportCountry": "Taiwan",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T13:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BR.png",
					"carrierCode": "BR",
					"carrierName": "EVA Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T08:50:00",
					"flightNumber": "198",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "3h 25m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 2h 45m",
					"arrivalTime": "1:15pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "8:50am",
					"departureDay": "2018-08-25",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "TPE",
					"originAirportName": "Taiwan Taoyuan Intl Airport",
					"originAirportCity": "Taipei",
					"originAirportState": null,
					"originAirportCountry": "Taiwan"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "1:15pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "9:30pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 2h 45m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_NH)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T18:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T08:45:00",
			"destination": "HND",
			"downPayment": 1292.78,
			"id": "d93078ee-295f-4bfd-bf73-f136c5792bed",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pUTawkN8S_fhi9rg9mtX7HCd7IJzz36EgTr3Fx_p6R_f3PsbY1xhK9ez9AkeRfqaCBLBI_prgfQh7qzpU2SG9vEONJ9j_fP8h_pwORqreDUJNJOjMU4oLFopY5xI7xZ11sZnvcINwR_fTPkYWArvlQjNiT_fiYzPV7teaQ0AUygEOp2_pxaAjo9Hw5KNNo2QIbGouR8TDkDwcJrVN1wGNkPM13iRZBVrrZPyV60gb6GA6iRuCKo7FKSeiNTg3_pQfNZbK1LSiOG1XMlLZKGBK92sGPjtsg0uSQS0LuPnNJ9B5pk967jq2fY2qQ2hAlQSRYLFfI4cJ5dvxnJjtLvoYid_p1jjIC4jrrPwjYpKP6l_flZfWQ5_p_fmw2vg_foNKkWv08tAxkjJXBq2fPxSYo7kl49qcebgEo91sfI2KQ7p59dSOFzVuDbpHZMJh0bSmkSNNKTY6PsVRa1SueEb2QFI4JJnICfrwMfaV4sh2kPspOPye5uMQDfnZWiK5CT9WV5G2HAv8yp0VOLfFE5T_pN8NVL0JVbvRqMUwKY78ZW_fF8lT_fxlEL1sB38fU0njhd_fHHMYy7_f4_fT9AVkaE6mQVBdQFu0ejyF_frfjZY0ov0_fJMLFmyxoToyppkCqjU6ctEMWFtaS9Hp2F26vUlhmcLAYOFdqz6N6JlFXUOtQM9hp0uXWxpARvu0GxAHZdFOXIc_puwJKq5eV_p1Bbi0a5cF5m065qdJPA3qVKhE8ZLp1ZcBAkd_fpZPuK8CCsJBJxrVhdr3T0Fx8sfiZeRWbIIeS7r9s3AOQHlmPS2_fiSaPIQKr3mL9SP_pvzFZB_f1zGhotHyMnqgpXsIV5Ru16Z_pYr33DkHTK4W0oo9UIJwizi8CCfQDyiGglPCr_f2aCJBPOkGkMwAM5xOD0TbqjyFxrAnXiCkQU22DpSHo0XpkrFWXMze05vbjErpG_ps0Qp29TfXcDRDLEtJ7IW3cpz3p1LUNhtj_pmDchjmp_pVNzCxckyVPtW5BFkd22pQFpHDkgDo47aXAbOGw3Lckj6OL_pcstjfByANwLeFHlD1_pr2mvMMqK1gMn3_fcLpSxARcJi5fzrSoJOUNL9mYKyaTSMknqv5sFuheqyoDKymTDHSQN8CvWn8jdzGs1stgUb57SM92_fo5VKEefNwpum0k55fL2fgYFzVqU7fQ2zt7BRAY_pMDkCsfHF1Kj7rt_f3Fu7kCzKeDN9Lq5iI1k04e84O_pFM4w4gIC63pvDJX8KsTPW3EvsVobdiUpeDWlBSqJdTHGj3XZmQvBHeFyH_p89qJlFtB17r2Wj_pr_pzzKjZrD5xFmgCiA2NXj3u_ph2Mc8EnXUOATaafoj4mc6KeSyHgYGfTZByQg_f1FIuwAkBzYlhyP3Zb8h5WBdzLD2vU4rQFW8sQhlWV87ZwLVW2mki2U9gjfQYuHMcn_pgyVYn2DhoVhRS6ZoRlK94RKKNyHxmznu9rz35prL8CcwX8lllGuz5CL2P0i_fgDSmpg7bWqSLH1RdTfp5_p9Y5rZ8dg8MwTPq4hIvui8wxTKrcyf0vWv00a43lxLFotPiqgAtU5MmP3L06mhiTTmVVg8OxN5hD7sCm3Ykc3c25LXjU1JX0oME2_fiYFHId5qdMGJTPe7v5dpU8325O7_fb3FM4l0B5utugZdPVjAWgBWPWA0jO2Sw_f34EnhyoucDDgjgz97xN7x8nVWym8wabxD83xf3FuGAyqcH2ndo3bg9L5SGeB4dAO8UdQgCPP4IbJJJ46HMZEFNu2bIWJ2592FhF8hARvyLz6HFioFIFSzewuHrWkiXOwKTRhR2nFdSe1nx74FsTFPYKaB5GDKqhIywZ7pqWt8gL_ppuneXHXFC7Oj87xP_f0FUAA2vcVR_pyQMDl_fmuGs7KAopuDRssDCkPswswp7eSGOGqa8Babw7giniDNx6RN8zZ5UG4SYk0ALgQ1gF1Bz6QP8LnVQNP8sN3vvZti8H8lsB8D6lrkMClBWREclhBV_pOXeQm3THMPYA6W_f1sEujeLSWmWn4mqKKpP07oyvvv88DOtcfHW6AEKfgZB90rH9WNWFmx2fKN8y17iSCO5F1yTjx_fiF6YnCj15zrnsuJKnC9fWm0RouJutP4M51FDtGXQx4J66Kyx056E0Ck9RVr7og1FeKaGklw1fqxn2yvNfIS8J2Cvx5g_pPCS5RKK3fqJK2_f2w75SEa7Uu7QXF4DDwV35KxRO9KK2SyTLfBXTI9S9oe9XRxuuA_fg5ZqwBL4hAS1F5cWWIZ1JzNTWa24_pYwJoEsW3FZswAnDi4bPF33k7_fXpxXPREM2A3Pd5aMZdTw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T11:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": "Air Canada",
					"departureDateTime": "2018-08-23T08:45:00",
					"flightNumber": "6819",
					"aircraft": "Boeing",
					"aircraftType": "Jet",
					"flightDuration": "5h 30m",
					"layoverDuration": "5h ",
					"layoverNoteValues": null,
					"totalTripDuration": "20h 35m",
					"arrivalTime": "11:15am",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:45am",
					"departureDay": "2018-08-23",
					"destination": "YVR",
					"destinationAirportName": "Vancouver Intl Airport",
					"destinationAirportCity": "Vancouver",
					"destinationAirportState": "BC",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T18:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T16:15:00",
					"flightNumber": "115",
					"aircraft": "Boeing 787-9",
					"aircraftType": "Jet",
					"flightDuration": "10h 5m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 35m",
					"arrivalTime": "6:20pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "4:15pm",
					"departureDay": "2018-08-23",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "YVR",
					"originAirportName": "Vancouver Intl Airport",
					"originAirportCity": "Vancouver",
					"originAirportState": "BC",
					"originAirportCountry": "Canada"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "ANA All Nippon Airways",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "6:20pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "8:45am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 35m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_I\\)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T14:40:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T17:14:00",
			"destination": "NRT",
			"downPayment": 1307.55,
			"id": "9cf23763-eab9-4f82-9bab-c4cdf1137bb4",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pZyB2VesPwVkFwJC1fIT7wjZ0B20uEQc9z9lCf03lhIuEXfeE02lGr38CWDRtfgsGMkzfA6xkz_pX_pPtHOGS9d3qTgmO4I8MJncX6vdQxuPFbD_plmnRC_f1rfWbh_pGK6NF8q2aigDeBuItfF9soR0DDEaK_fPVU3E_fHDKdoqeXZHOROiu8lqcp5imWItFIL3Vuwo6SrBSzhDEiF9RHjsn4bu8KPQKNYdmdOWcSG_fuFAL5C4brAKtxPnrmXukf_fFNrEk1xrRKorU3jN6ugADevPZ1kcih93J2WAHgCS0rX5_pSz5VQ62VFjuZOTL9D4Q7cfLQCFtKQtw3BrTe3OYhDQVBX8iE9_f_pYcivC63dlVw7wnVm7WGEeNN5vDoVdgqQuiM6uM1Vkfi_fB_pFFzjV77I7paqfoiqdgVpN1_pahL4cMtbOCk4dftCvKQVonbNd_pWFbMmp4uNzkTg_fTTIYbN22ct6BqLbURbEILBOa9OMygzX_fVhOy0a_pIb7vo_f_f68ro3dm2JbtAuHqaGljyfmZdvBuJZR9KyIrdLKWYMnEvb9uDQmT5AEQtxy7vCmYXXZBvCdhKS4RDdFqhrAw51h_fugEJeYo8igzxmHcY0Bb0qu_pmL7PIJrQMV6LRrEdIMHFybVqzqfoSvSAT_ff6mM3X98PVNQiH7ePxf7T400TGDWt8TnK_fgJXym1wLZZ_f_fJiASwwC6Iv9SLwF3yY3Pt9cRhvBlaJ4wB1AgV_fKHXFuCNqdYtuUkF0ePuu2YkjlpY8QF1x0vIyR4fjMNQ2aaEl5qEJF4HPABzzMJabAP5ww0GKOXN2mFI30aPFaEhGhhsdtZ2zNy4H1Xhb6ad2yapAMyKC_p3wWPAzPsyAaffKFGhIn2fraDA_pkzjCOtOIST_pLhF24eHs9xlDhfiqiJv3_frIPovKx0h1_ff7PJ_pml_pT7206XaBcCwqO7zTp2tVNlxS2N5z6jvR_f8dZiD8G7sGR6QhbsFgQBUyR0rqBwaWFEyUI_pYR6cmYw1KaruLxo5jzVWaCCXjLt2pEQsVa1UByu0XhfFgHfkAH3E8IueasQJUXq5tihNT6lSpZoj_f_pQ41H9SAT9FmSCD7uGLuwlEoDm2HM2z9zgOIHuog9Z4f4a1xfe0RA5kHuFvKZ0ihzS6qNBKiboCcLa_pfOpjIvka7nSZPRwfj0dR_fXJkrlazAiLRS_fdZrHbzxWHN0_peXYW0abiXOgf_fINAVvig9UvBS2Je8uMZbIzIORsMeWWZJV1wXo9Iz_fAQse_pAn61ONBHUf6VlZDBH8zdLOFRgsgEXzZwFS_pMrbXMB1sGQIHefSsLYbGB_fLqb5SOLbmUbJYbJibgntXq7KrzfrczXfxbe0UtZVbMR8EHnCcgGir4peTCegmKk4Tg7YWSczyfkoVdPXyfsukaZgRKegYGABu1jGaaEzzQVPNKSUyMDKTMEt2K3dCM_fDmROLsyMm0ds_fvUkorqy1eYum9T9z0BPYBwnuNTqmb_p_fIr_pSSUe_pl0UR3XtdZJaMIi_pwv1cx9VtSBiYE_faH5UGeuyfQg27ju29mV5v_p8KtR_p_p33HFwFrd7lL_paz7h_pLHD21TVnaQD1krF7H3O4b3tVXKDHq7X8xWa9sxOXRdWSgspqTW9zKYMjq5V_pdL2oWVl6nyjgP7stjAhjOzLKADVq1jD2GQNybOkRanlazX92aNgJrKPIo9VrtqUq7OBNjYtMBZCgAuC6lqIEIbpcagFBi_p0rKbUePXm3MuirNoMGhNVQDyLi_f3HkgYJ6orCoBUKKaSIo6xkPZcNoF4OTf9JfWKTB1Wcgr_p8_fPKqqbfKkGFU0dB6edfllrLAcowZrpKfUCl2OrVfF5XayzmE9YUsFl7Q235Rw5U1JiRs701rmqeGLXcUOkxG8O_pfbYBbmMGjZLT9pOgR_fxreggMQWSBLh2DcyEcC2ro2NuF9xtbs5Q_pfnzhO9GG6WYX0uCs5E07k0inq_pScnxp8jkITM_fptVPGfJQhSG5wkEYkfSkYYUDXTGVkn_f_pytmiS_pRKIiUaJcT2BP9_pmxlrArW48Er0R7oBwFXIS_pJbi9H4a0yrTvmFto_fWdQ5WOVmoGv3YQo6rUBJiDfw5QYBMilqowJlfSzvHYqVZNlh0MdrNV7b5E2EnYKutgnxpThKc8dr0l6Gy7wuof1fLLJZh29ptg_p1ryUDzH6xlSm1UidDzWe8GDqQwEGBe93ktujdqaIsdBPxMLekKCcwoh_fp1Avt8UrccsTGoxiFfQYQLjqotlKaBjKR91glwEFAbfJ71kPMPJj0eWDfNZq7EEmQsBqaj9RdYUQ",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T18:59:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T17:14:00",
					"flightNumber": "7475",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 45m",
					"layoverDuration": "16h 41m",
					"layoverNoteValues": [
						"Overnight Connection at John F Kennedy Intl Airport (JFK)."
					],
					"totalTripDuration": "1d 8h 26m",
					"arrivalTime": "6:59pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "5:14pm",
					"departureDay": "2018-08-23",
					"destination": "JFK",
					"destinationAirportName": "John F Kennedy Intl Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T14:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T11:40:00",
					"flightNumber": "3",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "14h ",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 8h 26m",
					"arrivalTime": "2:40pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:40am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Japan Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:40pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "5:14pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 8h 26m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_I\\)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T16:25:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T17:14:00",
			"destination": "HND",
			"downPayment": 1307.55,
			"id": "b0664d90-009f-4f11-a754-9909cade46a9",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pQ2_p_p1AGISMD7FWESC7A6CuKxSC5aMVw4ZLd_pQg6UI7k76RWlgm06ycsEq89MbOZ45T8WhGgvzb1X13wE424FEQMaR6If_pjC7Ig_fY6AZHXHaqmqKGklXYLvDsEC_fyIVFznb_p_f3ls3mUU74UUjmxKLrJkRk9x4suMJgrXtzAdIpk92BNIviEOQJiL2opRV5E_f1Rn_f1P2ToDr4_fiklr79L5LEYb2BNx5oLVtSKeP1lJcPiszAIJBlDlgfrer2Jsy4HyPUKnpva5Ky8erJfR3UW0hFvA89grGeShyDYapPldfgo59fqeKfaktopBOhf_p6XKldGkfd2VgGig0nLv5uafTBRRNmuIDrfa40rf_pv7apMiizNEDThPxz9yNlzZPfq7FiR0NTN_fT5ultIn_fhH546Ag_fwvS_f_fa7UAkXn_fI3qY66FiFZJx45m8zKzoE5tQU5n9Rp365KJ590Ja_pLAXZ6KVSAsqghAcXJxF_pUVuHWjfWHTco_fLloenCEWYFAtTj6KuIHOQcEa_ffgId596_pGZ5FfvB9jY27bmqnzMkcxhaCrp5sx_fhZcaj5W3j3XUrp7mJKLah9em_pQR3WBRzd7y9Oy0wJdI5cYpbBvUcnNncTTYHIFhn6kQT67ZgSYkEQL3_pJ3Uy_pZcU9yR0CcHhmYDnI9gLkZSDTVjOWpE_fReoV6EruRGaG_pGqqxsMy_pcxi1xzTIoQj0u8Vp01wrfJK_fZidGkjxZOHCXs7d4MjU9z0nshsUhvAj8cAFAHqUi2xmWcjesXVRwR3tvcgbbPc2zQVGzyfgf3YBT6oRvgmBryOm0UK2_pT1XaJkmbUkjtk_pdel_fRaX9JNDPpRu6XiuiYzWoGFE9mFWKiTQC7Owy_psGBkeDQ45JYwbWvTPPSfp5I8mL_fw1DvLrdlUf4jfgbCR0abpcYqSU1DpPaKbHb_frY4Znm7hAfmVdNQ4xUbo16VS9AUhPrgcdskOUgm3hcL2Ru_fkTjlNkWTkrCPYnuWFYpe82SyijPiheqpiXssiD7O3J7Ga3gWZMHrGxpvxIfn5XKQ8fxI3f_p5zhlD3K_fDr83NVJ_fY9nmg3S6_pFHLvGOb3krRUTb14xri6qKj3v9p9SP_pIrNp2BbX6VpfDUMG_fvw53UXiWniyAdpYVlAbBkn9Gk9kSWu0FpDtLpbxeXtPL7z5xQwgVmC2Pc2yiDgYI4jgirBz_foP5hBlIUn3hCQsStR9pI71GUTUvDz1B_powfPbGdZSL3LCfOjxZtVbXsjUe1XLUVUiHHrfvCcazVvolGAFfXHk5fTz41avJOnDFpzk6EoyxX7WR2aiM6g3PdfXO6m_pxmBolvI0eHtXOzI_f5Hy0frA_pWo6n1XIWwqo2farn_pUahFmHClrVd152c3DIlpKqwq2lbsFy9HV3xMVqa8vvZKRIa9rrClfkXzZ919zPhggMB7Si_fCLU4uUhVzmLEUNhSgV0wNMy6a5_fyKR6_fv_pFz62UyU5okTYSLOUyI1aNzBIxlfR_pwoFTO6GP79GgVAR_fSyxh1ERWqs_fDKGf1M1q9UeoZSJECRLJ0MTgOChYOYr003UWhoCFm6_fTr7r48FCFiZ9SwT62VAYtSlZFCJOfj0OOHpviFhN776eH9mXXKssE35xiJ_fAeLaCOxR_fcYtCAhFx_pw_pfaY_pSH2GT2EiHrp0KYnjPuSZHJprMh0EVnEREnpNSN0ok8KmMrF1ZkIbVtdFA_fR9pI1SS1Xkknt7Yu_pl1DbE6_fF2ms63CnmUqw63AaENNFnBGXgzeEs2f0BaYpgYKYl_fCevWuhSkpzw0tPzhss_faSqjPwF0yflu_f0eQ54udClqPpP9fHrHk5JXfSCn5yHx3qYGetmOx9vn1Bh2BZeXjA_pnaAOkoltuj9c0d66Smsd43YfKZyQjtJeEFQPsgrHiPSMKrgF55a8OzJ_pp7LaPjSA_pekIYICHtCAX0_pjwoGxaQVY9QvdVw4EY_pKFDo3OR8t15nglH4I5mPByN2dURca26blBQsQK3VIpvrHQrgNmNaG0LLD6uihEk2Gw2g1t2H0KWVko52ucIgyoOTtNc5k54rciA8TD_pugGV3N_pvVm1VygSow6gqiHjyZWRVs4T1Mxe3wfxxQU8zvSrU_f0dG8wy_p5Uyc0fglyWQtWj0IArWzw_p_fghZJUI9DHmqNackMREM2hVzjO_pX6I4WZcOd9AX6kX2LOxOQAqnTsPoLchej1RwiEnY8if4O_ptk1vKZo3hRWFc8LfZvYXm7BnBLNvj4C0twrYx1pV61Hugqqa8vhQk6w8O5TofUGOJ61gttt6CXqqjkVbFDBjMg",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T18:59:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": "Envoy as American Eagle",
					"departureDateTime": "2018-08-23T17:14:00",
					"flightNumber": "7475",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 45m",
					"layoverDuration": "18h 26m",
					"layoverNoteValues": [
						"Overnight Connection at John F Kennedy Intl Airport (JFK)."
					],
					"totalTripDuration": "1d 10h 11m",
					"arrivalTime": "6:59pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "5:14pm",
					"departureDay": "2018-08-23",
					"destination": "JFK",
					"destinationAirportName": "John F Kennedy Intl Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T16:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
					"carrierCode": "JL",
					"carrierName": "Japan Airlines",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T13:25:00",
					"flightNumber": "5",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "14h ",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 10h 11m",
					"arrivalTime": "4:25pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:25pm",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Japan Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/JL.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "4:25pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "5:14pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 10h 11m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_B~)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T14:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T20:00:00",
			"destination": "NRT",
			"downPayment": 1330.11,
			"id": "7672a800-3b30-40cf-95d7-1baf7f6b53ad",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pUeFWtDJn5o_pCftXBv4ItXqwODpf_fuNxTa4mLL44k_fGGJ8yoXydMC0ZPv_pwcNf0yw_fEYmB2M8J57_p98sbWEtNRBRUqsNIywJ9IEOh874u7K21KzUgK_fxsgBaHEK2G2UPhr3arz6G_pRMCtn7Mk1xeJdcZXds9BMh1088cSa54Lr3bZz1DPgNwiRrFp8Traqepx0zSSVrQIFpt13k1npwqaxWDk_pH_pHVSDiTT8znlbykYtcp9kvSDQ8F3cWO_fbE_fSY_p1VYhOfNBXFLN69WLszMp2jPArpIr_fH45CFzgRGRl5lmteBzwpuUGcYJk7JAH6cA7P_pWZHsth4MzByfyTfmucNucb_f3GkiX7PCWgT_fednPh1ihqnI4m2WS93xdDeyqA93h4O7bK2tddLKFgxw7VFAz43g5xBI0ZU_fKnGXxCDj1i5YcRN6v_psYSgcST3kACNOJRlvH_pCntymBUMLfLNiSqFYqP656pGYaxhIoJGAu_fwoyJeccNiNNa7n3KFCHeZIQuc8g3guaRCIjLLNsP4xkPGkOp5HUpFVKiuYnfv1iyXfvq2Fb8j5C8i1q97vHEMZ561ghYYC6GoqYl34v8DBzDwsIKjuz_pBI_f6CCmJ7lACxs6iLJKL7ur3JkpIHS5RwFRtgKzlGFmmjcPTOGiFAigl8uydJ4FmXhGocGb_fQT3Bvd5zQXjVD2AnYH218KWMMir_fNNL8i_pb6VxBEw2MmcJQ6HMXODmAn5duWQ0A_fLwwdzrtjDLEaUGdhBMtB9zLlJ6uODJyd_fLQwJWfKrywHDYxb5t_pJa0XTWHK7Tp1_fgYbs_fqPwbWjQ68RnVcbkGqa33lZ6xqRQu7bBEQX_fmIwOEkQaexagu5unTNkxbrZ5FRUiA_p6RAAuQDWGgK0ptlD19fH3RcRi5K27_fVdOiCFsbLrfNYng7UKrSFzwFcanx59MucpMh2mrOW_pIsG7qwi2WokvvCXjyvKEuKDo5PzD5Z_f2DgjqUhOGSOj5cUMnDu08YYdss2haGP9zkr7yEY9aX6CNbuYzbO06TuajGgQmrzcbXoTeKvHHJ2bWEUTz8NLQVXPDH_fsi0GjxprYhuD4Df9oY6s_fvPGMOvP0qjqTycAV5_fzu8eO5KE6yEcklsHdNCStP99tNIZ7XvYt4VVp16UWb6qBesQD8AAEylQqjxa_praEJRk7EHCc_f_p0zYKwu_pt7_p_fN8nI614jhJ7DnucLif6BPAj0LbQK36A7Xgz36rqtOcjFk3phsEmqdnRDT3cEqHuowlSbj83kqD6GAmJfGkohgOcJ06UD_f2bLIOGh57FCc1ZIXzUpn7MlY2jKCzdRey2div4GDb1pP1zGtiTn5Atdv9lQ5x8_fkZHcXDji3sPK35RfoJ9zMGhTiiCRLjbZPQFPaHj6tXv5l0biJqPiX45nH_pd1da7B_ft_poF9IN_fU3GYmxBSicmr0VY7WYZxc0WzywGtsIov6HbD_pU3iMKbbPc5cZhsg3kzevAb9KvAgDuSvxUhcYEkFh1AsUQbM3BrrBuQIlU6LDLjeWey_f_p1ws_pNbNDaAsrvuIRbM4HqmGqVWcYWlSG3czl0bxNSGtDAyMyOEP8oVA_pDLqpS0cbM4qwa0nPH9eSw2x3Fj0zJ2ak5qbldgsnPTFVAh2F1SSCpcEuyfssylyumYOhJffxDMsKAOSyik3itlWkipSyiztZhVEVZ_fldJ5qfKMHg6xWNT7_ptD8Y9RIRc_fiIKoHfu4VCXlEY9tlZFJjtFZ7hZuAiIvPVs_pefyv_f12tyZJHAjuO_fgByZF1kjppF_pTJp2EazVpzabrXOZb03fBQxn_p9R2yHEhsOsSpvpSbjN7hbvB0RO8B0KNl_plz6H96skVElHJR9kmuqcAVIfEo7yPNUYRWWzDCxi_pmJENC_fEOgwvtcp20VExRTJBYHUtt43eWDpPQYTOzhNfymBoNQTusUK6WN6m9zFoZA9z5cnutbsMlFHC2MjcKSLK_fv5aDOxBkZMDXLHHwpKw_fVUlcBhR_fOCJyvC8WI6O2NCFpb0jgPdOCho3L_foGlMQqb3_prv_ptn9KqlNo56tYzc91ZO2V7UtSUMt5BNzwY3y1YAXt_ppCMfuS8uapBjHdyrbfUdvHUOI9jGvh5EkIQ08LynOOSFsjtjNKMlKfgjjZ_pbc5NlGXv_pBkA_pdln05_p1U3jMCyy_f_fSwWR7Lc7B8yWovmlrKRzrf9g8h36Wr9GwZKfAj9JRK1tpSVCIMEDDozepNOttHRpCFNnDWAazuPrF_paov2yhhZQHw3ny04bxl_fpGTjkCF0iVRU9uZdle_pm9sIh2FWMBoU4xYI4gqfo_fHxyC9hDXXg",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T21:24:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
					"carrierCode": "UA",
					"carrierName": "United Airlines",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T20:00:00",
					"flightNumber": "8687",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "2h 24m",
					"layoverDuration": "13h 56m",
					"layoverNoteValues": [
						"Overnight Connection at O'Hare Intl Airport (ORD)."
					],
					"totalTripDuration": "1d 5h 20m",
					"arrivalTime": "9:24pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "8:00pm",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T14:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T11:20:00",
					"flightNumber": "11",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h ",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 5h 20m",
					"arrivalTime": "2:20pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:20am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "United Airlines",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/UA.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:20pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "8:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 5h 20m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AY)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T08:55:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T13:38:00",
			"destination": "NRT",
			"downPayment": 1574.31,
			"id": "3be75ac4-86d9-4e27-beca-92ae65fa5a31",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pSEOOWyaF0ZefV_pGPBRGAN4cuErVtUR0XCZWiU3Ijz4bM75zFAa9MM5wtMKfPKIwyXoou3Q9qf_fBLyZA9gxy9WRxWnUY_f6QrfA6xaK9IUqowQPlukpO_puySSkVjN6pxVG7bKI6Gsb3iTaYhLfdeBi9LitgdTYAjmld9SeW0BIG_fZG_pYBOxKOkB6pNSkbZdP35cpjdGwCiFaR8tGMUrwUIre58kSNIdCWMtA88iJpVn5VFbMisuyC0UmsIctl6rOSYG24dvom9aKwELItLgP4NDcY_fO_pfQ4tuoMRTlTKKQ2_fGWbMhvwQB1aTL5NlglO3puPvsiTAms_fmg9INR8uj_pDr4ju9Z_pEIMhdk_pV0EH6_fNMcw2pdCfSzua3zhr9IrBoOVbLN2_pjqqLem0v_pVOveA_fPg48k_fFWa61IEIa2S78AYtnqitG7TbTpkklrB5uvpM_p07QzSr3NcTcf8xzjtqssLXE17kUriIEPTWS4aHMIOeC_phbRbz_pNxUAUmS3eJNkZUyX2yKk_pQ9cLArXUahBBEF_f4CJqu9GPxptmp3AItDGzmXjsyxuA_pr_p1PP6m1MPp1xZbxDwBCUDV0Yen_fTThOB_pMbnVVFv6iQrEhECd3WGuRWAYC5XLRrft3ShDneSiwXQ3LK0iykbrKN5KrJUa1abNyPO63nKu_f_fL95FSkGEk7jzAdzNhGzICELWtvIMDtMAedB6Yfw_pXB85v0MauGuWWEbPBukbq8CnwZ9Gg1vu2Rh3POJRAFh2gCTp5zQZRY8eOMvunRUn3tpCHMH1oV74Wmc4oE6BXDIYC4eEVVug_foYUWHJl17SrifSUY39E5xcORKEdQhcnN5Kc99WANjC9VkzuI1FmGQZtPGatSRDl23Wxthee3Zvd_fsnLqhSl2q3n1CrmjJYhwiD8OB8XgiF2_pickFE4DstVBzdI88Q59bYlRyEjqIpgu47Qiw_fkJ7jWbrNCxlNFbgII6BA54ksxAjcXR4kj3Lqj4Qqp3xNn4qXK8eyOvJJmntfUheOHVm5xG85HjnACqb5aUghv674TmyZcsH0eaACXlUp3BtYqCHjPDyPHWG0xMHxYZY5bVhSwhZ5GQruvz9N8F8FI8Z5umdb4nVPYu5pwzVthCTwVSOpPuF_fnG_fTiGcnN0GRzgF41QFU_fFs8Id8NUIwyks4bEoHlPhBFmf6AFGsWuZhtMebGKgtgZV_pWkMbV7du_pRKtacB8C35_fT_faus1CZExOmvl3lo_fN_feWJxNHydjvYFCA5lXtaTY_fsn82y2yczgfX_f2x1Poh9DXHpFvif6Wzoel9gfhotURbXOmNZcD0_pBUeX6w_pbb7s0qxycMhNe0TzGLEil6vwxc2bC5sVmL_flPaW4D4TMlhmNfUfDb9k85B_fKG_pUyhcwJDMu1vFc9RFWKuX1x6BsyCFePT9SYNPUioo9Sfmr6fv8FdSvAUbDi9IA2iw8B8NOUzNnNBTnQtmnbOZJLiAdkWDvtpuVychCDfHm0gj8_fR3xsuhp_fxJJ4_pBbgyoxqgMcsvqFip_fbVpa3N_fFpiUKYLrHekUBfnMb6Ci_fneMiZKe1mM4q0qdLcR1qUtkuc6NlnbUdCEOwh8CwCp_fKamUtWIaNXZtWOng2XBbQcf4gKM1d7v3BK8Cy18kqWDzN5MIEp_fUcRB_fs_pgzAYsgWdeaVVh12giz649Nacjf3EnNUZ_fR8aA0tF_fICDC0nteiPasQ_p5Uv_fb95nQM9KTkB7uG4M_psEyJjA1gVzP8JQgEy_pLHaLXuq8aCikOWsfPbLzC0kaoqzbQGFeBQO3AygTNHUfVkQwHjSAJ8qSMrHEhGfC6cOkGEchItuaZ1lkGxvffAap7fK_pmj_fG_f0RlRLlzopsrggrkT2XSkmWJ4Isb1slEci774Ag6UlYssbbn10qOaJT7bqzld5iD_pG5hPA_fqcSydKGhrhQ3_pc7XpB3hBLWTGMaNp_fnnrKgp11_pHM_fVi8vP7TbWpRUvkVMjYnxyoboQznsO1tW0oLOYlD0_pdqIaMJ3tWwLVqZjji1_fyCaWVsPcoFXaMAax9_pQbzfJw_fpdXWeuFR3QtOcYRjjU3srN8bOnE8x_peBgDRdlFzE7myA_fKhZluEPLfuvyuFRYgKJ7yqnQeToS_pE2v_p5_p1dIOZs_pcldlXbQog_p8JMFgEyl5Szn2wkFYWq5Y9oNdYwICo1PI7CM7mnhzP0RRBTO3RdxTUHBLx14v_p4WO3F7B1uUMY14hBxPsAoTqh_pa9GYo9Gg9xK9II4GlSqEe_f2j_fzTAzM9eAYF_ffE5TjVCuqyOZodl6h6X0vhVuLDZo_pJE8G3ZYCWITkVrpjih3ZipVmDSRUNJeShjydMJc12BP",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T15:14:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AY.png",
					"carrierCode": "AY",
					"carrierName": "Finnair",
					"operatingAirlineName": "Envoy as American Eagle for American Airlines",
					"departureDateTime": "2018-08-23T13:38:00",
					"flightNumber": "4063",
					"aircraft": "Embraer 140",
					"aircraftType": "Jet",
					"flightDuration": "1h 36m",
					"layoverDuration": "2h 26m",
					"layoverNoteValues": null,
					"totalTripDuration": "1d 6h 17m",
					"arrivalTime": "3:14pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "1:38pm",
					"departureDay": "2018-08-23",
					"destination": "JFK",
					"destinationAirportName": "John F Kennedy Intl Airport",
					"destinationAirportCity": "New York City",
					"destinationAirportState": "NY",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T08:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AY.png",
					"carrierCode": "AY",
					"carrierName": "Finnair",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T17:40:00",
					"flightNumber": "6",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "8h 10m",
					"layoverDuration": "8h 35m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 6h 17m",
					"arrivalTime": "8:50am",
					"arrivalDay": "2018-08-24",
					"departureTime": "5:40pm",
					"departureDay": "2018-08-23",
					"destination": "HEL",
					"destinationAirportName": "Vantaa Airport",
					"destinationAirportCity": "Helsinki",
					"destinationAirportState": null,
					"destinationAirportCountry": "Finland",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-25T08:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AY.png",
					"carrierCode": "AY",
					"carrierName": "Finnair",
					"operatingAirlineName": "Japan Airlines",
					"departureDateTime": "2018-08-24T17:25:00",
					"flightNumber": "5811",
					"aircraft": "Boeing 787-9",
					"aircraftType": "Jet",
					"flightDuration": "9h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 6h 17m",
					"arrivalTime": "8:55am",
					"arrivalDay": "2018-08-25",
					"departureTime": "5:25pm",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "HEL",
					"originAirportName": "Vantaa Airport",
					"originAirportCity": "Helsinki",
					"originAirportState": null,
					"originAirportCountry": "Finland"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Finnair",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AY.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "8:55am",
				"arrivalDay": "2018-08-25",
				"departureTime": "1:38pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 6h 17m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CX)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T14:30:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T22:00:00",
			"destination": "NRT",
			"downPayment": 1590.12,
			"id": "5f167a60-7124-4d86-92e5-45687b61a3a3",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB0AYv_pXvZhboDPszREucLlR_f_feZxQ7v8Yeul4TAHta4X_pz0N9TGeY3mJxIHFmurWVwl1YixALsbAcvxbdwgS1tS4Jvbg0rCwdVZzgCnIMHL2q1nIxGs8GGAaMxOE_fVKE91CUpBw_pjaibSl2jtuF4FthLIsP6gFnamuNSusXYpPtZulOlhSluKkzBuiiwGHgJmUYNUMXv3_fgoPKqweBpNb2DQXM9VySiMy0MqbJ_pa_fZpemdmmb53T1fFAkXnD8PemUTuCAkkPux_f9cXKHr6EoEc2N56D7ifFV_pYMlNmvwcBwfqBMzezESL_pJyjRhyrEi6KDj_pjGT2tcsm9L3BGYyje5I8yifIfIh_pntV7v3zSnDSzbSKFAuhyoucL6bdRNQFRY8I1v_pdDOe87BL0Ikq7fxFZD1jOCCVAcdp6N4bVSSRvf_p6nn8bYfFUMw8DL4J_pKNAL24B9zBtYFVTZ26ycrhJjNC0OcCH1ojAD3cCvB1vAmKQwX16P7F_pPaI5T7N4O8BfoaCNyJqVnmFHSv_pHeO_fsu_fHW8_fjxZLSTkvP_pJih0OHfDC_fli862Gg_pyC78HjG8w_f3ofHq_fgc11_fnOoP3fm9_f5r0_frDfELh3vt9q3jkQmDYwem1mTPJC12HxtyPrfXopKSfGliY9_p70vBPA_fFuZJabHKPfpasu7lEAvvBS_foGdD7DrnjbLB97KE0BYq66TeBExK6YoGTwm4LtT2KspOxuxzh3g7PvPdMNwVLIPyDHtQbNhEB7ZCoWOwSP6Be3Cl9HdUHLJFTzFinI_fh3SylpLZpFECxZwU4x1UiXGBw_fKrpIeVmnGvgyOFVRyfyNoRBvnlsYy79er_frQK1C8dQVwb1pZjwMFrJRiwqSok7ojmIZtx7FXwECQskUoyPeQ0bTlp0EKlDBn4k5wwGfDnF5yMmLGIkDcXDeE3BCc6U9brCPlZRoRfypo_fiDjqCaP3y5BSzgftdQVQqU761lIVE2zC9sHE1q96NyUKIukSkIxKD_pjxDrdBr5Uu5St4DAdRyUJpi_p5e_fNo4kH6bba8hOTB_pU81YRFjxqoK_fcvlInTBZhX8vKcT016rvUOLUGPF0miTSPymdJ0_fWlnkiywIgRvXOtTMcFIt49heRxGZJptaf8rpYKkRQph7SwgdI4xJJXnkOVqDD0sj_p6xF7SJebXW8gC8PPiLlorNNH0ZHrgrZarbYKg8MgxlZm1nKkFeGOrnb74nHA0UlvzEz87Dv8w0ERhxYXsK_f_pjpok4HCt_pQq_f07Gl4tLMO1uM60qze86EfV_fwd13OqToMTohYJVa8SqAI5vCJ5khv6pLV7pGIVkY1fpczHtaAzoWftarf63XOnXHCnbxjoDKHQ2oY_fw_pmAX34itAWNMsM3LYdNpWjNDlNQl0aUIvPX3KW99W0Z3OV2uR_poTUEcBEdfVViwq6DPalOz_pIIKjxTi6dJr2DEJZozdWSzClWKZAynG6XZCTrx7Fm_plrp2A19XlLVRvPSR_pfSJzjfbEulHkbjg3oVi4hhZthvBG_fgIbd6IrC55sV2zIx4s2Facz7cWKnpTQKTVveZbxP_fp_fVbFfgyFLqXBjkiqMaZ2fBRCe75mkBFfvYJJxOGt_pbnT_pTy9BZRJIxaA8xd2tMO9kxFq28TqxCpWEI0t9DLRC2UXtEEEFGTLL9X2IUVwokGfS8g4bwVgSm1KqqAMD9aOj0xkkunEyu2Jhlnz0Jv2DLZ6xWEppxowqZ64EFxVNGJFThYUnZT0HvUL2fwm49Gzc7lEqvcqO7XD_p0XgC3tuHUTySC2tSEgVTFbXA96LEn63_pjJhRRHsM8WjKbpAvPQLY_p1VmR4v5B_fhxtK27_pdg38BE3cbZ_pHB58sqQhHa2pkBfqFv57qdqlKt8M0ZFaN_pTZgnQn99cCVBafYF52PbyB2CWJksUzxF86wRukmm3AkBYc3pdvo20q1xmAfbLykN76CN6VBVALTX7ndHnXZWoRrtGMIzK_pHv10v1V1umHrV7MJ_pU8RBO6KqDEouk0qoPyeInhOQxYxhKxBs2uiV3cKeYZKzrinD6HKhkfnC4DN_p0HKGcN4gU1ZZKr1I_ffvMZWIGHGZDjaeNHZWEHnvyq8AmC_fglIImVujpa7g0PskVggrc6_fgwUGb1l28HFUOUclKhYy_p24d_pNHk7LCyWHRA0tLRERO0QoOFS3_pdvgfFmhz3Sw2Qu3wfKh190fA5pW4blXo8xFDRIU_pu6DHbW5VRaAJkSnef076mziC9hfN_f2T_pV_fWtXSUoOzl6YMLLc4eq8hE4TIsCN8_pEY_fTX_pgNden8wKrzpEvdI3Y7pO7CCkqkakK_fgBQUeb4_pO8fZnZojBLDxlX3k2n3",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T23:31:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
					"carrierCode": "CX",
					"carrierName": "Cathay Pacific",
					"operatingAirlineName": "WestJet Encore for WestJet",
					"departureDateTime": "2018-08-23T22:00:00",
					"flightNumber": "7093",
					"aircraft": "De Havilland Dash 8-400",
					"aircraftType": "Turboprop",
					"flightDuration": "1h 31m",
					"layoverDuration": "2h 19m",
					"layoverNoteValues": [
						"Overnight Connection at Toronto Pearson Intl Airport (YYZ)."
					],
					"totalTripDuration": "1d 3h 30m",
					"arrivalTime": "11:31pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "10:00pm",
					"departureDay": "2018-08-23",
					"destination": "YYZ",
					"destinationAirportName": "Toronto Pearson Intl Airport",
					"destinationAirportCity": "Toronto",
					"destinationAirportState": "ON",
					"destinationAirportCountry": "Canada",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T05:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
					"carrierCode": "CX",
					"carrierName": "Cathay Pacific",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T01:50:00",
					"flightNumber": "829",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "15h 10m",
					"layoverDuration": "4h 5m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 3h 30m",
					"arrivalTime": "5:00am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:50am",
					"departureDay": "2018-08-24",
					"destination": "HKG",
					"destinationAirportName": "Hong Kong Intl Airport",
					"destinationAirportCity": "Hong Kong",
					"destinationAirportState": null,
					"destinationAirportCountry": "Hong Kong",
					"origin": "YYZ",
					"originAirportName": "Toronto Pearson Intl Airport",
					"originAirportCity": "Toronto",
					"originAirportState": "ON",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T14:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
					"carrierCode": "CX",
					"carrierName": "Cathay Pacific",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T09:05:00",
					"flightNumber": "504",
					"aircraft": "Boeing 777-300",
					"aircraftType": "Jet",
					"flightDuration": "4h 25m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 3h 30m",
					"arrivalTime": "2:30pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "9:05am",
					"departureDay": "2018-08-25",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "HKG",
					"originAirportName": "Hong Kong Intl Airport",
					"originAirportCity": "Hong Kong",
					"originAirportState": null,
					"originAirportCountry": "Hong Kong"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Cathay Pacific",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/CX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:30pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "10:00pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 3h 30m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_QR)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T22:40:00",
			"numOfStops": 2,
			"numOfUniqueCarriers": 2,
			"departureDateTime": "2018-08-23T13:35:00",
			"destination": "HND",
			"downPayment": 1612.11,
			"id": "55836516-d195-4438-808a-0224d2e6e6f8",
			"origin": "YUL",
			"ppnContractBundle": "_eJwB4AYf_pcKqjQcgVczc0NlkMta2UGNQSi_fRFb_fumJ0ypB3euS2Mfn9ylLH5ld_pdrpqXuu9k3rDQ2x39_p2uOsjXqJH5DIsypPKWOxluizxGTsD1pwfUjwRCAilJoF0EsOcUDDrDxmhx6hDWQFr6Hxav8zfRzO0C2PFqukqO2mAHStqjCEpNdPRakZbAe_pryp848jL1m9kLnDwfW1nIPqNSy58CWIcQWFGZt1r0WhP8kh2nd6JJ9yQhMMMRCK2sl_pZdgH_pIyYhjpTnSdYKgzxH8eF_pJ3_fACli_feInfgx9KxsWlTFZOr_fMsLSXjB_pyLfg2k_f57YbeJEgExyPmN7icayDR8Jrnc4B2V9g6p_p2OCLnHMhJ5K_pXkd_fTCk9vAqMZFaFbUzKK_pYnQp8LI1LCkhscJmA1OogkLnItUmY0YXDjFdsSMkd1_fWMrCpaYMivXd5wxy74Xarqy4kDDl4ZbbNckjj18SbQZfJ8RIGS5Oee1FlgdkPIb18ISmommTK2w6z1V0eYV9wmB5PN0skM3qOfCMhkFUGnHAU5ZupBDePVrvzNkHlNN1htXyeBORXDV_p65Q1bRpfVsH85A8A6zq5r0YbnWwlutsN84_fYagu7biKhBLbcz2gXgmebY889n_f12AmDRGkRfo_faJE0JMKUaYgREDyIeeAy47e_fH7lePWYP8IYrAt8vYXtmBXJsvBDkqzhvnBdZfYtogJAT_fAPzkbPkJKpmJfXXuODDQDP_fRai_f6J7AKY4_p824aLFKCULyqAEDRJGNV9aj1eJKaF70QQH4oiknAeDd9NN2vRDh7bmYn33vSOYeKjbQMSkSAKU5g_pc9c_pQxBnvwAP7kTpDpEp8k3yH0S70un7hOZgLvhi7K_pRjgCl2TU2QvevXkhwpACbnXf_flkn3oXB_fBOQIQQ70PAQVRM2XFVO0pjxFOc5vyHvaYLIht6xRO551Y1GwdLsQs0wl1wddS6tcF_pZBSCFczigJIYpVgykQdkgqFj1kpqoqRVDF3iUQ3Rv5EaTBNDWzXcUFBa_p_f04JRrZt04OM73w1Ifkf9YSmqoWojZqC5hxPTXngelssuXymHN6tvTUmmXzq6tbbn2aQ122IFEPZXqtx5N8XMO_fCfNwNP8Lgk_piHk_fqcpC_pFrbGc2UxjAwxnK2YBL2aI1URoksUFNcfxXxGtebEFGS9L6Vis2iRPd95uaJyJZJcvfpw8Iz6kzamoUFBjIHZFM4Ts4hr4jZg7oLKRMMQvMYPOVpWkILmjMRiSDt50fAvT2gUgQ154yMP8tqdTVst2Z2NNhRInx2WdAQh3cdPIJw4zXheB5EmjkGftFf4p5rfQ_fKjSY8yDBk4jr1bONfygz3AEKVfRdpmcyTvy94E9NY4For7U3CVG00H2zOuGKKS2ALlEKGA8I0eCwBGr1mzLjoZnY4OZipYfuSGMuj3WOkIaK_p3AeqyYtVJl_pyQS4RuXwLpq_fm00uUWIAXq4_pBa0Go2lpPGGndvKmm5XFKQGlFw2P4SC2YiueMy7zrIT26qH7RO2_p9eNbhaJuuhC2NHDXedp4JjdcoLdSA9daTt7U58hutVBB2muj2zyI860JFShF6bBDogZUkcpcmqmmdVpcmyXPD0JBOs_p_p4d8CoJwYcfy8Tn4K_fGpaD0G5_pQzhi4BN_pfcKz7Li69wxtbQUc90uUlmtA5cOfLq_pbdKf2tki6YLCLkInnaybwu2_f8YsjazbZ1kqJFclxord_pE2BQOSv9Isg9lu9pEaP_f6O75rweDy_pRl7C4JWVZ3MziT77wJ_pEEY1hLfhTuNBB88orLbZ2QAKzo9Df9L09DODR4hVblkm6o39D1EXabaqneun9yWsb9dmCG7ZXFZ0X_fyx6jQZ2j47rknaQN0dzYYwJL7Uiv9yrFYLeDPVZ3Ar0Hdcezaz3GQ47k9UyocnDbeVR_f6bcN6FDhoHWhwSrfkb1dfHGqE8y0386jCjQXWDDSwWCWtNiLkkHLBw2JFgzSUFU9BkL6OUWLfBwq1tJFfPDChUI0Nd9LqpAhuNFQXppkSTDdf_pP7gjfm3uJrfTQrGcJp8vO_p_fqJhArJD_paJ_fIQ58yyqREnZjae90TtGUtsDm_fYqmOyMan5HVVcsdNRe15tqNSmD6d84qjDG_f9P_pBEv6W0_pFczgfn_p7pjDctSjSi92sQy4OGxcmXfk8KM705aY8jS3JWQzobc1ypTEDerL0plileceVT6sPBCq1CQWTBkVy87OTUcJptkZFSadNclqNr2kAlKWLVMMHtCvd_fMF2m8qJ15_fgPrf_fz2yKp6XW7U6x5PJ9OtIrx7lutqdb9dLyjR5z6JQMFFmKbRvWY1aZfGgirKjA8CWQS_pFyymxOMJtABHnBmC0_fiL9697pw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T14:59:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
					"carrierCode": "AC",
					"carrierName": "Air Canada",
					"operatingAirlineName": "Air Canada Express / Sky Regional",
					"departureDateTime": "2018-08-23T13:35:00",
					"flightNumber": "7595",
					"aircraft": "Embraer 175",
					"aircraftType": "Jet",
					"flightDuration": "2h 24m",
					"layoverDuration": "3h 51m",
					"layoverNoteValues": null,
					"totalTripDuration": "1d 20h 5m",
					"arrivalTime": "2:59pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "1:35pm",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T16:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/QR.png",
					"carrierCode": "QR",
					"carrierName": "Qatar Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T18:50:00",
					"flightNumber": "726",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h 10m",
					"layoverDuration": "14h 45m",
					"layoverNoteValues": [
						"Flight arrives on the next day.",
						"Overnight Connection at Doha Intl Airport (DOH)."
					],
					"totalTripDuration": "1d 20h 5m",
					"arrivalTime": "4:00pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "6:50pm",
					"departureDay": "2018-08-23",
					"destination": "DOH",
					"destinationAirportName": "Doha Intl Airport",
					"destinationAirportCity": "Doha",
					"destinationAirportState": null,
					"destinationAirportCountry": "Qatar",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2018-08-25T22:40:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/QR.png",
					"carrierCode": "QR",
					"carrierName": "Qatar Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T06:45:00",
					"flightNumber": "812",
					"aircraft": "Airbus A359",
					"aircraftType": "Jet",
					"flightDuration": "9h 55m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "1d 20h 5m",
					"arrivalTime": "10:40pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "6:45am",
					"departureDay": "2018-08-25",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "DOH",
					"originAirportName": "Doha Intl Airport",
					"originAirportCity": "Doha",
					"originAirportState": null,
					"originAirportCountry": "Qatar"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Air Canada",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AC.png",
				"numOfUniqueCarriers": 2,
				"numOfStops": 2,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "10:40pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "1:35pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 20h 5m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_NH)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T14:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T06:38:00",
			"destination": "NRT",
			"downPayment": 1651.23,
			"id": "7c5f6cb9-078f-4a67-8264-5e582eb3db97",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBsAZP_pZEOY82NjZXTd0XezsgF4Kr2iTNUNuh3sZ36tgcLIaWmW6Znb3TSmLoMfMRok_frgobMi453JddBkw_p39629qGHS_ppud5Besx56Vo0yaVUpq00nCi_p2KuNQclfWk_pQOC1YC6RhXlro_pdSyF50RHpfPaMQ5Hk_pjFZeHsSu4fCSHTiMf78OWVFjdR4c22Kl_p2YN_fIwwTo97KUGWSMFVSmvJdCkawV_fG5ItgQvJGScXGKcbgm_pbsQ9KPpI0PIvu4GW6hkoKrEBn2Lq4O1_fjw2OEvT8lNcILPx_p4m3wv4Be3r51tQLT7SJVINE53HhvZpkhwDKp8_psI9rXgWXC_p4hWUuSx_pE7960n7kg0eNR7xh5za2DWCD4I2xWJ4CDGbtU10Ka6P5P23g2Xc0azb1bjCZ_fdRZCRnDIwqgcHqPp_p8gHIAJg_pMgtgSu_fGNN_pzlGgslUyI_pknMG7jCTQiRtwQkrP50hHO2kbYiNxzwUMrDLGIGCNHqx9HtX787UtBtz3SDc8_fnKZbo9shgkYw3juSVxYg_fK6CiOkGfC9jbutPmfAxpZkexc0dQvhzuq_pJtoAFdK4PRagx0cJh6_fV4RYSu9U7WbdKmNq8kZGVnUWaseIZA5jyYEirjjsw_fOyys61OMRguLfws94cmjySW40vDl2_pHpkcBYQE11e7QLhHnaCZP8_pSVHeyvpvGxyLuHWBFRFtP_pBCF_pYz9FqO11Cljy5_fUhnJGC0BNC3dxAvfkmQe8KGwOklVgqHz9Reo_fejdchEk_fWJLWDERmgqeT6IUos4xTirT7aYCe73QBsBekhyy0i9EPQA8vQgPkInWJjVgStX3uh6gjTJCZf_fvjMEOMjud_pCxQYHrPwtIdlF2sZFlvq1oTgaZn7fU_pOjA9skdTi4fDLikmXfCXQiYYzeMjirbhOXiz3YHiMfyF1QckIhiDkzxL7sCiFNZXqOvLRT2qw2S9H1VK7XvAHkL0RSXIhFltXHB5jqbR9cBh2RTUpp7nY2wgb3dBkL_fw0FFx_f8Ctlyfbi2DMUZVg6BgaWNs_fRBKbh6NBY3hen7SdN6pl1C4gkxgH02A3Oq0JI8LtaNx349X1GsYg0VM4gi1KGuFrG1sQgnKQNRcKPIRlDn8Mf_fdFgtv_p9TuOIwM41a7Nom_pT1yLOZXODWmrpop0N0N0nBU3rw_p3M26DKaAQ5PjjgW0CGCfPd5G1TmbZDDVh_p_pvhJndjxk1sSUEnRre6vYG1PWjd5AFHJVLVsaSpq7PuI0Nw2BDZYFmn0z_pc8PBeEcsAdW_f9U2nnMuc3oWkIGUrZ18_fbrpFAZmkyFJL865SzjpNvzMw3x4ROV76Hn8T09SduGhc_pXImj1yFdsZ0PeBZwhDpxsC2yYcXCSGjExiqvUz9HfEVPrzoRA60mDzLk_ped8HYzlIxVLLuX0XcLeM8bPnUHIUSBHWxOaIZkGFsQ4kUfqEgykBmtv_fSNzck_poxcZPMyrUymNWk_fzxr6dLfPhTYiPuxm_pRUN8PbvE2tPuCpAnqsuy_p0WeyVE5B2fZOYVtrp3FSTBAz_f2Clvz60AQ_peYvw5HzCSYz2Qb04kqTnQKzVX6hB33nFvBynjQOp_pIcMVEH340LpInLu5K5IUpT_pzy73_pkS6jXRq657JMMm7YSxiLbjK88gWUykvPKBWt0la_f0YNcBGsbwIDEnCO7iPFgx_pJsOkCzh5aJgUMyedthQp_fzeC26Mf_fxlmbKcMSzPUMUCwcofyFC50kF9W8sI_p5RIwazMIE6vXPbSTlqeejAUON59EVc1v3iFbCGoWNyfUF_fcH1O9pzYcRGQbZYERn87Zmh896EKJckqYFN_fuMovV6c5Zg5ApnJ_fiFZWXy8QcGIFSaXoBf1bHTORrSQEq_fHRFa_fuXrWT0dQEh73iRnUoTXjRUMO1Rs460M_fWUpYk7elyW77TcrVdIQ3Qrg3ERxxDmrGTLc49zln1HM7dZ7KnR4PsV4lea82_pbivsytQxG_fCtPtpabTYHc_fy_pY660TbDC6VXVirfPIZIFyZzyK3b6O3OW0nHp4PXKj9DegLAkAadbRd9rGggeIx6Vqa8Byxklrn3bt8nMBsEesxX0Bz9g3fjWdmtE80XXNgQ4wR9CsYn9qapdxOkNKiJdcJkq_pYaedB2BzEJRi_paZPizW5LhDn7G_fbNT6cMAJpccCrNcPpx2ZkCguEsuPK72aBanVxPtTKzQuy90bfn0w3Zp4NAp32Je_pxGNolsaThhDRDXK59eu_fhST3VY5trLRkVc3W0GpzdxZCD_pWIz8ijE1nOKz28Aw4vhhgeKBrY4FdldLg",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T08:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": "United Express/Republic Airlines",
					"departureDateTime": "2018-08-23T06:38:00",
					"flightNumber": "7431",
					"aircraft": "Embraer E175",
					"aircraftType": "Jet",
					"flightDuration": "2h 37m",
					"layoverDuration": "3h 5m",
					"layoverNoteValues": null,
					"totalTripDuration": "18h 42m",
					"arrivalTime": "8:15am",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:38am",
					"departureDay": "2018-08-23",
					"destination": "ORD",
					"destinationAirportName": "O'Hare Intl Airport",
					"destinationAirportCity": "Chicago",
					"destinationAirportState": "IL",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-24T14:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T11:20:00",
					"flightNumber": "11",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "13h ",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "18h 42m",
					"arrivalTime": "2:20pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "11:20am",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ORD",
					"originAirportName": "O'Hare Intl Airport",
					"originAirportCity": "Chicago",
					"originAirportState": "IL",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "ANA All Nippon Airways",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:20pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "6:38am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "18h 42m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_/P)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T14:35:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T18:25:00",
			"destination": "NRT",
			"downPayment": 1687.85,
			"id": "24e3e6ac-1a34-46c5-b36b-8b25ffd09440",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_paoVF2DUdo0sPZKTUt_pz5DtdjIrfFiwpEFp_pfYeO3xh2VqORxwelaFDU5xeGfdYIJIWRTlWZbROqT_pjFCqnKmbNt3Lfn6Qhs67bdYnHQsVMvTtTs68j0ZxTQU4GciAXECNfl6LP3iWol3s17bJeuzoEOyqae9eR_pgKodTIfXKRUeOXu8OzgXZiEsMrqnV6t_f9u7QjVcJMkWIvMrn16sUzcoUfde_fIxg6du_fDZJOizQvLimgdSZ0Qe4V3srhKV1gVFwTUvdQJHqZD4mP0AWg_fBHrOp_pJFhPS3tJrfTly4WxdTOwKF2QA8YwfHjpr6574WMZpMAYlmHj1qHnPj0hpsoq_fJcnxIZVNe_pJ_fuPXHnSm0W47Kj8mGwkCnFh2NUeULUHv5lwPHRnZZwSQSKjKt4rwPRc3NclicMBFmhCeVYSSThRKZuxveWGcRODvuutwhelqCXnSL1T8eZfXYWOra3ymFGnCbnsxIqpQFI_p49DUSovrXc_fSP3j8_prbGtxBDad6VJcOXRI8DvdpmUtSps3yl8PNaGgIkhD7vvfzKbFCxVFOUU74WgqFSm8Dt6NQOqa7MoX7ZlWzO2lgmZArfz6Vs_fYnsTKISfWouMoD867hptUd9gUu_fIyeWr9u_pgEZryypH4KmEK_pSrdKmemGWfnS_pMV_fDS_phaUIqPFHrQCWw0rJZC02M2VUZtNQbV673yt2mP3SNCvDz9utUIXDEleJWtDml2Q8_pTHChnZM7cSuuiOLkIGRJazypvkmJQrtWAs3Fz_fMk54ktEu3462f6jA3xaUN0wUf2B8SCZypCPkOw_pDBV_psAaLerkYQ_f6kS3KYW_fcEvxiA9Nuw10RDPhkG1AkCT7gDtY0p3B7xhchhr0w5TwFYfER5ArYqpD_phPbioC_pLRbI_poysD464nBamj0heiMbOaNSjzbqJeEj_fQ2th2betoBogZ844MKRy9M5XAHwZ7JeF_f162FXq_f8sstJEwOL_pPZRLU42Xo2Zfwt2c11he1A1n0ysGOEUFNjuuRm3kVA2XNDCiyR_pMN3qtUNBBzjlD7qnt7QdSHej6PX28hf_fXPYgbnqpBMTwsIhnHM3YGoUrGDE_fe2R5vUzV6RdtEu7JZpBTF3S0WlyzDIa_fTSmCQkIcDykZJn4tKa2zGuzrIcNcInRdHSNle4xEhPpZ6eFiksyxZBMgZSAraOOvqvzvum3_f8DiVEqeWWH4ojUFlB36GgOT_fXj0JpqhYMFLXvZkE8zT0MWEBMBjumcKeoH7tMTIRDkaZqigD_pxhqGYY3oXR7iX_pirhiyRgy7GQlCpc7AZxGdxepVDvJXNGpXpAEUjKBAUgoHroKR2aYkauzPsfVWyuwGSJ4cShIJ3w9TPkJU3hgg6UmZKDCqCe63zbRXysXKA3GPm8KhbkrwgKjZozD2F5qV7NsqQlEyHO4P1LBuTHqrglPqUFEJ1WB8OCqQgaRZhucWNfwxhodCrOpspdcAJZMZZ_pH_fMu3hS0UIRwaInUf2oQTY9SWr5a4ebeGgFZRt9gkNwU8veABNNvKehPm_pXqqQZ766cTAS3nasP0ixPNhhR2ECcjJV3wJaGSrYT4gtUtgvcj4FKhySW2dTW_fFsTwNOy3bkxHcDYfUFoAvB2tL89K90WuhHvK8QYYb4lQcXx3OGFFI9WAGs89MoUd5W66e7Xalx9suAh1nQJGqA_pC_prXN_pjOiA1heRugy8OlTv6tB2GF0qSkRTKQ5f7ZvjsohYIOXT60zRKT1Z0Ho7_p1AH_poqO9ZTnVf3vvj_fN9KwHs4h8NQPV9vWKXImczHABZlGHorxPa8GYYBAianxbb_fGJN9V1tCIJehHmMJ5H_fBQ7Bf2PDs9QP49XrZxkTx4iyTS03HNbfEXa_fOluBhNioFF67C6eS8lEDTZcqQvJ_pODcAZ_pJE_fV5VRZpntMeg07T_fr9qG3EfiLMvqOdVB7Yi5aqmfo_fiGxOoqQFgnWLQ5S4eN_pyawhCBab1DJGQndJ3X0HE1DQe8cKCcdl8hBzP2lWxmIUC7iCSTwDCfFW8d0QvQFOWM7CkRBlrsM9ElkIYKnxdrja6DqH_fGqsgDCBORppLMz_fiVEezhZDYHNXiYhNN0nWu48Tgw2k0gLzdmZeP_pLfg5nrX6NfMrd4qaxmiScB8E9US_pBw9IhiGbtdrDO4ujs_pOBVpMUbtfsrblIWnIbH7qQvk_pXVL4c_pQFLCdXy6uM7rdIxSbDwV9m_fu6NAScLzHl_pZENoUWGUwVkgSkOiMZOx_fCkDJnsL57uRymXFTHJwTH6KkrHSGUk0sRXUXsDEm_p9Ox7YdaN8ShhYmBkp9qr6CH_fDSZw",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T21:25:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/KE.png",
					"carrierCode": "KE",
					"carrierName": "Korean Air",
					"operatingAirlineName": "Delta Connection/Endeavor Airlines",
					"departureDateTime": "2018-08-23T18:25:00",
					"flightNumber": "3794",
					"aircraft": "Canadair Regional Jet 900",
					"aircraftType": "Jet",
					"flightDuration": "3h ",
					"layoverDuration": "14h 24m",
					"layoverNoteValues": [
						"Overnight Connection at Hartsfield-Jackson Atlanta Intl Airport (ATL)."
					],
					"totalTripDuration": "1d 7h 10m",
					"arrivalTime": "9:25pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "6:25pm",
					"departureDay": "2018-08-23",
					"destination": "ATL",
					"destinationAirportName": "Hartsfield-Jackson Atlanta Intl Airport",
					"destinationAirportCity": "Atlanta",
					"destinationAirportState": "GA",
					"destinationAirportCountry": "United States",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T14:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/KE.png",
					"carrierCode": "KE",
					"carrierName": "Korean Air",
					"operatingAirlineName": "Delta Air Lines",
					"departureDateTime": "2018-08-24T11:49:00",
					"flightNumber": "5094",
					"aircraft": "Boeing 777-200LR",
					"aircraftType": "Jet",
					"flightDuration": "13h 46m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 7h 10m",
					"arrivalTime": "2:35pm",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:49am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ATL",
					"originAirportName": "Hartsfield-Jackson Atlanta Intl Airport",
					"originAirportCity": "Atlanta",
					"originAirportState": "GA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Korean Air",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/KE.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "2:35pm",
				"arrivalDay": "2018-08-25",
				"departureTime": "6:25pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 7h 10m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AM)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T06:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T09:01:00",
			"destination": "NRT",
			"downPayment": 2929.13,
			"id": "b691abfe-1284-4055-a559-bab550fbff27",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_paBnBb13TVWXCG_prv2IgGWjb2Fy5tolA6JmiAdJKfEsfA2PAQxoTd18MV76XMz8bDmqsonr2Ggu0RRmVnIfsJd46omsPRwxP6y5zXSf4XjAtxtZ1SrbbZEjKCzLWzCFwgoJKawytXRBdNWfBR9bcsI2haBE_f3LuQsip_fsw5OlYoJauOQWYKj3Ae5DYkMYDIBSovreISaT_p4cTJKY5Ygg7s0qYSSVSmsJU9wp_pMudOWQSWDnw3pK8_p_p9l7JsjJYQ1EdtZgn9ETvZe8jL29mmyiIOV5tIMtNq_f7FY7UqVF3txofpf2VOKZHfTC1K9r01Tpju0NUNOEL8hOfD2_fyrURG20_p68V5hxdBxjYaN7EwadSlLXHIC67dymgMrbJsXToADQ4Xnmeg1_pw_fr126aV9g6mpa4QGP0PvLzCQHnDWbIv8RXVwCYKHu6_pQ84am0Pz1rQQVZyMKYze4w2ylkzy7SzrXULiCHeHhFMkA9KVY2UQ4nSne_pMfCC7aqE3MnyQWLzYyFKlH9cZ3dyvVQ7k9JJdhykiwuHMeXHT42KmbuZ_fN_p1Bxr3VaG0TgRvEmOZyWCzM8E_fF0L_pnsYjOqlofgzY2FjUEhQocrXA5nbgbPbvInL3EdtaGGIVXoybmDhXexdBINNZn61Ir64_fYIfxZyYgeFomwUAOoa80DBtJQM_pTG2uYXgjrZ_fw6I2LHOzf5gAqlnTRSrL_f3p1ompxTNfHiRUVYVUhaLcN15sHOExuZi9G2_f09dwVzIwS13J43rkkd0B8CIIemVJWh40IoD_pwnGC75lHIrVOhzR1fKWVfOebtMacKU9LkcZBPsJ_p4AMDhV1kzfW2O2EV7RQgzwL9wdguLMh92io3m_pMOx2rp0jtaoJ0GFa7NV6bt55uNoVxWmaCsBX9Sfo1UhqsJREUevOQ5ITx9w35TYgIqyeNUbN8N0H_fnBXYJrseBJ5GDta8cnnTaU3dO0s57tgfp1UIqeLfMbBL43xLCUDRiW6XO_fL6H1QOFa63iEawvtMeM25cK_f_puNLB5b13c74w822STSZ2VODVKYXBRUU7HKUHcPkrkDRN8QlsoNR76YwCEAu8cBIQa3UlWZKV9_p1f6B2cNd890V9hRM6vhYKZWWSkkQVWabfRFBWuJDkDuDWqb_pinUXAkBLodOwjGN3o2EaY8SnWndBiQNqzVTsWfmHubrM7i1g3WGPVLNxuq8mzuvYfkBAKY5ThHuEZCxpd3bfDmnvhg80avYbdJXhUscMHeSXOey_pbK3Pk_p1sgV4EtgXQPJ_pD4hleajHQ9xKsa7e44Dv_pHexGq_pgkJEVqAFXJ_fbn3sDW5EADbMKZ0UJ0ThhB_fpr88w0F4G2Mam5T1loVBVy_fa2VG_fy7nz0iGLzPNbtFJYdSNuOyPD_pku0V0AU6jJ_f7UPp_pkS7pb0m8PEVlptWgmUfKnA_fUBN9LxYBWbUsqMRufrEvT90YDEmjoZYzReDPGrtjFypBSEqasWAGaNNKI3WwO67TswB5WN2jJMoXSCnuC_f0G1AQsJarZJstCosKFQkMFs8lqRw4nVlPlVfRevV1Bz1e1rH8mhgbSJO_p3CX2hIvXLeBprf3xXraVNC9SXTX3fcCKL_fXMR5wRwtLXRQP12t63e5YA5FqIuFzvc96SJXGSHjpmtcy_p9A4BrAB3qXE949KxaOi0ebbgdPI0BnheFK0rPM_fT1r9nw0XOc1We0L4euV7XhKelYZEUUe8DwuvXhw9SfFAfEwBTGhpKTCtirkFxShuCS7FVPC7PfVyJUTGfxXx2zZDUGJJRaHZ4YF2GmpQXFlYgvUIQ9tycL_fm4MLNXIgEXPsJ_p_pFvoQhg0nItjRKmDB8L0NIQr2w7f7CYEGqoDIxbBvIjIbc_pt09202_pwoUgdFitajJ7GHhFNk3hIV6EEECskAq6SJG7QgrW7SlXaYxhl86J_fABJFSTdCBhPRqNuUTWSZR9HRoU86rzxHvneyfmQI7iNkhtnLGlQ_fdEdSF81RVEkj7FmW_fDXZSSid50_pmcs103am8ejqkPC_pYirhha2m7BHxN7M71hILhmZSQd7FHxtLKxZK41T5bZgrjIH29SHxp6ufcE13Zp0BjDbxivhPlHx5leXxAStLruGlmg_p7_fsnOg4aYWYGrP0OLioxyqbGqmnnvJvwau9_fsGmyKOaTV_f79MxsgyOqMwfr96lqp3XZY7TeAzwmiABbtb34bv6eQ6cS5bjYEYFcz7DDoj5OvMNzodm9xs_pyjrstckqLVqt1eTsDissZwAvt2zvWwoOnvtdLGOhaENXyTLU9ZgHnd8_fCYsGpyuy3xHKBSyWYk1EBzTLA",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-23T13:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AM.png",
					"carrierCode": "AM",
					"carrierName": "Aeromexico",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T09:01:00",
					"flightNumber": "681",
					"aircraft": "Boeing 737-800",
					"aircraftType": "Jet",
					"flightDuration": "5h 34m",
					"layoverDuration": "12h 20m",
					"layoverNoteValues": [
						"Overnight Connection at Benito JuÃ¡rez Intl Airport (MEX)."
					],
					"totalTripDuration": "1d 8h 19m",
					"arrivalTime": "1:35pm",
					"arrivalDay": "2018-08-23",
					"departureTime": "9:01am",
					"departureDay": "2018-08-23",
					"destination": "MEX",
					"destinationAirportName": "Benito JuÃ¡rez Intl Airport",
					"destinationAirportCity": "Mexico City",
					"destinationAirportState": null,
					"destinationAirportCountry": "Mexico",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T06:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AM.png",
					"carrierCode": "AM",
					"carrierName": "Aeromexico",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T01:55:00",
					"flightNumber": "58",
					"aircraft": "Boeing 787-8",
					"aircraftType": "Jet",
					"flightDuration": "14h 25m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 8h 19m",
					"arrivalTime": "6:20am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:55am",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "MEX",
					"originAirportName": "Benito JuÃ¡rez Intl Airport",
					"originAirportCity": "Mexico City",
					"originAirportState": null,
					"originAirportCountry": "Mexico"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Aeromexico",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AM.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "6:20am",
				"arrivalDay": "2018-08-25",
				"departureTime": "9:01am",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 8h 19m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AM)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-26T06:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T23:10:00",
			"destination": "NRT",
			"downPayment": 2929.13,
			"id": "53a3e961-2d40-4a87-898e-efcae76292c9",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pWNs6j9d_p8Bzaoz35CNHGbR_ftmCsMkchOdCAP2FA5Vz2RgI98NbBXo4jLBjbW4i6XuHLc3BoAyP74dUfV2kzQWnEuagZxDHKkf0awUK3SDOmBdq0bgvWVvr2RoZGbGpLfK2Gmf3ofsfS56J40jYkKOYmDFtNPLi_pnUCewVQyHteY4MV_fU6qFg9ff3IH_fPdJaDbMO4jlpV6JV3d1Lgs_pdH9syYAoBLsAVZp2UR8QPa9oD6_pufN14AvK0XyY2XX3fX3jJceJKRWZZpYXXBWiE3uIhmmSUR_p6CvmPA2qa2yxIJS78KPP3dXZHL1aoEwQ0zEcbBzlmtfCZYBKkmg_f_f_f7oU_fM_p76tY5JGzFruI8VECjtG0msdrPBAMMzu3c5PkRaXkVdobXSJsSLfXHd2cao6RPotKKsTdNK8QLEc27b1SbUBlP_f7QoGPP_fBtlROUiLQFUJ7My6Q6xItIodluncQxY0JZDQ2k6s_f9_fwffLGYaLmiljyBGRISY9LCSGQ58pLJ7tVCKzzKJHTEzSpaLkCrD51ttR_f_fIlZYaLft_fuj5gfxYRpM6Dd89K8_p87BzZt_pAGdwm7oPLIa4iOq0vJ5FUY11nWbVX60XmwlDwrnEAWWPAtnEtLVRWfWlJOAKa2FKKchCmgjW_pUwLleWLY9UnjJppL97DkQXD7r2AxUhC6d1MoWzO8Yv3r0sriONigpkQX5CqtzV0_fndfTqI2s1fiMjt_pOvc6OeSd4PKeGgA5RCflNi6mYJNwVhKBiPqLkKWSRcMbl7BJrSmN59sk5LO0bijBq0D5z09GTPlGqC7q_p5cY0e0x12o8weMWv0AqAu_pGT1sqICSic_pPRnH_fnLcHdGtJu9XdfzRYWM0va0taNtV2ON9hRJY_fecPzHavOu_p2Zd47qCV2LAAudrph5Wyup3c0c0EojY0v_fMQu7H62TverC6iCQ6Q76XF9EoBTJx_p6_fWH7OHO8QAm_fukTaiR3ULcYYjiB16Vzp4OsK7U6F7J2kLE41blkYb9_p37khOkcOsPwp5pdReil8TdwRFBrPzSI7agw_f2HYSvLOJSCkkxEB1OWcCXX4kcwCQ6_fxrgQ5jEho68igjTciGldd0RVgF_fnXn3JE8lxohfH9Mlx1EpBjgB4UMUlwG7VZeSBp_fx7qnj42JDMqHy_pVyYpP7xkengCcU4dsjhduiGrpbMWRT6PhiAw6qfUwdGGPSbDMPsxi9CWv7kpEDmKEoBkYTA5xGS08DZoM49syYZD_fuKVrCuqegUqwjDFR8lWqvnNM_fMhC6Q6TEDqAyj6j33FkubW5L3MLvor9TjrA_ffRH1rVW6L_pUZlXEFEsIFcv8ZPxIUwZYv8ycxPilW_peJ8thGOaf5K8C9pKKL0ow_pLg569oGGOS3CvKSGp3Wed2a8vrzKXGNUbtFe6Za1fpaZ3uU2X6bLm_pQIUfQOSXwdJyN6Hv_pK7mmpk689zJAXhpvwf8AJ85pOEw_fsGR778f3l6aEh7a3kFUh0wIVcC6Pq9oLfT9FOg_fkK33_pf63smtCqyr3v2Aw5LV_fHZZGvOeS6KJxhkWpJhS2a2R9vwAERrJWqBx4mPlp82acwNS6he2YvsaWJr2CSXXX7MPAoLfAoR08F_pEqIXx25_peGeI4pH3m9jONTThOfcGejx9dOTfMhk0a2GU4usDaePppOtxyLSD7oTfhvn0HlyjF_piJ9HmZje7cDq34dA4lxScrV2F4nrCQm4zFqI1qtWe0YNWY5B4650JYxrSBm90B2xunTUeGSsbsDAuNRaNgvrZ95yq1Ls1Fzas_faz8Wvgj1svlH4QlJOpQ_funhzjBeWQp69ZebYCmCv_f1RhmBtmFp2AEFzINv1DSZPL28RIO_pFsYfb_pk_foP_fc5FVMTVfbkdhSPnjNVoC0a2KpMT0hYFTuTSacHBbEnLqg3toH3jNTbFF5CewO5ad9qcW5z321s4RjuQPDRvKGGe7DuhCa8WsrVqhChxMhXAvjHEeMKk5_fWMFpgTQJEFrsvCAEYEviYqD5OdFrR4T0SmwrC_fohRxxVYzYrFbMBJqXsw3rCFGOt2ynMtmvFY2u3QAdu12jH4nyKAGvhYXz9fWmNPrILuvuOuT3YJ8wiP_fswCFxB4XMpzblBOvaQEoOGf0Y9yBK3Kokw0sN1l0mqtx7K1xW26A_fGAx5o40tao25AjH0CdJwsVbQPogi2MfdtQQ_pJxORmYLCZUrz_pBL57s2gVDaAz5ryxGjlOLY1dQaFEff8rx7ZTeaRVxRHizrdizEcVSiOabT0lRjTrwvx1q_f_fz75NySDejXyxa8gMswcekjUprEw0laxKHAqX6IW_fM",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-24T03:45:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AM.png",
					"carrierCode": "AM",
					"carrierName": "Aeromexico",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T23:10:00",
					"flightNumber": "637",
					"aircraft": "Boeing 737-800",
					"aircraftType": "Jet",
					"flightDuration": "5h 35m",
					"layoverDuration": "22h 10m",
					"layoverNoteValues": [
						"Flight arrives on the next day.",
						"Overnight Connection at Benito JuÃ¡rez Intl Airport (MEX)."
					],
					"totalTripDuration": "1d 18h 10m",
					"arrivalTime": "3:45am",
					"arrivalDay": "2018-08-24",
					"departureTime": "11:10pm",
					"departureDay": "2018-08-23",
					"destination": "MEX",
					"destinationAirportName": "Benito JuÃ¡rez Intl Airport",
					"destinationAirportCity": "Mexico City",
					"destinationAirportState": null,
					"destinationAirportCountry": "Mexico",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-26T06:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AM.png",
					"carrierCode": "AM",
					"carrierName": "Aeromexico",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-25T01:55:00",
					"flightNumber": "58",
					"aircraft": "Boeing 787-8",
					"aircraftType": "Jet",
					"flightDuration": "14h 25m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 18h 10m",
					"arrivalTime": "6:20am",
					"arrivalDay": "2018-08-26",
					"departureTime": "1:55am",
					"departureDay": "2018-08-25",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "MEX",
					"originAirportName": "Benito JuÃ¡rez Intl Airport",
					"originAirportCity": "Mexico City",
					"originAirportState": null,
					"originAirportCountry": "Mexico"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Aeromexico",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/AM.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "6:20am",
				"arrivalDay": "2018-08-26",
				"departureTime": "11:10pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 18h 10m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_BA)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T07:10:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T21:35:00",
			"destination": "HND",
			"downPayment": 3528.65,
			"id": "e4cc16af-7fd3-49d1-8da5-0444b0cef014",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pSaAfM0wYgKTuvLRUBZikVpyLsa6N2O4Exc4jU5t8Of0vXkrgCKyFItaJwrvtWncXwwrYavP33wUbk3mYwQcyIpRRDP81G4PMWa2lGX7l_f_pqxOiYTtUAiuxWsztQeRAKpNtBwQnvmH5qFFF_flMKWde7x5GJW2_fVvuFkDTkByMxbJnXBhoqJzW5aYJuBlhJETWZZ5AamQJUD0vHluno86u8lpQ0MeVutXKI7ZDFsI6JtfdCU1EOkyIuZdK8BQ5_fdcPCvKcJZZMynGZJ66ngPDUlPckbD2Cx98wsvHTcVKPPDOEOnX_fY0aVNejLPd6lqCkxzRTdauPklfWOZLZhDqNPjT7bfElpcJVCVEa8vu5Lv5DlkEx4J7Ej6EVswLTwXgoKxjMi6aTWmUKWpbU6h1RyyLlfxOqUB7zfz2OxbqtaXprlJ7D2rQ40VqYeD7cKz8y3GVpdr6Fa8nFljqeLqFLdaDBG3kBjBOix9erk9DSFQLi3L97qkb5V1T5B_fDbxnnlRucfR3fyM35Hiz7KpqFjQPaKAQWjsOS2_fQsYjpedHtn7FPB_p8qyc27c0xQWLCEqYO2rE3O0nWTLXbDd8IAq9EFxIWVuQLCIjH2Yxa7sCPnBjljRH70128YpOlS_pJ6m3M_py0EjsWW74fxpmxcr03yFHnn5MuUfo5tvMPPBHWsQ4nnvlfPSjaC0dukbAOvlvUWRPhPRE70OIWSfMDeQyMUTgf1DYqyHo5ZXE1f53ROBbqTBPPc5keU4SC3_fZ_pXCM4GmK_pfz_p3yQRcBe5BCLGCs2BEdouUo_pkq28CpKWNNk_fyejOtfwDb_fp4nZLVAEOmtP9fDuBWLhVBeZQUK5dk0e8ZuWSPy42Yu92MdvZlDRdCO24eJOkJaH8pphaGTZS73r2MjjlQblMXyZQ6fRroleJRvVsDR9f3jKNODMb2CFHsinzcxb8vD7Vq5x8wJQ8oA8IkXq8F2KoJspUtZ0mEo2H3V_pozuPjyq4auVbMYwXSZgqJU8wiBtJval5udfPVTDoyCc2biballJ21jZQv_peddZlWA4Nhsqhyo46nlozgdlWGBf7QBPsUDI6dGOaVyWiS_fj7tZUD8hVtJiJHqTBW5adkTGuCYi39Z6NevcJkZyNwkuByqHT4UsYmNlqlf0l6d27kKQwKFOlQkegEQZ1_fA274NR_pueawhCwJtj36qX_ppW6W6u9b5wr7fKv4wnSl8aHhcoyeO4UuMRBt4xKIxJ5VURBOIp4hKTO_pTMx4ZfJBd5IM4KokIVBqnrDqjuJfjapwg0mdrr3CFKnhbohWGeidbeh5cF5zODyGhClimm2xuZnsVtTS7WJ18KPVGEsWvwls5YkiUU8mTeySED4QwCs4mO6v8ZPxR2fIZSSlrfLttivjvv_f0ASQQOOezLj6Oo_pu4Qqw7xFPrCCJkmGPwQEoC_peejuttFJ8_pKcluC04jzTj4zEd0ylbbsnHoG_pwFFGx_fT0FouMGpP85XioysOC18nzjtp1nR_fgzRzVf6k3_p1zoHWYBP7gsHe8rtR4FmVtc8qhcdTvdLwoKZDM_fAxrUTRbUTQrklIWWC_ploFXvc468236Sborct_pnxdCHDYjP56dpeMH7hvYwrgjeFJVpRlRHRnN6mhqHCBEUpEJ3joDQi37ZYkDORPgx9Vqqg9tIrEytsKPU1RKEzS1QGCT4NPk_pdqylN6hXZUW8EPSKYIRYaHTh0w5_pHn00AJQugLJtojO8xdNTZU2SUGRk0JPLS1iRKclx981XUYB9iY1h2V9OmFqjquADvfnDUqFNOw_fKdnKHe96m0uN0w0LmSrPF0RlGOimqPgLot5sZyUn8a1sFHlcKnz4iC5OnKlch9OOXXb3XU9Srx0kZnb_psNceFIs7ANdOgz8wvgakXbUNHYkY1_phHzekGzwm_f_puHanq7zFnKd3A197hP9aFak_pM2dZYvSiDLOkfvpRZBup3L9ZvdbUc310E4HXSI_fp_fBJuc8UUQamToVOKSBQsDnkstHTSWs97NquYqYtVwbdeAh9XuTzkFZ2PER6DtTCRK1DMPygXYxUydRyFFVb0yeuWty_f1t96Js38OgobMjUOxAdfguPNb8yNN31lCw_f2r0jbKVwOqdkKE_fW_f9m7D1ZpRXmSdhGXZl50FeHMczmRQ_fOsiGstYOckGmcc6E4Sa_pmcur_p_fJKtenhTgzBesr3nWeFcZgu336JfqibZhAJzNHfzI2Uxft9vlXUG7HkIBlFFxR1gipob8amn_p1Jjf8aErb1ngkP50wDG54cnZ2LZhcSt_fKFnEpwmzUgxV7Yyou21UScqRmiJrCvYjh4nZxU",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-24T09:10:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BA.png",
					"carrierCode": "BA",
					"carrierName": "British Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T21:35:00",
					"flightNumber": "94",
					"aircraft": "Boeing 787-8",
					"aircraftType": "Jet",
					"flightDuration": "6h 35m",
					"layoverDuration": "2h 30m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 35m",
					"arrivalTime": "9:10am",
					"arrivalDay": "2018-08-24",
					"departureTime": "9:35pm",
					"departureDay": "2018-08-23",
					"destination": "LHR",
					"destinationAirportName": "Heathrow Airport",
					"destinationAirportCity": "London",
					"destinationAirportState": null,
					"destinationAirportCountry": "United Kingdom",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T07:10:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BA.png",
					"carrierCode": "BA",
					"carrierName": "British Airways",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T11:40:00",
					"flightNumber": "7",
					"aircraft": "Boeing 777",
					"aircraftType": "Jet",
					"flightDuration": "11h 30m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "20h 35m",
					"arrivalTime": "7:10am",
					"arrivalDay": "2018-08-25",
					"departureTime": "11:40am",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "LHR",
					"originAirportName": "Heathrow Airport",
					"originAirportCity": "London",
					"originAirportState": null,
					"originAirportCountry": "United Kingdom"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "British Airways",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/BA.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "7:10am",
				"arrivalDay": "2018-08-25",
				"departureTime": "9:35pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "20h 35m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AC)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-24T15:50:00",
			"numOfStops": 0,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T13:55:00",
			"destination": "NRT",
			"downPayment": 3678.38,
			"id": "5948e351-ac81-4b90-a2a8-7618b498cce5",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBkAZv_pT45EKt99bb5waP9UQS1Ng2lbo82mGELiNoOjWeZeLXEdKbBDHh7dXlMO3_f3bBsINvbPGaGNR4jkJZ0fnVdPdapHinvj1BezG4jokY_fbdG4_pmwByFt1qqHjIDtY_fW_ph3NWdqY4dLONBMtQ72RzPkArvtlLETkF_pXThmdIA6gZ1_p_pjX5uSAdipzhB_pZFEVtfTBrDXFUS3JFNhj4IE8QDGzLJBscyM_fW7y5aDL0tOTSfrmmNnHaBFwAZzkcEOWFp53Cw_fxH_pfVAG3lzn5wxVoWh0ZfWH_pRrxUiVjIamG1xvupCPwXvOY_f4qBjxkxkUhlmL4tMaH6PmwhHFjq7osenv8aOEW_fV9BBfTiuSUCBkysnYZv8TgzNRmMMdo8T1eiKbmPLbdw6rmXwnM7_pn6uTQRr_ppqRRFyLJ7ixTOf3eynY4zYOVgneGnAtEotN6NVHKIffDOb0Jm2KSWm4K6fKPBv7D2iveirpju4qKO4muCcMEP7XwGZw_fkAzX1IEfFkLdcvDQ0mhTNF4iD5Lb8dB6fwVG7X4UezHh1LnKdz3YpjEQlOLkZejjTlNltHjLssJI0WzheMnR7_fcimQc_fAMdKiRLAwpqKa83P56OvGTWGN8f3uXK_feaPZvhkPpuu_ftD6o6eV8mWgwE6B1L9Ahfxd5gNxjz8KPE_pFIRV6aI3i4Q8Zro8mVsNKwywqQf5rUKeJ2uQRP12HqXiZEcduM9DJjTBO6nIqTfQTZb35RmPN5yRZJzfhUuGbQMgrRWqLfOzxE9mEVVxsJXJ3pVXfcz2_fpLsHicwtMOmzAoWdJq3bIe7onAaZKVC3RdD8ewOYmDxBUKPMidRdpqMj4uZwoJ8maBOiHYqy9S1QEOCU2CFljKui8isBkU9hQ8PKGxZkZz0ncXlvKRoGLbNedNPD0RdesZP3seyi7lxzez6v7D09a5uwG7BYqywR8MxuviTi9re4Z_fwbNv82_fplF_p1u6au_pCYQC9sPLRruPRmTWOPJgGkz1Lp7lOu_fy15XDZbo63mIItEClJiYXuN_pn0QlUX1dhn6AcUUNfqKR77QLOXfK8GuJJQJItFV_pW75sYu3tarNcal_fKZ0bi1nyBYy6gczRukHyUlu2op0LmxYd5hW5zF_paWWHM523nPZY3POXyPgMKbEMrqdGrjMu7BmUeCyN6O2QZ_fbBKKfx7ZuxoGrjdP_phZQcsZRgd8yC3lvpr7295N6V97wHEDfeFt97mLYoIsQ8lit6E0kCzZt_pGGlsqG89_pVnv5z_fDUDqi2AQVmSLXAbWGmQWRAD0HVeBUULTtVcbu2nZYxYq59jitlAgwslintwfwiMZnVfRAMf8iQVibHEzPw9U4WkdH8T0WkZ79O3b15Bu1FXShg2IslGA_fAK24pQrtblXX8oR5AJmXWFISkrZ_pCPizgGCaqNF6F63FUxbG9r2jFdV4g_fv7fLemWrlaCAINShp5X8MGgnv46To_fjGZE81HvX4O6vY9eMC3LG6CUyZ9BEK_fDvm4iRBOS1lHIShzLkudPUEZc1Ol0lyYFdVec35Vb22t4mDp4ZKxVIoj9O548KlVtvrVi_psg37aWzu86KTBpq78NgMy8DasJfj2t8fAqaUe9_ptAyphjT6XunjQnP0EEvIDTXWP8R72ichBhFML87CjsbVkk5_p1NWhsNit5J_pmcBdLFPC6CLTk9_f7ouT_fNJt2qwsmFAJcil0gkWxnXTCmNFVMJ1hx1RgR_phrt27XpTPLM_fJ7xek1qRFR2VIv4BSRtnKu8yweAp8fRKRCs8FS3AvlqoH0N79R8YI8C534TcwVXX7jBgU_pHkzpJbE6o5kUR0WbANv3CqYbzigTjGf6ULH7tcoMayNtQSmi6aL8IT_pP3ZIFfq2IZqHIeqggQow_pISa6A590rXNbxVII9XcMXF3jmPMfcea4hKtRT4uykWjZNI4UxqCdEDc_pJ7l0_fUdhmTsuKJKzoF_fdpNXUlIvUATbd8J_pqepp_pwNE94e2e0S7IyRDLy9p4fpnf2brJi7fOK3mKqdExa4p6wdk6fpUhpSrDNjy3GNvuThekR6ZRDyHJ1GoiP7ghrjkUXpAs_fDwysnKwF2W_fHdM46TP00K7Yyr_fXVvSK09c8DhxNwI3LAVPJeTd1za77sTXSrPML6wxjn_p8CLcwLd_pVVprc52Xf7mu9pavJ8bgQ_fPD_pOBUNm0o_fWxrBo9zOt0XCgRLT_pOZoY_fsDm1GECF39Q93Whw2yvJy2VHrIu3zmn8oxhMyfi_fEpnkUUOI",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-24T15:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
					"carrierCode": "NH",
					"carrierName": "ANA All Nippon Airways",
					"operatingAirlineName": "Air Canada",
					"departureDateTime": "2018-08-23T13:55:00",
					"flightNumber": "6827",
					"aircraft": "Boeing 787-8",
					"aircraftType": "Jet",
					"flightDuration": "12h 55m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "12h 55m",
					"arrivalTime": "3:50pm",
					"arrivalDay": "2018-08-24",
					"departureTime": "1:55pm",
					"departureDay": "2018-08-23",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "ANA All Nippon Airways",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/NH.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 0,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "3:50pm",
				"arrivalDay": "2018-08-24",
				"departureTime": "1:55pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "12h 55m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_LX)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T07:50:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T16:50:00",
			"destination": "NRT",
			"downPayment": 6550.58,
			"id": "8a482672-e0bf-4a08-a503-e5f422c7dd44",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pZTpCKcVu01ulupswx_fMLq4BG7E_flWB_fJlZIFxxJFJb2wqVJ4z94n1enDAcUmAT_fU_fwKQLvCXfjgGxSwheZlAlAjkstGhn9mW0GM_fATczIaGmh26K4U7dsBIuKwLQorkf3daKmM2ESTNgceB0wdbe8YrD51qyJLeHWbS_fSIBlbOwXtwzd4Z67bdBYYIQmQM8yg7BoOCnUBEsEJnHvhYcNQ48_fOo2_puJ9mCjrs755jB_floM8F9DbUwvAx9hw3xxcGCXiqoJuLDQPXBAQuO3amuNsfL0r6H9AoDdQT3TPOt8yNlXhJVjEdCWM7GrXLvpNAcVy_pkuM6Dhq4SgVMYwWGyrBOdZ8bnLbsgDfXaPRouFDpEszq05Kr7AW9j5JklhMzqGRpT1Q5ZGjrzGHYiXiT2P3Jm9QWZ_pwt_fOxslnxa_pPpaWwRwGD2pKM61qEQAAcsJ0FKcpepgnbMEQRXYtc8Wuaq76BO_f64S409nsgpETyVz1IJuN_pycdWhg8IF51KqD_fZ0iR1_pdQrv4QqJx_pKDOdCQtIFQ3VNfzDWmoFxbXQ477xOX7JgUAlXwx1_pturb1aFxT4Vq9jfOrEjTCpCIGM_fwpkJTA5yYbwjvDk8MFIbOOaC8hHd_plibI2rs5q7724DtWabuftd0xBCvXtvfqgUxmgvR0qNwHXIHNWKjM6JyZhZJtXREg3TerClFn_filYwEDakWR2iMzDQL3VmR3P8znG5y1ub34XaQaUrlyQ7Ggc_pInHFc2Zypd7cQAKN4u_fMSozzenC7mjcwnLENTleIi4pjdpzKvm9if90iuIJBNJPukspzlnv58JmBE1HfZh0C5cUDIEDPSN5PctrVid3oDlwenAMUmRyOAqfNM4JQ4SNrBgMgwqK5Z5KeFuQp0rGkREgDTWSQEEcZrJX0OiTQHNr5FoPlyuTRfAVPUlPz6qlqb_fyYTDhWhzoHNOTOfak2zSV5ulqfssJma75JjZPOm7rAOrEWvdpE4zWrLCYv42bboHPZsqun87fqBftstX6YCMxWb0wNixbnLan0GQM8M_ffDg2CxLn4VgBvKcjYn4Glf0PQ43QRLN5BWF1sVs_pmoTMSrYi9EVQZUWN6wrhI5tnqW7tQ5E9eru21PvYhm61rCgtQ6rl_p4j1eiM1dUglBps8gc6jUg49PK2iibrZ_pBW9yxM7WDdd0SDiOZwMJLa8B2KY9OSupHm6KXX2MaCZiZG9FRrbd57bkbFje_f4RzQG2tD1Ji0rnXBWW5f4Zv7tI2c3Mx7qlLkiofC5zQGlD_prcG1Jl396VzMi7oNLb6EN96wrLQQA1io5bUsE6s9K0ZMNCWHR003HdRrVd4DqYYf1K60dx9pqt9xVYSh9wU4Xah5FMROKVDki_fpG1Wb6AQaiSlXUWwzltqvuVzXmgKupAA8xJXl_pWxOl4b0YsXmD2q63n1_f3cIJ2JY1_p58_f08XzHSdtxErCwrKr0bF697jQnXTxprEP_fB_plpi8YDFsrgE0VI5GjihhgXq1uRvbP09pUAhPTNn8Lz7VG_p5vmAG_pZbYjx4dwfJ3XzjyqVcu_pUDymjpJs42uEU70PAmqT2rEapg5BUbPtIUSzl4Pozn3tUy9qgbbgYk4TdoFbbO2I1_feOBh_f7VlgrrV6mT2SuFrLqtjhnKrZdSqBDq1zgtJhdFH_pS2oJeH2ZbVW_pUJ77_p0c3R_p0yVNZNLcJAK1mltA1UGQNTD2yaSs9afjb1Z6tTT3Sxx8Ocht0gSyw8B1oS0ciBs7rNut_fVAqqcBeBsbgX7T7GmlgHSPopWlXQ2k6CXTsIH6H8i_fRWth5GcOCcMH0w_fXBxBQmWD6F1dHrZ6kWJdspWH_ppRS9h9y7knArKj3UwRIiN2T4J4rGvr22_pvYvMO6JKRJbRSRIoduY_p0AEfzXn7Cp4fMSdax77L45TQBn_f5uUpw3WnFVEszsKg78d6ImpkHdTiTcE7fWA5H41yv2ZC7kFGyr2ruYcm8xQbb25H1jnXeZ4PTENGc_fzQYh7tqyKieNmVbspCAx_przAQpcaFMgV4O7hGZblId7puLDQhw_fgV0ws93lwtmswqeCfXM93FCzTwqNRiGzfIjSyoQEr3lYrWfdTzJf7J7VsVKop_p9sSXO8dkTD0PNZWdfAvxx0g_fAa4bO_fITA_flvi5oiWQXH3aAv0ghFphFuREK6ABT11g7IMVCZxbOQVN4lSkqJ4oFLIoUVu2w0VeMayURmETZpuVzYsVccRjv53Z9wGNk0rSXm74LYx1YHVqiPEwB_pm60oc_ftX_pnkYRK2mcmXyn7G6miZNQj6aw2MHhVJMdVcOvx9hqCZh3BX18",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-24T06:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/LX.png",
					"carrierCode": "LX",
					"carrierName": "SWISS",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-23T16:50:00",
					"flightNumber": "87",
					"aircraft": "Airbus A330-300",
					"aircraftType": "Jet",
					"flightDuration": "7h 25m",
					"layoverDuration": "6h 45m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 2h ",
					"arrivalTime": "6:15am",
					"arrivalDay": "2018-08-24",
					"departureTime": "4:50pm",
					"departureDay": "2018-08-23",
					"destination": "ZRH",
					"destinationAirportName": "Zurich Intl Airport",
					"destinationAirportCity": "Zurich",
					"destinationAirportState": null,
					"destinationAirportCountry": "Switzerland",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T07:50:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/LX.png",
					"carrierCode": "LX",
					"carrierName": "SWISS",
					"operatingAirlineName": null,
					"departureDateTime": "2018-08-24T13:00:00",
					"flightNumber": "160",
					"aircraft": "Airbus A340-300",
					"aircraftType": "Jet",
					"flightDuration": "11h 50m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "1d 2h ",
					"arrivalTime": "7:50am",
					"arrivalDay": "2018-08-25",
					"departureTime": "1:00pm",
					"departureDay": "2018-08-24",
					"destination": "NRT",
					"destinationAirportName": "Narita Intl Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "ZRH",
					"originAirportName": "Zurich Intl Airport",
					"originAirportCity": "Zurich",
					"originAirportState": null,
					"originAirportCountry": "Switzerland"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Narita Intl Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "SWISS",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/LX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "NRT",
				"arrivalTime": "7:50am",
				"arrivalDay": "2018-08-25",
				"departureTime": "4:50pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "1d 2h "
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_CL)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T06:35:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T17:50:00",
			"destination": "HND",
			"downPayment": 6573.86,
			"id": "4b09895b-7520-4685-a4f4-5bddc1fa2600",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pZLosaXDE5l6_prSiCUqkeTaNmdnG5a8UBMe17YbnKfABoJlJLbvhGzYOTnRWC0_p0Kf108eULOtPK4Sl3UKZ9KQUqc2DgizNQRcQhaN3R3vv_fUL_p2jaj795afPf60EuxRAbtyrIISfu42hsCXy2w1mezvkFnvDZ_paJ0LeQ_pU3KD2gHQwGHW6IWq9rrbubhTNr28ATsedWQGgO9HBUjuluL52HfOBAy80VCfLEFlrcyNc8bS9sCc_pCy972I4SY6lhBBnN_fXOli8rqgeWBh7IKYcOu68I4R4NvN4j6XQZXZEb7EkLY1qXawA4otJA3kAckhOAh6_faVPPrv8OukGpOWmYdPxtMhYbVK3_fy6w_phfaFrJt6BSfsTAtmdX_piAvGFxEQCVWeGnLksQCf7KKEY0T8VoJ2fcWoeLwIgEshqhXzD0aztBBiBloiXcywiHA4urfz3A1_pD82g7ufg0Vt07fsKmAgeq2_fhwu31RngzJ_ptQ_p294LBxu0r3TJkQg_peP_fHDCGMyvnQ_p8VDNKtFUSdE4jM87Xvb2gw7DmGsBqAkNTJlfuUmQzu4ww7Y3v_pmCNFerrdwQ5it0aRs3aXAqDz48YUaPqUn9KoFzcVy2Cp_p7OBxSacZnktYfupr00AJq0l_pj4chv8qxX0fiFQmITmThbBqKPZKgNQD1MG_pekOHpFnK6fcaacicdebssh_fysVbRwDShZW02Y30Jw3vRJpdAxH4oAaDFCkoypRAzLKY_pdZJ4S586tYRW1xAyz1jj90czMrt0d8iEGQupSz6Zr79YPtkKRmxnznZQG4Oe1Hm4OwzjeKwIS13u8yliXyE5bh6FhA_fT1EKxgWS5GgYGBTGfHLMBiLD9IqLFp2grD2FYgNhlvx_fRmzJScU_pEKFq5hUHUGhWN4kffXEBNsBQ537dOKJgARCrjhaalBn4kd8YMzDdKfEig_pSIdd9QLVb4JAHT9TROBMNUV2TVG0_fdkj_pve3yJUQhFENBJ2JGJy2VVP7ph3znCR7ak2H2qM2uJnKFzmvgV66heEdKxX6zAE8HnGLGQxZmd60T8wUImK0zjDa2H2TPK0wX9n6MyK7HKL0UOXNvVK5n5bboB6AIvUmcPVvm8G4EUd1kOrYulEy9rk2PIICYrjG8L8RgkmBYQEQJ4kPxm5M4Gg3uQNGfiut0_fO6IzKy6LMQ5yUTpbLz2GVovufgDlTpMJogQkx8QkCRox1857UuEYzewC1Yyi6oLmEZsVtFNpxJFglgOvUbCpvcw8iWbeA2RbfLvYQOAmmIAv823vhjcZ8R93af84xLP3ka_feXNFqeIB2EpFxUG0fy86tkWDHuTtxqMvv7Ek77kIR_pGyOpq8Gz1LLz9nrVx318AIBOW65oYPVZJZS3yw6Uh4dgoywFhEK1z_pdfZyJfg7VrIYE2QvTKE_pZDe0nAdXjwxpVBAokqcbcQbab9Y9qHDUzZcPDYWcGmDxjPkrq0L_pm16lzWZZqW2nXJPkqLNPgRbezI9u2E5R63W6C5MzF18bUQqWkwTAqejZ6ZDeF5hEb1fQTXwBYCOg8o79EGAmFxsZIilrD02cvgGuqIpTqUjJZx_pG3WN40vaz73bCJ0L5_pICaRWzW_pcr_fJ7AKiyaauZ_fwUTOvok4V_fPw0H0B74IfG817jTHFEifbUdhIsJ6GRiQ7GWtJBfGMiG1TMcdxArH3kbcLPMkKW8Z9j2QzpaRBuxLRYd5bUjpoZW9mXae5t_p5oMeKrYxjGr_pXckhtMOQEOkeornUgEbrlWAav6BGD3U9sayhQltkUtqM8zHhg3dqDxacB4FCb4j_pqESg4mjK0Jw6_puE3rKonPtCn_pWVCyYzsa7U7pjeFS_ff3KyWBvRTxNmOIgdzTTumS_pU2zq3EOTbPHSw5i23SH0SXi21bmF8g_plOrHyE03f_f9CPEQt6e1LLB6ehGBINCV_fcDVjF6qb7S5D0K77IKxEJmvL8b6dEZpsS8n6HP27urpnJWDTJXrptBJsgs7vjlc0GrjtE61nb3TY1dRoaO8RsLv2A_fMxbJJdCZZvCotXhS1ZLBIjeiobeO_f21Uikmiym_pm0ki0FnRkJTSY98vSKgvuNfdDKwrU5GtgDQygW07RApRmWqSeGOYQuYBiQ5s8VbKqIiMgvHoMUf2HXGyD9684EF1H2gOPnGqlk6M8lOahqqQzBSViqBfCxIcPlSoJSQ9qpWMVMTt9duQknEfC8S1gh1RN_fekNCK_f7zhsP_pXqj9UBpoIN534eFfnuSwA_pcGxfYZsKPBSPcru65bxbbsZwyezHTSHUdXHlUMj0s9aB5dOSJbVB8FWn_fmpsLb6DYMY",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-24T07:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/LH.png",
					"carrierCode": "LH",
					"carrierName": "Lufthansa",
					"operatingAirlineName": "Lufthansa Cityline",
					"departureDateTime": "2018-08-23T17:50:00",
					"flightNumber": "479",
					"aircraft": "Airbus A340-300",
					"aircraftType": "Jet",
					"flightDuration": "7h 10m",
					"layoverDuration": "5h 10m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "23h 45m",
					"arrivalTime": "7:00am",
					"arrivalDay": "2018-08-24",
					"departureTime": "5:50pm",
					"departureDay": "2018-08-23",
					"destination": "FRA",
					"destinationAirportName": "Frankfurt am Main Airport",
					"destinationAirportCity": "Frankfurt",
					"destinationAirportState": null,
					"destinationAirportCountry": "Germany",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T06:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/LH.png",
					"carrierCode": "LH",
					"carrierName": "Lufthansa",
					"operatingAirlineName": "ANA All Nippon Airways",
					"departureDateTime": "2018-08-24T12:10:00",
					"flightNumber": "4948",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "11h 25m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "23h 45m",
					"arrivalTime": "6:35am",
					"arrivalDay": "2018-08-25",
					"departureTime": "12:10pm",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "FRA",
					"originAirportName": "Frankfurt am Main Airport",
					"originAirportCity": "Frankfurt",
					"originAirportState": null,
					"originAirportCountry": "Germany"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Lufthansa",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/LH.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "6:35am",
				"arrivalDay": "2018-08-25",
				"departureTime": "5:50pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "23h 45m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_AC)",
			"departureDateDisplay": "Thursday, August 23rd, 2018",
			"arrivalDateTime": "2018-08-25T06:35:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2018-08-23T19:15:00",
			"destination": "HND",
			"downPayment": 6573.86,
			"id": "619b7333-ef7b-4fd5-a7b5-590507c226e1",
			"origin": "YUL",
			"ppnContractBundle": "_eJwBwAY_f_pYjTK61OFmYpSeK6BafAdCKd2vwAfUpa9JqZPK6nB04TMwtjajThof2etVsxMxSnpHoV_p_puh3GZr4Tl74JwLxUY_pmfUiwQfmzn21IvQxVh336EkhvP3CIlSC1M3B9I7pTeH6KsuelcJ5O_pEUY0bvTkw9CI_f5VFXs1SEqL2TuPTTtwIOafhflJVPshY7067kD9iHDoMOWTpRbdqNOBKbrfl0_fQNoUB_p2UtUUuioh0gE8iN1ro6UrObFTvQ3O4_frPfI_fnrPcfAky8S82BhBwUQRemjrS5RbxX_ffA_fPXNGi7XZAHOh1ANiJkkr_fD3bg_pKNY_fa47lgyhLkB2um4KsLh44rlW2CVo959eTWEMgqbZks_fFsVkysAvAoZ7NtLsgYWZ4uQaUcEkrE1tFp8LCUpAhhg0lRLU05CSr2KWbl8jxMxVwcH8vIMCnwHiI_f_pGm1L4Nrm1XS6U7HP_prrbAepOYSXRhYWDe9fAc61maopkF30ZzUmWmYM2j171K_p9qSJerZ21rcJFLG88vU4qm5O8DK_pU_pSTYPBIr0mmW0_p8EZ5_pxxruiNWTlDppFDuag71_f_fgATzOl8M17n5owbujTxy0IsqbHsyqf_f7yCExBkmfgpGNUH2dKDovD3uVBlzHc8KYAuzZab8Sli06T9ihcTj_p_p770dLypG3vmP4Add6Ay5oxi48qNhdyVElZyAojwXiV_fsiPnKsS51vZ2e9EATU6_fPf4WIOh8L0DWb8x1CZ1n5lPSoPLXxUNGrP1kBLlgkZUswCFISRHNgnH_fAGyRJn1I_f2NYFRodicRaLaSNaUEMgiIf6enqUYL7FuOVAku0EV1dh5IQQCvpm_fTcpg_pDE7197_p9PBv2TUzOhtS_fMgFQeSDUN2YTnXm2f5ZqEPcNCiHpNvcMoYyFGbkDpFcB1gbs7RR7HPoSTXqAkn_fATLDZu45ZvX_fxj2objF48wbcmwNRZVEOun2HQm0G9fdXhSpud_p1XSrXSmO7OqheaVCDbKj9Aao_pUtG4Lo2mp8K0jVEkcJWHmmhwQ2RXZEduYR86zBS1A9NSjmTagWHb8R0O_pBeBSLySHhnyl61Gdym2hUeP3v8vqwYoqByBTjbklWMGcMPbH9uycBzmiUT4XVrDCWHhb7i21kkDfD2Q4NgpAhaz3jJGPrkoyjr_p_p9uim0O3mwLT6T5_pgctdukJOm7fkIt4t4j6gaOgUddLz_pLXwhG5DjP9Q_fadFKSOHoNMi0tFBZEb2m80Q8ehtfo9EfwAP7F17_fFJKbULOKdz_f3K_fv8PWuOryiNVdDcXqy_fZvXhLWiHY_pIzOBJpSTrHoJc7_pG3krcZ57nlSi8hjMGnV4m40r92uBUUxWOTDOJnuvXQyNDG8Jq6NGmrWPwqqB38VPvrkX6H8c8OhD_fIuojqKG6jUMjELq_fA4NVcxQhkQ39PXyDwGRS_fPK6lal8inPY0ANaOnnrlExomGX_ffDakwUK3wPC8eZVN1kl2jCxZi1NwvOPvsAyXmumQZWtSqp_fSFABltORxjfgRC0hmXgLX4wL3XYph5cYrukgSOk973WnpbxVwyyB1xKfvwHv_pjxZO_fNqgVCkhj2MUHPL9Jte_pafvavt5rzuhZlLI1BsVrFmNvgD2SNOrrtGRZGp_plHyPwQ5MFMSrnAKW8Q7lqEJNhbsUMXn2KftptoDcA7YKRu6knl2saX0HR_pOfCBaOv9Ad8rNuVrTMMT0QxWdLpjEV56aGnMC17o7KtRwStfDSUa6mOkEOqZNlluOQxI2S9GKOZbKqdHPgR0cGRIMfiYpw_p8cAp31CGQZ8TONL4yxuBEJShh_fSl3yACnJSG_pATkdzbKc2by95kR5EQ35htU8PmJHextve9RQ3IRhUIi7NMgEDC_psB_pbo5NwquxnP7_p29QgaBO0RdBY9bdsyP8M8kjeyISj8gtYjhYMWJC_fZVSNvv58LGShrDE8pociZT4GcnEErTrRsMJW6tC71Xx4zhkeWVHToVSM3m1TPfZXKAMWpyMk0cu8Ytb_f9hO7aqJs_fAX_piLq4mRo87yvxMrhG8D7RTwMpAmYqIqgtm0L2baG8PpnY5bdpxJVAQkw0hnIwscZvbAe_pcjOM3GRJuzby_fJy3Z0SDFkzzgKXJ5q3_frH2n7Fok1iQ8FBZasFCawDrHhJjPRPD_fGfpqnhpD89hu5z9rBdTIESS9JUR5xcOlInHz5_fIDFSVkWye2QM6_pVG_fi6Z5bgmqKZEX_f8c0SoKDdZtv3ooQiuCiog_fGoYq7eLdDWAym5bWAO_fJhOW3M0z0_fSE2rH7Wpa3Z33k8h8ltUjSdiV_fsUyL32BfeVVkXeYIRDSa20",
			"tripSegments": [
				{
					"arrivalDateTime": "2018-08-24T08:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/LH.png",
					"carrierCode": "LH",
					"carrierName": "Lufthansa",
					"operatingAirlineName": "Air Canada",
					"departureDateTime": "2018-08-23T19:15:00",
					"flightNumber": "6795",
					"aircraft": "Boeing 787-8",
					"aircraftType": "Jet",
					"flightDuration": "7h 5m",
					"layoverDuration": "3h 50m",
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "22h 20m",
					"arrivalTime": "8:20am",
					"arrivalDay": "2018-08-24",
					"departureTime": "7:15pm",
					"departureDay": "2018-08-23",
					"destination": "FRA",
					"destinationAirportName": "Frankfurt am Main Airport",
					"destinationAirportCity": "Frankfurt",
					"destinationAirportState": null,
					"destinationAirportCountry": "Germany",
					"origin": "YUL",
					"originAirportName": "Pierre Elliott Trudeau Intl Airport",
					"originAirportCity": "Montreal",
					"originAirportState": "QC",
					"originAirportCountry": "Canada"
				},
				{
					"arrivalDateTime": "2018-08-25T06:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/LH.png",
					"carrierCode": "LH",
					"carrierName": "Lufthansa",
					"operatingAirlineName": "ANA All Nippon Airways",
					"departureDateTime": "2018-08-24T12:10:00",
					"flightNumber": "4948",
					"aircraft": "Boeing 777-300ER",
					"aircraftType": "Jet",
					"flightDuration": "11h 25m",
					"layoverDuration": null,
					"layoverNoteValues": [
						"Flight arrives on the next day."
					],
					"totalTripDuration": "22h 20m",
					"arrivalTime": "6:35am",
					"arrivalDay": "2018-08-25",
					"departureTime": "12:10pm",
					"departureDay": "2018-08-24",
					"destination": "HND",
					"destinationAirportName": "Tokyo Intl (Haneda) Airport",
					"destinationAirportCity": "Tokyo",
					"destinationAirportState": null,
					"destinationAirportCountry": "Japan",
					"origin": "FRA",
					"originAirportName": "Frankfurt am Main Airport",
					"originAirportCity": "Frankfurt",
					"originAirportState": null,
					"originAirportCountry": "Germany"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "Montreal",
				"originAirportState": "QC",
				"originAirportName": "Pierre Elliott Trudeau Intl Airport",
				"destinationAirportName": "Tokyo Intl (Haneda) Airport",
				"destinationAirportCity": "Tokyo",
				"destinationAirportState": null,
				"mainCarrierName": "Lufthansa",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/LH.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "YUL",
				"destination": "HND",
				"arrivalTime": "6:35am",
				"arrivalDay": "2018-08-25",
				"departureTime": "7:15pm",
				"departureDay": "2018-08-23",
				"totalTripDuration": "22h 20m"
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ../server/test/mocks/FlightDepartures_OneWay_Overnight_2.json
// module id = 595
// module chunks = 0